import { actions as actions$b, uninitState, statusSuccess, idleState, reducer as reducer$3, loadingState, failedState, successState, combineReducers, ApiConfigSelectors, FeatureToggleSelectors, IntlSelectors, useDispatch, useSelector, statusUnavailable, statusUninit, unavailableState, useIntl, statusLoading, statusFailed, LOADING, SUCCESS, connect, IntlContext, useFeatureToggles, statusWarning, statusIdle, withIntl, useSaga, useApiConfig, withApiConfig, withFeatureToggles, ReducersRegistry, SagaRegistry } from '@grandvisionhq/state';
import { createSelector } from 'reselect';
import { Selectors, State, Types, getToken, Actions as Actions$2, Utils, optIns, getParsedDataFromLS, useAccount, writeUserDataToLS, RouteKey, Login, CreateAccount, ResetPassword, ExpiredLink, Callback, AuthContextConsumer } from '@grandvisionhq/auth';
import { Util, Form, FirstName, LastName, PhoneNumber, AddressLine, HouseNumber, HouseNumberSuffix, PostalCode, City, Region, Email, TextArea, Select, Field, DatePicker, Password, PasswordWithStrengthIndicator } from '@grandvisionhq/forms';
import { takeLatest, put, call, select, race, take, all, delay } from 'redux-saga/effects';
import { Customers, Stores, Appointments, Orders as Orders$2, Products, useApiClient } from '@grandvisionhq/api-client';
import { toast, Alert, SkeletonLoader, SummaryItem, Flyout, MediaQuery, LoaderScreen, Breadcrumbs, Button, Summary, CheckboxList, Modal as Modal$2, Loader as Loader$1, Link, SummaryLoader, ErrorBoundary, Accordion, AccordionItem, ScrollIntoView, DateTime, SummaryContainer, EyeSideIndicator, LineItem, LineItemMedia, LineItemContent, LineItemAside, ProgressBar, Price, Tabs, Tab, LineItemPrescription as LineItemPrescription$1, PrescriptionGlassesBundleChildItem, Image as Image$1, Tooltip, DataTable, RadioButton, OptionCardGroup, Card, IconButton, RadioButtonGroup, List } from '@grandvisionhq/common';
import { format, parseISO, isValid, isAfter, isWithinInterval } from 'date-fns';
import { DataLayer } from '@grandvisionhq/analytics';
import { ReduxDataSource, Utils as Utils$1 } from '@grandvisionhq/carts';
import { Helpers, DailyPackageQuantity } from '@grandvisionhq/products';
import isNil from 'lodash/isNil';
import omitBy from 'lodash/omitBy';
import * as React from 'react';
import React__default, { useEffect, useState, useMemo, Component, createContext, useReducer, useContext, useCallback } from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { Heading, Hr, Label, Text, Checkbox } from '@grandvisionhq/elements';
import { getLocalizedValue, getFrontImage, StringUtils, placeholderImage, withPlusSign, DateUtils, isString, isNumber, formatPrice, QueryString, StringGuard } from '@grandvisionhq/utils';
import { SubMenuLinks } from '@grandvisionhq/layout';
import { gql, NetworkStatus, useQuery, useMutation, useLazyQuery, getGraphQLErrorCode } from '@grandvisionhq/graphql';
import { StoreDetail, PreferredStoreFinder } from '@grandvisionhq/stores';
import { debounce } from 'throttle-debounce';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { v4 } from 'uuid';
import { useAdyen, Sepa, CreditCard, ActionContainer } from '@grandvisionhq/payments';

var FETCH_ADDRESSES = 'auth/addresses/fetch-list';
var FETCH_ADDRESSES_SUCCESS = 'auth/addresses/fetch-list-success';
var FETCH_ADDRESSES_FAILED = 'auth/addresses/fetch-list-failed';
var TOGGLE_MODAL = 'auth/adresses/toggle_modal';
var ADD_ADDRESS = 'auth/addresses/add-address';
var ADD_ADDRESS_SUCCESS = 'auth/addresses/add-address-success';
var ADD_ADDRESS_FAILED = 'auth/addresses/add-address-failed';
var EDIT_ADDRESS = 'auth/addresses/edit-address';
var EDIT_ADDRESS_SAVE = 'auth/addresses/edit-address-save';
var EDIT_ADDRESS_SUCCESS = 'auth/addresses/edit-address-success';
var EDIT_ADDRESS_FAILED = 'auth/addresses/edit-address-failed';
var DELETE_ADDRESS = 'auth/addresses/delete-address';
var DELETE_ADDRESS_CONFIRM = 'auth/addresses/add-address-confirm';
var DELETE_ADDRESS_SUCCESS = 'auth/addresses/delete-address-success';
var DELETE_ADDRESS_FAILED = 'auth/addresses/delete-address-failed';
var action = actions$b.action, payload = actions$b.payload;
/**
 * Fetch list
 */
var fetchList$2 = action(FETCH_ADDRESSES);
var fetchListSuccess$2 = action(FETCH_ADDRESSES_SUCCESS, payload());
var fetchListFailed$2 = action(FETCH_ADDRESSES_FAILED, function (error) { return ({ error: error }); });
/**
 * ToggleModal
 */
var toggleModal = action(TOGGLE_MODAL, payload());
/**
 * Add address
 */
var addAddress = action(ADD_ADDRESS, payload());
var addAddressSuccess = action(ADD_ADDRESS_SUCCESS, payload());
var addAddressFailed = action(ADD_ADDRESS_FAILED, function (error) { return ({ error: error }); });
/**
 * Delete address
 */
var deleteAddress = action(DELETE_ADDRESS, payload());
var deleteAddressConfirm = action(DELETE_ADDRESS_CONFIRM);
var deleteAddressSuccess = action(DELETE_ADDRESS_SUCCESS, payload());
var deleteAddressFailed = action(DELETE_ADDRESS_FAILED, function (error, id) { return ({
    error: error,
    id: id,
}); });
/**
 * Edit address
 */
var editAddress = action(EDIT_ADDRESS, payload());
var editAddressSave = action(EDIT_ADDRESS_SAVE, payload());
var editAddressSuccess = action(EDIT_ADDRESS_SUCCESS, payload());
var editAddressFailed = action(EDIT_ADDRESS_FAILED, function (error) { return ({ error: error }); });

var actions$a = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_ADDRESSES: FETCH_ADDRESSES,
  FETCH_ADDRESSES_SUCCESS: FETCH_ADDRESSES_SUCCESS,
  FETCH_ADDRESSES_FAILED: FETCH_ADDRESSES_FAILED,
  TOGGLE_MODAL: TOGGLE_MODAL,
  ADD_ADDRESS: ADD_ADDRESS,
  ADD_ADDRESS_SUCCESS: ADD_ADDRESS_SUCCESS,
  ADD_ADDRESS_FAILED: ADD_ADDRESS_FAILED,
  EDIT_ADDRESS: EDIT_ADDRESS,
  EDIT_ADDRESS_SAVE: EDIT_ADDRESS_SAVE,
  EDIT_ADDRESS_SUCCESS: EDIT_ADDRESS_SUCCESS,
  EDIT_ADDRESS_FAILED: EDIT_ADDRESS_FAILED,
  DELETE_ADDRESS: DELETE_ADDRESS,
  DELETE_ADDRESS_CONFIRM: DELETE_ADDRESS_CONFIRM,
  DELETE_ADDRESS_SUCCESS: DELETE_ADDRESS_SUCCESS,
  DELETE_ADDRESS_FAILED: DELETE_ADDRESS_FAILED,
  fetchList: fetchList$2,
  fetchListSuccess: fetchListSuccess$2,
  fetchListFailed: fetchListFailed$2,
  toggleModal: toggleModal,
  addAddress: addAddress,
  addAddressSuccess: addAddressSuccess,
  addAddressFailed: addAddressFailed,
  deleteAddress: deleteAddress,
  deleteAddressConfirm: deleteAddressConfirm,
  deleteAddressSuccess: deleteAddressSuccess,
  deleteAddressFailed: deleteAddressFailed,
  editAddress: editAddress,
  editAddressSave: editAddressSave,
  editAddressSuccess: editAddressSuccess,
  editAddressFailed: editAddressFailed
});

var fetchStore = actions$b.action('auth/appointments/fetch_store', actions$b.payload());
var fetchStoreSuccess = actions$b.action('auth/appointments/fetch_store_success', actions$b.payload());
var fetchStoreFailed = actions$b.action('auth/appointments/fetch_store_failed', function (error) { return ({ error: error }); });
var cancel = actions$b.action('auth/appointments/cancel', actions$b.payload());
var cancelSuccess = actions$b.action('auth/appointments/cancel-success', actions$b.payload());
var cancelFailed = actions$b.action('auth/appointments/cancel-failed', function (error) { return ({ error: error }); });

var actions$9 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fetchStore: fetchStore,
  fetchStoreSuccess: fetchStoreSuccess,
  fetchStoreFailed: fetchStoreFailed,
  cancel: cancel,
  cancelSuccess: cancelSuccess,
  cancelFailed: cancelFailed
});

var APPOINTMENTS_VIEW = 'my-account/datalayer/appointments-view';
var UPCOMING_APPOINTMENT_VIEW = 'my-account/datalayer/upcoming-appointment-view';
var RESCHEDULE_APPOINTMENT = 'my-account/datalayer/reschedule-appointment';
var CANCEL_APPOINTMENT = 'my-account/datalayer/cancel-appointment';
var appointmentsView = function (appointments) { return ({
    type: APPOINTMENTS_VIEW,
    payload: { appointments: appointments },
}); };
var upcomingAppointmentView = function (appointment) { return ({
    type: UPCOMING_APPOINTMENT_VIEW,
    payload: { appointment: appointment },
}); };
var rescheduleAppointment = function (appointment) { return ({
    type: RESCHEDULE_APPOINTMENT,
    payload: { appointment: appointment },
}); };
var cancelAppointment = function (appointment) { return ({
    type: CANCEL_APPOINTMENT,
    payload: { appointment: appointment },
}); };

var actions$8 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  APPOINTMENTS_VIEW: APPOINTMENTS_VIEW,
  UPCOMING_APPOINTMENT_VIEW: UPCOMING_APPOINTMENT_VIEW,
  RESCHEDULE_APPOINTMENT: RESCHEDULE_APPOINTMENT,
  CANCEL_APPOINTMENT: CANCEL_APPOINTMENT,
  appointmentsView: appointmentsView,
  upcomingAppointmentView: upcomingAppointmentView,
  rescheduleAppointment: rescheduleAppointment,
  cancelAppointment: cancelAppointment
});

var PAGE_VIEW = 'my-account/datalayer/page-view';
var ORDER_DETAILS_VIEW = 'my-account/datalayer/order-details-view';
var ORDER_ITEM_SELECT = 'my-account/datalayer/order-item-select';
var ORDER_REORDER = 'my-account/datalayer/order-reorder';
var TRACE_ORDER = 'my-account/datalayer/trace-order';
var PROFILE_EDIT_SUCCESS = 'my-account/datalayer/profile-edit-success';
var PROFILE_EDIT_ERROR = 'my-account/datalayer/profile-edit-error';
var PASSWORD_CHANGE_SUCCESS = 'my-account/datalayer/password-change-success';
var PASSWORD_CHANGE_ERROR = 'my-account/datalayer/password-change-error';
var pageView = function (currentRoute) { return ({
    type: PAGE_VIEW,
    payload: {
        currentRoute: currentRoute,
    },
}); };
var profileEditSuccess = function () { return ({
    type: PROFILE_EDIT_SUCCESS,
}); };
var profileEditError = function (error) { return ({
    type: PROFILE_EDIT_ERROR,
    payload: {
        error: error,
    },
}); };
var orderDetailsView = function (orderId, orderDate, paymentStatus, shippingStatus) { return ({
    type: ORDER_DETAILS_VIEW,
    payload: {
        orderId: orderId,
        orderDate: orderDate,
        paymentStatus: paymentStatus,
        shippingStatus: shippingStatus,
    },
}); };
var traceOrder = function (orderId, orderDate, paymentStatus, shippingStatus) { return ({
    type: TRACE_ORDER,
    payload: {
        orderId: orderId,
        orderDate: orderDate,
        paymentStatus: paymentStatus,
        shippingStatus: shippingStatus,
    },
}); };
var orderItemSelect = function (select, orderId, orderDate, paymentStatus, shippingStatus) { return ({
    type: ORDER_ITEM_SELECT,
    payload: {
        select: select,
        orderId: orderId,
        orderDate: orderDate,
        paymentStatus: paymentStatus,
        shippingStatus: shippingStatus,
    },
}); };
var orderReorder = function (currencyCode, id, lineItems, prescriptionGlassesLineItems) { return ({
    type: ORDER_REORDER,
    payload: {
        currencyCode: currencyCode,
        id: id,
        lineItems: lineItems,
        prescriptionGlassesLineItems: prescriptionGlassesLineItems,
    },
}); };

var actions$7 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Appointments: actions$8,
  PAGE_VIEW: PAGE_VIEW,
  ORDER_DETAILS_VIEW: ORDER_DETAILS_VIEW,
  ORDER_ITEM_SELECT: ORDER_ITEM_SELECT,
  ORDER_REORDER: ORDER_REORDER,
  TRACE_ORDER: TRACE_ORDER,
  PROFILE_EDIT_SUCCESS: PROFILE_EDIT_SUCCESS,
  PROFILE_EDIT_ERROR: PROFILE_EDIT_ERROR,
  PASSWORD_CHANGE_SUCCESS: PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_ERROR: PASSWORD_CHANGE_ERROR,
  pageView: pageView,
  profileEditSuccess: profileEditSuccess,
  profileEditError: profileEditError,
  orderDetailsView: orderDetailsView,
  traceOrder: traceOrder,
  orderItemSelect: orderItemSelect,
  orderReorder: orderReorder
});

var FETCH_PAGE = 'auth/orders/fetch_page';
var FETCH_PAGE_SUCCESS = 'auth/orders/fetch_page_success';
var FETCH_PAGE_FAILED = 'auth/orders/fetch_page_failed';
var FETCH_LEGACY_PAGE = 'auth/orders/fetch_legacy_page';
var FETCH_LEGACY_PAGE_SUCCESS = 'auth/orders/fetch_legacy_page_success';
var FETCH_LEGACY_PAGE_FAILED = 'auth/orders/fetch_legacy_page_failed';
var FETCH_DETAIL$1 = 'auth/orders/fetch_detail';
var FETCH_DETAIL_SUCCESS$1 = 'auth/orders/fetch_detail_success';
var FETCH_DETAIL_FAILED$1 = 'auth/orders/fetch_detail_failed';
var FETCH_LEGACY_DETAIL = 'auth/orders/fetch_legacy_detail';
var FETCH_LEGACY_DETAIL_SUCCESS = 'auth/orders/fetch_legacy_detail_success';
var FETCH_LEGACY_DETAIL_FAILED = 'auth/orders/fetch_legacy_detail_failed';
var REORDER = 'auth/orders/reorder';
var REORDER_SUCCESS = 'auth/orders/reorder_success';
var REORDER_FAILED = 'auth/orders/reorder_failed';
var fetchPage = function (payload) { return ({
    type: FETCH_PAGE,
    payload: payload,
}); };
var fetchPageSuccess = function (payload) { return ({
    type: FETCH_PAGE_SUCCESS,
    payload: payload,
}); };
var fetchPageFailed = function (error) { return ({
    type: FETCH_PAGE_FAILED,
    error: error,
}); };
var fetchLegacyPage = function (payload) { return ({
    type: FETCH_LEGACY_PAGE,
    payload: payload,
}); };
var fetchLegacyPageSuccess = function (payload) { return ({
    type: FETCH_LEGACY_PAGE_SUCCESS,
    payload: payload,
}); };
var fetchLegacyPageFailed = function (error) { return ({
    type: FETCH_LEGACY_PAGE_FAILED,
    error: error,
}); };
var fetchDetail$1 = function (payload) { return ({
    type: FETCH_DETAIL$1,
    payload: payload,
}); };
var fetchDetailSuccess$1 = function (payload) { return ({
    type: FETCH_DETAIL_SUCCESS$1,
    payload: payload,
}); };
var fetchDetailFailed$1 = function (error) { return ({
    type: FETCH_DETAIL_FAILED$1,
    error: error,
}); };
var fetchLegacyDetail = function (payload) { return ({
    type: FETCH_LEGACY_DETAIL,
    payload: payload,
}); };
var fetchLegacyDetailSuccess = function (payload) { return ({
    type: FETCH_LEGACY_DETAIL_SUCCESS,
    payload: payload,
}); };
var fetchLegacyDetailFailed = function (error) { return ({
    type: FETCH_LEGACY_DETAIL_FAILED,
    error: error,
}); };
var reorder = function (payload) { return ({
    type: REORDER,
    payload: payload,
}); };
var reorderSuccess = function () { return ({
    type: REORDER_SUCCESS,
}); };
var reorderFailed = function (error) { return ({
    type: REORDER_FAILED,
    error: error,
}); };

var actions$6 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_PAGE: FETCH_PAGE,
  FETCH_PAGE_SUCCESS: FETCH_PAGE_SUCCESS,
  FETCH_PAGE_FAILED: FETCH_PAGE_FAILED,
  FETCH_LEGACY_PAGE: FETCH_LEGACY_PAGE,
  FETCH_LEGACY_PAGE_SUCCESS: FETCH_LEGACY_PAGE_SUCCESS,
  FETCH_LEGACY_PAGE_FAILED: FETCH_LEGACY_PAGE_FAILED,
  FETCH_DETAIL: FETCH_DETAIL$1,
  FETCH_DETAIL_SUCCESS: FETCH_DETAIL_SUCCESS$1,
  FETCH_DETAIL_FAILED: FETCH_DETAIL_FAILED$1,
  FETCH_LEGACY_DETAIL: FETCH_LEGACY_DETAIL,
  FETCH_LEGACY_DETAIL_SUCCESS: FETCH_LEGACY_DETAIL_SUCCESS,
  FETCH_LEGACY_DETAIL_FAILED: FETCH_LEGACY_DETAIL_FAILED,
  REORDER: REORDER,
  REORDER_SUCCESS: REORDER_SUCCESS,
  REORDER_FAILED: REORDER_FAILED,
  fetchPage: fetchPage,
  fetchPageSuccess: fetchPageSuccess,
  fetchPageFailed: fetchPageFailed,
  fetchLegacyPage: fetchLegacyPage,
  fetchLegacyPageSuccess: fetchLegacyPageSuccess,
  fetchLegacyPageFailed: fetchLegacyPageFailed,
  fetchDetail: fetchDetail$1,
  fetchDetailSuccess: fetchDetailSuccess$1,
  fetchDetailFailed: fetchDetailFailed$1,
  fetchLegacyDetail: fetchLegacyDetail,
  fetchLegacyDetailSuccess: fetchLegacyDetailSuccess,
  fetchLegacyDetailFailed: fetchLegacyDetailFailed,
  reorder: reorder,
  reorderSuccess: reorderSuccess,
  reorderFailed: reorderFailed
});

var FETCH_LIST$1 = 'auth/prescriptions/fetch_list';
var FETCH_LIST_SUCCESS$1 = 'auth/prescriptions/fetch_list_success';
var FETCH_LIST_FAILED$1 = 'auth/prescriptions/fetch_list_failed';
var FETCH_SIGNED = 'auth/prescriptions/fetch_signed';
var FETCH_SIGNED_SUCCESS = 'auth/prescriptions/fetch_signed_success';
var FETCH_SIGNED_FAILED = 'auth/prescriptions/fetch_signed_failed';
var fetchList$1 = function () { return ({
    type: FETCH_LIST$1,
}); };
var fetchListSuccess$1 = function (payload) { return ({
    type: FETCH_LIST_SUCCESS$1,
    payload: payload,
}); };
var fetchListFailed$1 = function (error) { return ({
    type: FETCH_LIST_FAILED$1,
    error: error,
}); };
var fetchSigned = function () { return ({
    type: FETCH_SIGNED,
}); };
var fetchSignedSucccess = function (payload) { return ({
    type: FETCH_SIGNED_SUCCESS,
    payload: payload,
}); };
var fetchSignedFailed = function (error) { return ({
    type: FETCH_SIGNED_FAILED,
    error: error,
}); };

var actions$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_LIST: FETCH_LIST$1,
  FETCH_LIST_SUCCESS: FETCH_LIST_SUCCESS$1,
  FETCH_LIST_FAILED: FETCH_LIST_FAILED$1,
  FETCH_SIGNED: FETCH_SIGNED,
  FETCH_SIGNED_SUCCESS: FETCH_SIGNED_SUCCESS,
  FETCH_SIGNED_FAILED: FETCH_SIGNED_FAILED,
  fetchList: fetchList$1,
  fetchListSuccess: fetchListSuccess$1,
  fetchListFailed: fetchListFailed$1,
  fetchSigned: fetchSigned,
  fetchSignedSucccess: fetchSignedSucccess,
  fetchSignedFailed: fetchSignedFailed
});

var FETCH_OPT_INS = 'privacy/fetch-opt-ins';
var FETCH_OPT_INS_SUCCESS = 'privacy/fetch-opt-ins-success';
var FETCH_OPT_INS_FAILED = 'privacy/fetch-opt-ins-failed';
var UPDATE_OPT_INS = 'privacy/update-opt-ins';
var UPDATE_OPT_INS_SUCCESS = 'privacy/update-opt-ins-success';
var UPDATE_OPT_INS_FAILED = 'privacy/update-opt-ins-failed';
var fetchOptIns$1 = function () { return ({
    type: FETCH_OPT_INS,
}); };
var fetchOptInsSuccess = function (payload) { return ({
    type: FETCH_OPT_INS_SUCCESS,
    payload: payload,
}); };
var fetchOptInsFailed = function (error) { return ({
    type: FETCH_OPT_INS_FAILED,
    error: error,
}); };
var updateOptIns$1 = function (payload) { return ({
    type: UPDATE_OPT_INS,
    payload: payload,
}); };
var updateOptInsSuccess = function () { return ({
    type: UPDATE_OPT_INS_SUCCESS,
}); };
var updateOptInsFailed = function (error) { return ({
    type: UPDATE_OPT_INS_FAILED,
    error: error,
}); };

var actions$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_OPT_INS: FETCH_OPT_INS,
  FETCH_OPT_INS_SUCCESS: FETCH_OPT_INS_SUCCESS,
  FETCH_OPT_INS_FAILED: FETCH_OPT_INS_FAILED,
  UPDATE_OPT_INS: UPDATE_OPT_INS,
  UPDATE_OPT_INS_SUCCESS: UPDATE_OPT_INS_SUCCESS,
  UPDATE_OPT_INS_FAILED: UPDATE_OPT_INS_FAILED,
  fetchOptIns: fetchOptIns$1,
  fetchOptInsSuccess: fetchOptInsSuccess,
  fetchOptInsFailed: fetchOptInsFailed,
  updateOptIns: updateOptIns$1,
  updateOptInsSuccess: updateOptInsSuccess,
  updateOptInsFailed: updateOptInsFailed
});

var FETCH_USER_DATA = 'auth/fetch-user-data';
var FETCH_USER_DATA_FAILED = 'auth/fetch-user-data-failed';
var FETCH_USER_DATA_SUCCESS = 'auth/fetch-user-data-success';
var UPDATE_USER_DATA = 'auth/update-user-data';
var UPDATE_USER_DATA_FAILED = 'auth/update-user-data-failed';
var UPDATE_USER_DATA_SUCCESS = 'auth/update-user-data-success';
var STORE_FORM_DATA = 'auth/store-form-data';
var TOGGLE_FORM_EDIT_MODE = 'auth/toggle-form-edit-mode';
var toggleFormEditMode = function (payload) { return ({
    type: TOGGLE_FORM_EDIT_MODE,
    payload: payload,
}); };
var fetchUserData$1 = function () { return ({
    type: FETCH_USER_DATA,
}); };
var fetchUserDataFailed = function (error) { return ({
    type: FETCH_USER_DATA_FAILED,
    error: error,
}); };
var fetchUserDataSuccess = function (payload) { return ({
    type: FETCH_USER_DATA_SUCCESS,
    payload: payload,
}); };
var updateUserData$1 = function (payload) { return ({
    type: UPDATE_USER_DATA,
    payload: payload,
}); };
var updateUserDataFailed = function (payload) { return ({
    type: UPDATE_USER_DATA_FAILED,
    payload: payload,
}); };
var updateUserDataSuccess = function (payload) { return ({
    type: UPDATE_USER_DATA_SUCCESS,
    payload: payload,
}); };

var actions$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_USER_DATA: FETCH_USER_DATA,
  FETCH_USER_DATA_FAILED: FETCH_USER_DATA_FAILED,
  FETCH_USER_DATA_SUCCESS: FETCH_USER_DATA_SUCCESS,
  UPDATE_USER_DATA: UPDATE_USER_DATA,
  UPDATE_USER_DATA_FAILED: UPDATE_USER_DATA_FAILED,
  UPDATE_USER_DATA_SUCCESS: UPDATE_USER_DATA_SUCCESS,
  STORE_FORM_DATA: STORE_FORM_DATA,
  TOGGLE_FORM_EDIT_MODE: TOGGLE_FORM_EDIT_MODE,
  toggleFormEditMode: toggleFormEditMode,
  fetchUserData: fetchUserData$1,
  fetchUserDataFailed: fetchUserDataFailed,
  fetchUserDataSuccess: fetchUserDataSuccess,
  updateUserData: updateUserData$1,
  updateUserDataFailed: updateUserDataFailed,
  updateUserDataSuccess: updateUserDataSuccess
});

var FETCH_DETAIL = 'auth/subscriptions/fetch-detail';
var FETCH_DETAIL_SUCCESS = 'auth/subscriptions/fetch-detail-success';
var FETCH_DETAIL_FAILED = 'auth/subscriptions/fetch-detail-failed';
var PAUSE = 'auth/subscriptions/pause';
var PAUSE_SUCCESS = 'auth/subscriptions/pause-success';
var PAUSE_FAILED = 'auth/subscriptions/pause-failed';
var QUANTITY = 'auth/subscriptions/quantity';
var QUANTITY_SUCCESS = 'auth/subscriptions/quantity-success';
var QUANTITY_FAILED = 'auth/subscriptions/quantity-failed';
var FETCH_PRODUCT_DATA = 'auth/subscriptions/fetch-product-data';
var FETCH_PRODUCT_DATA_SUCCESS = 'auth/subscriptions/fetch-product-data-success';
var FETCH_PRODUCT_DATA_FAILED = 'auth/subscriptions/fetch-product-data-failed';
var FETCH_LIST = 'auth/subscriptions/fetch-list';
var FETCH_LIST_SUCCESS = 'auth/subscriptions/fetch-list-success';
var FETCH_LIST_FAILED = 'auth/subscriptions/fetch-list-failed';
var SUBSCRIPTION_ADDRESS_UPDATE = 'auth/subscriptions/subscription-address/update';
var SUBSCRIPTION_ADDRESS_RESET = 'auth/subscriptions/subscription-address/reset';
var SUBSCRIPTION_ADDRESS_SAVE = 'auth/subscriptions/subscription-address/save';
var SUBSCRIPTION_ADDRESS_SAVE_FAILED = 'auth/subscriptions/subscription-address/save-failed';
var SUBSCRIPTION_ADDRESS_SAVE_SUCCESS = 'auth/subscriptions/subscription-address/save-success';
var SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE = 'auth/subscriptions/subscription-address/set-is-edit-mode';
var SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN = 'auth/subscriptions/subscription-address/is-modal-open';
var fetchDetail = function (payload) { return ({
    type: FETCH_DETAIL,
    payload: payload,
}); };
var fetchDetailSuccess = function (payload) { return ({
    type: FETCH_DETAIL_SUCCESS,
    payload: payload,
}); };
var fetchDetailFailed = function (error) { return ({
    type: FETCH_DETAIL_FAILED,
    error: error,
}); };
var pause = function (payload) { return ({
    type: PAUSE,
    payload: payload,
}); };
var pauseSuccess = function (payload) { return ({
    type: PAUSE_SUCCESS,
    payload: payload,
}); };
var pauseFailed = function (error) { return ({
    type: PAUSE_FAILED,
    error: error,
}); };
var quantity = function (payload) { return ({
    type: QUANTITY,
    payload: payload,
}); };
var quantitySuccess = function (payload) { return ({
    type: QUANTITY_SUCCESS,
    payload: payload,
}); };
var quantityFailed = function (payload) { return ({
    type: QUANTITY_FAILED,
    payload: payload,
}); };
var fetchProductData = function (payload) { return ({
    type: FETCH_PRODUCT_DATA,
    payload: payload,
}); };
var fetchProductDataSuccess = function (payload) { return ({
    type: FETCH_PRODUCT_DATA_SUCCESS,
    payload: payload,
}); };
var fetchProductDataFailed = function (payload) { return ({
    type: FETCH_PRODUCT_DATA_FAILED,
    payload: payload,
}); };
var fetchList = function () { return ({ type: FETCH_LIST }); };
var fetchListSuccess = function (payload) { return ({
    type: FETCH_LIST_SUCCESS,
    payload: payload,
}); };
var fetchListFailed = function (error) { return ({
    type: FETCH_LIST_FAILED,
    error: error,
}); };
var updateSubscriptionAddress = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_UPDATE,
    payload: payload,
}); };
var resetSubscriptionAddress = function () { return ({
    type: SUBSCRIPTION_ADDRESS_RESET,
}); };
var saveSubscriptionAddress = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_SAVE,
    payload: payload,
}); };
var saveSubscriptionAddressSuccess = function () { return ({
    type: SUBSCRIPTION_ADDRESS_SAVE_SUCCESS,
}); };
var saveSubscriptionAddressFailed = function (error) { return ({
    type: SUBSCRIPTION_ADDRESS_SAVE_FAILED,
    error: error,
}); };
var setSubscriptionFormIsModalOpen = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN,
    payload: payload,
}); };
var setSubscriptionFormIsEditMode = function (payload) { return ({
    type: SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE,
    payload: payload,
}); };

var actions$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  FETCH_DETAIL: FETCH_DETAIL,
  FETCH_DETAIL_SUCCESS: FETCH_DETAIL_SUCCESS,
  FETCH_DETAIL_FAILED: FETCH_DETAIL_FAILED,
  PAUSE: PAUSE,
  PAUSE_SUCCESS: PAUSE_SUCCESS,
  PAUSE_FAILED: PAUSE_FAILED,
  QUANTITY: QUANTITY,
  QUANTITY_SUCCESS: QUANTITY_SUCCESS,
  QUANTITY_FAILED: QUANTITY_FAILED,
  FETCH_PRODUCT_DATA: FETCH_PRODUCT_DATA,
  FETCH_PRODUCT_DATA_SUCCESS: FETCH_PRODUCT_DATA_SUCCESS,
  FETCH_PRODUCT_DATA_FAILED: FETCH_PRODUCT_DATA_FAILED,
  FETCH_LIST: FETCH_LIST,
  FETCH_LIST_SUCCESS: FETCH_LIST_SUCCESS,
  FETCH_LIST_FAILED: FETCH_LIST_FAILED,
  SUBSCRIPTION_ADDRESS_UPDATE: SUBSCRIPTION_ADDRESS_UPDATE,
  SUBSCRIPTION_ADDRESS_RESET: SUBSCRIPTION_ADDRESS_RESET,
  SUBSCRIPTION_ADDRESS_SAVE: SUBSCRIPTION_ADDRESS_SAVE,
  SUBSCRIPTION_ADDRESS_SAVE_FAILED: SUBSCRIPTION_ADDRESS_SAVE_FAILED,
  SUBSCRIPTION_ADDRESS_SAVE_SUCCESS: SUBSCRIPTION_ADDRESS_SAVE_SUCCESS,
  SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE: SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE,
  SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN: SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN,
  fetchDetail: fetchDetail,
  fetchDetailSuccess: fetchDetailSuccess,
  fetchDetailFailed: fetchDetailFailed,
  pause: pause,
  pauseSuccess: pauseSuccess,
  pauseFailed: pauseFailed,
  quantity: quantity,
  quantitySuccess: quantitySuccess,
  quantityFailed: quantityFailed,
  fetchProductData: fetchProductData,
  fetchProductDataSuccess: fetchProductDataSuccess,
  fetchProductDataFailed: fetchProductDataFailed,
  fetchList: fetchList,
  fetchListSuccess: fetchListSuccess,
  fetchListFailed: fetchListFailed,
  updateSubscriptionAddress: updateSubscriptionAddress,
  resetSubscriptionAddress: resetSubscriptionAddress,
  saveSubscriptionAddress: saveSubscriptionAddress,
  saveSubscriptionAddressSuccess: saveSubscriptionAddressSuccess,
  saveSubscriptionAddressFailed: saveSubscriptionAddressFailed,
  setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen,
  setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode
});

/*
 * UnlinkOrder actions
 */
var unlinkOrder = actions$b.action('auth/orders/unlink', actions$b.payload());
var unlinkOrderSuccess = actions$b.action('auth/orders/unlink-success');
var unlinkOrderFailed = actions$b.action('auth/orders/unlink-failed', function (error) { return ({
    error: error,
}); });
/*
 * UnlinkAppointment actions
 */
var unlinkAppointment = actions$b.action('auth/appointments/unlink', actions$b.payload());
var unlinkAppointmentSuccess = actions$b.action('auth/appointments/unlink-success');
var unlinkAppointmentFailed = actions$b.action('auth/appointments/unlink-failed', function (error) { return ({
    error: error,
}); });

var actions$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  unlinkOrder: unlinkOrder,
  unlinkOrderSuccess: unlinkOrderSuccess,
  unlinkOrderFailed: unlinkOrderFailed,
  unlinkAppointment: unlinkAppointment,
  unlinkAppointmentSuccess: unlinkAppointmentSuccess,
  unlinkAppointmentFailed: unlinkAppointmentFailed
});

var CHANGE_FORM_VALUE = 'my-account/change-form-value';
var TOGGLE_OPT_INS = 'auth/toggle-opt-ins';
var CREATE_ORDER = 'my-account/create-order';
var CREATE_ORDER_SUCCESS = 'my-account/create-order-success';
var CREATE_ORDER_FAILED = 'my-account/create-order-failed';
var toggleOptIns = function (payload) { return ({
    type: TOGGLE_OPT_INS,
    payload: payload,
}); };
var changeFormValue = function (payload) { return ({
    type: CHANGE_FORM_VALUE,
    payload: payload,
}); };
var createOrder = function (payload) { return ({
    type: CREATE_ORDER,
    payload: payload,
}); };
var createOrderSuccess = function (payload) { return ({
    type: CREATE_ORDER_SUCCESS,
    payload: payload,
}); };
var createOrderFailed = function (error) { return ({
    type: CREATE_ORDER_FAILED,
    error: error,
}); };

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddressBookActions: actions$a,
  AppointmentsActions: actions$9,
  ProfileActions: actions$3,
  PrivacyActions: actions$4,
  OrdersActions: actions$6,
  DataLayerActions: actions$7,
  SubscriptionsActions: actions$2,
  PrescriptionsActions: actions$5,
  UnlinkActions: actions$1,
  CHANGE_FORM_VALUE: CHANGE_FORM_VALUE,
  TOGGLE_OPT_INS: TOGGLE_OPT_INS,
  CREATE_ORDER: CREATE_ORDER,
  CREATE_ORDER_SUCCESS: CREATE_ORDER_SUCCESS,
  CREATE_ORDER_FAILED: CREATE_ORDER_FAILED,
  toggleOptIns: toggleOptIns,
  changeFormValue: changeFormValue,
  createOrder: createOrder,
  createOrderSuccess: createOrderSuccess,
  createOrderFailed: createOrderFailed
});

var getMyAccount = function (state) { return state.myAccount; };
var getUnlinkAppointmentCall = createSelector(getMyAccount, function (myAccount) { return myAccount.unlinkAppointmentCall; });
var getUnlinkOrderCall = createSelector(getMyAccount, function (myAccount) { return myAccount.unlinkOrderCall; });

var ViewMode;
(function (ViewMode) {
    ViewMode["ADD"] = "ADD";
    ViewMode["DELETE"] = "DELETE";
    ViewMode["EDIT"] = "EDIT";
})(ViewMode || (ViewMode = {}));

var getAddressBook = createSelector(Selectors.getAuth, getMyAccount, function (auth, myAccount) {
    return State.isLoggedIn(auth) ? myAccount.addressBook : undefined;
});
var getAddressBookList = createSelector(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.list : uninitState();
});
var getAddressBookListLength = createSelector(getAddressBook, function (addressBook) {
    return addressBook && statusSuccess(addressBook.list) ? addressBook.list.result.length : undefined;
});
var getAddCall = createSelector(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.calls.add : idleState();
});
var getEditCall = createSelector(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.calls.edit : idleState();
});
var getModalState = createSelector(getAddressBook, function (addressBook) {
    return addressBook ? addressBook.modalState : { isOpen: false, viewMode: ViewMode.ADD };
});
var getEditedAddress = createSelector(getAddressBook, function (addressBook) {
    return (addressBook === null || addressBook === void 0 ? void 0 : addressBook.currentlyEditingId)
        ? addressBook === null || addressBook === void 0 ? void 0 : addressBook.pendingListChanges[addressBook.currentlyEditingId]
        : undefined;
});

var selectors = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getAddressBook: getAddressBook,
  getAddressBookList: getAddressBookList,
  getAddressBookListLength: getAddressBookListLength,
  getAddCall: getAddCall,
  getEditCall: getEditCall,
  getModalState: getModalState,
  getEditedAddress: getEditedAddress
});

var isProfileForm = function (formName) {
    if (typeof formName === 'string') {
        return formName in Types.FormName;
    }
    return formName.formName in Types.FormName;
};

var state$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  isProfileForm: isProfileForm
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

// Strips out all falsy values so the formatter can handle it.
var sanitizeAddress = function (_a) {
    _a.addressTypes; var rest = __rest(_a, ["addressTypes"]);
    return Object.entries(rest).reduce(function (a, _a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        return (v ? ((a[k] = v), a) : a);
    }, {});
};

var sortAddresses = function (list) {
    return list
        .map(function (address) { return (__assign(__assign({}, address), { createdAt: address.createdAt || '0' })); })
        .sort(function (a, b) {
        return b.createdAt.localeCompare(a.createdAt, 'en', {
            usage: 'sort',
            numeric: true,
        });
    })
        .sort(function (a, b) { return b.addressTypes.length - a.addressTypes.length; });
};

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  sanitizeAddress: sanitizeAddress,
  sortAddresses: sortAddresses
});

var initialState$9 = {
    list: uninitState(),
    pendingListChanges: {},
    calls: {
        add: idleState(),
        edit: idleState(),
    },
    modalState: {
        isOpen: false,
        viewMode: ViewMode.ADD,
    },
};
var getList = function (list) {
    return statusSuccess(list) ? list.result : [];
};
var pushNewAddress = function (prevList, newAddress) {
    if (newAddress.addressTypes.length) {
        prevList = prevList.map(function (item) {
            if (item.addressTypes.length) {
                var addressTypes = item.addressTypes.filter(function (addressType) { return !newAddress.addressTypes.includes(addressType); });
                return __assign(__assign({}, item), { addressTypes: addressTypes });
            }
            return item;
        });
    }
    return sortAddresses(__spreadArray(__spreadArray([], __read(prevList)), [newAddress]));
};
var addressBookReducer = reducer$3(initialState$9, 
/**
 * Fetch address book
 */
actions$b.on(fetchList$2, function (state) { return (__assign(__assign({}, state), { list: loadingState() })); }), actions$b.on(fetchListFailed$2, function (state, action) { return (__assign(__assign({}, state), { list: failedState(action.error) })); }), actions$b.on(fetchListSuccess$2, function (state, action) { return (__assign(__assign({}, state), { list: successState(sortAddresses(action.payload)) })); }), 
/**
 * Toggle modal
 */
actions$b.on(toggleModal, function (state, _a) {
    var payload = _a.payload;
    return (__assign(__assign({}, state), { modalState: __assign(__assign({}, state.modalState), payload), calls: __assign({}, initialState$9.calls) }));
}), 
/**
 * Add address
 */
actions$b.on(addAddress, function (state) { return (__assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { add: loadingState() }) })); }), actions$b.on(addAddressFailed, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { add: failedState(error) }) }));
}), actions$b.on(addAddressSuccess, function (state, _a) {
    var newAddress = _a.payload;
    var prevList = getList(state.list);
    var newAddresses = pushNewAddress(prevList, newAddress);
    return __assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { add: idleState() }), list: successState(newAddresses), modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
}), 
/**
 * Delete address
 */
actions$b.on(deleteAddress, function (state, _a) {
    var _b;
    var id = _a.payload;
    var prevList = getList(state.list);
    var removedItem = prevList.find(function (item) { return item.id === id; });
    return __assign(__assign({}, state), { pendingListChanges: (_b = {}, _b[id] = removedItem, _b), currentlyEditingId: id, modalState: {
            isOpen: true,
            viewMode: ViewMode.DELETE,
        } });
}), actions$b.on(deleteAddressConfirm, function (state) {
    var prevList = getList(state.list);
    return __assign(__assign({}, state), { list: successState(__spreadArray([], __read(prevList.filter(function (item) { return item.id !== state.currentlyEditingId; })))), currentlyEditingId: undefined, modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
}), actions$b.on(deleteAddressSuccess, function (state, _a) {
    var id = _a.payload;
    var _b = state.pendingListChanges, _c = id; _b[_c]; var restPendingChanges = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
    return __assign(__assign({}, state), { pendingListChanges: restPendingChanges });
}), actions$b.on(deleteAddressFailed, function (state, _a) {
    var id = _a.id;
    if (id) {
        var prevList = getList(state.list);
        var _b = state.pendingListChanges, _c = id, pendingItem = _b[_c], restPendingChanges = __rest(_b, [typeof _c === "symbol" ? _c : _c + ""]);
        return __assign(__assign({}, state), { list: successState(sortAddresses(__spreadArray(__spreadArray([], __read(prevList)), [pendingItem]))), pendingListChanges: restPendingChanges });
    }
    else {
        return __assign(__assign({}, state), { modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
    }
}), 
/**
 * Edit address
 */
actions$b.on(editAddress, function (state, _a) {
    var _b;
    var id = _a.payload;
    var prevList = getList(state.list);
    var editedItem = prevList.find(function (item) { return item.id === id; });
    return __assign(__assign({}, state), { pendingListChanges: (_b = {}, _b[id] = editedItem, _b), currentlyEditingId: id, modalState: {
            isOpen: true,
            viewMode: ViewMode.EDIT,
        } });
}), actions$b.on(editAddressSave, function (state) {
    return __assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { edit: loadingState() }) });
}), actions$b.on(editAddressSuccess, function (state, _a) {
    var editedFields = _a.payload;
    var prevList = getList(state.list).filter(function (item) { return item.id !== state.currentlyEditingId; });
    var editedAddress = __assign(__assign({}, state.pendingListChanges[state.currentlyEditingId || 0]), editedFields);
    var newAddresses = pushNewAddress(prevList, editedAddress);
    return __assign(__assign({}, state), { list: successState(newAddresses), calls: __assign(__assign({}, state.calls), { edit: idleState() }), modalState: __assign(__assign({}, state.modalState), { isOpen: false }) });
}), actions$b.on(editAddressFailed, function (state, _a) {
    var error = _a.error;
    return __assign(__assign({}, state), { calls: __assign(__assign({}, state.calls), { edit: failedState(error) }), modalState: state.modalState });
}));

var initialState$8 = {
    storeCall: idleState(),
    cancelCall: idleState(),
    currentStore: undefined,
};
var appointmentsReducer = reducer$3(initialState$8, 
/**
 * fetchStore
 */
actions$b.on(fetchStore, function (state) { return (__assign(__assign({}, state), { storeCall: loadingState() })); }), actions$b.on(fetchStoreFailed, function (state, action) { return (__assign(__assign({}, state), { storeCall: failedState(action.error) })); }), actions$b.on(fetchStoreSuccess, function (state, action) { return (__assign(__assign({}, state), { storeCall: idleState(), currentStore: action.payload })); }), 
/**
 * cancel
 */
actions$b.on(cancel, function (state) { return (__assign(__assign({}, state), { cancelCall: loadingState() })); }), actions$b.on(cancelFailed, function (state, action) { return (__assign(__assign({}, state), { cancelCall: failedState(action.error) })); }), actions$b.on(cancelSuccess, function (state) { return (__assign(__assign({}, state), { cancelCall: idleState() })); }));

var initialState$7 = {
    historyCall: idleState(),
    legacyHistoryCall: idleState(),
    detailCall: idleState(),
    legacyDetailCall: idleState(),
    reorderCall: idleState(),
};
function ordersReducer(state, action) {
    if (state === void 0) { state = initialState$7; }
    switch (action.type) {
        case FETCH_PAGE:
            return __assign(__assign({}, state), { historyCall: loadingState() });
        case FETCH_PAGE_FAILED:
            return __assign(__assign({}, state), { historyCall: failedState(action.error) });
        case FETCH_PAGE_SUCCESS: {
            var currentPages = state.history ? state.history.pages : [];
            return __assign(__assign({}, state), { historyCall: idleState(), history: {
                    total: action.payload.total,
                    pages: __spreadArray(__spreadArray([], __read(currentPages)), [action.payload.page]),
                    size: action.payload.limit,
                } });
        }
        case FETCH_LEGACY_PAGE:
            return __assign(__assign({}, state), { legacyHistoryCall: loadingState() });
        case FETCH_LEGACY_PAGE_FAILED:
            return __assign(__assign({}, state), { legacyHistoryCall: failedState(action.error) });
        case FETCH_LEGACY_PAGE_SUCCESS: {
            var currentPages = state.legacyHistory ? state.legacyHistory.pages : [];
            return __assign(__assign({}, state), { legacyHistoryCall: idleState(), legacyHistory: {
                    total: action.payload.total,
                    pages: __spreadArray(__spreadArray([], __read(currentPages)), [action.payload.page]),
                    size: action.payload.limit,
                } });
        }
        case FETCH_DETAIL$1:
            var detail = state.detail;
            /* Reset detail data when it's for a different order. We still want to re-fetch
             * the order because it might have been updated since the last fetch.
             * We can still display the old data until the new data is fetched though
             * so we will just replace it when the call succeeds but until then we leave the old data
             */
            if (detail && detail.orderNumber !== action.payload.orderNumber) {
                detail = undefined;
            }
            return __assign(__assign({}, state), { detailCall: loadingState(), detail: detail });
        case FETCH_DETAIL_FAILED$1:
            return __assign(__assign({}, state), { detailCall: failedState(action.error), detail: undefined });
        case FETCH_DETAIL_SUCCESS$1:
            return __assign(__assign({}, state), { detailCall: idleState(), detail: action.payload });
        case FETCH_LEGACY_DETAIL:
            var legacyDetail = state.legacyDetail;
            /* Reset detail data when it's for a different order. We still want to re-fetch
             * the order because it might have been updated since the last fetch.
             * We can still display the old data until the new data is fetched though
             * so we will just replace it when the call succeeds but until then we leave the old data
             */
            if (legacyDetail && legacyDetail.orderNumber !== action.payload.orderNumber) {
                legacyDetail = undefined;
            }
            return __assign(__assign({}, state), { legacyDetailCall: loadingState(), legacyDetail: legacyDetail });
        case FETCH_LEGACY_DETAIL_FAILED:
            return __assign(__assign({}, state), { legacyDetailCall: failedState(action.error), legacyDetail: undefined });
        case FETCH_LEGACY_DETAIL_SUCCESS:
            return __assign(__assign({}, state), { legacyDetailCall: idleState(), legacyDetail: action.payload });
        case REORDER:
            return __assign(__assign({}, state), { reorderCall: loadingState() });
        case REORDER_FAILED:
            return __assign(__assign({}, state), { reorderCall: failedState(action.error) });
        case REORDER_SUCCESS:
            return __assign(__assign({}, state), { reorderCall: idleState() });
        default:
            return state;
    }
}

var initialState$6 = {
    listCall: idleState(),
};
function prescriptionsReducer(state, action) {
    if (state === void 0) { state = initialState$6; }
    switch (action.type) {
        case FETCH_LIST$1:
            return __assign(__assign({}, state), { listCall: loadingState() });
        case FETCH_LIST_FAILED$1:
            return __assign(__assign({}, state), { listCall: failedState(action.error) });
        case FETCH_LIST_SUCCESS$1: {
            return __assign(__assign({}, state), { listCall: idleState(), list: action.payload });
        }
        default:
            return state;
    }
}

var initialState$5 = {
    optInsOnServer: uninitState(),
    changedOptIns: {},
    updateOptInsCall: idleState(),
};
function privacyReducer(state, action) {
    if (state === void 0) { state = initialState$5; }
    switch (action.type) {
        case FETCH_OPT_INS:
            return __assign(__assign({}, state), { optInsOnServer: loadingState() });
        case FETCH_OPT_INS_SUCCESS:
            return __assign(__assign({}, state), { optInsOnServer: successState(action.payload) });
        case FETCH_OPT_INS_FAILED:
            return __assign(__assign({}, state), { optInsOnServer: failedState(action.error) });
        case TOGGLE_OPT_INS:
            return __assign(__assign({}, state), { changedOptIns: __assign(__assign({}, state.changedOptIns), action.payload) });
        case UPDATE_OPT_INS:
            return __assign(__assign({}, state), { updateOptInsCall: loadingState() });
        case UPDATE_OPT_INS_SUCCESS:
            return __assign(__assign({}, state), { updateOptInsCall: idleState() });
        case UPDATE_OPT_INS_FAILED:
            return __assign(__assign({}, state), { updateOptInsCall: failedState(action.error) });
    }
    return state;
}

var initialState$4 = {
    forms: {},
    userData: uninitState(),
    updateCalls: {
        personalDetails: idleState(),
        billingAddress: idleState(),
        preferredStore: idleState(),
    },
};
function profileReducer(state, action) {
    var _a, _b, _c, _d, _e, _f;
    if (state === void 0) { state = initialState$4; }
    switch (action.type) {
        case CHANGE_FORM_VALUE:
            if (!isProfileForm(action.payload.form.formName)) {
                return state;
            }
            return __assign(__assign({}, state), { forms: __assign(__assign({}, state.forms), (_a = {}, _a[action.payload.form.formName] = __assign(__assign({}, state.forms[action.payload.form.formName]), { state: action.payload.form }), _a)) });
        case TOGGLE_FORM_EDIT_MODE:
            var initialFormState = state.forms[action.payload.formName];
            var internalState = initialFormState
                ? initialFormState.state
                : {
                    formState: {},
                    formValid: false,
                    formName: action.payload.formName,
                };
            var internalFormState = {
                state: internalState,
                inEditMode: action.payload.inEditMode,
            };
            return __assign(__assign({}, state), { forms: __assign(__assign({}, state.forms), (_b = {}, _b[action.payload.formName] = internalFormState, _b)) });
        case FETCH_USER_DATA:
            return __assign(__assign({}, state), { userData: loadingState() });
        case FETCH_USER_DATA_FAILED:
            return __assign(__assign({}, state), { userData: failedState(action.error) });
        case FETCH_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: successState(action.payload) });
        case UPDATE_USER_DATA:
            return __assign(__assign({}, state), { updateCalls: __assign(__assign({}, state.updateCalls), (_c = {}, _c[action.payload] = loadingState(), _c)) });
        case UPDATE_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: successState(action.payload.server), updateCalls: __assign(__assign({}, state.updateCalls), (_d = {}, _d[action.payload.formName] = idleState(), _d)), forms: __assign(__assign({}, state.forms), (_e = {}, _e[action.payload.formName] = __assign(__assign({}, state.forms[action.payload.formName]), { inEditMode: false }), _e)) });
        case UPDATE_USER_DATA_FAILED:
            return __assign(__assign({}, state), { updateCalls: __assign(__assign({}, state.updateCalls), (_f = {}, _f[action.payload.formName] = failedState(action.payload.error), _f)) });
    }
    return state;
}

var initialState$3 = {
    detailCall: idleState(),
    pauseCall: idleState(),
    quantityCall: idleState(),
    productDataCall: idleState(),
    productData: {},
    subscriptionForm: {
        state: {},
        saveFormCall: idleState(),
        isInEditMode: false,
        isModalOpen: false,
    },
    list: uninitState(),
};
var getFormState = function (address) {
    if (address === void 0) { address = {}; }
    var streetName = address.streetName, addressLine1 = address.addressLine1, addressLine2 = address.addressLine2, addressLine3 = address.addressLine3, additionalStreetInfo = address.additionalStreetInfo, additionalAddressInfo = address.additionalAddressInfo, county = address.county, region = address.region, rest = __rest(address, ["streetName", "addressLine1", "addressLine2", "addressLine3", "additionalStreetInfo", "additionalAddressInfo", "county", "region"]);
    var mappedAddress = __assign(__assign({}, rest), { streetName: streetName || addressLine1 || '', additionalStreetInfo: additionalStreetInfo || addressLine2 || '', additionalAddressInfo: additionalAddressInfo || addressLine3 || '', region: region || county || '' });
    return Util.fieldsToFormState(mappedAddress);
};
function subscriptionsReducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState$3; }
    switch (action.type) {
        case FETCH_DETAIL:
            var detail = state.detail;
            /* Reset detail data when it's for a different subscription. We still want to re-fetch
             * the subscription because it might have been updated since the last fetch.
             * We can still display the old data until the new data is fetched though
             * so we will just replace it when the call succeeds but until then we leave the old data
             */
            if (detail && detail.id !== action.payload.subscriptionId) {
                detail = undefined;
            }
            return __assign(__assign({}, state), { detailCall: loadingState(), detail: detail });
        case FETCH_DETAIL_FAILED:
            return __assign(__assign({}, state), { detailCall: failedState(action.error), detail: undefined });
        case FETCH_DETAIL_SUCCESS:
            return __assign(__assign({}, state), { detailCall: idleState(), detail: action.payload, subscriptionForm: __assign(__assign({}, state.subscriptionForm), { state: getFormState(action.payload.deliveryAddress) }) });
        case SUBSCRIPTION_ADDRESS_UPDATE:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { state: action.payload }) });
        case SUBSCRIPTION_ADDRESS_RESET:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, initialState$3.subscriptionForm), { state: getFormState((_a = state.detail) === null || _a === void 0 ? void 0 : _a.deliveryAddress) }) });
        case SUBSCRIPTION_ADDRESS_SAVE:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { saveFormCall: loadingState() }) });
        case SUBSCRIPTION_ADDRESS_SAVE_SUCCESS:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, initialState$3.subscriptionForm), { state: getFormState((_b = state.detail) === null || _b === void 0 ? void 0 : _b.deliveryAddress), isModalOpen: true }) });
        case SUBSCRIPTION_ADDRESS_SAVE_FAILED:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { saveFormCall: failedState(action.error) }) });
        case SUBSCRIPTION_ADDRESS_SET_IS_EDIT_MODE:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { isInEditMode: action.payload }) });
        case SUBSCRIPTION_ADDRESS_SET_IS_MODAL_OPEN:
            return __assign(__assign({}, state), { subscriptionForm: __assign(__assign({}, state.subscriptionForm), { isModalOpen: action.payload }) });
        case PAUSE:
            return __assign(__assign({}, state), { pauseCall: loadingState() });
        case PAUSE_FAILED:
            return __assign(__assign({}, state), { pauseCall: failedState(action.error) });
        case PAUSE_SUCCESS:
            return __assign(__assign({}, state), { pauseCall: idleState() });
        case QUANTITY:
            return __assign(__assign({}, state), { quantityCall: loadingState() });
        case QUANTITY_FAILED:
            return __assign(__assign({}, state), { quantityCall: 'reason' in action.payload ? idleState() : failedState(action.payload) });
        case QUANTITY_SUCCESS:
            return __assign(__assign({}, state), { quantityCall: idleState() });
        case FETCH_PRODUCT_DATA:
            return __assign(__assign({}, state), { productDataCall: loadingState(), productData: __assign(__assign({}, state.productData), action.payload.productIds.reduce(function (acc, id) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[id] = loadingState(), _a)));
                }, {})) });
        case FETCH_PRODUCT_DATA_FAILED:
            var _c = action.payload, error = _c.error, productData = _c.productData;
            return __assign(__assign({}, state), { productDataCall: failedState(error), productData: __assign(__assign({}, state.productData), productData) });
        case FETCH_PRODUCT_DATA_SUCCESS:
            return __assign(__assign({}, state), { productDataCall: idleState(), productData: __assign(__assign({}, state.productData), action.payload.productData) });
        case FETCH_LIST:
            return __assign(__assign({}, state), { list: loadingState() });
        case FETCH_LIST_SUCCESS:
            return __assign(__assign({}, state), { list: successState(action.payload) });
        case FETCH_LIST_FAILED:
            return __assign(__assign({}, state), { list: failedState(action.error) });
        default:
            return state;
    }
}

var initialState$2 = {
    privacy: initialState$5,
    profile: initialState$4,
    orders: initialState$7,
    subscriptions: initialState$3,
    prescriptions: initialState$6,
    appointments: initialState$8,
    addressBook: initialState$9,
    unlinkOrderCall: idleState(),
    unlinkAppointmentCall: idleState(),
};
var unlinkAppointmentReducer = function (state, action) {
    if (state === void 0) { state = initialState$2.unlinkAppointmentCall; }
    switch (action.type) {
        case unlinkAppointment.type:
            return loadingState();
        case unlinkAppointmentSuccess.type:
            return idleState();
        case unlinkAppointmentFailed.type:
            return failedState(action.error);
        default:
            return state;
    }
};
var unlinkOrderReducer = function (state, action) {
    if (state === void 0) { state = initialState$2.unlinkAppointmentCall; }
    switch (action.type) {
        case unlinkOrder.type:
            return loadingState();
        case unlinkOrderSuccess.type:
            return idleState();
        case unlinkOrderFailed.type:
            return failedState(action.error);
        default:
            return state;
    }
};
var reducer$2 = combineReducers({
    profile: profileReducer,
    privacy: privacyReducer,
    orders: ordersReducer,
    subscriptions: subscriptionsReducer,
    prescriptions: prescriptionsReducer,
    appointments: appointmentsReducer,
    addressBook: addressBookReducer,
    unlinkOrderCall: unlinkOrderReducer,
    unlinkAppointmentCall: unlinkAppointmentReducer,
});

function onFetchAddressBook() {
    var authState, customerId, accessToken, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                authState = _a.sent();
                if (!!State.isLoggedIn(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchListFailed$2(new Error('User needs to be logged in to fetch addresses')))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                customerId = authState.userId;
                _a.label = 4;
            case 4:
                _a.trys.push([4, 8, , 10]);
                return [4 /*yield*/, call(getToken)];
            case 5:
                accessToken = _a.sent();
                return [4 /*yield*/, call(Customers.Addresses.list, authState.apiUrl, { customerId: customerId, accessToken: accessToken })];
            case 6:
                result = _a.sent();
                return [4 /*yield*/, put(fetchListSuccess$2(result))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchListFailed$2(err_1))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onAddAddress(action) {
    var authState, customerId, accessToken, newAddress, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                authState = _a.sent();
                if (!!State.isLoggedIn(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(addAddressFailed(new Error('User needs to be logged in to add an address to the address book')))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                customerId = authState.userId;
                _a.label = 4;
            case 4:
                _a.trys.push([4, 8, , 10]);
                return [4 /*yield*/, call(getToken)];
            case 5:
                accessToken = _a.sent();
                return [4 /*yield*/, call(Customers.Addresses.create, authState.apiUrl, {
                        customerId: customerId,
                        accessToken: accessToken,
                        address: action.payload,
                    })];
            case 6:
                newAddress = _a.sent();
                return [4 /*yield*/, put(addAddressSuccess(newAddress))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_2 = _a.sent();
                return [4 /*yield*/, put(addAddressFailed(err_2))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onDeleteAddress(action) {
    var authState, customerId, addressId, cancel, accessToken, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                authState = _a.sent();
                if (!!State.isLoggedIn(authState)) return [3 /*break*/, 4];
                return [4 /*yield*/, call(toast.failed, 'account.addressBook.delete.authFailed')];
            case 2:
                _a.sent();
                return [4 /*yield*/, put(deleteAddressFailed(new Error('User needs to be logged in to add an address to the address book')))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                customerId = authState.userId;
                addressId = action.payload;
                return [4 /*yield*/, race({
                        cancel: take(toggleModal.type),
                        confirm: take(deleteAddressConfirm.type),
                    })];
            case 5:
                cancel = (_a.sent()).cancel;
                if (cancel) {
                    return [2 /*return*/];
                }
                _a.label = 6;
            case 6:
                _a.trys.push([6, 11, , 14]);
                return [4 /*yield*/, call(getToken)];
            case 7:
                accessToken = _a.sent();
                return [4 /*yield*/, call(Customers.Addresses.deleteAddress, authState.apiUrl, {
                        customerId: customerId,
                        accessToken: accessToken,
                        addressId: addressId,
                    })];
            case 8:
                _a.sent();
                return [4 /*yield*/, call(toast.success, 'account.addressBook.delete.success')];
            case 9:
                _a.sent();
                return [4 /*yield*/, put(deleteAddressSuccess(addressId))];
            case 10:
                _a.sent();
                return [3 /*break*/, 14];
            case 11:
                err_3 = _a.sent();
                return [4 /*yield*/, call(toast.failed, 'account.addressBook.delete.failed')];
            case 12:
                _a.sent();
                return [4 /*yield*/, put(deleteAddressFailed(err_3, addressId))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function onEditAddress(action) {
    var authState, customerId, _a, editedAddress, id, accessToken, err_4;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                authState = _b.sent();
                if (!!State.isLoggedIn(authState)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(editAddressFailed(new Error('User needs to be logged in to edit an address in the address book')))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3:
                customerId = authState.userId;
                _a = action.payload, editedAddress = _a.address, id = _a.id;
                _b.label = 4;
            case 4:
                _b.trys.push([4, 8, , 10]);
                return [4 /*yield*/, call(getToken)];
            case 5:
                accessToken = _b.sent();
                return [4 /*yield*/, call(Customers.Addresses.edit, authState.apiUrl, {
                        customerId: customerId,
                        accessToken: accessToken,
                        address: editedAddress,
                        id: id,
                    })];
            case 6:
                _b.sent();
                return [4 /*yield*/, put(editAddressSuccess(editedAddress))];
            case 7:
                _b.sent();
                return [3 /*break*/, 10];
            case 8:
                err_4 = _b.sent();
                return [4 /*yield*/, put(editAddressFailed(err_4))];
            case 9:
                _b.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
var addressBookSagas = [
    takeLatest(fetchList$2.type, onFetchAddressBook),
    takeLatest(addAddress.type, onAddAddress),
    takeLatest(deleteAddress.type, onDeleteAddress),
    takeLatest(editAddressSave.type, onEditAddress),
];

function onFetchStore(action) {
    var storeCode, apiConfig, store, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                storeCode = action.payload.storeCode;
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 1:
                apiConfig = _a.sent();
                if (!!apiConfig) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchStoreFailed(new Error('Stores API is unreachable')))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, call(Stores.getDetailsByCode, apiConfig.storesUrl, {
                    code: storeCode,
                })];
            case 4:
                store = _a.sent();
                return [4 /*yield*/, put(fetchStoreSuccess(store))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchStoreFailed(__assign({}, err_1)))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function onCancel(action) {
    var auth, token, cancellationReason, requestBody, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(cancelFailed(new Error("Can't cancel an appointment when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 7, , 9]);
                return [4 /*yield*/, call(getToken)];
            case 4:
                token = _a.sent();
                cancellationReason = action.payload.cancellationReason;
                requestBody = { cancellationReason: cancellationReason };
                return [4 /*yield*/, call(Appointments.cancel, auth.apiUrl, action.payload.id, token, requestBody)];
            case 5:
                response = _a.sent();
                return [4 /*yield*/, put(cancelSuccess(response))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _a.sent();
                return [4 /*yield*/, put(cancelFailed(__assign({}, err_2)))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function onCancelSuccess() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            // TODO: Refresh appointment list
            //yield put(Actions.AppointmentsActions.fetchList())
            return [4 /*yield*/, call(toast.success, 'account.appointment.cancel.success.toast')];
            case 1:
                // TODO: Refresh appointment list
                //yield put(Actions.AppointmentsActions.fetchList())
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var appointmentsSagas = [
    takeLatest(fetchStore.type, onFetchStore),
    takeLatest(cancel.type, onCancel),
    takeLatest(cancelSuccess.type, onCancelSuccess),
];

var mapAppointmentsForDataLayer = function (a) {
    var _a, _b;
    return ({
        appointmentId: a.id,
        appointmentType: ((_a = a.appointmentType) === null || _a === void 0 ? void 0 : _a.name) || '',
        appointmentDate: format(a.startTime, 'ddMMyyyy'),
        appointmentTime: format(a.startTime, 'HH:mm'),
        storeName: ((_b = a.store) === null || _b === void 0 ? void 0 : _b.name) || '',
    });
};
function onAppointmentsView(action) {
    var evt;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                evt = {
                    event: 'myAccount',
                    myAppointment: {
                        action: {
                            block: 'appointment overview',
                            interaction: 'view',
                            appointments: action.payload.appointments.map(mapAppointmentsForDataLayer),
                        },
                    },
                };
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(evt))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onGenericAppointmentAction(actionType, action) {
    var evt;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                evt = {
                    event: 'myAccount',
                    myAppointment: {
                        action: __assign({ block: 'appointment', interaction: actionType }, mapAppointmentsForDataLayer(action.payload.appointment)),
                    },
                };
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(evt))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Main export
 */
var AppointmentsSagas = [
    takeLatest(APPOINTMENTS_VIEW, onAppointmentsView),
    takeLatest(UPCOMING_APPOINTMENT_VIEW, onGenericAppointmentAction, 'view'),
    takeLatest(RESCHEDULE_APPOINTMENT, onGenericAppointmentAction, 'reschedule'),
    takeLatest(CANCEL_APPOINTMENT, onGenericAppointmentAction, 'cancel'),
];

var DOWNLOAD_PRESCRIPTION = 'my-account/datalayer/download-prescription';
var downloadPrescription = function () { return ({
    type: DOWNLOAD_PRESCRIPTION,
}); };

function onDownloadPrescription() {
    var evt;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                evt = {
                    event: 'myAccount',
                    myPrescriptions: {
                        action: {
                            block: 'prescriptions',
                            interaction: 'download',
                        },
                    },
                };
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(evt))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/**
 * Main export
 */
var PrescriptionsSagas = [takeLatest(DOWNLOAD_PRESCRIPTION, onDownloadPrescription)];

function onOrderDetailsView(action) {
    var _a, orderId, orderDate, paymentStatus, shippingStatus, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, orderId = _a.orderId, orderDate = _a.orderDate, paymentStatus = _a.paymentStatus, shippingStatus = _a.shippingStatus;
                if (!orderId || !orderDate)
                    throw new Error('Can not construct a meaningful event');
                data = makeOrderEvent('order details', 'view', orderId, orderDate, paymentStatus, shippingStatus);
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onTraceOrder(action) {
    var _a, orderId, orderDate, paymentStatus, shippingStatus, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, orderId = _a.orderId, orderDate = _a.orderDate, paymentStatus = _a.paymentStatus, shippingStatus = _a.shippingStatus;
                if (!orderId || !orderDate)
                    throw new Error('Can not construct a meaningful event');
                data = makeOrderEvent('product list', 'follow order', orderId, orderDate, paymentStatus, shippingStatus);
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onOrderItemSelect(action) {
    var _a, select, orderId, orderDate, paymentStatus, shippingStatus, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, select = _a.select, orderId = _a.orderId, orderDate = _a.orderDate, paymentStatus = _a.paymentStatus, shippingStatus = _a.shippingStatus;
                if (!orderId || !orderDate)
                    throw new Error('Can not construct a meaningful event');
                data = makeOrderEvent('product list', select ? 'select' : 'unselect', orderId, orderDate, paymentStatus, shippingStatus);
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function onReorder$1(action) {
    var _a, currencyCode, id, lineItems, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload, currencyCode = _a.currencyCode, id = _a.id, lineItems = _a.lineItems;
                if (!currencyCode || !id || !lineItems || lineItems.length === 0)
                    throw new Error('Can not construct a meaningful event');
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent({ atfEcommerce: null }))];
            case 1:
                _b.sent();
                data = makeReorderEvent(currencyCode, id, lineItems);
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 2:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function makeReorderEvent(currencyCode, id, lineItems, prescriptionGlassesLineItems) {
    var products = DataLayer.DataLayerUtils.mapLineItemToDataLayerProductObjects(lineItems, prescriptionGlassesLineItems).map(function (product) { return (__assign(__assign({}, product), { dimension150: 'reorder: partial', dimension140: product ? product.id : 'n/a' })); });
    return {
        event: 'gvAddToCart',
        atfEcommerce: {
            ecommerce: {
                currencyCode: currencyCode,
                cart: { id: id },
                add: { products: products },
            },
        },
    };
}
function makeOrderEvent(block, interaction, orderId, orderDate, paymentStatus, shippingStatus) {
    return {
        event: 'myAccount',
        myOrders: {
            action: {
                block: block,
                interaction: interaction,
                orderId: orderId,
                orderDate: "" + format(orderDate, "ddMMyyyy"),
                paymentStatus: paymentStatus || 'n/a',
                shippingStatus: shippingStatus || 'n/a',
            },
        },
    };
}
/**
 * Main export
 */
var OrderSagas = [
    takeLatest(ORDER_DETAILS_VIEW, onOrderDetailsView),
    takeLatest(TRACE_ORDER, onTraceOrder),
    takeLatest(ORDER_ITEM_SELECT, onOrderItemSelect),
    takeLatest(ORDER_REORDER, onReorder$1),
];

var getUserId = function (authState) { return authState.userId.split('|')[1]; }; // id in format <proivder>|<auth0id>
function createUser(authState) {
    if (State.isUninitialized(authState)) {
        throw new Error('Can not build meaningful user data when unintialized');
    }
    if (State.isLoggedIn(authState)) {
        return {
            id: {
                auth0: getUserId(authState),
                auth0_email: authState.email,
            },
            loginStatus: true,
        };
    }
    else {
        return {
            id: {
                auth0: '',
                auth0_email: '',
            },
            loginStatus: false,
        };
    }
}

function onPageView(action) {
    var auth, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)
                // can't do anything meaningful without auth data
            ];
            case 1:
                auth = _a.sent();
                // can't do anything meaningful without auth data
                if (State.isUninitialized(auth)) {
                    return [2 /*return*/];
                }
                data = makePageView(auth, action.payload.currentRoute);
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function makePageView(authState, currentRoute) {
    return {
        event: 'init_data_loaded',
        page: {
            type: "account - " + currentRoute,
        },
        user: createUser(authState),
    };
}
/**
 * Main export
 */
var PageViewSagas = [takeLatest(PAGE_VIEW, onPageView)];

function onPasswordChangeSucсess() {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = makePasswordChange('success');
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onPasswordChangeError(action) {
    var error, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                error = action.error;
                data = makePasswordChange('error', makeDescriptiveErrorMessage(error));
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function makeDescriptiveErrorMessage(error) {
    if (typeof error === 'string') {
        return error;
    }
    return "" + (error ? error.statusCode : '');
}
function makePasswordChange(status, errorCode) {
    return {
        event: 'myAccount',
        myProfile: {
            action: __assign({ block: 'password change', interaction: 'edit', status: status }, (errorCode && { errorCode: errorCode })),
        },
    };
}
/**
 * Main export
 */
var PasswordChangeSagas = [
    takeLatest(Actions$2.ResetPasswordActions.CHANGE_PASSWORD_SUCCESS, onPasswordChangeSucсess),
    takeLatest(Actions$2.ResetPasswordActions.CHANGE_PASSWORD_FAILED, onPasswordChangeError),
];

function onProfileEditSuccess() {
    var data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                data = makeProfileEdit('success');
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onProfileEditError(action) {
    var _a, error, data;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = action.payload.error, error = _a === void 0 ? { message: 'error' } : _a;
                data = makeProfileEdit(error.message);
                return [4 /*yield*/, put(DataLayer.Actions.pushEvent(data))];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function makeProfileEdit(status) {
    return {
        event: 'myAccount',
        myProfile: {
            action: {
                block: 'personal details',
                interaction: 'edit',
                status: status,
            },
        },
    };
}
/**
 * Main export
 */
var MyProfileSagas = [
    takeLatest(PROFILE_EDIT_SUCCESS, onProfileEditSuccess),
    takeLatest(PROFILE_EDIT_ERROR, onProfileEditError),
];

var dataLayerSagas = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(PageViewSagas)), __read(MyProfileSagas)), __read(PasswordChangeSagas)), __read(OrderSagas)), __read(AppointmentsSagas)), __read(PrescriptionsSagas));

function getStoreResult(apiConfig, storeId) {
    if (!apiConfig || !storeId) {
        return;
    }
    /**
     * We want to still show the prescription (without store name if this call fails. So we catch the error and don't
     * extend the prescription with store detail data, but don't send the use into a different flow.
     */
    return Stores.getDetailsByCode(apiConfig.storesUrl, {
        code: storeId,
    }).catch(console.error);
}
function onFetchList$1() {
    var auth, apiConfig_1, token, response, storeFetchResults, storeResponse_1, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchListFailed$1(new Error("Can't fetch prescriptions when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 11, , 13]);
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 4:
                apiConfig_1 = _a.sent();
                if (!!apiConfig_1) return [3 /*break*/, 6];
                return [4 /*yield*/, put(fetchListFailed$1({
                        message: "Can't fetch stores without API Config",
                    }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6: return [4 /*yield*/, call(getToken)];
            case 7:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.Prescriptions.list, auth.apiUrl, token, {
                        customerId: auth.userId,
                    })
                    // Build store fetch call effects
                ];
            case 8:
                response = _a.sent();
                storeFetchResults = response.reduce(function (m, prescription) {
                    var _a;
                    if (!prescription.storeId) {
                        return m;
                    }
                    return __assign(__assign({}, m), (_a = {}, _a[prescription.storeId] = call(getStoreResult, apiConfig_1, prescription.storeId), _a));
                }, {});
                return [4 /*yield*/, all(storeFetchResults)
                    // Add store name to prescription
                ];
            case 9:
                storeResponse_1 = _a.sent();
                result = response.map(function (prescription) {
                    var _a;
                    return (__assign(__assign({}, prescription), { storeName: prescription.storeId && ((_a = storeResponse_1[prescription.storeId]) === null || _a === void 0 ? void 0 : _a.storeName) }));
                });
                return [4 /*yield*/, put(fetchListSuccess$1(result))];
            case 10:
                _a.sent();
                return [3 /*break*/, 13];
            case 11:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchListFailed$1(__assign({}, err_1)))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function onFetchSigned() {
    var auth, token, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchSignedFailed(new Error("Can't fetch signed prescriptions when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 7, , 9]);
                return [4 /*yield*/, call(getToken)];
            case 4:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.Prescriptions.signedPrescriptions, auth.apiUrl, token, {
                        customerId: auth.userId,
                    })];
            case 5:
                response = _a.sent();
                return [4 /*yield*/, put(fetchSignedSucccess(response.prescriptionTokens))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_2 = _a.sent();
                return [4 /*yield*/, put(fetchSignedFailed(__assign({}, err_2)))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function getSignedTokens(accessToken, timeout) {
    var _a, success, timedOut;
    if (timeout === void 0) { timeout = 30000; }
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, put(fetchSigned())];
            case 1:
                _b.sent();
                return [4 /*yield*/, race({
                        success: take(FETCH_SIGNED_SUCCESS),
                        failed: take(FETCH_SIGNED_FAILED),
                        timedOut: delay(timeout),
                    })];
            case 2:
                _a = _b.sent(), success = _a.success, timedOut = _a.timedOut;
                if (success) {
                    return [2 /*return*/, success.payload];
                }
                if (timedOut) {
                    console.error("Fetching signed prescription failed because the request exceeded timeout of " + timeout);
                }
                return [2 /*return*/, []];
        }
    });
}
var prescriptionsSagas = [
    takeLatest(FETCH_LIST$1, onFetchList$1),
    takeLatest(FETCH_SIGNED, onFetchSigned),
];

var getOrders = createSelector(Selectors.getAuth, getMyAccount, function (auth, myAccount) {
    return State.isLoggedIn(auth) ? myAccount.orders : undefined;
});
var getOrderHistory = createSelector(getOrders, function (orders) { return (orders ? orders.history : undefined); });
var getLegacyOrderHistory = createSelector(getOrders, function (orders) { return (orders ? orders.legacyHistory : undefined); });
var getOrderHistoryCall = createSelector(getOrders, function (orders) { return (orders ? orders.historyCall : idleState()); });
var getLegacyOrderHistoryCall = createSelector(getOrders, function (orders) {
    return orders ? orders.legacyHistoryCall : idleState();
});
var getOrderDetail = createSelector(getOrders, function (orders) {
    return orders ? orders.detail : undefined;
});
var getOrderDetailCall = createSelector(getOrders, function (orders) { return (orders ? orders.detailCall : idleState()); });
var getLegacyOrderDetail = createSelector(getOrders, function (orders) { return (orders ? orders.legacyDetail : undefined); });
var getLegacyOrderDetailCall = createSelector(getOrders, function (orders) {
    return orders ? orders.legacyDetailCall : idleState();
});
var getReorderCall = createSelector(getOrders, function (orders) { return (orders ? orders.reorderCall : idleState()); });

function onFetchPageSaga(action, listApi, fetchPageSuccess, fetchPageFailed$1) {
    var auth, apiConfig, token, orderResponse, history_1, serverTotal, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to fetch orders.');
                }
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(fetchPageFailed(new Error("Can't fetch orders when user isn't logged-in")))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                _a.trys.push([4, 11, , 14]);
                return [4 /*yield*/, call(getToken)];
            case 5:
                token = _a.sent();
                return [4 /*yield*/, call(listApi, apiConfig.ordersUrl, token, {
                        customerId: auth.userId,
                        limit: action.payload.limit,
                        offset: action.payload.skip,
                    })];
            case 6:
                orderResponse = _a.sent();
                return [4 /*yield*/, select(getOrderHistory)];
            case 7:
                history_1 = _a.sent();
                serverTotal = orderResponse.total;
                if (!(history_1 && history_1.total !== serverTotal)) return [3 /*break*/, 9];
                return [4 /*yield*/, call(toast.info, 'account.orders.history.outOfSync')];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9: return [4 /*yield*/, put(fetchPageSuccess({
                    page: orderResponse.orders,
                    total: orderResponse.total,
                    limit: action.payload.limit,
                }))];
            case 10:
                _a.sent();
                return [3 /*break*/, 14];
            case 11:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchPageFailed$1(__assign({}, err_1)))];
            case 12:
                _a.sent();
                return [4 /*yield*/, call(toast.failed, 'account.fetchOrders.failed')];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function onPageFetch(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onFetchPageSaga, action, Orders$2.list, fetchPageSuccess, fetchPageFailed)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onLegacyPageFetch(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onFetchPageSaga, action, Orders$2.legacyList, fetchLegacyPageSuccess, fetchLegacyPageFailed)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onFetchDetailSaga(action, detailsApi, fetchDetailSuccess, fetchDetailFailed) {
    var auth, apiConfig, token, orderResponse, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to fetch orders.');
                }
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 4];
                return [4 /*yield*/, put(fetchDetailFailed$1(new Error("Can't fetch order detail when user isn't logged-in")))];
            case 3:
                _a.sent();
                return [2 /*return*/];
            case 4:
                _a.trys.push([4, 8, , 10]);
                return [4 /*yield*/, call(getToken)];
            case 5:
                token = _a.sent();
                return [4 /*yield*/, call(detailsApi, apiConfig.ordersUrl, token, {
                        customerId: auth.userId,
                        orderId: action.payload.orderNumber,
                    })];
            case 6:
                orderResponse = _a.sent();
                return [4 /*yield*/, put(fetchDetailSuccess(orderResponse.order))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_2 = _a.sent();
                return [4 /*yield*/, put(fetchDetailFailed(__assign({}, err_2)))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onDetailFetch$1(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onFetchDetailSaga, action, Orders$2.details, fetchDetailSuccess$1, fetchDetailFailed$1)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onLegacyDetailFetch(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(onFetchDetailSaga, action, Orders$2.legacyDetails, fetchLegacyDetailSuccess, fetchLegacyDetailFailed)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onReorder(action) {
    var auth, _a, locale, country, currency, drafts, cartDraft, accessToken, tokens, _b, failed, success, timeout, _c, totalPrice, id, lineItems, prescriptionGlassesLineItems, checkoutRoute, message, err_3;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _d.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(reorderFailed(new Error("Can't reorder when user isn't logged-in")))];
            case 2:
                _d.sent();
                return [2 /*return*/];
            case 3:
                _d.trys.push([3, 20, , 22]);
                _a = action.payload, locale = _a.locale, country = _a.country, currency = _a.currency, drafts = _a.drafts;
                return [4 /*yield*/, call(Utils$1.parseAddToCartPayload, __assign(__assign({}, drafts), { currency: currency, country: country, locale: locale }))];
            case 4:
                cartDraft = _d.sent();
                if (!auth.putPrescriptionTokensOnCart) return [3 /*break*/, 7];
                return [4 /*yield*/, call(getToken)];
            case 5:
                accessToken = _d.sent();
                return [4 /*yield*/, call(getSignedTokens, accessToken)];
            case 6:
                tokens = _d.sent();
                if (Array.isArray(tokens) && tokens.length) {
                    cartDraft = __assign(__assign({}, cartDraft), { custom: __assign(__assign({}, cartDraft.custom), { fields: __assign(__assign({}, cartDraft.custom.fields), { prescriptionSignatures: JSON.stringify(tokens) }) }) });
                }
                _d.label = 7;
            case 7: return [4 /*yield*/, put(ReduxDataSource.Actions.createCart({ cartDraft: cartDraft }))];
            case 8:
                _d.sent();
                return [4 /*yield*/, race({
                        failed: take(ReduxDataSource.Actions.CART_FAILED),
                        success: take(ReduxDataSource.Actions.CART_SUCCESS),
                        timeout: delay(3000),
                    })];
            case 9:
                _b = _d.sent(), failed = _b.failed, success = _b.success, timeout = _b.timeout;
                if (!success) return [3 /*break*/, 15];
                _c = success.payload.result, totalPrice = _c.totalPrice, id = _c.id, lineItems = _c.lineItems, prescriptionGlassesLineItems = _c.prescriptionGlassesLineItems;
                return [4 /*yield*/, put(orderReorder(totalPrice.currencyCode, id, lineItems, prescriptionGlassesLineItems))];
            case 10:
                _d.sent();
                return [4 /*yield*/, put(reorderSuccess())];
            case 11:
                _d.sent();
                return [4 /*yield*/, select(Selectors.getCheckoutRoute)];
            case 12:
                checkoutRoute = _d.sent();
                if (!checkoutRoute) return [3 /*break*/, 14];
                return [4 /*yield*/, call(Utils.redirect, checkoutRoute)];
            case 13:
                _d.sent();
                _d.label = 14;
            case 14: return [2 /*return*/];
            case 15:
                message = '';
                if (timeout) {
                    message = 'Reorder timed out';
                }
                else if (failed) {
                    message = 'Reorder failed';
                }
                if (!message) return [3 /*break*/, 17];
                return [4 /*yield*/, put(reorderFailed({ message: message }))];
            case 16:
                _d.sent();
                return [3 /*break*/, 19];
            case 17: return [4 /*yield*/, put(reorderFailed({
                    message: 'Reorder failed for an unknown reason',
                }))];
            case 18:
                _d.sent();
                _d.label = 19;
            case 19: return [3 /*break*/, 22];
            case 20:
                err_3 = _d.sent();
                return [4 /*yield*/, put(reorderFailed(__assign({}, err_3)))];
            case 21:
                _d.sent();
                return [3 /*break*/, 22];
            case 22: return [2 /*return*/];
        }
    });
}
var ordersSagas = [
    takeLatest(FETCH_PAGE, onPageFetch),
    takeLatest(FETCH_LEGACY_PAGE, onLegacyPageFetch),
    takeLatest(FETCH_DETAIL$1, onDetailFetch$1),
    takeLatest(FETCH_LEGACY_DETAIL, onLegacyDetailFetch),
    takeLatest(REORDER, onReorder),
];

var createOptInsUpdate = function (optIns) {
    if (optIns === void 0) { optIns = {}; }
    return Object.keys(optIns).reduce(function (m, optInName) {
        var _a;
        return (__assign(__assign({}, m), (_a = {}, _a[optInName] = {
            value: optIns[optInName].checked,
            uiType: 'checkbox',
            literalText: optIns[optInName].label,
        }, _a)));
    }, {});
};

var getPrivacy = createSelector(Selectors.getAuth, getMyAccount, function (auth, myAccount) {
    return State.isLoggedIn(auth) ? myAccount.privacy : undefined;
});
var getChangedOptIns = createSelector(getPrivacy, function (privacy) { return (privacy ? privacy.changedOptIns : {}); });
var getOptInsOnServer = createSelector(getPrivacy, function (privacy) {
    return privacy ? privacy.optInsOnServer : uninitState();
});
var getUpdateOptInsCall = createSelector(getPrivacy, function (privacy) {
    return privacy ? privacy.updateOptInsCall : idleState();
});

function fetchOptIns() {
    var auth, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!State.isLoggedIn(auth)) {
                    throw new Error("Can't fetch opt-ins when user isn't logged in");
                }
                return [4 /*yield*/, call([optIns, 'fetch'], auth.apiUrl, auth.userId)];
            case 2:
                result = _a.sent();
                return [4 /*yield*/, put(fetchOptInsSuccess(result))];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchOptInsFailed(err_1))];
            case 5:
                _a.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function updateOptIns(action) {
    var auth, changedOptIns, updates, serverOptInsState_1, diff, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 11, , 13]);
                return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!State.isLoggedIn(auth)) {
                    throw new Error("Can't fetch opt-ins when user isn't logged in");
                }
                changedOptIns = action.payload;
                if (!(changedOptIns === undefined)) return [3 /*break*/, 3];
                return [4 /*yield*/, select(getChangedOptIns)];
            case 2:
                changedOptIns = _a.sent();
                _a.label = 3;
            case 3: return [4 /*yield*/, call(createOptInsUpdate, changedOptIns)];
            case 4:
                updates = _a.sent();
                if (!(Object.keys(updates).length > 0)) return [3 /*break*/, 10];
                return [4 /*yield*/, call([optIns, 'fetch'], auth.apiUrl, auth.userId)
                    // Diff what is actually an opt-in update
                ];
            case 5:
                serverOptInsState_1 = _a.sent();
                diff = Object.entries(updates).reduce(function (acc, _a) {
                    var _b;
                    var _c = __read(_a, 2), key = _c[0], optIn = _c[1];
                    return (serverOptInsState_1.optinValues || {})[key] !== optIn.value
                        ? __assign(__assign({}, acc), (_b = {}, _b[key] = optIn, _b)) : acc;
                }, {});
                if (!(Object.keys(diff).length > 0)) return [3 /*break*/, 7];
                return [4 /*yield*/, call([optIns, 'update'], auth.apiUrl, auth.userId, diff)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [4 /*yield*/, put(updateOptInsSuccess())];
            case 8:
                _a.sent();
                return [4 /*yield*/, call(toast.success, 'account.updateOptins.success')];
            case 9:
                _a.sent();
                _a.label = 10;
            case 10: return [3 /*break*/, 13];
            case 11:
                err_2 = _a.sent();
                return [4 /*yield*/, put(updateOptInsFailed(err_2))];
            case 12:
                _a.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
var privacySagas = [
    takeLatest(FETCH_OPT_INS, fetchOptIns),
    takeLatest(UPDATE_OPT_INS, updateOptIns),
];

var getProfile = createSelector(getMyAccount, Selectors.getAuth, function (myAccount, auth) {
    return State.isLoggedIn(auth) ? myAccount.profile : undefined;
});
var getForms = createSelector(getProfile, function (profile) { return (profile && profile.forms) || {}; });
var getFormData = createSelector(getForms, function (forms) {
    return forms
        ? {
            personalDetails: forms.personalDetails
                ? Util.getValuesFromState(forms.personalDetails.state.formState)
                : {},
            billingAddress: forms.billingAddress
                ? Util.getValuesFromState(forms.billingAddress.state.formState)
                : {},
            preferredStore: forms.preferredStore
                ? Util.getValuesFromState(forms.preferredStore.state.formState)
                : {},
        }
        : {};
});
var getFormValidity = createSelector(getForms, function (forms) { return ({
    personalDetails: forms && forms.personalDetails ? forms.personalDetails.state.formValid : false,
    billingAddress: forms && forms.billingAddress ? forms.billingAddress.state.formValid : false,
    preferredStore: forms && forms.preferredStore ? forms.preferredStore.state.formValid : false,
}); });
var getUserData = createSelector(getProfile, function (profile) {
    return (profile && profile.userData) || undefined;
});
var getCallStatus = createSelector(getProfile, function (profile) {
    return (profile && profile.updateCalls) || undefined;
});

function fetchUserData() {
    var auth, token, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!State.isLoggedIn(auth)) {
                    throw new Error("Can't fetch user data when not logged in");
                }
                _a.label = 2;
            case 2:
                _a.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(getToken)];
            case 3:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.details, auth.apiUrl, token, auth.userId)];
            case 4:
                response = _a.sent();
                return [4 /*yield*/, put(fetchUserDataSuccess(response.personalDetails))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchUserDataFailed(err_1))];
            case 7:
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function updateUserData(action) {
    var formName, auth, userData, formData, updatedUserData, token, err_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                formName = action.payload;
                return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _b.sent();
                return [4 /*yield*/, select(getUserData)];
            case 2:
                userData = _b.sent();
                return [4 /*yield*/, select(getFormData)];
            case 3:
                formData = _b.sent();
                if (!State.isLoggedIn(auth)) {
                    throw new Error("Can't fetch user data when not logged in");
                }
                if (!(userData && statusSuccess(userData))) return [3 /*break*/, 13];
                updatedUserData = __assign(__assign({}, userData.result), (_a = {}, _a[formName] = formData[formName], _a));
                _b.label = 4;
            case 4:
                _b.trys.push([4, 10, , 13]);
                return [4 /*yield*/, call(getToken)];
            case 5:
                token = _b.sent();
                return [4 /*yield*/, call(Customers.updateDetails, auth.apiUrl, token, auth.userId, {
                        personalDetails: updatedUserData,
                    })];
            case 6:
                _b.sent();
                return [4 /*yield*/, put(updateUserDataSuccess({
                        server: updatedUserData,
                        formName: formName,
                    }))];
            case 7:
                _b.sent();
                return [4 /*yield*/, call(toast.success, 'account.updateProfile.success')];
            case 8:
                _b.sent();
                return [4 /*yield*/, put(profileEditSuccess())];
            case 9:
                _b.sent();
                return [3 /*break*/, 13];
            case 10:
                err_2 = _b.sent();
                return [4 /*yield*/, put(updateUserDataFailed({ error: err_2, formName: formName }))];
            case 11:
                _b.sent();
                return [4 /*yield*/, put(profileEditError(err_2))];
            case 12:
                _b.sent();
                return [3 /*break*/, 13];
            case 13: return [2 /*return*/];
        }
    });
}
function updateForm(action) {
    var formData, formNames, serverData, newFormsState;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getForms) || {}];
            case 1:
                formData = _a.sent();
                formNames = Object.keys(Types.FormName);
                serverData = action.type === UPDATE_USER_DATA_SUCCESS
                    ? action.payload.server
                    : action.payload;
                newFormsState = formNames.reduce(function (formAcc, formName) {
                    var _a;
                    var form = formData[formName];
                    var clientForm = (form && form.state) || {
                        formValid: false,
                        formName: formName,
                        formState: {},
                    };
                    var serverForm = serverData[formName];
                    if (!serverForm) {
                        console.warn('No server form');
                        return formAcc;
                    }
                    var clientFieldNames = Object.keys(clientForm.formState);
                    var serverFieldNames = Object.keys(serverForm);
                    var combinedFieldNames = Array.from(new Set(__spreadArray(__spreadArray([], __read(clientFieldNames)), __read(serverFieldNames))));
                    var newFieldValues = combinedFieldNames.reduce(function (fieldAcc, fieldName) {
                        var _a;
                        var clientFieldState = clientForm.formState[fieldName] || {
                            name: fieldName,
                            value: '',
                        };
                        var serverValue = serverForm[fieldName];
                        var value = serverValue ? serverValue.toString() : clientFieldState.value;
                        return __assign(__assign({}, fieldAcc), (_a = {}, _a[fieldName] = __assign(__assign({}, clientFieldState), { value: value }), _a));
                    }, {});
                    return __assign(__assign({}, formAcc), (_a = {}, _a[formName] = __assign(__assign({}, clientForm), { formState: newFieldValues }), _a));
                }, {});
                if (!newFormsState.personalDetails) return [3 /*break*/, 3];
                return [4 /*yield*/, put(changeFormValue({
                        form: newFormsState.personalDetails,
                    }))];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3:
                if (!newFormsState.billingAddress) return [3 /*break*/, 5];
                return [4 /*yield*/, put(changeFormValue({
                        form: newFormsState.billingAddress,
                    }))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5:
                if (!newFormsState.preferredStore) return [3 /*break*/, 7];
                return [4 /*yield*/, put(changeFormValue({
                        form: newFormsState.preferredStore,
                    }))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [2 /*return*/];
        }
    });
}
var profileSagas = [
    takeLatest(FETCH_USER_DATA, fetchUserData),
    takeLatest(UPDATE_USER_DATA, updateUserData),
    takeLatest([
        UPDATE_USER_DATA_SUCCESS,
        FETCH_USER_DATA_SUCCESS,
    ], updateForm),
];

var createProductLookup = function (productProjections) {
    var product = {};
    var variant = {};
    productProjections.forEach(function (p) {
        var variants = __spreadArray([p.masterVariant], __read(p.variants));
        variants.forEach(function (v) {
            var _a, _b;
            if (v.sku) {
                product = __assign(__assign({}, product), (_a = {}, _a[v.sku] = p, _a));
                variant = __assign(__assign({}, variant), (_b = {}, _b[v.sku] = v, _b));
            }
        });
    });
    return {
        product: product,
        variant: variant,
    };
};

var getSubscriptions = createSelector(getMyAccount, Selectors.getAuth, function (myAccount, auth) {
    return State.isLoggedIn(auth) ? myAccount.subscriptions : undefined;
});
var getSubscriptionDetail = createSelector(getSubscriptions, function (subscription) {
    return subscription ? subscription.detail : undefined;
});
var getSubscriptionForm = createSelector(getSubscriptions, function (subscription) {
    return subscription === null || subscription === void 0 ? void 0 : subscription.subscriptionForm;
});
var getSubscriptionDetailCall = createSelector(getSubscriptions, function (subscription) {
    return subscription ? subscription.detailCall : idleState();
});
var getPauseCall = createSelector(getSubscriptions, function (subscription) {
    return subscription ? subscription.pauseCall : idleState();
});
var getQuantityCall = createSelector(getSubscriptions, function (subscription) {
    return subscription ? subscription.quantityCall : idleState();
});
var getProductDataCall = createSelector(getSubscriptions, function (subscription) {
    return subscription ? subscription.productDataCall : idleState();
});
var getProductData = createSelector(getSubscriptions, function (subscription) {
    return subscription ? subscription.productData : {};
});
var getSubscriptionList = createSelector(getSubscriptions, function (subscriptions) {
    return subscriptions ? subscriptions.list : uninitState();
});

function onDetailFetch(action) {
    var auth, token, response, productIds, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchDetailFailed(new Error("Can't fetch subscription details when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 8, , 10]);
                return [4 /*yield*/, call(getToken)];
            case 4:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.Subscriptions.details, auth.apiUrl, token, {
                        customerId: auth.userId,
                        subscriptionId: action.payload.subscriptionId,
                    })];
            case 5:
                response = _a.sent();
                return [4 /*yield*/, put(fetchDetailSuccess(response))];
            case 6:
                _a.sent();
                productIds = response.lineItems.map(function (i) { return i.productId; });
                return [4 /*yield*/, put(fetchProductData({ productIds: productIds }))];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_1 = _a.sent();
                return [4 /*yield*/, put(fetchDetailFailed(__assign({}, err_1)))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
function onPause(action) {
    var auth, detail, token, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(pauseFailed(new Error("Can't update subscription pausing state when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getSubscriptionDetail)];
            case 4:
                detail = _a.sent();
                if (!detail) return [3 /*break*/, 11];
                _a.label = 5;
            case 5:
                _a.trys.push([5, 9, , 11]);
                return [4 /*yield*/, call(getToken)];
            case 6:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.Subscriptions.pause, auth.apiUrl, token, auth.userId, detail.id, action.payload)];
            case 7:
                _a.sent();
                return [4 /*yield*/, put(pauseSuccess({ subscriptionId: detail.id }))];
            case 8:
                _a.sent();
                return [3 /*break*/, 11];
            case 9:
                err_2 = _a.sent();
                return [4 /*yield*/, put(pauseFailed(__assign({}, err_2)))];
            case 10:
                _a.sent();
                return [3 /*break*/, 11];
            case 11: return [2 /*return*/];
        }
    });
}
function onPauseSuccess(action) {
    var subscriptionId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                subscriptionId = action.payload.subscriptionId;
                return [4 /*yield*/, put(fetchDetail({ subscriptionId: subscriptionId }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(toast.success, 'account.subscription.pause.success.toast')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onQuantity(action) {
    var auth, detail, quantity, subscriptionQuantity, token, err_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(quantityFailed(new Error("Can't update subscription quantity when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, select(getSubscriptionDetail)];
            case 4:
                detail = _a.sent();
                if (!detail) return [3 /*break*/, 12];
                quantity = action.payload.quantity;
                subscriptionQuantity = detail.lineItems.reduce(function (q, i) { return i.quantity; }, 0);
                if (!(quantity === subscriptionQuantity)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(quantityFailed({ reason: 'quantity_same' }))];
            case 5:
                _a.sent();
                return [2 /*return*/];
            case 6:
                _a.trys.push([6, 10, , 12]);
                return [4 /*yield*/, call(getToken)];
            case 7:
                token = _a.sent();
                return [4 /*yield*/, call(Customers.Subscriptions.quantity, auth.apiUrl, token, auth.userId, detail.id, action.payload)];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(quantitySuccess({
                        subscriptionId: detail.id,
                    }))];
            case 9:
                _a.sent();
                return [3 /*break*/, 12];
            case 10:
                err_3 = _a.sent();
                return [4 /*yield*/, put(quantityFailed(__assign({}, err_3)))];
            case 11:
                _a.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function onQuantitySuccess(action) {
    var subscriptionId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                subscriptionId = action.payload.subscriptionId;
                return [4 /*yield*/, put(fetchDetail({ subscriptionId: subscriptionId }))];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(toast.success, 'account.subscription.quantity.success.toast')];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function onQuantityFailed(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!('reason' in action.payload)) return [3 /*break*/, 2];
                return [4 /*yield*/, call(toast.info, 'account.subscription.quantity.noChange')];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}
function onFetchProductData(action) {
    var productIds, locale, auth, featureToggles, isBynderImagesEnabled, results, productData, lookup_1, succeeded_1, failed_1, error, error_1, productData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                productIds = action.payload.productIds;
                return [4 /*yield*/, select(IntlSelectors.getLocale)];
            case 1:
                locale = _a.sent();
                return [4 /*yield*/, select(Selectors.getAuth)];
            case 2:
                auth = _a.sent();
                return [4 /*yield*/, select(FeatureToggleSelectors.getFeatureToggles)];
            case 3:
                featureToggles = _a.sent();
                isBynderImagesEnabled = featureToggles.isBynderImagesEnabled;
                _a.label = 4;
            case 4:
                _a.trys.push([4, 12, , 14]);
                return [4 /*yield*/, call(Products.query, auth.apiUrl + "/products", {
                        filters: ["variants.sku:" + encodeURIComponent(productIds.map(function (id) { return "\"" + id + "\""; }).join(','))],
                        expand: ['productType'],
                    })];
            case 5:
                results = (_a.sent()).results;
                if (!(!results || !results.length)) return [3 /*break*/, 7];
                productData = productIds.reduce(function (acc, id) {
                    var _a;
                    return (__assign(__assign({}, acc), (_a = {}, _a[id] = failedState(new Error('Did not receive any product data for this product')), _a)));
                }, {});
                return [4 /*yield*/, put(fetchProductDataFailed({
                        error: new Error("Did not receive any product data for these IDs: " + productIds.join(', ')),
                        productData: productData,
                    }))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7:
                lookup_1 = createProductLookup(results);
                succeeded_1 = {};
                failed_1 = {};
                productIds.forEach(function (id) {
                    var _a, _b, _c, _d;
                    var product = lookup_1.product[id];
                    var variant = lookup_1.variant[id];
                    if (!product || !variant) {
                        failed_1 = __assign(__assign({}, failed_1), (_a = {}, _a[id] = failedState(new Error("No data was returned for variant with ID " + id)), _a));
                        return;
                    }
                    var productTypeName = Helpers.getProductTypeName(product);
                    if (!productTypeName) {
                        failed_1 = __assign(__assign({}, failed_1), (_b = {}, _b[id] = failedState(new Error("Couldn't find productType from product with ID " + product.id + " for SKU " + id)), _b));
                    }
                    if (id in lookup_1.product && id in lookup_1.variant && productTypeName) {
                        var info = Helpers.getVariantInfo(product, productTypeName, locale || 'en-IE', variant, undefined, isBynderImagesEnabled);
                        succeeded_1 = __assign(__assign({}, succeeded_1), (_c = {}, _c[id] = successState(info), _c));
                    }
                    else {
                        failed_1 = __assign(__assign({}, failed_1), (_d = {}, _d[id] = failedState(new Error("No data was returned for variant with ID " + id)), _d));
                    }
                });
                if (!(Object.keys(succeeded_1).length > 0)) return [3 /*break*/, 9];
                return [4 /*yield*/, put(fetchProductDataSuccess({
                        productData: succeeded_1,
                    }))];
            case 8:
                _a.sent();
                _a.label = 9;
            case 9:
                if (!(Object.keys(failed_1).length > 0)) return [3 /*break*/, 11];
                error = new Error("Encountered errors for variants with the following IDs: " + Object.keys(failed_1).join(', '));
                return [4 /*yield*/, put(fetchProductDataFailed({
                        error: error,
                        productData: failed_1,
                    }))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 14];
            case 12:
                error_1 = _a.sent();
                productData = productIds.reduce(function (acc, id) {
                    var _a;
                    return (_a = {},
                        _a[id] = failedState(new Error("Encountered an error when fetching data. Error: " + error_1)),
                        _a);
                }, {});
                return [4 /*yield*/, put(fetchProductDataFailed({
                        error: error_1,
                        productData: productData,
                    }))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function onFetchList() {
    var auth, accessToken, result, err_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(fetchListFailed(new Error("Can't fetch subscription list when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 7, , 9]);
                return [4 /*yield*/, call(getToken)];
            case 4:
                accessToken = _a.sent();
                return [4 /*yield*/, call(Customers.Subscriptions.list, auth.apiUrl, {
                        customerId: auth.userId,
                        accessToken: accessToken,
                    })];
            case 5:
                result = _a.sent();
                return [4 /*yield*/, put(fetchListSuccess(result.subscriptions))];
            case 6:
                _a.sent();
                return [3 /*break*/, 9];
            case 7:
                err_4 = _a.sent();
                return [4 /*yield*/, put(fetchListFailed(err_4))];
            case 8:
                _a.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
function onSaveSubscriptionAddress(action) {
    var auth, accessToken, custom, err_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 3];
                return [4 /*yield*/, put(saveSubscriptionAddressFailed(new Error("Can't update subscription address when user isn't logged-in")))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3:
                _a.trys.push([3, 8, , 10]);
                return [4 /*yield*/, call(getToken)];
            case 4:
                accessToken = _a.sent();
                return [4 /*yield*/, select(getSubscriptionDetail)];
            case 5:
                custom = (_a.sent()).custom;
                return [4 /*yield*/, call(Customers.changeAddress, auth.apiUrl, accessToken, auth.userId, {
                        fields: Util.getValuesFromState(action.payload),
                        externalId: custom === null || custom === void 0 ? void 0 : custom.membershipId,
                        addressTypes: ['delivery-subscription'],
                    })];
            case 6:
                _a.sent();
                return [4 /*yield*/, put(saveSubscriptionAddressSuccess())];
            case 7:
                _a.sent();
                return [3 /*break*/, 10];
            case 8:
                err_5 = _a.sent();
                return [4 /*yield*/, put(saveSubscriptionAddressFailed(err_5))];
            case 9:
                _a.sent();
                return [3 /*break*/, 10];
            case 10: return [2 /*return*/];
        }
    });
}
var subscriptionsSagas = [
    takeLatest(FETCH_DETAIL, onDetailFetch),
    takeLatest(PAUSE, onPause),
    takeLatest(PAUSE_SUCCESS, onPauseSuccess),
    takeLatest(QUANTITY, onQuantity),
    takeLatest(QUANTITY_FAILED, onQuantityFailed),
    takeLatest(QUANTITY_SUCCESS, onQuantitySuccess),
    takeLatest(FETCH_PRODUCT_DATA, onFetchProductData),
    takeLatest(FETCH_LIST, onFetchList),
    takeLatest(SUBSCRIPTION_ADDRESS_SAVE, onSaveSubscriptionAddress),
];

function onUnlinkOrder(action) {
    var auth, formattedRoutes, getSuccessRoute, apiConfig, _a, orderNumber, orderToken, requestBody, err_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _b.sent();
                return [4 /*yield*/, select(Selectors.getFormattedRoutes)];
            case 2:
                formattedRoutes = _b.sent();
                getSuccessRoute = function (orderNumber) {
                    return (formattedRoutes === null || formattedRoutes === void 0 ? void 0 : formattedRoutes.unlinkOrder)
                        ? formattedRoutes.unlinkOrder + "/success?orderNumber=" + orderNumber
                        : "unlink-order/success?orderNumber=" + orderNumber;
                };
                _b.label = 3;
            case 3:
                _b.trys.push([3, 10, , 12]);
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 4:
                apiConfig = _b.sent();
                if (!!apiConfig) return [3 /*break*/, 6];
                return [4 /*yield*/, put(unlinkOrderFailed(new Error('ApiConfig is unreachable')))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6:
                _a = action.payload, orderNumber = _a.orderNumber, orderToken = _a.orderToken;
                requestBody = { orderNumber: orderNumber, orderToken: orderToken };
                return [4 /*yield*/, call(Orders$2.unlink, auth.apiUrl, requestBody)];
            case 7:
                _b.sent();
                return [4 /*yield*/, put(unlinkOrderSuccess())];
            case 8:
                _b.sent();
                return [4 /*yield*/, put(Actions$2.goto({ path: getSuccessRoute(orderNumber) }))];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10:
                err_1 = _b.sent();
                return [4 /*yield*/, put(unlinkOrderFailed(__assign({}, err_1)))];
            case 11:
                _b.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
function onUnlinkAppointment(action) {
    var auth, formattedRoutes, getSuccessRoute, apiConfig, _a, appointmentToken, appointmentId, requestBody, err_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _b.sent();
                return [4 /*yield*/, select(Selectors.getFormattedRoutes)];
            case 2:
                formattedRoutes = _b.sent();
                getSuccessRoute = function (appointmentId) {
                    return (formattedRoutes === null || formattedRoutes === void 0 ? void 0 : formattedRoutes.unlinkAppointment)
                        ? formattedRoutes.unlinkAppointment + "/success?appointmentId=" + appointmentId
                        : "unlink-appointment/success?appointmentId=" + appointmentId;
                };
                _b.label = 3;
            case 3:
                _b.trys.push([3, 10, , 12]);
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 4:
                apiConfig = _b.sent();
                if (!!apiConfig) return [3 /*break*/, 6];
                return [4 /*yield*/, put(unlinkAppointmentFailed(new Error('ApiConfig is unreachable')))];
            case 5:
                _b.sent();
                return [2 /*return*/];
            case 6:
                _a = action.payload, appointmentToken = _a.appointmentToken, appointmentId = _a.appointmentId;
                requestBody = { appointmentId: appointmentId, appointmentToken: appointmentToken };
                return [4 /*yield*/, call(Appointments.unlink, auth.apiUrl, requestBody)];
            case 7:
                _b.sent();
                return [4 /*yield*/, put(unlinkAppointmentSuccess())];
            case 8:
                _b.sent();
                return [4 /*yield*/, put(Actions$2.goto({ path: getSuccessRoute(appointmentId) }))];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10:
                err_2 = _b.sent();
                return [4 /*yield*/, put(unlinkAppointmentFailed(__assign({}, err_2)))];
            case 11:
                _b.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
var unlinkOrderSagas = [
    takeLatest(unlinkAppointment.type, onUnlinkAppointment),
    takeLatest(unlinkOrder.type, onUnlinkOrder),
];

function onCreateOrder(action) {
    var auth, apiConfig, loggedIn, token, result, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(Selectors.getAuth)];
            case 1:
                auth = _a.sent();
                return [4 /*yield*/, select(ApiConfigSelectors.getApiConfig)];
            case 2:
                apiConfig = _a.sent();
                if (!apiConfig) {
                    throw new Error('Need API configuration to create order.');
                }
                if (!State.isInitialized(auth)) return [3 /*break*/, 6];
                return [4 /*yield*/, put(Actions$2.LoginActions.recoverSession())];
            case 3:
                _a.sent();
                return [4 /*yield*/, race({
                        loggedIn: take(Actions$2.LoginActions.PARSE_HASH_SUCCEEDED),
                        loginFailed: take(Actions$2.LoginActions.RECOVER_SESSION_FAILED),
                    })];
            case 4:
                loggedIn = (_a.sent()).loggedIn;
                if (!loggedIn) return [3 /*break*/, 6];
                return [4 /*yield*/, select(Selectors.getAuth)];
            case 5:
                auth = _a.sent();
                _a.label = 6;
            case 6:
                if (!!State.isLoggedIn(auth)) return [3 /*break*/, 8];
                return [4 /*yield*/, put(createOrderFailed(new Error("Can only create order on behalf of user when they're actually logged-in")))];
            case 7:
                _a.sent();
                return [2 /*return*/];
            case 8:
                _a.trys.push([8, 12, , 14]);
                return [4 /*yield*/, call(getToken)];
            case 9:
                token = _a.sent();
                return [4 /*yield*/, call(Orders$2.createForCustomer, apiConfig.ordersUrl, auth.userId, token, action.payload)];
            case 10:
                result = _a.sent();
                return [4 /*yield*/, put(createOrderSuccess(result))];
            case 11:
                _a.sent();
                return [3 /*break*/, 14];
            case 12:
                err_1 = _a.sent();
                return [4 /*yield*/, put(createOrderFailed(err_1))];
            case 13:
                _a.sent();
                return [3 /*break*/, 14];
            case 14: return [2 /*return*/];
        }
    });
}
function sagas () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(addressBookSagas)), __read(appointmentsSagas)), __read(dataLayerSagas)), __read(ordersSagas)), __read(subscriptionsSagas)), __read(prescriptionsSagas)), __read(privacySagas)), __read(profileSagas)), __read(unlinkOrderSagas)), [
                    takeLatest(CREATE_ORDER, onCreateOrder),
                ]))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}

var state = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var PrescriptionSide;
(function (PrescriptionSide) {
    PrescriptionSide["Right"] = "rightEye";
    PrescriptionSide["Left"] = "leftEye";
})(PrescriptionSide || (PrescriptionSide = {}));
var PrescriptionKey;
(function (PrescriptionKey) {
    PrescriptionKey["Power"] = "power";
    PrescriptionKey["Axis"] = "axis";
    PrescriptionKey["Cylinder"] = "cylinder";
    PrescriptionKey["Addition"] = "addition";
    PrescriptionKey["BaseCurve"] = "baseCurve";
    PrescriptionKey["Diameter"] = "diameter";
})(PrescriptionKey || (PrescriptionKey = {}));
var AddressFieldTypes;
(function (AddressFieldTypes) {
    AddressFieldTypes["Subscription"] = "SUBSCRIPTION";
    AddressFieldTypes["SubscriptionV2"] = "SUBSCRIPTION_V2";
})(AddressFieldTypes || (AddressFieldTypes = {}));
var SubscriptionAddressTypes;
(function (SubscriptionAddressTypes) {
    SubscriptionAddressTypes["Address"] = "ADDRESS";
    SubscriptionAddressTypes["BusinessAddress"] = "BUSINESS_ADDRESS";
})(SubscriptionAddressTypes || (SubscriptionAddressTypes = {}));
var SubscriptionSummaryTypes;
(function (SubscriptionSummaryTypes) {
    SubscriptionSummaryTypes["Address"] = "ADDRESS";
    SubscriptionSummaryTypes["Invoice"] = "INVOICE";
})(SubscriptionSummaryTypes || (SubscriptionSummaryTypes = {}));
var AddressSummaryTypes;
(function (AddressSummaryTypes) {
    AddressSummaryTypes["Subscription"] = "SUBSCRIPTION";
    AddressSummaryTypes["SubscriptionV2"] = "SUBSCRIPTION_V2";
})(AddressSummaryTypes || (AddressSummaryTypes = {}));
var PaymentDetailsSummaryTypes;
(function (PaymentDetailsSummaryTypes) {
    PaymentDetailsSummaryTypes["Subscription"] = "SUBSCRIPTION";
    PaymentDetailsSummaryTypes["SubscriptionV2"] = "SUBSCRIPTION_V2";
})(PaymentDetailsSummaryTypes || (PaymentDetailsSummaryTypes = {}));
// Credit card brands
var CardBrandName;
(function (CardBrandName) {
    CardBrandName["MasterCard"] = "mc";
    CardBrandName["NoCard"] = "nocard";
    CardBrandName["Visa"] = "visa";
    CardBrandName["Unknown"] = "unknown";
})(CardBrandName || (CardBrandName = {}));

var types = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get PrescriptionSide () { return PrescriptionSide; },
  get PrescriptionKey () { return PrescriptionKey; },
  get AddressFieldTypes () { return AddressFieldTypes; },
  get SubscriptionAddressTypes () { return SubscriptionAddressTypes; },
  get SubscriptionSummaryTypes () { return SubscriptionSummaryTypes; },
  get AddressSummaryTypes () { return AddressSummaryTypes; },
  get PaymentDetailsSummaryTypes () { return PaymentDetailsSummaryTypes; },
  get CardBrandName () { return CardBrandName; }
});

function getActivePath() {
    var url = new URL(window.location.href);
    return url.pathname;
}
var hrefToUrl = function (href) { return new URL("" + window.location.origin + href); };
var getMyAccountMenuItems = function (logout, routes, intl, isUserLoggedIn, isAddressBookEnabled, isAabEnabled, isSubscriptionsV2Enabled, onNavigate) {
    var _a, _b, _c, _d, _e, _f;
    var activePath = getActivePath();
    var navigate = function (href) { return function (e) {
        e.preventDefault();
        var url = hrefToUrl(href);
        onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(url);
    }; };
    var logoutItem = {
        label: intl.getLabel('account.menu.logOut'),
        parameters: {
            icon: 'logout',
            action: logout,
            testId: 'logout',
        },
        childMenuItems: [],
        link: { href: '', type: 'external' },
    };
    var loginItem = {
        label: intl.getLabel('account.action.login'),
        childMenuItems: [],
        parameters: {
            testId: 'login',
        },
        link: { href: routes.login, type: 'external' },
    };
    function getProfileChildMenuItems() {
        var _a, _b;
        var items = [];
        if (isAddressBookEnabled) {
            items.push({
                label: intl.getLabel('account.menu.addresses'),
                link: {
                    href: (_a = routes.addressBook) !== null && _a !== void 0 ? _a : '',
                    onClick: routes.addressBook && onNavigate ? navigate(routes.addressBook) : undefined,
                    type: 'external',
                    active: [routes.addressBook].includes(activePath),
                },
                parameters: {
                    testId: 'addressBook',
                },
            });
        }
        items.push({
            label: intl.getLabel('account.menu.changePassword'),
            link: {
                href: (_b = routes.changePassword) !== null && _b !== void 0 ? _b : '',
                onClick: routes.changePassword && onNavigate ? navigate(routes.changePassword) : undefined,
                type: 'external',
                active: [routes.changePassword].includes(activePath),
            },
            parameters: {
                testId: 'changePassword',
            },
        });
        return items;
    }
    var userHasParsedDataFromLS = getParsedDataFromLS();
    var lastItem = logoutItem;
    if (!isUserLoggedIn && !userHasParsedDataFromLS) {
        lastItem = loginItem;
    }
    var items = [
        {
            label: intl.getLabel('account.menu.accountDetails'),
            parameters: {
                icon: 'user',
                testId: 'profile',
            },
            link: {
                href: (_a = routes.profile) !== null && _a !== void 0 ? _a : '',
                onClick: routes.profile && onNavigate ? navigate(routes.profile) : undefined,
                type: 'external',
                active: [routes.addressBook, routes.changePassword, routes.profile].includes(activePath),
            },
            childMenuItems: getProfileChildMenuItems(),
        },
        {
            label: intl.getLabel('account.menu.appointments'),
            parameters: {
                icon: 'calendar',
                testId: 'appointments',
            },
            link: {
                href: (isAabEnabled && routes.appointments) || '',
                onClick: routes.appointments && onNavigate ? navigate(routes.appointments) : undefined,
                type: 'external',
                active: routes.appointments === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.prescriptions'),
            parameters: {
                icon: 'frame',
                testId: 'prescriptions',
            },
            link: {
                href: (_b = routes.prescriptions) !== null && _b !== void 0 ? _b : '',
                onClick: routes.prescriptions && onNavigate ? navigate(routes.prescriptions) : undefined,
                type: 'external',
                active: routes.prescriptions === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.orders'),
            parameters: {
                icon: 'orders',
                testId: 'orders',
            },
            link: {
                href: (_c = routes.orders) !== null && _c !== void 0 ? _c : '',
                onClick: routes.orders && onNavigate ? navigate(routes.orders) : undefined,
                type: 'external',
                active: routes.orders === activePath,
            },
        },
        {
            label: intl.getLabel('account.menu.subscriptions'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptions',
            },
            link: {
                href: (_d = routes.subscriptions) !== null && _d !== void 0 ? _d : '',
                onClick: routes.subscriptions && onNavigate ? navigate(routes.subscriptions) : undefined,
                type: 'external',
                active: Boolean(routes.subscriptions &&
                    !(routes.subscriptionsv2 && activePath.startsWith(routes.subscriptionsv2)) &&
                    activePath.startsWith(routes.subscriptions)),
            },
        },
        {
            label: "" + intl.getLabel('account.menu.subscriptions-v2'),
            parameters: {
                icon: 'shipment-next',
                testId: 'subscriptionsv2',
            },
            link: {
                href: isSubscriptionsV2Enabled ? (_e = routes.subscriptionsv2) !== null && _e !== void 0 ? _e : '' : '',
                onClick: routes.subscriptionsv2 && isSubscriptionsV2Enabled && onNavigate
                    ? navigate(routes.subscriptionsv2)
                    : undefined,
                type: 'external',
                active: routes.subscriptionsv2 ? activePath.startsWith(routes.subscriptionsv2) : false,
            },
        },
        {
            label: intl.getLabel('account.menu.privacy'),
            parameters: {
                icon: 'lock',
                testId: 'privacy',
            },
            link: {
                href: (_f = routes.privacy) !== null && _f !== void 0 ? _f : '',
                onClick: routes.privacy && onNavigate ? navigate(routes.privacy) : undefined,
                type: 'external',
                active: routes.privacy === activePath,
            },
        },
        lastItem,
    ];
    var hasLink = function (item) { var _a; return ((_a = item.link) === null || _a === void 0 ? void 0 : _a.href) && item.link.href !== ''; };
    var hasAction = function (item) { var _a; return (_a = item.parameters) === null || _a === void 0 ? void 0 : _a.action; };
    return items.filter(function (item) { return hasLink(item) || hasAction(item); });
};

var convertToLineItemDraft = function (orderLineItem, isLegacyOrderSupplierEanEnabled) {
    var custom;
    if (Orders$2.isContactLenses(orderLineItem.product) ||
        Orders$2.isDetailContactLenses(orderLineItem.product)) {
        custom = {
            eyeSide: orderLineItem.product.attributes.eyeSide,
        };
    }
    if (Orders$2.isDetailContactLensBundles(orderLineItem.product)) {
        var customValues = {
            leftLensAxis: orderLineItem.product.attributes.leftLensAxis,
            leftLensBaseCurve: orderLineItem.product.attributes.leftLensBaseCurve,
            leftLensCylinder: orderLineItem.product.attributes.leftLensCylinder,
            leftLensDiameter: orderLineItem.product.attributes.leftLensDiameter,
            leftLensName: orderLineItem.product.attributes.leftLensName,
            leftLensPower: orderLineItem.product.attributes.leftLensPower,
            leftLensSku: orderLineItem.product.attributes.leftLensSku,
            leftLensVariantSku: orderLineItem.product.attributes.leftLensVariantSku,
            rightLensAxis: orderLineItem.product.attributes.rightLensAxis,
            rightLensBaseCurve: orderLineItem.product.attributes.rightLensBaseCurve,
            rightLensCylinder: orderLineItem.product.attributes.rightLensCylinder,
            rightLensDiameter: orderLineItem.product.attributes.rightLensDiameter,
            rightLensName: orderLineItem.product.attributes.rightLensName,
            rightLensPower: orderLineItem.product.attributes.rightLensPower,
            rightLensSku: orderLineItem.product.attributes.rightLensSku,
            rightLensVariantSku: orderLineItem.product.attributes.rightLensVariantSku,
            solutionName: orderLineItem.product.attributes.solutionName,
            solutionSku: orderLineItem.product.attributes.solutionSku,
            // parse add to cart sets a default type: gv-core-components/packages/carts/src/Util/parse-add-to-cart-payload.ts
            type: 'contact-lens-bundle',
        };
        // Remove all undefined / null values
        var customData = omitBy(customValues, isNil);
        custom = customData;
    }
    return {
        quantity: orderLineItem.quantity,
        sku: isLegacyOrderSupplierEanEnabled &&
            Orders$2.isSunglasses(orderLineItem.product) &&
            orderLineItem.product.attributes.supplierEAN
            ? orderLineItem.product.attributes.supplierEAN
            : orderLineItem.product.sku,
        custom: custom,
    };
};
var convertToDraftLineItemPrescription = function (lineItem) {
    var prescription = lineItem.product.lineItemDetail.prescription;
    if (!prescription)
        return undefined;
    switch (prescription.type) {
        case 'NewPrescription': {
            return __assign(__assign({}, prescription), { rightLens: prescription.rightLens || {}, leftLens: prescription.leftLens || {} });
        }
        case 'PrescriptionFile': {
            return {
                type: 'PrescriptionFile',
                uploadedPrescriptionFile: {
                    fileName: prescription.fileName,
                },
                uploadedPupillaryDistanceFile: {
                    fileName: prescription.pupillaryDistanceFileFileName,
                },
            };
        }
        default: {
            return prescription;
        }
    }
};
var convertToPrescriptionGlassesLineItemDraft = function (lineItem) {
    var _a = lineItem.product.lineItemDetail, bundleMainLineItem = _a.bundleMainLineItem, bundleChildLineItems = _a.bundleChildLineItems;
    return {
        prescription: convertToDraftLineItemPrescription(lineItem),
        quantity: lineItem.quantity,
        bundleMainLineItem: {
            quantity: bundleMainLineItem.quantity,
            sku: bundleMainLineItem.variant.sku,
            productType: bundleMainLineItem.productType,
        },
        bundleChildLineItems: bundleChildLineItems.map(function (_a) {
            var variant = _a.variant, quantity = _a.quantity, productType = _a.productType;
            return ({
                sku: variant.sku,
                productType: productType,
                quantity: quantity,
            });
        }),
    };
};
var convertLineItemsToDrafts = function (items, isLegacyOrderSupplierEanEnabled) {
    var e_1, _a;
    var drafts = { lineItems: [] };
    try {
        for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
            var lineItem = items_1_1.value;
            if (Orders$2.isPrescriptionGlassesLineItem(lineItem)) {
                drafts = __assign(__assign({}, drafts), { prescriptionGlassesBundleLineItems: __spreadArray(__spreadArray([], __read((drafts.prescriptionGlassesBundleLineItems || []))), [
                        convertToPrescriptionGlassesLineItemDraft(lineItem),
                    ]) });
            }
            else {
                drafts = __assign(__assign({}, drafts), { lineItems: __spreadArray(__spreadArray([], __read(drafts.lineItems)), [
                        convertToLineItemDraft(lineItem, isLegacyOrderSupplierEanEnabled),
                    ]) });
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return drafts;
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AddressBookUtils: index$1,
  getMyAccountMenuItems: getMyAccountMenuItems,
  convertLineItemsToDrafts: convertLineItemsToDrafts
});

var useAddressBookList = function (_a) {
    var _b = _a === void 0 ? {} : _a, skip = _b.skip;
    var dispatch = useDispatch();
    var state = useAccount();
    var addressBook = useSelector(getAddressBookList);
    React.useEffect(function () {
        if (!skip &&
            !statusUnavailable(addressBook) &&
            statusUninit(addressBook) &&
            state === State.AuthState.LoggedIn) {
            dispatch(fetchList$2());
        }
    }, [state, dispatch, addressBook]);
    if (skip || state === State.AuthState.LoggedOut) {
        return unavailableState();
    }
    return addressBook;
};

var useAddressBook = function () {
    var dispatch = useDispatch();
    var toggleModal$1 = function (state) {
        dispatch(toggleModal(state));
    };
    var toggleAddressModal = function (isOpen) {
        toggleModal$1({ isOpen: isOpen, viewMode: ViewMode.ADD });
    };
    var deleteAddress$1 = function (id) {
        dispatch(deleteAddress(id));
    };
    var editAddress$1 = function (id) {
        dispatch(editAddress(id));
    };
    var closeModal = function () {
        dispatch(toggleModal({ isOpen: false }));
    };
    return { closeModal: closeModal, toggleAddressModal: toggleAddressModal, deleteAddress: deleteAddress$1, editAddress: editAddress$1 };
};

var AddAddress$2 = function (_a) {
    var addressForm = _a.addressForm, onSubmit = _a.onSubmit, className = _a.className;
    var getFormattedLabel = useIntl().getFormattedLabel;
    var addCall = useSelector(getAddCall);
    var isAddCallLoading = statusLoading(addCall);
    var isAddCallFailed = statusFailed(addCall);
    var handleSubmit = React.useCallback(function (state) {
        var _a = Util.getValuesFromState(state.formState), firstName = _a.firstName, lastName = _a.lastName, streetName = _a.streetName, rest = __rest(_a, ["firstName", "lastName", "streetName"]);
        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(__assign({ firstName: firstName, lastName: lastName, streetName: streetName, addressTypes: [] }, rest));
    }, []);
    return (React.createElement(React.Fragment, null,
        isAddCallFailed && (React.createElement(Alert, { type: "error", message: getFormattedLabel('checkout.addressBook.newAddress.error', { parseLink: true }) })),
        React.createElement(Form, { name: "add-address", "data-t": "add-address", onSubmit: handleSubmit, className: classnames('add-address', className) },
            React.createElement("fieldset", { disabled: isAddCallLoading, className: "add-address__fieldset", "data-t": "add-address__fieldset" }, addressForm))));
};

var UNAVAILABLE = { status: 'unavailable' };
function isDataUnavailable(state) {
    return state.status === 'unavailable';
}
function isDataLoading(state) {
    return state.status === LOADING;
}
function isDataSuccess(state) {
    return state.status === SUCCESS;
}
var fetchIfUninit = function (props) {
    if (statusUninit(props.myAccount.profile.userData)) {
        props.fetchUserData();
    }
    if (props.loadOptIns && statusUninit(props.myAccount.privacy.optInsOnServer)) {
        props.fetchOptIns();
    }
};
var resourceToDataState = function (resource, defaultState, extractSuccess) {
    if (statusSuccess(resource)) {
        return extractSuccess(resource);
    }
    else if (statusFailed(resource)) {
        return UNAVAILABLE;
    }
    else {
        return defaultState;
    }
};
function WithUserData(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var Wrapper = /** @class */ (function (_super) {
        __extends(Wrapper, _super);
        function Wrapper() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Wrapper.prototype.componentDidMount = function () {
            var auth = this.props.auth;
            if (State.isInitialized(auth)) {
                this.props.recoverSession();
            }
            if (State.isLoggedIn(auth)) {
                fetchIfUninit(this.props);
            }
        };
        Wrapper.prototype.componentDidUpdate = function (prevProps) {
            if (State.isUninitialized(prevProps.auth) && State.isInitialized(this.props.auth)) {
                this.props.recoverSession();
            }
            if (State.isInitialized(prevProps.auth) && State.isLoggedIn(this.props.auth)) {
                fetchIfUninit(this.props);
            }
        };
        Wrapper.prototype.render = function () {
            var _a = this.props, auth = _a.auth, myAccount = _a.myAccount, loadOptIns = _a.loadOptIns;
            var email = auth.email;
            var userData = loadingState();
            var optInsData = loadOptIns ? loadingState() : UNAVAILABLE;
            if (!State.isUninitialized(auth) && !State.isInitialized(auth)) {
                userData = UNAVAILABLE;
                optInsData = UNAVAILABLE;
            }
            if (State.isLoggedIn(auth)) {
                userData = resourceToDataState(myAccount.profile.userData, loadingState(), function (userData) {
                    return successState(__assign(__assign({}, userData.result), { email: email }));
                });
                optInsData = resourceToDataState(myAccount.privacy.optInsOnServer, loadOptIns ? loadingState() : UNAVAILABLE, function (serverOptIns) { return successState(serverOptIns.result.optinValues); });
            }
            return React.createElement(Component, __assign({}, this.props, { userData: userData, optInsData: optInsData }));
        };
        Wrapper.displayName = "WithUserData(" + wrappedName + ")";
        return Wrapper;
    }(React.Component));
    var mapStateToProps = function (state) { return ({
        auth: Selectors.getAuth(state),
        myAccount: getMyAccount(state),
    }); };
    var ConnectedWrapper = connect(mapStateToProps, {
        recoverSession: Actions$2.LoginActions.recoverSession,
        fetchUserData: fetchUserData$1,
        fetchOptIns: fetchOptIns$1,
    })(Wrapper);
    return function (props) {
        return props.isMyAccountEnabled ? (React.createElement(ConnectedWrapper, __assign({}, props))) : (React.createElement(Component, __assign({}, props, { userData: UNAVAILABLE, optInsData: UNAVAILABLE })));
    };
}

var Loader = function () { return (React.createElement(SkeletonLoader, { className: "myaccount-menu-loader", "data-t": "myaccount-menu-loader" },
    React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "16" },
        React.createElement("rect", { width: "100%", height: "16", rx: "5", fill: "currentColor" })))); };

var SummaryName;
(function (SummaryName) {
    SummaryName["addressSummary"] = "addressSummary";
    SummaryName["storeAddressSummary"] = "storeAddressSummary";
    SummaryName["personalDetailsSummary"] = "personalDetailsSummary";
    SummaryName["preferredStoreSummary"] = "preferredStoreSummary";
    SummaryName["paymentDetailsSummary"] = "paymentDetailsSummary";
    SummaryName["personalGreeting"] = "personalGreeting";
    SummaryName["menuGreeting"] = "menuGreeting";
    SummaryName["addressSummaryV2"] = "addressSummaryV2";
    SummaryName["invoiceDetailsSummaryV2"] = "invoiceDetailsSummaryV2";
})(SummaryName || (SummaryName = {}));
var DefaultFormTemplates = function () {
    var _a;
    return (_a = {},
        _a[Types.FormName.personalDetails] = (React__default.createElement(IntlContext.Consumer, null, function (intl) { return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FirstName, { label: intl.getLabel('checkout.contact.firstName'), errorMessage: intl.getLabel('checkout.contact.firstName.errorMessage') }),
            React__default.createElement(LastName, { label: intl.getLabel('checkout.contact.lastName'), errorMessage: intl.getLabel('checkout.contact.lastName.errorMessage') }),
            React__default.createElement(PhoneNumber, { label: intl.getLabel('checkout.contact.phoneNumber'), errorMessage: intl.getLabel('checkout.contact.phoneNumber.errorMessage') }))); })),
        _a[Types.FormName.billingAddress] = (React__default.createElement(IntlContext.Consumer, null, function (intl) { return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(FirstName, { label: intl.getLabel('checkout.contact.firstName'), errorMessage: intl.getLabel('checkout.contact.firstName.errorMessage') }),
            React__default.createElement(LastName, { label: intl.getLabel('checkout.contact.lastName'), errorMessage: intl.getLabel('checkout.contact.lastName.errorMessage') }),
            React__default.createElement(AddressLine, { count: "1", label: intl.getLabel('checkout.address.addressLine') + ' 1', errorMessage: intl.getLabel('checkout.address.addressLine.errorMessage') }),
            React__default.createElement(HouseNumber, { label: intl.getLabel('checkout.contact.houseNumber'), errorMessage: intl.getLabel('checkout.contact.houseNumber.errorMessage') }),
            React__default.createElement(HouseNumberSuffix, { label: intl.getLabel('checkout.contact.houseNumberSuffix'), errorMessage: intl.getLabel('checkout.contact.houseNumberSuffix.errorMessage') }),
            React__default.createElement(PostalCode, { label: intl.getLabel('checkout.address.postalCode'), errorMessage: intl.getLabel('checkout.address.postalCode.errorMessage') }),
            React__default.createElement(City, { label: intl.getLabel('checkout.address.city'), errorMessage: intl.getLabel('checkout.address.city.errorMessage') }),
            React__default.createElement(Region, { required: false, label: intl.getLabel('checkout.address.district') }))); })),
        _a[Types.FormName.signUp] = (React__default.createElement(IntlContext.Consumer, null, function (intl) { return (React__default.createElement(Email, { label: intl.getLabel('fields.input.email.label'), errorMessage: intl.getLabel('account.error.emailInvalid'), required: true })); })),
        _a);
};
var DefaultSummaryTemplates = function () {
    var _a;
    return (_a = {},
        _a[SummaryName.addressSummary] = function (_a, title) {
            var data = _a.data;
            return (
            // TODO: Clean up soon. This became very messy becuase of inconsistencies in interfaces (due to OpCo acceptance criteria).
            React__default.createElement("p", null,
                title && (React__default.createElement(Heading, { variant: "subheading2", component: "span" }, title)),
                SummaryItem([data.firstName, data.lastName]),
                SummaryItem([data.streetName, data.streetinteger]),
                SummaryItem([data.addressLine1, data.streetNumber, data.additionalStreetInfo]),
                SummaryItem(data.addressLine2),
                SummaryItem(data.addressLine3),
                SummaryItem([data.postalCode, data.city]),
                SummaryItem(data.region),
                SummaryItem(data.country)));
        },
        _a[SummaryName.storeAddressSummary] = function (_a, title) {
            var data = _a.data;
            return (React__default.createElement("p", null,
                title && (React__default.createElement("span", null,
                    React__default.createElement("b", null, title))),
                SummaryItem(data.storeName),
                SummaryItem([data.streetName, data.streetNumber]),
                SummaryItem([data.postalCode, data.town]),
                SummaryItem([data.country, data.province && "(" + data.province + ")"])));
        },
        _a[SummaryName.personalDetailsSummary] = function (_a, title) {
            var data = _a.data, email = _a.email;
            return (React__default.createElement("p", null,
                title && (React__default.createElement("span", null,
                    React__default.createElement("b", null, title))),
                SummaryItem([data.firstName, data.lastName]),
                SummaryItem(data.phone),
                SummaryItem(email)));
        },
        _a[SummaryName.preferredStoreSummary] = function (_a, title) {
            var data = _a.data;
            return (React__default.createElement("p", null,
                title && (React__default.createElement("span", null,
                    React__default.createElement("b", null, title))),
                SummaryItem(data.storeName),
                SummaryItem([data.streetName, data.streetNumber]),
                SummaryItem([data.postalCode, data.town])));
        },
        _a[SummaryName.paymentDetailsSummary] = function (_a, title) {
            var data = _a.data, getLabel = _a.getLabel;
            return (React__default.createElement("section", { className: "payment-details-summary" },
                title && (React__default.createElement("span", null,
                    React__default.createElement("b", null, title))),
                data.type && (React__default.createElement("div", { className: "row" },
                    SummaryItem(getLabel('account.subscription.payment.method') + ": "),
                    SummaryItem(data.type))),
                data.details.bankName && (React__default.createElement("div", { className: "row" },
                    SummaryItem(getLabel('account.subscription.payment.provider') + ": "),
                    SummaryItem(data.details.bankName))),
                data.details.bankNumber && (React__default.createElement("div", { className: "row" },
                    SummaryItem(getLabel('account.subscription.payment.accountNumber') + ": "),
                    SummaryItem(data.details.bankNumber))),
                data.details.bankSortCode && (React__default.createElement("div", { className: "row" },
                    SummaryItem(getLabel('account.subscription.payment.sortCode') + ": "),
                    SummaryItem(data.details.bankSortCode))),
                data.details.bankAccountHolderName && (React__default.createElement("div", { className: "row" },
                    SummaryItem(getLabel('account.subscription.payment.accountHolder') + ": "),
                    SummaryItem(data.details.bankAccountHolderName)))));
        },
        _a[SummaryName.personalGreeting] = function (_a) {
            var data = _a.data, getLabel = _a.getLabel;
            return (React__default.createElement(React__default.Fragment, null, data && data.firstName
                ? getLabel('account.profile.title.personalized', {
                    labelData: data,
                    hideLabelKey: true,
                })
                : getLabel('account.profile.title')));
        },
        _a[SummaryName.menuGreeting] = function (_a) {
            var data = _a.data, getLabel = _a.getLabel;
            return (React__default.createElement(React__default.Fragment, null, data && data.firstName && data.lastName
                ? getLabel('account.menu.greeting.withPersonalDetails', {
                    labelData: data,
                })
                : getLabel('account.menu.greeting.withoutPersonalDetails')));
        },
        _a[SummaryName.addressSummaryV2] = function (_a, title) {
            var data = _a.data;
            return (React__default.createElement("p", null,
                title && (React__default.createElement(Heading, { variant: "subheading2", component: "span" }, title)),
                SummaryItem([data.firstName, data.lastName]),
                SummaryItem([data.streetName, data.streetNumber, data.additionalStreetInfo]),
                SummaryItem([data.postalCode, data.city, data.region])));
        },
        _a[SummaryName.invoiceDetailsSummaryV2] = function (_a) {
            var data = _a.data;
            return (React__default.createElement("p", null,
                SummaryItem([data.vatId]),
                SummaryItem([data.certifiedEmail]),
                SummaryItem([data.certifiedRecipientCode])));
        },
        _a);
};
var DefaultOrderTemplates = function () { return ({
    address: function (address) { return (React__default.createElement("p", null,
        SummaryItem([address.firstName, address.lastName]),
        SummaryItem([address.streetName, address.streetNumber, address.additionalStreetInfo]),
        SummaryItem([address.postalCode, address.city]),
        SummaryItem(address.region))); },
    storeAddress: function (address) { return (React__default.createElement("p", null,
        SummaryItem(address.company),
        SummaryItem([address.streetName, address.streetNumber, address.additionalStreetInfo]),
        SummaryItem([address.postalCode, address.city]),
        SummaryItem(address.region))); },
    contactDetails: function (order) { return (React__default.createElement("p", null,
        SummaryItem(order.customerInfo.email),
        SummaryItem(order.customerInfo.phone))); },
}); };

var PersonalizedGreeting = function (_a) {
    var auth = _a.auth, greetingFormatter = _a.greetingFormatter;
    var getFormattedLabel = useIntl().getFormattedLabel;
    var personalDetails = getParsedDataFromLS();
    var hasPersonalDetails = Boolean(personalDetails);
    var isLoggedIn = State.getLoggedInState(auth) === 'logged-in';
    var formatter = greetingFormatter || DefaultSummaryTemplates()[SummaryName.menuGreeting];
    var appearLoggedIn = isLoggedIn || hasPersonalDetails;
    return (React.createElement(React.Fragment, null,
        appearLoggedIn ? React.createElement(Icon, { name: "user-checkmark" }) : React.createElement(Icon, { name: "user" }),
        React.createElement("span", { className: "myaccount-menu-button__label", "data-t": "personalized-greeting" }, formatter({ data: personalDetails, getLabel: getFormattedLabel }))));
};

var MyAccountMenu = function (_a) {
    var _b = _a.menuItems, menuItems = _b === void 0 ? [] : _b, greetingFormatter = _a.greetingFormatter, auth = _a.auth, userData = _a.userData, className = _a.className;
    var classes = classnames('myaccount-menu', className);
    var getLabel = useIntl().getLabel;
    var loggedInState = State.getLoggedInState(auth);
    var triggerContent;
    if (getParsedDataFromLS()) {
        if (loggedInState === 'logged-in') {
            if (userData && isDataSuccess(userData)) {
                userData.result.personalDetails && writeUserDataToLS(userData.result.personalDetails);
            }
        }
        triggerContent = React.createElement(PersonalizedGreeting, { auth: auth, greetingFormatter: greetingFormatter });
    }
    else {
        if (loggedInState === 'logged-in') {
            if (userData && isDataLoading(userData)) {
                triggerContent = React.createElement(Loader, null);
            }
            if (userData && isDataSuccess(userData)) {
                userData.result.personalDetails && writeUserDataToLS(userData.result.personalDetails);
                triggerContent = React.createElement(PersonalizedGreeting, { auth: auth, greetingFormatter: greetingFormatter });
            }
        }
        else if (loggedInState === 'logged-out') {
            triggerContent = (React.createElement(React.Fragment, null,
                React.createElement(Icon, { name: "user" }),
                React.createElement("span", { "data-t": "logged-out-greeting", className: "myaccount-menu-button__label" }, getLabel('account.menu.greeting.loggedOut'))));
        }
        else if (loggedInState === 'loading') {
            triggerContent = React.createElement(Loader, null);
        }
    }
    return (React.createElement(Flyout, { "data-t": "myaccount-menu", id: "myaccount-menu", className: classes },
        React.createElement(Flyout.Trigger, { "data-t": "my-account-menu-button", className: classnames('header-menu__icon myaccount-menu-button', className, 'myaccount-menu-button--link'), title: getLabel('account.menu.myAccount'), "aria-controls": "myaccount-menu" }, triggerContent),
        React.createElement(Flyout.Menu, null, menuItems.map(function (item) {
            var _a, _b;
            return (React.createElement(Flyout.MenuItem, { key: item.label, link: (_a = item.link) === null || _a === void 0 ? void 0 : _a.href, action: (_b = item.parameters) === null || _b === void 0 ? void 0 : _b.action }, item.label));
        }))));
};
var mapStateToProps$e = function (state) { return ({
    auth: Selectors.getAuth(state),
}); };
var MyAccountMenuWithUserData = WithUserData(MyAccountMenu);
var MyAccountMenuWrapper = function (props) {
    return React.createElement(MyAccountMenuWithUserData, __assign({}, props, { isMyAccountEnabled: true }));
};
var MyAccountMenu$1 = connect(mapStateToProps$e)(MyAccountMenuWrapper);

var elementName$1 = 'myaccount-page-with-menu';
var PageWithMenu = function (_a) {
    var routes = _a.routes, logout = _a.logout, children = _a.children, authState = _a.authState, onNavigate = _a.onNavigate;
    var isTabletLandscapeAndUp = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    var isUserLoggedIn = State.isLoggedIn(authState);
    var intl = useIntl();
    var _b = useFeatureToggles(), isAddressBookEnabled = _b.isAddressBookEnabled, isAABEnabled = _b.isAABEnabled, isSubscriptionsV2Enabled = _b.isSubscriptionsV2Enabled;
    return (React.createElement("article", { className: elementName$1 },
        routes && isTabletLandscapeAndUp && (React.createElement(SubMenuLinks, { items: getMyAccountMenuItems(logout, routes, intl, isUserLoggedIn, isAddressBookEnabled, isAABEnabled, isSubscriptionsV2Enabled, onNavigate) })),
        React.createElement("div", { className: elementName$1 + "__content" }, children)));
};
var mapStateToProps$d = function (state) { return ({
    authState: Selectors.getAuth(state),
    routes: Selectors.getFormattedRoutes(state),
}); };
var dispatchProps = {
    logout: Actions$2.LogoutActions.logOut,
};
var PageWithMenu$1 = connect(mapStateToProps$d, dispatchProps)(PageWithMenu);

var OnlyOnClient = /** @class */ (function (_super) {
    __extends(OnlyOnClient, _super);
    function OnlyOnClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            onServer: true,
        };
        return _this;
    }
    OnlyOnClient.prototype.componentDidMount = function () {
        this.setState({ onServer: false });
    };
    OnlyOnClient.prototype.render = function () {
        return this.state.onServer ? this.props.serverContent : this.props.children;
    };
    OnlyOnClient.defaultProps = {
        serverContent: React.createElement(LoaderScreen, { height: 50 }),
    };
    return OnlyOnClient;
}(React.Component));

var Protected = /** @class */ (function (_super) {
    __extends(Protected, _super);
    function Protected() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.redirectOut = function () {
            var query = _this.returnPath
                ? "returnPath=" + encodeURIComponent("/" + _this.returnPath)
                : undefined;
            _this.props.goto({ route: RouteKey.Login, query: query });
        };
        return _this;
    }
    Protected.prototype.componentDidMount = function () {
        this.returnPath = window.location.pathname.replace('//', '/').replace(/^\//, '');
        if (State.isInitialized(this.props.auth)) {
            this.props.recoverSession();
        }
        else if (State.isLoggedOut(this.props.auth)) {
            this.redirectOut();
        }
    };
    Protected.prototype.render = function () {
        var auth = this.props.auth;
        if (State.isLoggedIn(auth)) {
            return this.props.children;
        }
        return React.createElement(LoaderScreen, { height: 50 });
    };
    Protected.prototype.componentDidUpdate = function (prevProps) {
        if (State.isLoggedOut(this.props.auth)) {
            this.redirectOut();
        }
    };
    return Protected;
}(React.Component));
var mapStateToProps$c = function (state) { return ({
    auth: Selectors.getAuth(state),
}); };
var mapDispatchToProps$b = {
    goto: Actions$2.goto,
    recoverSession: Actions$2.LoginActions.recoverSession,
};
var Protected$1 = connect(mapStateToProps$c, mapDispatchToProps$b)(Protected);

var MyAccountBreadcrumbs = function (_a) {
    var formattedRoutes = _a.formattedRoutes, items = _a.items;
    var getLabel = useIntl().getLabel;
    var breadcrumbs = __spreadArray([
        {
            name: getLabel('account.menu.home') || 'Home',
        }
    ], __read(items.map(function (_a) {
        var name = _a.name, routeKey = _a.routeKey;
        return ({
            name: name,
            url: formattedRoutes && routeKey ? formattedRoutes[routeKey] : undefined,
        });
    })));
    return (React.createElement("div", { className: "myaccount-breadcrumbs" },
        React.createElement(Breadcrumbs, { pages: breadcrumbs })));
};
MyAccountBreadcrumbs.displayName = 'MyAccountBreadcrumbs';
var mapStateToProps$b = function (state) { return ({
    basePath: Selectors.getBasePath(state),
    formattedRoutes: Selectors.getFormattedRoutes(state),
}); };
var MyAccountBreadcrumbs$1 = connect(mapStateToProps$b)(MyAccountBreadcrumbs);

function getBreadcrumbs(segments, intl) {
    return segments.map(function (segment) { return ({
        name: intl.getLabel("account.menu." + segment),
        routeKey: segment,
    }); });
}

var Actions$1 = function (_a) {
    var onEditClick = _a.onEditClick, onDeleteClick = _a.onDeleteClick;
    var getLabel = useIntl().getLabel;
    return (React__default.createElement("div", { className: "address-summary__actions" },
        onEditClick && (React__default.createElement(Button, { className: "address-summary__button", "data-t": "summary-edit-button", variant: "ghost", size: "custom", caption: getLabel('common.actions.edit'), onClick: onEditClick })),
        onDeleteClick && (React__default.createElement(Button, { className: "address-summary__button", "data-t": "summary-edit-button", size: "custom", variant: "ghost", caption: getLabel('common.actions.remove'), onClick: onDeleteClick }))));
};

var Labels = function (_a) {
    var addressTypes = _a.addressTypes;
    var getLabel = useIntl().getLabel;
    return (React__default.createElement("div", { className: "address-summary__labels" },
        React__default.createElement(Hr, null),
        addressTypes.map(function (addressType) { return (React__default.createElement(Label, { key: addressType, className: "address-summary__label", type: "info" }, getLabel("account.addressBook.addressTypes." + addressType))); })));
};

var AddressSummary$1 = function (_a) {
    var address = _a.address, formatter = _a.formatter, title = _a.title, className = _a.className, onDeleteClick = _a.onDeleteClick, onEditClick = _a.onEditClick, rest = __rest(_a, ["address", "formatter", "title", "className", "onDeleteClick", "onEditClick"]);
    var templates = DefaultSummaryTemplates();
    var resolvedFormatter = formatter || templates[SummaryName.addressSummary];
    var data = sanitizeAddress(address);
    var isPreferredAddress = address.addressTypes.length ? true : false;
    var hasActions = onDeleteClick || onEditClick;
    return (React__default.createElement(Summary, __assign({ className: classnames('address-summary', className) }, rest),
        React__default.createElement("div", { className: "address-summary__inner" },
            React__default.createElement("div", { className: "address-summary__content" }, resolvedFormatter({ data: data }, title)),
            hasActions && React__default.createElement(Actions$1, { onDeleteClick: onDeleteClick, onEditClick: onEditClick })),
        isPreferredAddress && React__default.createElement(Labels, { addressTypes: address.addressTypes })));
};

var preferredAddresses = [{ value: 'billing' }, { value: 'delivery' }];
var AddAddress$1 = function (_a) {
    var addressForm = _a.addressForm, address = _a.address, onSubmit = _a.onSubmit, className = _a.className, isCallFailed = _a.isCallFailed, isCallLoading = _a.isCallLoading, isSelectVisible = _a.isSelectVisible, errorMessage = _a.errorMessage, preferredAddress = _a.preferredAddress;
    var getLabel = useIntl().getLabel;
    var _b = __read(React.useState(preferredAddress ? preferredAddress.map(function (value) { return ({ value: value }); }) : []), 2), selectedAddresses = _b[0], setSelectedAddresses = _b[1];
    var _c = __read(React.useState(Util.fieldsToFormState(address || {})), 2), formState = _c[0], setFormState = _c[1];
    return (React.createElement(React.Fragment, null,
        isCallFailed && React.createElement(Alert, { type: "error", message: errorMessage }),
        React.createElement(Form, { name: "address-form", onSubmit: function (formState) {
                if (isCallLoading) {
                    return;
                }
                var state = Util.getValuesFromState(formState.formState);
                var addressTypes = selectedAddresses.reduce(function (acc, _a) {
                    var value = _a.value;
                    return __spreadArray(__spreadArray([], __read(acc)), [value]);
                }, []);
                onSubmit(state, addressTypes);
            }, initialFormState: formState, onChange: function (state) {
                setFormState(state.formState);
            }, className: classnames('address-form', className) },
            React.createElement("fieldset", { disabled: isCallLoading, className: "address-form__fieldset" }, addressForm)),
        isSelectVisible !== false && (React.createElement(CheckboxList, { idPrefix: "address-form_", items: preferredAddresses, renderItem: function (_a) {
                var value = _a.value;
                return getLabel("account.addressBook.preferred." + value);
            }, getItemIdentifier: function (item) { return item.value; }, onChange: setSelectedAddresses, selectedItems: selectedAddresses }))));
};

var AddAddress = function (_a) {
    _a.onSubmit; var props = __rest(_a, ["onSubmit"]);
    var getFormattedLabel = useIntl().getFormattedLabel;
    var addCall = useSelector(getAddCall);
    var isAddCallLoading = statusLoading(addCall);
    var isAddCallFailed = statusFailed(addCall);
    var dispatch = useDispatch();
    var errorMessage = getFormattedLabel('checkout.addressBook.newAddress.error', {
        parseLink: true,
    });
    var listLength = useSelector(getAddressBookListLength);
    var handleSubmit = React.useCallback(function (state, addressTypes) {
        var firstName = state.firstName, lastName = state.lastName, streetName = state.streetName, restAddress = __rest(state, ["firstName", "lastName", "streetName"]);
        dispatch(addAddress(__assign({ firstName: firstName, lastName: lastName, streetName: streetName, addressTypes: addressTypes }, restAddress)));
    }, []);
    return (React.createElement(AddAddress$1, __assign({}, props, { onSubmit: handleSubmit, isCallFailed: isAddCallFailed, isCallLoading: isAddCallLoading, isSelectVisible: !!listLength, errorMessage: errorMessage })));
};

var EditAddress = function (_a) {
    var address = _a.address, props = __rest(_a, ["address"]);
    var getLabel = useIntl().getLabel;
    var editCall = useSelector(getEditCall);
    var isAddCallLoading = statusLoading(editCall);
    var isAddCallFailed = statusFailed(editCall);
    var dispatch = useDispatch();
    var errorMessage = getLabel('checkout.addressBook.newAddress.error');
    var listLength = useSelector(getAddressBookListLength);
    var handleSubmit = React.useCallback(function (state, addressTypes) {
        var firstName = state.firstName, lastName = state.lastName, streetName = state.streetName, restAddress = __rest(state, ["firstName", "lastName", "streetName"]);
        dispatch(editAddressSave({
            address: __assign({ firstName: firstName, lastName: lastName, streetName: streetName, addressTypes: addressTypes }, restAddress),
            id: address.id,
        }));
    }, []);
    var addressTypes = address.addressTypes, addressFields = __rest(address, ["addressTypes"]);
    return (React.createElement(AddAddress$1, __assign({}, props, { onSubmit: handleSubmit, preferredAddress: addressTypes, address: addressFields, isCallFailed: isAddCallFailed, isCallLoading: isAddCallLoading, isSelectVisible: !!listLength, errorMessage: errorMessage })));
};

var Note = function (_a) {
    var message = _a.message;
    var getLabel = useIntl().getLabel;
    return (React.createElement("p", { className: "address-modal__note" },
        React.createElement("strong", null,
            getLabel('account.common.pleaseNote'),
            ":"),
        " ",
        message));
};
var getViewContent = function (activeView, content) { return content[activeView]; };
var AddAddressModal = function (_a) {
    var _b, _c, _d, _e;
    var addressForm = _a.addressForm, onClose = _a.onClose;
    var getLabel = useIntl().getLabel;
    var dispatch = useDispatch();
    var modalState = useSelector(getModalState);
    var addCall = useSelector(getAddCall);
    var editCall = useSelector(getEditCall);
    var isLoading = getViewContent(modalState.viewMode, (_b = {},
        _b[ViewMode.ADD] = statusLoading(addCall),
        _b[ViewMode.DELETE] = false,
        _b[ViewMode.EDIT] = statusLoading(editCall),
        _b));
    var editedAddress = useSelector(getEditedAddress);
    var title = getViewContent(modalState.viewMode, (_c = {},
        _c[ViewMode.ADD] = getLabel('account.addressBook.addAddressLabel'),
        _c[ViewMode.DELETE] = getLabel('account.addressBook.deleteAddressLabel'),
        _c[ViewMode.EDIT] = getLabel('account.addressBook.editAddressLabel'),
        _c));
    return (React.createElement(Modal$2, { className: "address-modal", isOpen: modalState.isOpen, onModalClose: onClose, title: title, showIcon: true, footer: React.createElement("div", { className: "address-modal__buttons" },
            React.createElement(Button, { className: "address-modal__button", caption: getLabel('common.actions.cancel'), onClick: onClose, variant: "outline" }),
            getViewContent(modalState.viewMode, (_d = {},
                _d[ViewMode.ADD] = (React.createElement(Button, { className: "address-modal__button", caption: getLabel('account.addressBook.saveChanges'), type: "submit", form: "address-form", isLoading: isLoading })),
                _d[ViewMode.DELETE] = (React.createElement(Button, { className: "address-modal__button", caption: getLabel('common.actions.remove'), onClick: function () { return dispatch(deleteAddressConfirm()); } })),
                _d[ViewMode.EDIT] = (React.createElement(Button, { className: "address-modal__button", caption: getLabel('account.addressBook.saveChanges'), type: "submit", form: "address-form", isLoading: isLoading })),
                _d))) }, getViewContent(modalState.viewMode, (_e = {},
        _e[ViewMode.ADD] = React.createElement(AddAddress, { addressForm: addressForm }),
        _e[ViewMode.DELETE] = editedAddress && (React.createElement(React.Fragment, null,
            React.createElement(AddressSummary$1, { address: editedAddress }),
            React.createElement(Note, { message: getLabel('account.deleteAddress.note') }))),
        _e[ViewMode.EDIT] = editedAddress && (React.createElement(React.Fragment, null,
            React.createElement(EditAddress, { addressForm: addressForm, address: editedAddress }),
            React.createElement(Note, { message: getLabel('account.editAddress.note') }))),
        _e))));
};

var EmptyAddressBook = function (_a) {
    var toggleAddressModal = _a.toggleAddressModal;
    var getLabel = useIntl().getLabel;
    var buttonLabel = getLabel('account.addressBook.buttonAddAddress');
    return (React.createElement("div", { className: "empty-address-book" },
        React.createElement(Icon, { name: "address-book" }),
        React.createElement(Text, { color: "text-secondary" }, getLabel('account.addressBook.empty')),
        React.createElement(Button, { className: "add-address-button", caption: buttonLabel, variant: "ghost", onClick: function () {
                toggleAddressModal(true);
            } })));
};

var FailedAddressBook = function () {
    var getFormattedLabel = useIntl().getFormattedLabel;
    return (React.createElement(Alert, { type: "error", notifyScreenReader: false, title: getFormattedLabel('account.addressBook.errors.fetchFailed', { parseLink: true }) }));
};

var widthMap = {
    phone: ['80%', '60%', '70%', '50%'],
    default: ['50%', '30%', '40%', '20%'],
};
var Image = React.memo(function (_a) {
    var isPhone = _a.isPhone;
    var widths = isPhone ? widthMap.phone : widthMap.default;
    return (React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "120px" },
        React.createElement("rect", { width: widths[0], height: "15px", rx: "5", fill: "currentColor", y: "0" }),
        React.createElement("rect", { width: widths[1], height: "15px", rx: "5", fill: "currentColor", y: "30" }),
        React.createElement("rect", { width: widths[2], height: "15px", rx: "5", fill: "currentColor", y: "60" }),
        React.createElement("rect", { width: widths[3], height: "15px", rx: "5", fill: "currentColor", y: "90" })));
});
var LoadingAddressBook = function () {
    var isPhone = MediaQuery.useIsPhone();
    return (React.createElement(SkeletonLoader, null,
        React.createElement(Image, { isPhone: isPhone })));
};

var Content = function (_a) {
    var list = _a.list, toggleAddressModal = _a.toggleAddressModal, deleteAddress = _a.deleteAddress, editAddress = _a.editAddress, formatter = _a.formatter;
    if (statusUnavailable(list)) {
        return React.createElement(FailedAddressBook, null);
    }
    if (!list || statusUninit(list) || statusLoading(list)) {
        return React.createElement(LoadingAddressBook, null);
    }
    if (statusWarning(list) || statusFailed(list)) {
        return React.createElement(FailedAddressBook, null);
    }
    if (!list || list.result.length < 1) {
        return React.createElement(EmptyAddressBook, { toggleAddressModal: toggleAddressModal });
    }
    return (React.createElement(React.Fragment, null, list.result.map(function (address) { return (React.createElement(AddressSummary$1, { key: address.id, address: address, formatter: formatter, onDeleteClick: function () {
            deleteAddress(address.id);
        }, onEditClick: function () {
            editAddress(address.id);
        }, className: "address-book__address-summary" })); })));
};
var AddressBook = function (props) {
    var intl = useIntl();
    var getLabel = intl.getLabel;
    var isMobile = MediaQuery.useIsPhone();
    var openModal = React.useCallback(function () {
        props.toggleAddressModal(true);
    }, [props.toggleAddressModal]);
    return (React.createElement("div", { className: "address-book", "data-t": "address-book" },
        React.createElement(MyAccountBreadcrumbs$1, { items: getBreadcrumbs(['profile', 'addressBook'], intl) }),
        React.createElement("div", { className: "address-book__header" },
            React.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title address-book__title" }, getLabel('account.addressBook.title')),
            !isMobile && statusSuccess(props.list) && !!props.list.result.length && (React.createElement(Button, { size: "small", icon: "plus", variant: "outline", caption: getLabel('account.addressBook.buttonAddAddress'), onClick: openModal }))),
        React.createElement(Content, __assign({}, props)),
        isMobile && statusSuccess(props.list) && !!props.list.result.length && (React.createElement(Button, { className: "address-book__mobile-button", icon: "plus", variant: "outline", caption: getLabel('account.addressBook.buttonAddAddress'), onClick: openModal })),
        React.createElement(AddAddressModal, { addressForm: props.addressForm, onClose: props.closeModal })));
};

var AddressBookContainer = function (_a) {
    var addressForm = _a.addressForm;
    return (React.createElement(AddressBook, __assign({ addressForm: addressForm, list: useAddressBookList() }, useAddressBook())));
};
var AddressBookContainer$1 = React.memo(AddressBookContainer);

var BOOK_APPOINTMENT_ROUTE = '/book-appointment';
var PROFILE_PATH = '/my-account/profile';

var toCustomer = function (raw) {
    var _a;
    if (!raw)
        return undefined;
    return {
        firstName: raw.firstName,
        lastName: (_a = raw.lastName) !== null && _a !== void 0 ? _a : undefined,
    };
};
var toAppointment = function (raw) {
    var _a;
    // for some reason this query DOES NOT return dates in the same YYYY-MM-DD
    // format like in the cls queries.
    // TODO: badger BE until they fix it.
    return (_a = raw === null || raw === void 0 ? void 0 : raw.map(function (rawAppointment) {
        var _a, _b;
        return ({
            appointmentType: (_a = rawAppointment === null || rawAppointment === void 0 ? void 0 : rawAppointment.appointmentType) !== null && _a !== void 0 ? _a : undefined,
            customer: toCustomer(rawAppointment.customer),
            endTime: parseISO(rawAppointment.endTime),
            id: rawAppointment.id,
            startTime: parseISO(rawAppointment.startTime),
            store: (_b = rawAppointment === null || rawAppointment === void 0 ? void 0 : rawAppointment.store) !== null && _b !== void 0 ? _b : undefined,
        });
    })) !== null && _a !== void 0 ? _a : null;
};

var AppointmentFragment = gql(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  fragment AppointmentFragment on Appointment {\n    id\n    appointmentType {\n      name\n      label\n      duration {\n        amount\n        unit\n      }\n    }\n    startTime\n    endTime\n    customer {\n      firstName\n      lastName\n    }\n    store {\n      name\n      code\n    }\n  }\n"], ["\n  fragment AppointmentFragment on Appointment {\n    id\n    appointmentType {\n      name\n      label\n      duration {\n        amount\n        unit\n      }\n    }\n    startTime\n    endTime\n    customer {\n      firstName\n      lastName\n    }\n    store {\n      name\n      code\n    }\n  }\n"])));
var templateObject_1$w;

var GET_MY_APPOINTMENTS = gql(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  query getMyAppointments {\n    me {\n      id\n      appointments {\n        ...AppointmentFragment\n      }\n    }\n  }\n  ", "\n"], ["\n  query getMyAppointments {\n    me {\n      id\n      appointments {\n        ...AppointmentFragment\n      }\n    }\n  }\n  ", "\n"])), AppointmentFragment);
var templateObject_1$v;

var useAppointments = function () {
    var _a;
    var _b = useQuery(GET_MY_APPOINTMENTS), data = _b.data, rest = __rest(_b, ["data"]);
    return __assign({ data: toAppointment((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.appointments), isRefetching: rest.networkStatus === NetworkStatus.refetch }, rest);
};

var getAppointments = createSelector(Selectors.getAuth, getMyAccount, function (auth, myAccount) {
    return State.isLoggedIn(auth) ? myAccount.appointments : undefined;
});
var getCurrentStore = createSelector(getAppointments, function (appointments) {
    return appointments ? appointments.currentStore : undefined;
});
var getStoreCall = createSelector(getAppointments, function (appointments) {
    return appointments ? appointments.storeCall : idleState();
});
var getCancelCall = createSelector(getAppointments, function (appointments) {
    return appointments ? appointments.cancelCall : idleState();
});

var FooterButton = function (_a) {
    var caption = _a.caption, onClick = _a.onClick, isLoading = _a.isLoading;
    return (React.createElement(Button, { type: "submit", form: "cancellation-reason", caption: caption, className: "cancel-appointment__button", "data-t": "cancel-appointment-modal-cancel", onClick: onClick, disabled: isLoading, variant: "outline", size: "medium" }));
};
FooterButton.displayName = 'FooterButton';
var CancelAppointmentModal = /** @class */ (function (_super) {
    __extends(CancelAppointmentModal, _super);
    function CancelAppointmentModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            formState: {
                formState: {},
                formValid: true,
                formName: 'cancellation-reason',
            },
        };
        return _this;
    }
    CancelAppointmentModal.prototype.componentDidUpdate = function (prevProps) {
        // if previous status was loading, and now idle, assume success
        if (statusLoading(prevProps.cancelCall) && statusIdle(this.props.cancelCall)) {
            this.props.traceCancelAppointment(this.props.appointment);
            this.props.onClose();
        }
    };
    CancelAppointmentModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, appointment = _a.appointment, cancelCall = _a.cancelCall, cancelAppointment = _a.cancelAppointment, onClose = _a.onClose, intl = _a.intl;
        var getLabel = intl.getLabel, getFormattedLabel = intl.getFormattedLabel;
        var onCancelClick = function (state) {
            var cancellationReason = state.formState.reason && state.formState.reason.value;
            cancelAppointment({ id: appointment.id, cancellationReason: cancellationReason });
        };
        var buttonCaption = statusLoading(cancelCall)
            ? getLabel('common.loadingText')
            : getLabel('account.appointment.action.cancelAppointment');
        return (React.createElement(Modal$2, { showIcon: true, isOpen: true, onModalClose: onClose, title: getLabel('account.appointment.cancel.title'), footer: React.createElement(FooterButton, { caption: buttonCaption, onClick: function () { return onCancelClick(_this.state.formState); }, isLoading: statusLoading(cancelCall) }), className: classnames(className, 'cancel-appointment') },
            React.createElement(Form, { name: "cancellation-reason", onBlur: function (formState) { return _this.setState({ formState: formState }); }, onSubmit: onCancelClick },
                statusFailed(this.props.cancelCall) && (React.createElement(Alert, { type: "error", icon: "warning", message: getFormattedLabel('account.appointment.cancel.error.general', {
                        parseLink: true,
                    }) })),
                React.createElement("p", { className: "cancel-appointment__description" }, getLabel('account.appointment.cancel.description')),
                React.createElement(TextArea, { name: "reason", label: getLabel('account.appointment.cancel.reason.label'), placeholder: getLabel('account.appointment.cancel.reason.placeholder'), maxLength: 255, errorMessage: "" // this message will never show
                 }))));
    };
    return CancelAppointmentModal;
}(React.Component));
var mapStateToProps$a = function (state) { return ({
    cancelCall: getCancelCall(state),
}); };
var mapDispatchToProps$a = {
    cancelAppointment: cancel,
    traceCancelAppointment: cancelAppointment,
};
var CancelAppointmentModal$1 = connect(mapStateToProps$a, mapDispatchToProps$a)(withIntl(CancelAppointmentModal));

var ButtonAsLink = React__default.forwardRef(function (_a, ref) {
    var caption = _a.caption, className = _a.className, onClick = _a.onClick;
    return (React__default.createElement("button", { className: classnames('button-as-link', className), onClick: onClick, ref: ref }, caption));
});
ButtonAsLink.displayName = 'ButtonAsLink';

var StoreDetailModal = function (_a) {
    var storeCode = _a.storeCode, onModalClose = _a.onModalClose;
    var getFormattedLabel = useIntl().getFormattedLabel;
    var dispatch = useDispatch();
    var store = useSelector(getCurrentStore);
    var storeCall = useSelector(getStoreCall);
    useEffect(function () {
        dispatch(fetchStore({ storeCode: storeCode }));
    }, [storeCode, dispatch]);
    if (statusFailed(storeCall))
        return React__default.createElement(Alert, { message: getFormattedLabel('common.error.network') });
    return (React__default.createElement(Modal$2, { isOpen: true, showIcon: true, className: "store-modal", onModalClose: onModalClose },
        statusLoading(storeCall) && React__default.createElement(Loader$1, null),
        store && (React__default.createElement(StoreDetail, { className: "store-detail--modal", store: store, googleMaps: {
                defaultZoom: 9,
            } }))));
};

var AppointmentSummary = function (_a) {
    var appointment = _a.appointment, className = _a.className, openCancelModal = _a.openCancelModal, rescheduleLink = _a.rescheduleLink, _b = _a.ariaLevel, ariaLevel = _b === void 0 ? 4 : _b, onReschedule = _a.onReschedule;
    var id = appointment.id, appointmentType = appointment.appointmentType, startTime = appointment.startTime, endTime = appointment.endTime, customer = appointment.customer, store = appointment.store;
    var _c = useIntl(), dateTime = _c.dateTime, getLabel = _c.getLabel;
    var durationString = (appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.duration)
        ? "(" + appointmentType.duration.amount + " " + getLabel("appointments.shortTimeUnits." + appointmentType.duration.unit.toLowerCase()) + ")"
        : '';
    var _d = __read(React.useState(false), 2), storeDetailModalOpen = _d[0], setStoreDetailModalOpen = _d[1];
    var storeButtonRef = React.createRef();
    var onStoreDetailModalOpen = React.useCallback(function () { return setStoreDetailModalOpen(true); }, []);
    var onStoreDetailModalClose = React.useCallback(function () {
        storeButtonRef.current && storeButtonRef.current.focus();
        setStoreDetailModalOpen(false);
    }, [storeButtonRef]);
    var onDeleteClick = function () {
        openCancelModal(id);
    };
    return (React.createElement(Summary, { className: classnames('myaccount-appointment-summary', className), onDeleteClick: onDeleteClick },
        customer && (React.createElement(Heading, { variant: "smallest", className: "myaccount-appointment-summary__title", "aria-level": ariaLevel },
            customer.firstName,
            " ", customer === null || customer === void 0 ? void 0 :
            customer.lastName)),
        (appointmentType === null || appointmentType === void 0 ? void 0 : appointmentType.name) && (React.createElement("b", { className: "myaccount-appointment-summary__item" },
            appointmentType.name,
            " ",
            durationString)),
        isValid(startTime) && isValid(endTime) && (React.createElement("div", { className: "myaccount-appointment-summary__time-date" },
            React.createElement("p", { className: "myaccount-appointment-summary__item" }, dateTime.formatLongDate(startTime)),
            React.createElement("p", { className: "myaccount-appointment-summary__item" }, dateTime.formatTime(startTime) + " - " + dateTime.formatTime(endTime)),
            React.createElement(Link, { className: "myaccount-appointment-summary__reschedule", url: rescheduleLink, onClick: onReschedule }, getLabel('appointments.reschedule')))),
        store && (React.createElement(React.Fragment, null,
            React.createElement("p", { className: "myaccount-appointment-summary__item" }, store.name),
            React.createElement("p", { className: "myaccount-appointment-summary__item" },
                React.createElement(ButtonAsLink, { ref: storeButtonRef, onClick: onStoreDetailModalOpen, caption: getLabel('account.appointment.summary.openStoreDetail') })))),
        store && storeDetailModalOpen && (React.createElement(StoreDetailModal, { storeCode: store.code, onModalClose: onStoreDetailModalClose }))));
};

var AppointmentsList = function (_a) {
    var appointments = _a.appointments, bookAppointmentRoute = _a.bookAppointmentRoute, myAppointmentsRoute = _a.myAppointmentsRoute;
    // used both to determine if cancel appointment modal needs to open as well
    // as for which appointment it should be active by setting it to a reference
    // of the appointment
    var _b = __read(useState(null), 2), activeCancelModal = _b[0], setActiveCancelModal = _b[1];
    var getLabel = useIntl().getLabel;
    var dispatch = useDispatch();
    var closeModal = function () {
        setActiveCancelModal(null);
    };
    var handleOpenCancelModal = function (id) {
        var toOpen = appointments.find(function (ap) { return ap.id === id; }) || null;
        setActiveCancelModal(toOpen);
    };
    var returnLabel = encodeURIComponent(getLabel('appointments.rescheduling.returnLabel'));
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Text, null, getLabel('appointments.overview.message')),
        appointments.map(function (appointment) {
            var reschedulePath = bookAppointmentRoute + "?appointmentId=" + appointment.id + "&returnPath=" + myAppointmentsRoute + "&returnLabel=" + returnLabel;
            var handleOnReschedule = function () {
                dispatch(rescheduleAppointment(appointment));
            };
            return (React__default.createElement(AppointmentSummary, { appointment: appointment, openCancelModal: handleOpenCancelModal, rescheduleLink: reschedulePath, onReschedule: handleOnReschedule, ariaLevel: 4, key: appointment.id }));
        }),
        React__default.createElement(Button, { className: "appointmentslist__book-appointment", href: bookAppointmentRoute, caption: getLabel('appointments.bookAppointment'), size: "small" }),
        activeCancelModal !== null && (React__default.createElement(CancelAppointmentModal$1, { appointment: activeCancelModal, onClose: closeModal }))));
};

var NoAppointmentsView = function (_a) {
    var bookAppointmentRoute = _a.bookAppointmentRoute;
    var getLabel = useIntl().getLabel;
    return (React__default.createElement("div", { className: "myaccount-no-appointments" },
        React__default.createElement("p", { className: "myaccount-no-appointments__message" }, getLabel('appointments.noAppointments.message')),
        React__default.createElement(Button, { href: bookAppointmentRoute, caption: getLabel('appointments.bookAppointment'), size: "small", className: "myaccount-no-appointments__link" })));
};

var AppointmentBody = function (_a) {
    var appointments = _a.appointments, bookAppointmentRoute = _a.bookAppointmentRoute, myAppointmentsRoute = _a.myAppointmentsRoute;
    return appointments.length < 1 ? (React__default.createElement(NoAppointmentsView, { bookAppointmentRoute: bookAppointmentRoute })) : (React__default.createElement(AppointmentsList, { appointments: appointments, bookAppointmentRoute: bookAppointmentRoute, myAppointmentsRoute: myAppointmentsRoute }));
};

var AppointmentsContainer = function (_a) {
    var _b;
    var bookAppointmentRoute = _a.bookAppointmentRoute;
    var _c = useIntl(), getLabel = _c.getLabel, getFormattedLabel = _c.getFormattedLabel;
    var dispatch = useDispatch();
    var accountRoutes = useSelector(Selectors.getFormattedRoutes);
    var _d = useAppointments(), appointments = _d.data, loading = _d.loading, error = _d.error, isRefetching = _d.isRefetching, refetch = _d.refetch;
    var routeLabel = getLabel("account.menu.appointments");
    var breadcrumbs = [{ name: routeLabel }];
    useSaga(useMemo(function () {
        return function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, takeLatest(function (a) { return actions$b.isType(a, cancelSuccess); }, refetch)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        };
    }, [refetch]));
    useEffect(function () {
        if (loading || appointments === null)
            return;
        dispatch(appointmentsView(appointments));
    }, [appointments, dispatch, loading]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MyAccountBreadcrumbs$1, { items: breadcrumbs }),
        React__default.createElement(Heading, { variant: "small", className: "myaccount-page-title" }, routeLabel),
        loading || isRefetching ? (React__default.createElement(Loader$1, null)) : error || appointments === null ? ( // not loading but has error
        React__default.createElement(Alert, { type: "error", message: getFormattedLabel('common.error.network') })) : (
        // not loading and no error
        React__default.createElement(AppointmentBody, { appointments: appointments, bookAppointmentRoute: bookAppointmentRoute || BOOK_APPOINTMENT_ROUTE, myAppointmentsRoute: (_b = accountRoutes === null || accountRoutes === void 0 ? void 0 : accountRoutes.appointments) !== null && _b !== void 0 ? _b : '' }))));
};

var PreferredStore = function (_a) {
    var callStatus = _a.callStatus, onStoreSelect = _a.onStoreSelect, onCancel = _a.onCancel, onSave = _a.onSave, disableSave = _a.disableSave;
    var getLabel = useIntl().getLabel;
    return (React.createElement(React.Fragment, null,
        React.createElement(PreferredStoreFinder, { onStoreSelect: onStoreSelect, selected: undefined }),
        React.createElement("div", { className: "preferred-store__footer" },
            React.createElement(Button, { "data-t": "close-preferred-store", variant: "outline", color: "secondary", caption: getLabel('account.profile.preferredStore.cancel'), onClick: onCancel }),
            React.createElement(Button, { caption: getLabel('account.action.save'), isLoading: !callStatus || statusLoading(callStatus[Types.FormName.preferredStore]), type: "button", onClick: onSave, disabled: disableSave }))));
};

var PreferredStoreSummary = function (_a) {
    var preferredStoreCode = _a.preferredStoreCode, onEdit = _a.onEdit, formatter = _a.formatter, className = _a.className;
    var intl = useIntl();
    var storesUrl = useApiConfig().storesUrl;
    var params = React.useMemo(function () { return ({
        code: preferredStoreCode,
    }); }, [preferredStoreCode]);
    var _b = __read(useApiClient(Stores.getDetailsByCode, null, storesUrl, params), 3), isLoading = _b[0], store = _b[1], error = _b[2];
    if (isLoading) {
        return React.createElement(SummaryLoader, null);
    }
    if (error) {
        return (React.createElement(Alert, { title: intl.getFormattedLabel('account.profile.preferredStore.notFound', {
                parseLink: true,
            }) }));
    }
    if (!store) {
        return React.createElement("span", null, intl.getLabel('account.profile.preferredStore.noStoreSelected'));
    }
    return (React.createElement(Summary, { className: className, onEditClick: onEdit }, formatter({ data: store })));
};

var Appointment = function (_a) {
    var profileRoute = _a.profileRoute, bookAppointmentRoute = _a.bookAppointmentRoute, upcomingAppointment = _a.upcomingAppointment;
    var getLabel = useIntl().getLabel;
    var _b = __read(React.useState(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var openModal = React.useCallback(function () {
        setIsModalOpen(true);
    }, []);
    var closeModal = React.useCallback(function () {
        setIsModalOpen(false);
    }, []);
    var id = upcomingAppointment.id;
    var returnLabel = encodeURIComponent(getLabel('account.appointment.returnPath'));
    var reschedulePath = (bookAppointmentRoute.startsWith('/') ? bookAppointmentRoute : "/" + bookAppointmentRoute) + "?appointmentId=" + id + "&returnPath=" + profileRoute + "&returnLabel=" + returnLabel;
    return (React.createElement(React.Fragment, null,
        React.createElement(AppointmentSummary, { className: "myaccount-profile__summary upcoming-appointment__summary", appointment: upcomingAppointment, rescheduleLink: reschedulePath, ariaLevel: 5, openCancelModal: openModal }),
        isModalOpen && (React.createElement(CancelAppointmentModal$1, { appointment: upcomingAppointment, onClose: closeModal }))));
};
Appointment.displayName = 'Appointment';

var FailedAppointment = function () {
    var getLabel = useIntl().getLabel;
    return React.createElement(Alert, { type: "error", title: getLabel('account.appointments.errors.fetchFailed') });
};
FailedAppointment.displayName = 'FailedAppointment';

var LoadingAppointment = function () { return (React.createElement(SkeletonLoader, null,
    React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", height: "60px" },
        React.createElement("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor" }),
        React.createElement("rect", { width: "25%", height: "15px", rx: "5", fill: "currentColor", y: "30" })))); };
LoadingAppointment.displayName = 'LoadingAppointment';

var UpcomingAppointment = function (_a) {
    var bookAppointmentRoute = _a.bookAppointmentRoute;
    var getLabel = useIntl().getLabel;
    var dispatch = useDispatch();
    var _b = useAppointments(), appointments = _b.data, loading = _b.loading, error = _b.error;
    var accountRoutes = useSelector(Selectors.getFormattedRoutes);
    var bookAppointmentRouteWithFallback = bookAppointmentRoute || BOOK_APPOINTMENT_ROUTE;
    if (loading) {
        return React__default.createElement(LoadingAppointment, null);
    }
    else if (error || appointments === null) {
        return React__default.createElement(FailedAppointment, null);
    }
    else if (appointments.length === 0) {
        return React__default.createElement(NoAppointmentsView, { bookAppointmentRoute: bookAppointmentRouteWithFallback });
    }
    else {
        dispatch(upcomingAppointmentView(appointments[0]));
        return (React__default.createElement("div", { className: "myaccount-profile-appointment" },
            React__default.createElement(Appointment, { upcomingAppointment: appointments[0], profileRoute: (accountRoutes === null || accountRoutes === void 0 ? void 0 : accountRoutes.profile) || PROFILE_PATH, bookAppointmentRoute: bookAppointmentRouteWithFallback }),
            React__default.createElement("div", { className: "myaccount-profile-appointment__actions" },
                React__default.createElement(Button, { href: bookAppointmentRouteWithFallback, caption: getLabel('appointments.bookAppointment'), size: "small", className: "myaccount-profile-appointment__book-appointment" }),
                React__default.createElement(Link, { className: "myaccount-profile-appointment__view-all", url: accountRoutes === null || accountRoutes === void 0 ? void 0 : accountRoutes.appointments }, getLabel('appointments.viewAll')))));
    }
};

var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleFormChange = debounce(250, function (form) {
            _this.props.changeFormValue({ form: form });
        });
        _this.handleChangePreferredStore = function (store) {
            _this.handleFormChange({
                formName: Types.FormName.preferredStore,
                formState: { code: { name: 'code', value: store.code } },
                formValid: true,
            });
        };
        _this.handleUpdateUserData = function (formName) { return function () {
            _this.props.updateUserData(formName);
        }; };
        _this.isInEditMode = function (formName) {
            var formState = _this.props.formState && _this.props.formState[formName];
            return formState ? formState.inEditMode : false;
        };
        _this.toggleEditMode = function (formName, inEditMode) {
            if (inEditMode === void 0) { inEditMode = true; }
            return function () {
                return _this.props.toggleFormEditMode({ formName: formName, inEditMode: inEditMode });
            };
        };
        _this.editPersonalDetails = _this.toggleEditMode(Types.FormName.personalDetails);
        _this.editBillingAddress = _this.toggleEditMode(Types.FormName.billingAddress);
        _this.editPreferredStore = _this.toggleEditMode(Types.FormName.preferredStore);
        _this.closePreferredStore = _this.toggleEditMode(Types.FormName.preferredStore, false);
        _this.handleSavePersonalDetails = _this.handleUpdateUserData(Types.FormName.personalDetails);
        _this.handleSaveBillingAddress = _this.handleUpdateUserData(Types.FormName.billingAddress);
        _this.handleSavePreferredStore = _this.handleUpdateUserData(Types.FormName.preferredStore);
        _this.renderErrorAlert = function (formName) {
            var _a = _this.props, intl = _a.intl, callStatus = _a.callStatus;
            return (callStatus &&
                statusFailed(callStatus[formName]) && (React__default.createElement(ScrollIntoView, null,
                React__default.createElement(Alert, { type: "error", message: intl.getFormattedLabel('account.profile.updateProfile.errors.general', {
                        parseLink: true,
                    }) }))));
        };
        return _this;
    }
    Profile.prototype.componentDidMount = function () {
        this.props.fetchUserData();
    };
    Profile.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d;
        var _e = this.props, auth = _e.auth, myAccount = _e.myAccount, bookAppointmentRoute = _e.bookAppointmentRoute, formState = _e.formState, personalDetailsForm = _e.personalDetailsForm, addressForm = _e.addressForm, addressSummary = _e.addressSummary, personalDetailsSummary = _e.personalDetailsSummary, preferredStoreSummary = _e.preferredStoreSummary, callStatus = _e.callStatus, intl = _e.intl, personalGreetingFormatter = _e.personalGreetingFormatter;
        var ROUTE_KEY = RouteKey.Profile;
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        if (auth.type !== 'regular') {
            throw new Error("Can't look at the Profile page with passwordless login");
        }
        var userData = myAccount.profile.userData;
        var preferredStoreCode = (_d = (_c = (_b = (_a = formState === null || formState === void 0 ? void 0 : formState.preferredStore) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b.formState) === null || _c === void 0 ? void 0 : _c.code) === null || _d === void 0 ? void 0 : _d.value;
        if (statusSuccess(userData)) {
            var personalDetailsData = userData.result ? userData.result.personalDetails : {};
            var openSections_1 = [0];
            var sections = [
                {
                    title: intl.getLabel('account.profile.personalDetails'),
                    body: (React__default.createElement("div", { className: "section__body" },
                        React__default.createElement("p", null, intl.getLabel('account.profile.personalDetails.intro')),
                        this.isInEditMode(Types.FormName.personalDetails) ? (React__default.createElement(React__default.Fragment, null,
                            this.renderErrorAlert(Types.FormName.personalDetails),
                            React__default.createElement(Form, { name: "personalDetails", "data-t": "personalDetails", initialFormState: formState &&
                                    formState.personalDetails &&
                                    formState.personalDetails.state &&
                                    formState.personalDetails.state.formState, onChange: this.handleFormChange }, personalDetailsForm),
                            React__default.createElement("div", { className: "myaccount-profile__email" },
                                React__default.createElement("div", { className: "form-control__label" }, intl.getLabel('checkout.contact.email')),
                                React__default.createElement("div", null, auth.email)),
                            React__default.createElement("div", { className: "myaccount-profile__button-container" },
                                React__default.createElement(Button, { caption: intl.getLabel('account.action.save'), isLoading: !callStatus || statusLoading(callStatus[Types.FormName.personalDetails]), type: "button", "data-t": "save-personal-details", onClick: this.handleSavePersonalDetails, disabled: !this.props.formValidity.personalDetails, className: "myaccount-profile__button" })))) : (React__default.createElement(Summary, { className: "myaccount-profile__summary", onEditClick: this.editPersonalDetails }, personalDetailsSummary({
                            data: personalDetailsData || {},
                            email: auth.email,
                        }))))),
                },
                {
                    title: intl.getLabel('account.profile.preferredStore'),
                    body: (React__default.createElement("div", { className: "section__body preferred-store" },
                        this.renderErrorAlert(Types.FormName.preferredStore),
                        !preferredStoreCode && !this.isInEditMode(Types.FormName.preferredStore) && (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement("p", null, intl.getLabel('account.profile.preferredStore.noStoreSelected')),
                            React__default.createElement(Button, { "data-t": "edit-preferred-store", className: "preferred-store__add-store myaccount-profile__button", caption: intl.getLabel('account.profile.preferredStore.addStore'), color: "secondary", onClick: this.editPreferredStore }))),
                        preferredStoreCode && !this.isInEditMode(Types.FormName.preferredStore) && (React__default.createElement(PreferredStoreSummary, { preferredStoreCode: preferredStoreCode, formatter: preferredStoreSummary, onEdit: this.editPreferredStore, className: "myaccount-profile__summary" })),
                        this.isInEditMode(Types.FormName.preferredStore) && (React__default.createElement(ErrorBoundary, null, function (error) {
                            return error ? (React__default.createElement(Alert, { type: "error", title: intl.getLabel('account.profile.preferredStore.errors.fetchFailed') })) : (React__default.createElement(PreferredStore, { callStatus: callStatus, onCancel: _this.closePreferredStore, onSave: _this.handleSavePreferredStore, disableSave: !preferredStoreCode, onStoreSelect: _this.handleChangePreferredStore }));
                        })))),
                },
            ];
            if (!auth.disableAddressEditing) {
                sections.splice(1, 0, {
                    title: intl.getLabel('account.billingAddress'),
                    body: (React__default.createElement("div", { className: "section__body" },
                        React__default.createElement("p", null, intl.getLabel('account.profile.billingAddress.intro')),
                        this.isInEditMode(Types.FormName.billingAddress) ? (React__default.createElement(React__default.Fragment, null,
                            this.renderErrorAlert(Types.FormName.billingAddress),
                            React__default.createElement(Form, { name: "billingAddress", "data-t": "billingAddress", initialFormState: formState &&
                                    formState.billingAddress &&
                                    formState.billingAddress.state &&
                                    formState.billingAddress.state.formState, onChange: this.handleFormChange },
                                addressForm,
                                React__default.createElement("div", { className: "myaccount-profile__button-container" },
                                    React__default.createElement(Button, { caption: intl.getLabel('account.action.save'), isLoading: !callStatus || statusLoading(callStatus[Types.FormName.billingAddress]), type: "button", "data-t": "save-billing-address", onClick: this.handleSaveBillingAddress, disabled: !this.props.formValidity.billingAddress, className: "myaccount-profile__button" }))))) : (React__default.createElement(Summary, { className: "myaccount-profile__summary", onEditClick: this.editBillingAddress }, addressSummary({
                            data: userData.result.billingAddress || {},
                        }))))),
                });
            }
            if (auth.isAabEnabled) {
                sections.splice(0, 0, {
                    title: intl.getLabel('account.appointments.title'),
                    body: React__default.createElement(UpcomingAppointment, { bookAppointmentRoute: bookAppointmentRoute }),
                });
                openSections_1.push(1);
            }
            return (React__default.createElement("div", { className: "myaccount-profile" },
                React__default.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                React__default.createElement("div", { className: "myaccount-profile__wrapper" },
                    React__default.createElement("div", { className: "welcome-message" },
                        React__default.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title" }, personalGreetingFormatter({
                            data: personalDetailsData,
                            getLabel: intl.getFormattedLabel,
                        }) || intl.getLabel('account.profile.title')),
                        React__default.createElement("p", null, intl.getLabel('account.profile.intro'))),
                    React__default.createElement(Accordion, null, sections.map(function (section, i) { return (React__default.createElement(AccordionItem, { key: i, id: section.title.replace(' ', '-'), label: section.title, expanded: openSections_1.includes(i) }, section.body)); })))));
        }
        else if (statusLoading(userData) || statusUninit(userData)) {
            return React__default.createElement(Loader$1, null);
        }
        return (React__default.createElement(Alert, { type: "error", message: intl.getFormattedLabel('account.profile.updateProfile.errors.general', {
                parseLink: true,
            }) }));
    };
    return Profile;
}(Component));
var mapStateToProps$9 = function (state) { return ({
    auth: Selectors.getAuth(state),
    myAccount: getMyAccount(state),
    userData: getUserData(state),
    formState: getForms(state),
    formValidity: getFormValidity(state),
    callStatus: getCallStatus(state),
}); };
var mapDispatchToProps$9 = {
    changeFormValue: changeFormValue,
    fetchUserData: fetchUserData$1,
    updateUserData: updateUserData$1,
    toggleFormEditMode: toggleFormEditMode,
};
var Profile$1 = connect(mapStateToProps$9, mapDispatchToProps$9)(withApiConfig(withIntl(Profile)));

var alreadyLoaded = function (paged) {
    return paged.pages.reduce(function (total, page) { return total + page.length; }, 0);
};

var isMixedItemsReorderAvailable = function (lineItems, isPrescriptionGlassesReorderEnabled) {
    return !Orders$2.isSubscriptionItemInArray(lineItems) &&
        (isPrescriptionGlassesReorderEnabled || !Orders$2.isPrescriptionBundleInArray(lineItems));
};

var DetailHeaderItem = function (_a) {
    var term = _a.term, definition = _a.definition, className = _a.className;
    return (React.createElement(React.Fragment, null,
        React.createElement("dt", { className: classnames('detail-header__term', className) }, term),
        React.createElement("dd", { className: classnames('detail-header__definition', className) }, definition)));
};
var DetailHeader = function (_a) {
    var className = _a.className, children = _a.children;
    var childArray = React.Children.toArray(children);
    var kids = childArray.map(function (child) {
        return React.isValidElement(child)
            ? React.cloneElement(child, {
                className: "columns-" + childArray.length,
            })
            : child;
    });
    return React.createElement("dl", { className: classnames('detail-header', className) }, kids);
};
DetailHeader.Item = DetailHeaderItem;

var getProductTitle = function (product, locale) {
    switch (product.attributesType) {
        case 'sunglasses': {
            var _a = product.attributes, brand_1 = _a.brand, brandModel = _a.brandModel;
            return "" + brand_1 + (brandModel ? " " + brandModel : '');
        }
        case 'frames':
            return product.attributes.brand;
        case 'prescriptionGlasses':
            var _b = product.attributes, brand = _b.brand, brandModelCode = _b.brandModelCode;
            return "" + brand + (brandModelCode ? " " + brandModelCode : '');
        default:
            return getLocalizedValue(product.name, locale || 'en');
    }
};

function getLensAttrLabel(intl, key) {
    var PREFIX = 'products.contactLenses';
    var opts = { hideLabelKey: true };
    return {
        power: intl.getLabel(PREFIX + ".prescription.power", opts),
        baseCurve: intl.getLabel(PREFIX + ".prescription.baseCurve", opts),
        diameter: intl.getLabel(PREFIX + ".prescription.diameter", opts),
        cylinder: intl.getLabel(PREFIX + ".prescription.cylinder", opts),
        axis: intl.getLabel(PREFIX + ".prescription.axis", opts),
        addition: intl.getLabel(PREFIX + ".prescription.addition", opts),
        left: intl.getLabel(PREFIX + ".leftEye", opts),
        right: intl.getLabel(PREFIX + ".rightEye", opts),
        both: '',
    }[key];
}
function getProductA11yLabel(intl, product, quantity) {
    var quantityLabel = intl.getLabel('cart.item.quantity');
    var a11yLabel = getProductTitle(product, intl.locale);
    if (quantity) {
        a11yLabel += ", " + quantityLabel + ": " + quantity;
    }
    if (Orders$2.isDetailContactLenses(product)) {
        var _a = product.attributes, power = _a.power, baseCurve = _a.baseCurve, diameter = _a.diameter, cylinder = _a.cylinder, axis = _a.axis, addition = _a.addition, eyeSide = _a.eyeSide;
        // prepend label with eyeSide if eyeSide is 'left' or 'right'
        if (eyeSide && getLensAttrLabel(intl, eyeSide)) {
            a11yLabel = getLensAttrLabel(intl, eyeSide) + ", " + a11yLabel;
        }
        var lensAttributes = {
            power: power,
            baseCurve: baseCurve,
            diameter: diameter,
            cylinder: cylinder,
            axis: axis,
            addition: addition,
        };
        return Object.entries(lensAttributes).reduce(function (acc, _a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var label = getLensAttrLabel(intl, key);
            if (!label || !value) {
                return acc;
            }
            return acc + (", " + label + ": " + value);
        }, a11yLabel);
    }
    return a11yLabel;
}

var getProductQuantity = function (product, quantity) {
    var intl = useIntl();
    switch (product.attributesType) {
        case 'Contact-lens-bundles':
            var _a = product.attributes, isSubscription = _a.isSubscription, months = _a.months;
            var monthLabel = months <= 1
                ? intl.getLabel('account.contactLensBundles.month')
                : intl.getLabel('account.contactLensBundles.months');
            return isSubscription
                ? intl.getLabel('account.contactLensBundles.subtitle')
                : months + " " + monthLabel;
        default:
            return quantity;
    }
};

var getProductSubtitle$1 = function (product, locale) {
    if (locale === void 0) { locale = 'en'; }
    var intl = useIntl();
    switch (product.attributesType) {
        case 'Contact-lenses':
            var _a = product.attributes, packageQuantity = _a.packageQuantity, replacementFrequency = _a.replacementFrequency, eyeSide = _a.eyeSide;
            var eyeSideLabelKey = eyeSide === 'left' ? 'products.contactLenses.leftEye' : 'products.contactLenses.rightEye';
            return packageQuantity + " " + replacementFrequency.en + " " + intl.getLabel('products.unit.contactLenses') + " " + intl.getLabel('products.perBox') + ", " + intl.getLabel(eyeSideLabelKey);
        case 'Contact-lens-bundles':
            var lensType = product.attributes.lensType;
            return getLocalizedValue(lensType, locale);
        case 'Solutions':
            var volume = product.attributes.volume;
            return "" + volume + intl.getLabel('products.unit.metric.liter.milli.abbr');
        case 'contactLensSubscription':
            return '';
        case 'sunglasses':
            var _b = product.attributes, brandModel = _b.brandModel, brandModelCode = _b.brandModelCode;
            if (!brandModelCode || (brandModel === null || brandModel === void 0 ? void 0 : brandModel.includes(brandModelCode)))
                return '';
            return brandModelCode;
    }
    if ('attributes' in product && 'brandModel' in product.attributes) {
        return product.attributes.brandModel;
    }
};

var getDiscountIfDifferent = function (catalogPrice, discountPrice) {
    return catalogPrice !== discountPrice ? discountPrice : undefined;
};
var getLineItemProps = function (lineItem, includeAddOns) {
    var _a, _b, _c;
    if (Orders$2.isPrescriptionGlasses(lineItem.product)) {
        var catalogPrice = lineItem.catalogPrice, discountedPrice = lineItem.discountedPrice, totalPrice = lineItem.totalPrice, product = lineItem.product, quantity = lineItem.quantity;
        var price = product.lineItemDetail.bundleMainLineItem.price;
        var mainPrice = __assign(__assign({}, catalogPrice), { amount: includeAddOns ? catalogPrice.amount : price.value.centAmount });
        var discountPrice = includeAddOns
            ? (_a = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.amount) !== null && _a !== void 0 ? _a : discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.amount
            : (_b = price.discounted) === null || _b === void 0 ? void 0 : _b.value.centAmount;
        return {
            product: product,
            catalogPrice: mainPrice,
            discountPrice: getDiscountIfDifferent(catalogPrice.amount, discountPrice),
            quantity: quantity,
        };
    }
    else {
        var product = lineItem.product, catalogPrice = lineItem.catalogPrice, discountedPrice = lineItem.discountedPrice, totalPrice = lineItem.totalPrice, quantity = lineItem.quantity;
        var discountPrice = (_c = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.amount) !== null && _c !== void 0 ? _c : discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.amount;
        return {
            product: product,
            catalogPrice: catalogPrice,
            discountPrice: getDiscountIfDifferent(catalogPrice.amount, discountPrice),
            quantity: quantity,
        };
    }
};

var allowedKeys = [
    'power',
    'baseCurve',
    'diameter',
    'cylinder',
    'axis',
    'addition',
    'pupillaryDistance',
];
var getProductPrescriptionAttributes = function (attributes) {
    var keys = Object.keys(attributes).filter(function (attribute) { return allowedKeys.includes(attribute); });
    return keys.reduce(function (prescription, attributeName) {
        var _a;
        return (__assign(__assign({}, prescription), (_a = {}, _a[attributeName] = attributes[attributeName], _a)));
    }, {});
};

var PaymentStatusLabelKey;
(function (PaymentStatusLabelKey) {
    PaymentStatusLabelKey["BalanceDue"] = "balanceDue";
    PaymentStatusLabelKey["CreditOwed"] = "creditOwed";
    PaymentStatusLabelKey["Failed"] = "failed";
    PaymentStatusLabelKey["Paid"] = "paid";
    PaymentStatusLabelKey["Pending"] = "pending";
})(PaymentStatusLabelKey || (PaymentStatusLabelKey = {}));
var toPaymentStatusLabelKey = function (status) {
    if (!status)
        return undefined;
    return PaymentStatusLabelKey[status];
};

var LABEL_PREFIX$9 = 'account.order';
var OrderHeader = function (_a) {
    var locale = _a.locale, className = _a.className, orderDate = _a.orderDate, orderNumber = _a.orderNumber, shipmentState = _a.shipmentState, paymentMethod = _a.paymentMethod, paymentState = _a.paymentState, trackingURL = _a.trackingURL, onTraceOrder = _a.onTraceOrder, onReorder = _a.onReorder;
    var getLabel = useIntl().getLabel;
    var state = shipmentState
        ? getLabel(LABEL_PREFIX$9 + ".shipmentState." + shipmentState.toLowerCase())
        : getLabel(LABEL_PREFIX$9 + ".shipmentState.undefined");
    return (React.createElement("section", { className: classnames('order-header', className) },
        React.createElement(DetailHeader, null,
            React.createElement(DetailHeader.Item, { term: getLabel(LABEL_PREFIX$9 + ".number.label"), definition: orderNumber }),
            React.createElement(DetailHeader.Item, { term: getLabel(LABEL_PREFIX$9 + ".date.label"), definition: React.createElement(DateTime, { dateTime: orderDate, locale: locale }) }),
            paymentMethod ? (React.createElement(DetailHeader.Item, { term: getLabel(LABEL_PREFIX$9 + ".paymentMethod.label"), definition: getLabel(LABEL_PREFIX$9 + ".paymentMethod." + paymentMethod) })) : null,
            paymentState ? (React.createElement(DetailHeader.Item, { term: getLabel(LABEL_PREFIX$9 + ".paymentStatus.label"), definition: getLabel(LABEL_PREFIX$9 + ".paymentStatus." + toPaymentStatusLabelKey(paymentState)) })) : null,
            trackingURL ? (React.createElement(DetailHeader.Item, { term: getLabel(LABEL_PREFIX$9 + ".trackingURL.label"), definition: React.createElement("a", { href: trackingURL, target: "_blank", rel: "noreferrer", onClick: onTraceOrder }, getLabel(LABEL_PREFIX$9 + ".trackingURL.value")) })) : null,
            React.createElement(DetailHeader.Item, { term: getLabel(LABEL_PREFIX$9 + ".shipmentState.label"), definition: state })),
        React.createElement("aside", { className: "order-header__actions" },
            React.createElement(Button, { "data-t": "re-order", className: "order-header__action", caption: getLabel('account.action.reOrder'), disabled: !onReorder, onClick: onReorder }))));
};

var Order = /** @class */ (function (_super) {
    __extends(Order, _super);
    function Order() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleReorder = function () {
            var _a = _this.props, locale = _a.locale, country = _a.country, currency = _a.currency, drafts = _a.drafts, onReorder = _a.onReorder;
            onReorder && onReorder({ locale: locale, currency: currency, country: country, drafts: drafts });
        };
        return _this;
    }
    Order.prototype.render = function () {
        var _a = this.props, children = _a.children, footer = _a.footer, locale = _a.locale, className = _a.className, orderDate = _a.orderDate, orderNumber = _a.orderNumber, shipmentState = _a.shipmentState, paymentMethod = _a.paymentMethod, paymentState = _a.paymentState, trackingURL = _a.trackingURL, onTraceOrder = _a.onTraceOrder, onReorder = _a.onReorder;
        return (React.createElement(SummaryContainer, { className: classnames('order', className) },
            React.createElement(OrderHeader, { locale: locale, orderDate: orderDate, orderNumber: orderNumber, shipmentState: shipmentState, paymentMethod: paymentMethod, paymentState: paymentState, trackingURL: trackingURL, onTraceOrder: onTraceOrder, onReorder: onReorder && this.handleReorder, className: "order__header" }),
            children,
            footer && React.createElement("div", { className: "order__footer" }, footer)));
    };
    return Order;
}(React.Component));

var LineItemQuantity = function (_a) {
    var quantity = _a.quantity, className = _a.className, isContactLensBundle = _a.isContactLensBundle;
    var getLabel = useIntl().getLabel;
    var fieldLabel = !isContactLensBundle ? getLabel('cart.item.quantity') + ": " : null;
    return (React.createElement("span", { className: classnames('line-item-quantity', className) },
        fieldLabel,
        quantity));
};

var LineItemSubtitle = function (_a) {
    var className = _a.className, subtitle = _a.subtitle;
    return (React.createElement("p", { className: classnames('line-item-subtitle', className) }, subtitle));
};

var LineItemTitle = function (_a) {
    var className = _a.className, title = _a.title;
    return (React.createElement(Heading, { variant: "subheading1", className: classnames('line-item-title', className) }, title));
};

var LineItemTrackingLink = function (_a) {
    var url = _a.url, className = _a.className, onTraceOrder = _a.onTraceOrder;
    var intl = useIntl();
    return (React.createElement(Link, { className: classnames('line-item-tracking-link', className), openInNewWindow: true, url: url, label: intl.getLabel('account.order.trackingLink.label'), onClick: onTraceOrder }));
};

var getProductImageUrl = function (product, isBynderImagesEnabled, staticsUrl) {
    var _a;
    if (staticsUrl === void 0) { staticsUrl = ''; }
    var imageId = (_a = (Orders$2.isSubscriptionProduct(product)
        ? product.lineItemDetail.bundleLineItems[0].regularImages[0].url
        : product.imageId)) !== null && _a !== void 0 ? _a : '';
    var legacyUrl = "" + staticsUrl + imageId;
    var fullImageUrl = '';
    if (isBynderImagesEnabled) {
        fullImageUrl = getFullImageUrl(product);
    }
    return (fullImageUrl || legacyUrl) + "?w=300&bg=FFFFFF&fm=jpeg&auto=format";
};
var getSubscriptionBundleLineItemProductImageUrl = function (product, bundleLineItem, isBynderImagesEnabled, staticsUrl) {
    if (staticsUrl === void 0) { staticsUrl = ''; }
    var imageId = bundleLineItem.regularImages[0].url;
    var legacyUrl = "" + staticsUrl + imageId;
    var fullImageUrl = '';
    if (isBynderImagesEnabled) {
        fullImageUrl = getFullImageUrl(product);
    }
    return (fullImageUrl || legacyUrl) + "?w=300&bg=FFFFFF&fm=jpeg&auto=format";
};
var getFullImageUrl = function (product) {
    var _a, _b;
    var productImages = Orders$2.isPrescriptionGlasses(product)
        ? (_a = product.lineItemDetail.bundleMainLineItem.variant.media) === null || _a === void 0 ? void 0 : _a.images
        : (_b = product.media) === null || _b === void 0 ? void 0 : _b.images;
    var images = (productImages !== null && productImages !== void 0 ? productImages : []).map(function (image) { return (__assign(__assign({}, image), { label: image.label || '' })); });
    var imageUrl = getFrontImage(images).url;
    return images.length ? "" + imageUrl : '';
};

var OrderLineItem = function (_a) {
    var staticsUrl = _a.staticsUrl, lineItem = _a.lineItem, _b = _a.includeAddOns, includeAddOns = _b === void 0 ? false : _b, trackingUrl = _a.trackingUrl, children = _a.children, className = _a.className, priceClassName = _a.priceClassName, locale = _a.locale, onTraceOrder = _a.onTraceOrder;
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var _c = getLineItemProps(lineItem, includeAddOns), catalogPrice = _c.catalogPrice, discountPrice = _c.discountPrice, quantity = _c.quantity;
    var product = lineItem.product;
    var title = getProductTitle(product, locale);
    var subtitle = getProductSubtitle$1(product, locale);
    var eyeSide = Orders$2.isContactLensesLineItem(lineItem)
        ? lineItem.product.attributes.eyeSide
        : '';
    var imagePath = getProductImageUrl(product, isBynderImagesEnabled, staticsUrl);
    var eyeSideElement = eyeSide && eyeSide !== 'both' ? (React.createElement(EyeSideIndicator, { className: "order-line-item__eyeside-indicator", side: eyeSide })) : null;
    return (React.createElement("div", { className: classnames('order-line-item', className) },
        React.createElement(LineItem, { className: "order-line-item__container" },
            React.createElement(LineItemMedia, { type: "image", imageUrl: imagePath, imageAlt: title, overlayElement: eyeSideElement }),
            React.createElement(LineItemContent, null,
                React.createElement(LineItemTitle, { title: title }),
                React.createElement("div", { className: "order-line-item__content" },
                    subtitle && React.createElement(LineItemSubtitle, { subtitle: subtitle }),
                    children && React.createElement("div", { className: "order-line-item__children" }, children)),
                React.createElement(LineItemQuantity, { quantity: getProductQuantity(product, quantity), isContactLensBundle: Orders$2.isContactLensBundleLineItem(lineItem) }),
                trackingUrl && (React.createElement("p", null,
                    React.createElement(LineItemTrackingLink, { url: trackingUrl, onTraceOrder: onTraceOrder })))),
            React.createElement(LineItemAside, { currency: catalogPrice.currency, price: catalogPrice.amount, discountPrice: discountPrice, className: priceClassName }))));
};

var SubscriptionOrderLineItem = function (_a) {
    var _b, _c, _d, _e, _f;
    var includeAddOns = _a.includeAddOns, lineItem = _a.lineItem, priceClassName = _a.priceClassName, staticsUrl = _a.staticsUrl, subscriptionsUrl = _a.subscriptionsUrl;
    var _g = useIntl(), getFormattedLabel = _g.getFormattedLabel, getLabel = _g.getLabel, locale = _g.locale;
    var _h = getLineItemProps(lineItem, includeAddOns), catalogPrice = _h.catalogPrice, discountPrice = _h.discountPrice;
    var product = lineItem.product;
    var TYPE_LENS = 'LENS';
    var monthlyLabel = getLabel('common.frequency.monthly');
    var quarterlyLabel = getLabel('common.frequency.quarterly');
    // Bundle the prescription and left/right lens into one object, so we can use it to correctly display our information
    var prescriptionWithLensSideItem = (_c = (_b = product.lineItemDetail) === null || _b === void 0 ? void 0 : _b.bundleLineItems) === null || _c === void 0 ? void 0 : _c.map(function (item, i) {
        var _a;
        return item.type === TYPE_LENS
            ? Object.assign({}, item[i], product.lineItemDetail.bundleLineItems[i], [
                Object.keys((_a = product.typeDetails) === null || _a === void 0 ? void 0 : _a.prescription)[i],
            ])
            : // Item type is a solution, so we don't need to map the prescription to it
                Object.assign({}, item[i], product.lineItemDetail.bundleLineItems[i]);
    });
    var getQuantityLabel = function (item) {
        if (item !== 0 && !item)
            return '';
        var getAmount = getFormattedLabel('products.contactLenses.amountPerBox', {
            labelData: {
                includedUnits: prescriptionWithLensSideItem[item].quantity,
                packageQuantity: prescriptionWithLensSideItem[item].packageQuantity || '0',
                boxLabel: prescriptionWithLensSideItem[item].quantity > 1 ? labels.boxesLabel : labels.boxLabel,
                lensLabel: (prescriptionWithLensSideItem[item].packageQuantity || 0) > 1
                    ? labels.lensesLabel
                    : labels.lensLabel,
            },
        });
        return prescriptionWithLensSideItem[item].type === TYPE_LENS
            ? getAmount + " | " + (prescriptionWithLensSideItem[item][0] === 'leftLens'
                ? labels.leftEyeLabel
                : labels.rightEyeLabel)
            : // Item type is a solution, therefore we don't want to return a quantity to be displayed
                '';
    };
    var getFrequencyLabel = React.useCallback(function (frequency) {
        if (!frequency)
            return '';
        return frequency === 'MONTHLY' ? monthlyLabel : quarterlyLabel;
    }, [monthlyLabel, quarterlyLabel]);
    var labels = React.useMemo(function () {
        var _a, _b;
        return ({
            subscriptionTitle: getLabel('products.contactLenses.subscription.title'),
            viewDetails: getLabel('account.common.viewDetails'),
            delivery: getLabel('cart.delivery'),
            deliveryDefinition: StringUtils.upFirst(getFrequencyLabel((_a = product.typeDetails) === null || _a === void 0 ? void 0 : _a.deliveryFrequency)),
            billing: getLabel('account.orders.billing'),
            billingDefinition: StringUtils.upFirst(getFrequencyLabel((_b = product.typeDetails) === null || _b === void 0 ? void 0 : _b.billingFrequency)),
            startDate: getLabel('products.contactLenses.subscription.steps.startDate'),
            lensesLabel: getLabel('products.unit.contactLenses'),
            lensLabel: getLabel('products.unit.contactLens'),
            boxLabel: getLabel('products.unit.contactLensBox'),
            boxesLabel: getLabel('products.unit.contactLensBoxes'),
            leftEyeLabel: getLabel('products.contactLenses.leftEye'),
            rightEyeLabel: getLabel('products.contactLenses.rightEye'),
        });
    }, [getFrequencyLabel, getLabel, product.typeDetails]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "subscription-order-line-item__main" },
            React.createElement(Heading, { variant: "subheading1", component: "h4", className: "subscription-order-line-item__title" }, labels.subscriptionTitle),
            React.createElement(Link, { label: labels.viewDetails, url: subscriptionsUrl })),
        React.createElement("section", { className: "order-header" },
            React.createElement(DetailHeader, { className: "subscription-order-line-item__header" },
                React.createElement(DetailHeader.Item, { term: labels.delivery, definition: labels.deliveryDefinition }),
                React.createElement(DetailHeader.Item, { term: labels.billing, definition: labels.billingDefinition }),
                ((_d = lineItem.product.typeDetails) === null || _d === void 0 ? void 0 : _d.subscriptionStartDate) && (React.createElement(DetailHeader.Item, { term: labels.startDate, definition: React.createElement(DateTime, { locale: locale, dateTime: lineItem.product.typeDetails.subscriptionStartDate }) })))), (_f = (_e = lineItem.product.lineItemDetail) === null || _e === void 0 ? void 0 : _e.bundleLineItems) === null || _f === void 0 ? void 0 :
        _f.map(function (item, i) { return (React.createElement(LineItem, { key: item.sku, className: "subscription-order-line-item__item" },
            React.createElement(LineItemMedia, { type: "image", imageUrl: getSubscriptionBundleLineItemProductImageUrl(lineItem.product, item, false, staticsUrl), imageAlt: item.name }),
            React.createElement(LineItemContent, null,
                React.createElement(LineItemTitle, { title: item.name }),
                getQuantityLabel(i)),
            React.createElement(LineItemAside, { currency: catalogPrice.currency, price: catalogPrice.amount, discountPrice: discountPrice, className: priceClassName }))); })));
};

var OverviewFooter = function (_a) {
    var order = _a.order, children = _a.children;
    var intl = useIntl();
    return (React.createElement("div", { className: "order__footer--overview" },
        React.createElement("p", null,
            React.createElement("span", null, intl.getLabel('common.total')),
            "\u00A0",
            React.createElement(Price, { value: order.totalChargedPrice.amount, currency: order.totalChargedPrice.currency, centAmount: true })),
        children));
};
var elementName = 'myaccount-order-list';
var OrderList = /** @class */ (function (_super) {
    __extends(OrderList, _super);
    function OrderList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fetchNextPage = function () {
            var _a = _this.props, orders = _a.orders, fetchPage = _a.fetchPage;
            if (!orders) {
                return;
            }
            var loaded = alreadyLoaded(orders);
            if (loaded >= orders.total) {
                // All pages are loaded
                return;
            }
            fetchPage({
                limit: orders.size,
                skip: loaded,
            });
        };
        _this.traceOrder = function (order) {
            var orderNumber = order.orderNumber, orderDate = order.orderDate, paymentState = order.paymentState, shipmentState = order.shipmentState;
            _this.props.traceOrder(orderNumber, orderDate, paymentState, shipmentState);
        };
        _this.renderOrders = function (orders) {
            var loaded = alreadyLoaded(orders);
            var _a = _this.props, intl = _a.intl, locale = _a.locale, country = _a.country, staticsUrl = _a.staticsUrl, subscriptionsUrl = _a.subscriptionsUrl, getDetailsUrl = _a.getDetailsUrl, isPrescriptionGlassesReorderEnabled = _a.isPrescriptionGlassesReorderEnabled, isLegacyOrderSupplierEanEnabled = _a.isLegacyOrderSupplierEanEnabled, fetchCall = _a.fetchCall, reorderCall = _a.reorderCall, reorder = _a.reorder, onNavigate = _a.onNavigate, _b = _a.convertOrderLineItem, convertOrderLineItem = _b === void 0 ? convertLineItemsToDrafts : _b;
            return (React.createElement(React.Fragment, null,
                orders.pages.map(function (page) {
                    return page.map(function (order) {
                        var drafts = convertOrderLineItem(order.lineItems, isLegacyOrderSupplierEanEnabled);
                        var isPGReorderAvailable = isMixedItemsReorderAvailable(order.lineItems, isPrescriptionGlassesReorderEnabled);
                        var onClick = function (e) {
                            e.preventDefault();
                            if (!getDetailsUrl)
                                return;
                            onNavigate === null || onNavigate === void 0 ? void 0 : onNavigate(new URL("" + window.location.origin + getDetailsUrl(order.orderNumber)));
                            window.scrollTo(0, 0);
                        };
                        return (React.createElement(Order, { key: order.orderNumber, locale: locale, country: country, currency: order.totalChargedPrice.currency, orderDate: order.orderDate, orderNumber: order.orderNumber, shipmentState: order.shipmentState, paymentMethod: order.paymentMethod, trackingURL: order.trackingURL, paymentState: order.paymentState, drafts: drafts, onTraceOrder: function () { return _this.traceOrder(order); }, onReorder: isPGReorderAvailable && !statusLoading(reorderCall) ? reorder : undefined, footer: React.createElement(OverviewFooter, { order: order }, getDetailsUrl && (React.createElement("a", { href: getDetailsUrl(order.orderNumber), onClick: onNavigate ? onClick : undefined }, intl.getLabel('account.common.viewDetails')))) },
                            React.createElement("div", { className: "order-line-item__items" }, order.lineItems.map(function (item) {
                                return Orders$2.isSubscriptionOrderLineItem(item) ? (React.createElement(SubscriptionOrderLineItem, { lineItem: item, staticsUrl: staticsUrl, subscriptionsUrl: subscriptionsUrl, includeAddOns: false, key: item.product.sku })) : (React.createElement(OrderLineItem, { key: item.product.sku, staticsUrl: staticsUrl, includeAddOns: true, lineItem: item, locale: locale, onTraceOrder: function () { return _this.traceOrder(order); } }));
                            }))));
                    });
                }),
                React.createElement("div", { className: elementName + "__pager" },
                    React.createElement(ProgressBar, { max: orders.total, value: loaded }),
                    React.createElement("div", { className: elementName + "__pager-label" }, OrderList.formatProgressLabel(intl.getLabel('account.orders.pagingStatus'), orders.total, loaded)),
                    loaded < orders.total && (React.createElement(Button, { "data-t": "load-more", className: elementName + "__pager-button", caption: intl.getLabel('account.orders.showMore'), onClick: _this.fetchNextPage, disabled: statusLoading(fetchCall), variant: "outline" })))));
        };
        return _this;
    }
    OrderList.prototype.componentDidMount = function () {
        if (!this.props.orders) {
            // Fetch first page
            this.props.fetchPage({
                limit: 5,
                skip: 0,
            });
        }
    };
    OrderList.prototype.render = function () {
        var _a = this.props, intl = _a.intl, orders = _a.orders;
        return (React.createElement("div", { className: elementName }, !orders ? (React.createElement(Loader$1, null)) : orders.total <= 0 ? (React.createElement("p", null, intl.getLabel('account.order.noHistory.message'))) : (this.renderOrders(orders))));
    };
    OrderList.formatProgressLabel = function (label, total, loaded) {
        return label.replace('{{total}}', total.toFixed(0)).replace('{{loaded}}', loaded.toFixed(0));
    };
    return OrderList;
}(React.Component));
var OrderList$1 = withFeatureToggles(withIntl(OrderList));

var Orders = /** @class */ (function (_super) {
    __extends(Orders, _super);
    function Orders() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeTabIndex: 0,
        };
        _this.onOrdersTabChange = function (activeTabIndex) {
            _this.setState({ activeTabIndex: activeTabIndex });
        };
        return _this;
    }
    Orders.prototype.getOrderListProps = function () {
        var _a = this.props, historyCall = _a.historyCall, legacyHistoryCall = _a.legacyHistoryCall, legacyOrderPages = _a.legacyOrderPages, reorder = _a.reorder, orderPages = _a.orderPages, reorderCall = _a.reorderCall, fetchPage = _a.fetchPage, fetchLegacyPage = _a.fetchLegacyPage, routes = _a.routes, traceOrder = _a.traceOrder;
        var activeTabIndex = this.state.activeTabIndex;
        return activeTabIndex === 0
            ? {
                fetchPage: fetchPage,
                fetchCall: historyCall,
                orders: orderPages,
                reorder: reorder,
                reorderCall: reorderCall,
                getDetailsUrl: routes
                    ? function (orderNumber) { return routes.orders + "/" + orderNumber; }
                    : undefined,
                traceOrder: traceOrder,
            }
            : {
                fetchPage: fetchLegacyPage,
                fetchCall: legacyHistoryCall,
                orders: legacyOrderPages,
                reorder: undefined,
                reorderCall: reorderCall,
                getDetailsUrl: routes
                    ? function (orderNumber) { return routes.orders + "/legacy/" + orderNumber; }
                    : undefined,
                traceOrder: traceOrder,
            };
    };
    Orders.prototype.render = function () {
        var _a = this.props, intl = _a.intl, routes = _a.routes, locale = _a.locale, country = _a.country, staticsUrl = _a.staticsUrl, subscriptionsUrl = _a.subscriptionsUrl, reorderCall = _a.reorderCall, enableLegacyOrderHistory = _a.enableLegacyOrderHistory, onNavigate = _a.onNavigate, convertOrderLineItem = _a.convertOrderLineItem;
        var activeTabIndex = this.state.activeTabIndex;
        var reduxProps = this.getOrderListProps();
        var ROUTE_KEY = RouteKey.Orders;
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        return (React.createElement("div", { className: "myaccount-orders" },
            React.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
            React.createElement(Heading, { variant: "small", className: "myaccount-page-title" }, routeLabel),
            enableLegacyOrderHistory && (React.createElement("div", { className: "myaccount-orders__tabs" },
                React.createElement(Tabs, { onChange: this.onOrdersTabChange, activeTabIndex: activeTabIndex },
                    React.createElement(Tab, { label: intl.getLabel('account.order.tabs.commercetools') }),
                    React.createElement(Tab, { label: intl.getLabel('account.order.tabs.legacy') })))),
            statusFailed(reorderCall) && (React.createElement(ScrollIntoView, null,
                React.createElement(Alert, { type: "error", message: intl.getFormattedLabel('account.order.reorder.errors.general', {
                        parseLink: true,
                    }) }))),
            routes ? (React.createElement(OrderList$1, __assign({}, reduxProps, { locale: locale, country: country, staticsUrl: staticsUrl, subscriptionsUrl: subscriptionsUrl, convertOrderLineItem: convertOrderLineItem, onNavigate: onNavigate, key: activeTabIndex === 0 ? 'regular' : 'legacy' }))) : (React.createElement(Loader$1, null))));
    };
    return Orders;
}(React.PureComponent));
var mapStateToProps$8 = function (state) { return ({
    routes: Selectors.getFormattedRoutes(state),
    orderPages: getOrderHistory(state),
    legacyOrderPages: getLegacyOrderHistory(state),
    historyCall: getOrderHistoryCall(state),
    legacyHistoryCall: getLegacyOrderHistoryCall(state),
    reorderCall: getReorderCall(state),
}); };
var mapDispatchToProps$8 = {
    fetchPage: fetchPage,
    fetchLegacyPage: fetchLegacyPage,
    reorder: reorder,
    traceOrder: traceOrder,
};
var Orders$1 = connect(mapStateToProps$8, mapDispatchToProps$8)(withIntl(Orders));

var Item = function (_a) {
    var label = _a.label, subtitle = _a.subtitle, className = _a.className, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", { className: classnames('detail-footer__item', className) },
            label && React.createElement("th", { scope: "row" }, label),
            children && React.createElement("td", null, children)),
        subtitle && (React.createElement("tr", { className: classnames('detail-footer__item', 'detail-footer__item--subtitle', className) },
            React.createElement("th", { colSpan: 2 }, subtitle)))));
};
var PriceItem = function (_a) {
    var price = _a.price, negativePrice = _a.negativePrice, label = _a.label, _b = _a.type, type = _b === void 0 ? 'default' : _b, rest = __rest(_a, ["price", "negativePrice", "label", "type"]);
    return (
    // Suffix all PriceItems labels with a colon and space
    React.createElement(Item, __assign({ label: label + ': ' }, rest),
        React.createElement(Price, { value: negativePrice ? -price.amount : price.amount, currency: price.currency, centAmount: true, type: type })));
};
var DetailFooter = function (_a) {
    var subtotal = _a.subtotal, includesProductDiscount = _a.includesProductDiscount, discount = _a.discount, shipping = _a.shipping, total = _a.total;
    var intl = useIntl();
    return (React.createElement("table", { className: "detail-footer" },
        React.createElement("tbody", null,
            !!subtotal && (React.createElement(PriceItem, { price: subtotal, label: intl.getLabel('common.subtotal'), subtitle: includesProductDiscount ? intl.getLabel('common.includesProductDiscount') : '' })),
            !!discount && discount.amount > 0 && (React.createElement(PriceItem, { price: discount, negativePrice: true, type: "discount", label: intl.getLabel('common.additionalDiscount') })),
            shipping !== undefined && shipping.amount > 0 ? (React.createElement(PriceItem, { price: shipping, label: intl.getLabel('common.shipping') })) : (React.createElement(Item, { label: intl.getLabel('common.shipping') + ': ' }, intl.getLabel('common.free'))),
            React.createElement(PriceItem, { price: total, label: intl.getLabel('common.total'), className: "detail-footer__item--total" }))));
};

var getLensParameters = function (item, eyeSide) {
    var intl = useIntl();
    if (!('attributes' in item.product)) {
        return [];
    }
    var fields = item.product.attributes;
    if (!fields) {
        return [];
    }
    var paramsLabels = {
        basecurve: intl.getLabel('products.contactLenses.prescription.baseCurve'),
        basecurveAbbr: intl.getLabel('products.contactLenses.prescription.baseCurve.abbr'),
        diameter: intl.getLabel('products.contactLenses.prescription.diameter'),
        diameterAbbr: intl.getLabel('products.contactLenses.prescription.diameter.abbr'),
        power: intl.getLabel('products.contactLenses.prescription.power'),
        powerAbbr: intl.getLabel('products.contactLenses.prescription.power.abbr'),
        cylinder: intl.getLabel('products.contactLenses.prescription.cylinder'),
        cylinderAbbr: intl.getLabel('products.contactLenses.prescription.cylinder.abbr'),
        axis: intl.getLabel('products.contactLenses.prescription.axis'),
        axisAbbr: intl.getLabel('products.contactLenses.prescription.axis.abbr'),
    };
    return [
        {
            key: paramsLabels.basecurve,
            keyAbbr: paramsLabels.basecurveAbbr,
            value: fields[eyeSide + "LensBaseCurve"],
        },
        {
            key: paramsLabels.diameter,
            keyAbbr: paramsLabels.diameterAbbr,
            value: fields[eyeSide + "LensDiameter"],
        },
        {
            key: paramsLabels.power,
            keyAbbr: paramsLabels.powerAbbr,
            value: fields[eyeSide + "LensPower"],
        },
        {
            key: paramsLabels.cylinder,
            keyAbbr: paramsLabels.cylinderAbbr,
            value: fields[eyeSide + "LensCylinder"],
        },
        {
            key: paramsLabels.axis,
            keyAbbr: paramsLabels.axisAbbr,
            value: fields[eyeSide + "LensAxis"],
        },
    ];
};
var getBundleConfiguration = function (item, locale) {
    var product = item.product;
    var name = product.name[locale];
    var lensType = product.attributes.lensType[locale];
    var months = product.attributes.months;
    var isSubscription = product.attributes.isSubscription;
    var fixedDiscount = product.attributes.fixedDiscount || 0;
    var leftItemName = product.attributes.leftLensName;
    var rightItemName = product.attributes.rightLensName;
    var solutionName = product.attributes.solutionName;
    return {
        item: {
            name: name,
            lensType: lensType,
            months: months,
            isSubscription: isSubscription,
            fixedDiscount: fixedDiscount,
        },
        leftEye: {
            name: leftItemName,
            parameters: getLensParameters(item, 'left'),
        },
        rightEye: {
            name: rightItemName,
            parameters: getLensParameters(item, 'right'),
        },
        solution: {
            name: solutionName,
        },
    };
};
var getDiscountDescription = function (fixedDiscount, intl) {
    var discountLabel = intl.getLabel('products.includingCareDiscount');
    return fixedDiscount ? discountLabel + " " + fixedDiscount * 100 + "%" : '';
};
var getDeliveryDescription = function (bundleConfiguration, intl) {
    var duration = bundleConfiguration.item.months;
    if (bundleConfiguration.item.isSubscription) {
        return intl.getLabel('products.shipment.method.monthly');
    }
    else {
        return duration > 1
            ? duration + " " + intl.getLabel('products.months')
            : duration + " " + intl.getLabel('products.month');
    }
};
var toFixed = function (key, value) {
    var ommitedKeys = ['As', 'Axis'];
    return ommitedKeys.includes(key) ? value.toString() : value.toFixed(2);
};
var formatLensAttr = function (key, value) {
    if (key === 'Str') {
        return withPlusSign(toFixed(key, value));
    }
    return toFixed(key, value);
};
var fallbackImageLabel = function (image) { return (__assign(__assign({}, image), { label: image.label || '' })); };
var BundleItem = function (_a) {
    var _b, _c;
    var item = _a.item, locale = _a.locale;
    var intl = useIntl();
    var isMobile = MediaQuery.useIsPhone();
    var bundleConfiguration = getBundleConfiguration(item, locale);
    var currency = item.catalogPrice.currency;
    var price = item.catalogPrice.amount;
    var discountPrice = item.discountedPrice ? item.discountedPrice.amount : undefined;
    var bundleImageUrl = placeholderImage.url;
    var bundleImageAlt = placeholderImage.url;
    var solutionImageUrl = placeholderImage.label;
    var solutionImageAlt = placeholderImage.label;
    if (Orders$2.isContactLensBundleLineItem(item)) {
        var contactLensImages = (_b = item.product.attributes.bundleProduct1Media) === null || _b === void 0 ? void 0 : _b.images.map(fallbackImageLabel);
        bundleImageUrl = getFrontImage(contactLensImages).url;
        bundleImageAlt = bundleConfiguration.item.name;
        var solutionImages = (_c = item.product.attributes.bundleProduct3Media) === null || _c === void 0 ? void 0 : _c.images.map(fallbackImageLabel);
        solutionImageUrl = getFrontImage(solutionImages).url;
        solutionImageAlt = bundleConfiguration.solution.name || '';
    }
    var priceClassNames = classnames('bundle-item__price', {
        'bundle-item__price--strikethrough': typeof discountPrice === 'number',
    });
    return (React.createElement("div", { className: "bundle-item" },
        React.createElement("div", { className: "bundle-item__box bundle-item__bundle" },
            React.createElement("figure", { className: "bundle-item__product-image" },
                React.createElement("img", { className: "bundle-item__image", src: bundleImageUrl, alt: bundleImageAlt })),
            React.createElement("div", { className: "bundle-item__main" },
                React.createElement(Heading, { variant: "subheading1", className: "bundle-item__title" }, bundleConfiguration.item.name),
                !isMobile && (React.createElement("div", { className: "bundle-item__children" },
                    React.createElement("div", null, bundleConfiguration.item.lensType),
                    React.createElement("div", null, getDeliveryDescription(bundleConfiguration, intl)),
                    React.createElement("div", null, getDiscountDescription(bundleConfiguration.item.fixedDiscount, intl))))),
            isMobile && (React.createElement("div", { className: "bundle-item__children" },
                React.createElement("div", null, bundleConfiguration.item.lensType),
                React.createElement("div", null, getDeliveryDescription(bundleConfiguration, intl)),
                React.createElement("div", null, getDiscountDescription(bundleConfiguration.item.fixedDiscount, intl)))),
            React.createElement("aside", { className: "bundle-item__prices" },
                React.createElement("p", { className: priceClassNames },
                    React.createElement(Price, { value: price, currency: currency })),
                discountPrice && (React.createElement("p", { className: "bundle-item__price" },
                    React.createElement(Price, { value: discountPrice, currency: currency, type: "discount" }))))),
        bundleConfiguration.leftEye.name ? (React.createElement("div", { className: "bundle-item__box bundle-item__lens" },
            React.createElement("figure", { className: "bundle-item__product-image bundle-item__lens-icon" },
                React.createElement(Icon, { name: "left-eye", width: 48, height: 48 }),
                React.createElement(Heading, { variant: "subheading1", className: "bundle-item__eye-label" }, intl.getLabel('products.contactLenses.leftEye'))),
            React.createElement("div", { className: "bundle-item__main bundle-item__lens-details" },
                React.createElement(Heading, { variant: "subheading1", className: "bundle-item__title bundle-item__title--lens" }, bundleConfiguration.leftEye.name),
                !isMobile && (React.createElement("div", { className: "bundle-item__children" }, bundleConfiguration.leftEye.parameters.map(function (param) {
                    return param.value !== undefined ? (React.createElement("div", { key: param.key, className: "bundle-item__lens-param" },
                        React.createElement("span", { className: "bundle-item__lens-param-name" }, param.key),
                        React.createElement("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
                })))),
            isMobile && (React.createElement("div", { className: "bundle-item__children" }, bundleConfiguration.leftEye.parameters.map(function (param) {
                return param.value !== undefined ? (React.createElement("div", { key: param.key, className: "bundle-item__lens-param" },
                    React.createElement("span", { className: "bundle-item__lens-param-name" }, param.key),
                    React.createElement("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
            }))))) : null,
        bundleConfiguration.rightEye.name ? (React.createElement("div", { className: "bundle-item__box bundle-item__lens" },
            React.createElement("figure", { className: "bundle-item__product-image bundle-item__lens-icon" },
                React.createElement(Icon, { name: "right-eye", width: 48, height: 48 }),
                React.createElement(Heading, { variant: "subheading1", className: "bundle-item__eye-label" }, intl.getLabel('products.contactLenses.rightEye'))),
            React.createElement("div", { className: "bundle-item__main bundle-item__lens-details" },
                React.createElement(Heading, { variant: "subheading1", className: "bundle-item__title bundle-item__title--lens" }, bundleConfiguration.rightEye.name),
                !isMobile && (React.createElement("div", { className: "bundle-item__children" }, bundleConfiguration.rightEye.parameters.map(function (param) {
                    return param.value !== undefined ? (React.createElement("div", { key: param.key, className: "bundle-item__lens-param" },
                        React.createElement("span", { className: "bundle-item__lens-param-name" }, param.key),
                        React.createElement("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
                })))),
            isMobile && (React.createElement("div", { className: "bundle-item__children" }, bundleConfiguration.rightEye.parameters.map(function (param) {
                return param.value !== undefined ? (React.createElement("div", { key: param.key, className: "bundle-item__lens-param" },
                    React.createElement("span", { className: "bundle-item__lens-param-name" }, param.key),
                    React.createElement("span", { className: "bundle-item__lens-param-value" }, formatLensAttr(param.keyAbbr, param.value)))) : null;
            }))))) : null,
        bundleConfiguration.solution.name ? (React.createElement("div", { className: "bundle-item__box bundle-item__solution" },
            React.createElement("figure", { className: "bundle-item__product-image bundle-item__product-image--solution" },
                React.createElement("img", { className: "bundle-item__image", src: solutionImageUrl, alt: solutionImageAlt })),
            React.createElement("div", { className: "bundle-item__main bundle-item__solution-details" },
                React.createElement(Heading, { variant: "subheading1", className: "bundle-item__title bundle-item__title--solution" }, bundleConfiguration.solution.name)))) : null));
};
var BundleItem$1 = MediaQuery.WithBreakpoints(BundleItem);

var baseClassName = 'prescription-glasses-line-item';
function mapPrescription(prescription) {
    switch (prescription === null || prescription === void 0 ? void 0 : prescription.type) {
        case 'PrescriptionFile': {
            return {
                type: 'PrescriptionFile',
                uploadedPrescriptionFile: {
                    fileName: prescription.fileName,
                },
                uploadedPupillaryDistanceFile: {
                    fileName: prescription.pupillaryDistanceFileFileName,
                },
            };
        }
        default: {
            return prescription;
        }
    }
}
var PrescriptionGlassesLineItem = function (_a) {
    var _b;
    var orderProps = __rest(_a, []);
    var _c = useIntl(), currency = _c.currency, getLabel = _c.getLabel;
    var product = orderProps.lineItem.product;
    var lineItemDetail = product.lineItemDetail;
    var _d = getLineItemProps(orderProps.lineItem, true), catalogPrice = _d.catalogPrice, discountPrice = _d.discountPrice;
    return (React.createElement("div", { className: baseClassName },
        React.createElement(OrderLineItem, __assign({}, orderProps, { priceClassName: baseClassName + "__frame-price" })),
        React.createElement("div", { className: baseClassName + "__info-container" },
            lineItemDetail.prescription && (React.createElement(React.Fragment, null,
                React.createElement(LineItemPrescription$1, { prescription: mapPrescription(lineItemDetail.prescription), className: "line-item-prescription__details" }),
                React.createElement(Hr, null))),
            !!((_b = lineItemDetail === null || lineItemDetail === void 0 ? void 0 : lineItemDetail.bundleChildLineItems) === null || _b === void 0 ? void 0 : _b.length) && (React.createElement(Block, { column: true },
                React.createElement(BlockHeadline, null, getLabel('account.order.labels.yourAddOns')),
                React.createElement("div", null, lineItemDetail === null || lineItemDetail === void 0 ? void 0 : lineItemDetail.bundleChildLineItems.map(function (item) {
                    var _a;
                    return (React.createElement(PrescriptionGlassesBundleChildItem, { key: item.productId, currency: currency, originalPrice: item.price.value.centAmount, discountedPrice: (_a = item.price.discounted) === null || _a === void 0 ? void 0 : _a.value.centAmount, label: getLabel("cart.lineItem.glasses.bundleItem." + item.productType), priceIsZeroLabel: getLabel('cart.lineItem.glasses.isIncluded', {
                            hideLabelKey: true,
                        }), value: getLocalizedValue(item.name, orderProps.locale || 'en') }));
                })))),
            React.createElement(Block, null,
                React.createElement(BlockHeadline, { inline: true }, getLabel('account.order.labels.productPrice')),
                React.createElement(LineItemAside, { currency: catalogPrice.currency, price: catalogPrice.amount, discountPrice: discountPrice, className: baseClassName + "__total-price" })))));
};
var BlockHeadline = function (_a) {
    var _b;
    var children = _a.children, inline = _a.inline;
    return (React.createElement("p", { className: classnames([
            baseClassName + "__headline",
            (_b = {},
                _b[baseClassName + "__headline--block"] = !inline,
                _b[baseClassName + "__headline--inline"] = inline,
                _b),
        ]) }, children));
};
var Block = function (_a) {
    var _b;
    var children = _a.children, column = _a.column;
    return (React.createElement("div", { className: classnames([
            baseClassName + "__block",
            (_b = {},
                _b[baseClassName + "__block--column"] = column,
                _b),
        ]) }, children));
};

var SelectableLineItem = function (_a) {
    var lineItem = _a.lineItem, staticsUrl = _a.staticsUrl, locale = _a.locale, _b = _a.isSelectable, isSelectable = _b === void 0 ? true : _b, onSelectionChange = _a.onSelectionChange, onTraceOrder = _a.onTraceOrder, isSelected = _a.isSelected;
    var intl = useIntl();
    var _c = lineItem.product, name = _c.name, sku = _c.sku;
    var eyeSideForId = Orders$2.isDetailContactLenses(lineItem.product) && lineItem.product.attributes.eyeSide
        ? " - " + lineItem.product.attributes.eyeSide
        : '';
    var id = getLocalizedValue(name, 'en') + " - " + sku + eyeSideForId;
    var a11yLabel = getProductA11yLabel(intl, lineItem.product);
    var renderLineItem = function () {
        if (Orders$2.isContactLensBundleLineItem(lineItem)) {
            return React.createElement(BundleItem$1, { key: lineItem.product.sku, item: lineItem, locale: locale });
        }
        if (Orders$2.isPrescriptionGlassesLineItem(lineItem)) {
            return (React.createElement(PrescriptionGlassesLineItem, { key: lineItem.product.sku, staticsUrl: staticsUrl, lineItem: lineItem, locale: locale }));
        }
        return (React.createElement(OrderLineItem, { key: lineItem.product.sku, staticsUrl: staticsUrl, lineItem: lineItem, locale: locale, onTraceOrder: onTraceOrder }));
    };
    return (React.createElement("div", { className: "selectable-line-item" },
        React.createElement("div", { className: "selectable-line-item__selection" },
            isSelectable && (React.createElement("label", { htmlFor: id, className: classnames([
                    'selectable-line-item__checkbox',
                    {
                        'selectable-line-item__checkbox--prescription-glasses': Orders$2.isPrescriptionGlasses(lineItem.product),
                    },
                ]) },
                React.createElement(Checkbox, { id: id, "aria-label": a11yLabel, value: lineItem, onChange: onSelectionChange, checked: isSelected }))),
            React.createElement("div", { className: "selectable-line-item__content" }, renderLineItem())),
        Orders$2.isDetailContactLenses(lineItem.product) && (React.createElement(LineItemPrescription$1, { prescription: {
                rightLens: lineItem.product.attributes.eyeSide === 'right'
                    ? getProductPrescriptionAttributes(lineItem.product.attributes)
                    : undefined,
                leftLens: lineItem.product.attributes.eyeSide === 'left'
                    ? getProductPrescriptionAttributes(lineItem.product.attributes)
                    : undefined,
                type: 'NewPrescription',
            } }))));
};

var AddressSummaryRenderer = function (_a) {
    var address = _a.address, formatter = _a.formatter;
    return formatter(address);
};
var ContactDetailsSummaryRenderer = function (_a) {
    var order = _a.order, formatter = _a.formatter;
    return formatter(order);
};
var hasProductDiscount = function (order) {
    return order.lineItems.some(function (item) { return item.hasOwnProperty('discountedPrice'); });
};
var OrderDetail = /** @class */ (function (_super) {
    __extends(OrderDetail, _super);
    function OrderDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            orderDetailsTracked: false,
            isModalOpen: false,
        };
        _this.handleOpenModal = function () {
            _this.setState({ isModalOpen: true });
        };
        _this.handleCloseModal = function () {
            _this.setState({ isModalOpen: false });
        };
        _this.trackOrderItemSelect = function (isSelect) {
            var detail = _this.getOrderDetail();
            if (!detail)
                return null;
            var orderNumber = detail.orderNumber, orderDate = detail.orderDate, paymentState = detail.paymentState, shipmentState = detail.shipmentState;
            _this.props.orderItemSelect(isSelect, orderNumber, orderDate, paymentState, shipmentState);
        };
        _this.onSelectionChange = function (_a) {
            var checked = _a.checked, lineItem = _a.value;
            var current = _this.state.selectedItems;
            if (!current) {
                // This should not really occur as we're seeding the selected set with all lineitem sku on first load
                return;
            }
            var selectedItems = new Set(current);
            if (checked) {
                selectedItems.add(_this.getProductIdentifier(lineItem));
            }
            else {
                selectedItems.delete(_this.getProductIdentifier(lineItem));
            }
            _this.setState({ selectedItems: selectedItems });
            _this.trackOrderItemSelect(checked);
        };
        _this.isSelected = function (sku) {
            return _this.state.selectedItems ? _this.state.selectedItems.has(sku) : false;
        };
        _this.onReorder = function (_a) {
            var _b;
            var drafts = _a.drafts, rest = __rest(_a, ["drafts"]);
            var prescriptionGlassesBundleLineItems = (_b = drafts.prescriptionGlassesBundleLineItems) === null || _b === void 0 ? void 0 : _b.filter(function (draft) { return _this.isSelected(draft.bundleMainLineItem.sku); });
            return _this.props.reorder(__assign(__assign({}, rest), { drafts: {
                    lineItems: drafts.lineItems.filter(function (draft) { return _this.isSelected(draft.sku); }),
                    prescriptionGlassesBundleLineItems: (prescriptionGlassesBundleLineItems === null || prescriptionGlassesBundleLineItems === void 0 ? void 0 : prescriptionGlassesBundleLineItems.length)
                        ? prescriptionGlassesBundleLineItems
                        : undefined,
                } }));
        };
        _this.traceOrder = function () {
            var detail = _this.getOrderDetail();
            if (!detail)
                return;
            var orderNumber = detail.orderNumber, orderDate = detail.orderDate, paymentState = detail.paymentState, shipmentState = detail.shipmentState;
            _this.props.traceOrder(orderNumber, orderDate, paymentState, shipmentState);
        };
        return _this;
    }
    OrderDetail.prototype.componentDidMount = function () {
        var _a = this.props, orderNumber = _a.orderNumber, fetchDetail = _a.fetchDetail, fetchLegacyDetail = _a.fetchLegacyDetail, isLegacy = _a.isLegacy;
        isLegacy ? fetchLegacyDetail({ orderNumber: orderNumber }) : fetchDetail({ orderNumber: orderNumber });
    };
    OrderDetail.prototype.componentDidUpdate = function () {
        var detail = this.getOrderDetail();
        if (detail && !this.state.orderDetailsTracked) {
            var orderNumber = detail.orderNumber, orderDate = detail.orderDate, paymentState = detail.paymentState, shipmentState = detail.shipmentState;
            this.props.orderDetailsView(orderNumber, orderDate, paymentState, shipmentState);
            this.setState({ orderDetailsTracked: true });
        }
    };
    OrderDetail.prototype.getOrderDetail = function () {
        var _a = this.props, isLegacy = _a.isLegacy, legacyDetail = _a.legacyDetail, detail = _a.detail;
        return isLegacy ? legacyDetail : detail;
    };
    OrderDetail.prototype.getDetailCall = function () {
        var _a = this.props, isLegacy = _a.isLegacy, legacyDetailCall = _a.legacyDetailCall, detailCall = _a.detailCall;
        return isLegacy ? legacyDetailCall : detailCall;
    };
    OrderDetail.prototype.getProductIdentifier = function (item) {
        var isLegacyOrderSupplierEanEnabled = this.props.isLegacyOrderSupplierEanEnabled;
        return isLegacyOrderSupplierEanEnabled && Orders$2.isSunglassesLineItem(item)
            ? item.product.attributes.supplierEAN || item.product.sku
            : item.product.sku;
    };
    OrderDetail.prototype.render = function () {
        var _this = this;
        var _a = this.props, staticsUrl = _a.staticsUrl, locale = _a.locale, country = _a.country, subscriptionsUrl = _a.subscriptionsUrl, isLegacy = _a.isLegacy, isPrescriptionGlassesReorderEnabled = _a.isPrescriptionGlassesReorderEnabled, intl = _a.intl, isLegacyOrderSupplierEanEnabled = _a.isLegacyOrderSupplierEanEnabled;
        var detail = this.getOrderDetail();
        var detailCall = this.getDetailCall();
        if (detail && detail.orderNumber === this.props.orderNumber) {
            var isReorderAvailable_1 = isMixedItemsReorderAvailable(detail.lineItems, isPrescriptionGlassesReorderEnabled) &&
                !isLegacy;
            var drafts = convertLineItemsToDrafts(detail.lineItems, isLegacyOrderSupplierEanEnabled);
            return (React.createElement("div", { className: "order-detail" },
                React.createElement(Image$1
                // TODO: Fetch correct image
                , { 
                    // TODO: Fetch correct image
                    url: "https://unsplash.it/800/425?image=156", cover: true, lazyLoadingOptions: { q: '50', auto: '50' }, className: "myaccount-hero" }),
                React.createElement(MyAccountBreadcrumbs$1, { items: [
                        {
                            name: intl.getLabel('account.menu.orders'),
                            routeKey: RouteKey.Orders,
                        },
                        {
                            name: intl.getLabel('common.order') + " " + detail.orderNumber,
                        },
                    ] }),
                React.createElement(Heading, { variant: "small", className: "myaccount-page-title order-detail__title" }, intl.getLabel('account.menu.orders')),
                React.createElement(Order, { className: "order-details__order", locale: locale, country: country, currency: detail.totalChargedPrice.currency, drafts: drafts, onReorder: isReorderAvailable_1 ? this.onReorder : undefined, footer: React.createElement(DetailFooter, { subtotal: detail.totalProductsPrice, includesProductDiscount: hasProductDiscount(detail), discount: detail.totalAdditionalDiscount, shipping: detail.shippingPrice, total: detail.totalChargedPrice }), orderDate: detail.orderDate, orderNumber: detail.orderNumber, shipmentState: detail.shipmentState, paymentState: detail.paymentState, onTraceOrder: this.traceOrder }, detail.lineItems.map(function (item) {
                    return Orders$2.isContactLensesSubscriptionLineItem(item) ? (React.createElement(SubscriptionOrderLineItem, { lineItem: item, staticsUrl: staticsUrl, subscriptionsUrl: subscriptionsUrl, includeAddOns: false, key: item.product.sku })) : (React.createElement(SelectableLineItem, { key: item.product.sku, lineItem: item, staticsUrl: staticsUrl, locale: locale, isSelectable: isReorderAvailable_1, onSelectionChange: _this.onSelectionChange, isSelected: _this.isSelected(_this.getProductIdentifier(item)), onTraceOrder: _this.traceOrder }));
                })),
                React.createElement("div", { className: "order-details__summary order-details__summary--contact" },
                    React.createElement(Heading, { variant: "smallest", className: "order-details__section-title" }, intl.getLabel('checkout.completed.contactDetails.title')),
                    React.createElement(Summary, null,
                        React.createElement(ContactDetailsSummaryRenderer, { order: detail, formatter: this.props.contactDetailsFormatter }))),
                React.createElement("div", { className: "order-details__summary order-details__summary--delivery" },
                    React.createElement(Heading, { variant: "smallest", className: "order-details__section-title" }, intl.getLabel('checkout.shipment.title')),
                    React.createElement(Summary, null,
                        React.createElement("div", { className: "order-details__summary" },
                            React.createElement(Heading, { variant: "subheading1" }, intl.getLabel('checkout.shipment.method.title')),
                            SummaryItem(intl.getLabel("checkout.shipment.method." + detail.shippingInfo.deliveryMethod)),
                            (detail === null || detail === void 0 ? void 0 : detail.shippingInfo.deliveryMethod) === 'pick-up' && (React.createElement("div", { className: "order-details__store" },
                                React.createElement(ButtonAsLink, { className: "order-details__store-info", onClick: this.handleOpenModal, caption: intl.getLabel('account.orders.storeInfo') })))),
                        (detail === null || detail === void 0 ? void 0 : detail.shippingAddress.externalId) && this.state.isModalOpen && (React.createElement(StoreDetailModal, { storeCode: detail.shippingAddress.externalId, onModalClose: this.handleCloseModal })),
                        React.createElement("div", { className: "order-details__addresses" },
                            React.createElement("div", { className: "order-details__delivery-address" },
                                React.createElement(Heading, { variant: "subheading1" }, intl.getLabel('checkout.shipment.address')),
                                React.createElement(AddressSummaryRenderer, { address: detail.shippingAddress, formatter: detail.shippingInfo &&
                                        detail.shippingInfo.deliveryMethod &&
                                        detail.shippingInfo.deliveryMethod === 'pick-up'
                                        ? this.props.storeAddressFormatter
                                        : this.props.addressFormatter })),
                            React.createElement("div", { className: "order-details__billing-address" },
                                React.createElement(Heading, { variant: "subheading1" }, intl.getLabel('checkout.billingAddress')),
                                React.createElement(AddressSummaryRenderer, { address: detail.billingAddress, formatter: this.props.addressFormatter })))))));
        }
        if (statusLoading(detailCall) || statusIdle(detailCall)) {
            return React.createElement(Loader$1, null);
        }
        if (statusFailed(detailCall) || !detail) {
            return (
            // TODO: Find out what design should look like
            React.createElement(Alert, { type: "error", message: intl.getFormattedLabel('checkout.errors.general.message', { parseLink: true }) }));
        }
    };
    OrderDetail.getDerivedStateFromProps = function (props, state) {
        if (!state.selectedItems && props.detail) {
            return __assign(__assign({}, state), { selectedItems: new Set(props.detail.lineItems.map(function (item) {
                    return props.isLegacyOrderSupplierEanEnabled && Orders$2.isSunglasses(item.product)
                        ? item.product.attributes.supplierEAN || item.product.sku
                        : item.product.sku;
                })) });
        }
        return null;
    };
    return OrderDetail;
}(React.Component));
var mapStateToProps$7 = function (state) { return ({
    detailCall: getOrderDetailCall(state),
    detail: getOrderDetail(state),
    legacyDetailCall: getLegacyOrderDetailCall(state),
    legacyDetail: getLegacyOrderDetail(state),
}); };
var mapDispatchToProps$7 = {
    fetchDetail: fetchDetail$1,
    fetchLegacyDetail: fetchLegacyDetail,
    reorder: reorder,
    orderDetailsView: orderDetailsView,
    traceOrder: traceOrder,
    orderItemSelect: orderItemSelect,
    orderReorder: orderReorder,
};
var OrderDetail$1 = connect(mapStateToProps$7, mapDispatchToProps$7)(withIntl(withFeatureToggles(OrderDetail)));

var NoPrescription = function (_a) {
    var bookAppointmentRoute = _a.bookAppointmentRoute;
    var getLabel = useIntl().getLabel;
    var route = bookAppointmentRoute || BOOK_APPOINTMENT_ROUTE;
    return (React.createElement("section", { className: "no-prescription" },
        React.createElement("p", null, getLabel('account.noPrescription.message')),
        React.createElement(Button, { caption: getLabel('stores.actions.selectStore'), href: "/" + route })));
};

var PrescriptionInfoBar = function (_a) {
    var storeName = _a.storeName, expiryDate = _a.expiryDate, className = _a.className;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    return (React.createElement("div", { className: classnames('prescription-infobar', className) },
        storeName && React.createElement("div", { className: "prescription-infobar__store-name" }, storeName),
        React.createElement(Label, { type: "neutral", className: "prescription-infobar__label" },
            React.createElement("span", null,
                getLabel('account.prescription.expiryDate'),
                ": "),
            React.createElement(DateTime, { dateTime: expiryDate, locale: locale }))));
};

function getEyePrescriptionData(prescription, eye) {
    return Object.entries(prescription[eye]).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), key = _c[0], value = _c[1];
        return (value ? __assign(__assign({}, acc), (_b = {}, _b[key] = value, _b)) : acc);
    }, {
        power: '',
        baseCurve: '',
        diameter: '',
        cylinder: '',
        axis: '',
        addition: '',
    });
}

var EYE_SIDES = [PrescriptionSide.Right, PrescriptionSide.Left];
var dataOrDash = function (prescription, eye, key) { return prescription[eye][key] || '-'; };
var CLASS_PREFIX = 'prescription-table';
var TableMobile = function (_a) {
    var keys = _a.keys, prescription = _a.prescription, labelFormatter = _a.labelFormatter, className = _a.className, ariaLabel = _a["aria-label"];
    var getLabel = useIntl().getLabel;
    var classes = classnames(CLASS_PREFIX + " " + CLASS_PREFIX + "--mobile " + CLASS_PREFIX + "--cols-3", className);
    return (React.createElement("table", { className: classes, "aria-label": ariaLabel },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("td", null, ''),
                EYE_SIDES.map(function (eyeSide) { return (React.createElement("th", { key: "header-" + eyeSide, scope: "col" }, getLabel("products.contactLenses." + eyeSide))); }))),
        React.createElement("tbody", null, keys.map(function (key) { return (React.createElement("tr", { key: key },
            React.createElement("th", { scope: "row" }, labelFormatter(key)),
            EYE_SIDES.map(function (eyeSide) { return (React.createElement("td", { key: "cell-" + eyeSide + "-" + key }, dataOrDash(prescription, eyeSide, key))); }))); }))));
};
var TableDesktop = function (_a) {
    var keys = _a.keys, prescription = _a.prescription, labelFormatter = _a.labelFormatter, className = _a.className, ariaLabel = _a["aria-label"];
    var getLabel = useIntl().getLabel;
    var classes = classnames(CLASS_PREFIX + " " + CLASS_PREFIX + "--desktop " + CLASS_PREFIX + "--cols-" + (keys.length + 1), className);
    return (React.createElement("table", { className: classes, "aria-label": ariaLabel },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("td", null, '' /* Add empty string for the top cell above the header column */),
                keys.map(function (label) { return (React.createElement("th", { key: label, scope: "col" }, labelFormatter(label))); }))),
        React.createElement("tbody", null, EYE_SIDES.map(function (eyeSide) { return (React.createElement("tr", { key: "row-" + eyeSide },
            React.createElement("th", { scope: "row" }, getLabel("products.contactLenses." + eyeSide)),
            keys.map(function (key) { return (React.createElement("td", { key: key }, dataOrDash(prescription, eyeSide, key))); }))); }))));
};
var PrescriptionTable = function (props) {
    var prescription = props.prescription;
    var getLabel = useIntl().getLabel;
    var BreakpointName = MediaQuery.BreakpointName, useBreakpoint = MediaQuery.useBreakpoint;
    var breakpoint = useBreakpoint();
    var isMobile = breakpoint === BreakpointName.PHONE || breakpoint === BreakpointName.TABLET_PORTRAIT;
    var keys = [
        PrescriptionKey.Power,
        PrescriptionKey.BaseCurve,
        PrescriptionKey.Diameter,
        PrescriptionKey.Cylinder,
        PrescriptionKey.Axis,
        PrescriptionKey.Addition,
    ];
    var getAbbreviatedLabel = function (propertyName) {
        return getLabel("products.contactLenses.prescription." + propertyName + ".abbr");
    };
    var tableProps = {
        keys: keys,
        prescription: prescription,
        labelFormatter: getAbbreviatedLabel,
        className: props.className,
        'aria-label': props['aria-label'],
    };
    return isMobile ? React.createElement(TableMobile, __assign({}, tableProps)) : React.createElement(TableDesktop, __assign({}, tableProps));
};

var PrescriptionTableContainer = function (_a) {
    var _b;
    var prescription = _a.prescription, name = _a.name;
    var eyeData = (_b = {},
        _b[PrescriptionSide.Right] = getEyePrescriptionData(prescription, PrescriptionSide.Right),
        _b[PrescriptionSide.Left] = getEyePrescriptionData(prescription, PrescriptionSide.Left),
        _b);
    return React.createElement(PrescriptionTable, { prescription: eyeData, "aria-label": name });
};

var Prescription = function (_a) {
    var prescription = _a.prescription;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, dateTime = _b.dateTime;
    var name = prescription.name || prescription.storeName;
    var expiryDate = prescription.expiryDate, recommendedNextEyeTestDate = prescription.recommendedNextEyeTestDate;
    return (React.createElement(React.Fragment, null,
        recommendedNextEyeTestDate &&
            isRecommendedEyeTestDue(recommendedNextEyeTestDate, expiryDate) && (React.createElement(Alert, { type: "info", message: getFormattedLabel('account.prescription.eyeTestDue', {
                labelData: {
                    date: dateTime.formatShortDate(new Date(expiryDate)),
                },
                parseLink: false,
            }), icon: "info" })),
        isPrescriptionExpired(expiryDate) && (React.createElement(Alert, { type: "warning", message: getLabel('account.prescription.prescriptionExpired'), icon: "warning" })),
        React.createElement(Summary, null,
            React.createElement(Heading, { variant: "subheading2", component: "h2" }, name),
            React.createElement(Hr, null),
            React.createElement(PrescriptionInfoBar, { storeName: prescription.storeName, expiryDate: prescription.expiryDate }),
            React.createElement(Hr, null),
            React.createElement(PrescriptionTableContainer, { name: name, prescription: prescription }))));
};
function isRecommendedEyeTestDue(eyeTestDate, expiryDate, todayDate) {
    if (todayDate === void 0) { todayDate = new Date(); }
    if (!eyeTestDate) {
        return false;
    }
    var dateEyeTestDate = new Date(eyeTestDate);
    var dateExpiryDate = new Date(expiryDate);
    if (isAfter(dateEyeTestDate, dateExpiryDate)) {
        return false;
    }
    return isWithinInterval(todayDate, {
        start: dateEyeTestDate,
        end: dateExpiryDate,
    });
}
function isPrescriptionExpired(expiryDate, todayDate) {
    if (todayDate === void 0) { todayDate = new Date(); }
    return isAfter(todayDate, new Date(expiryDate));
}

var getPrescriptions = createSelector(Selectors.getAuth, getMyAccount, function (auth, myAccount) {
    return State.isLoggedIn(auth) ? myAccount.prescriptions : undefined;
});
var getPrescriptionList = createSelector(getPrescriptions, function (prescriptions) {
    return prescriptions ? prescriptions.list : undefined;
});
var getPrescriptionListCall = createSelector(getPrescriptions, function (prescriptions) {
    return prescriptions ? prescriptions.listCall : idleState();
});

// @TODO split this into a view/container component and feed the prescriptions from the new global solution
var PrescriptionList = /** @class */ (function (_super) {
    __extends(PrescriptionList, _super);
    function PrescriptionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PrescriptionList.prototype.componentDidMount = function () {
        this.props.fetchList();
    };
    PrescriptionList.prototype.render = function () {
        var _a = this.props, list = _a.list, listCall = _a.listCall, getFormattedLabel = _a.intl.getFormattedLabel, bookAppointmentRoute = _a.bookAppointmentRoute;
        if (Array.isArray(list)) {
            return list.length > 0 ? (list.map(function (item) { return React.createElement(Prescription, { key: item.id, prescription: item }); })) : (React.createElement(NoPrescription, { bookAppointmentRoute: bookAppointmentRoute }));
        }
        else if (statusLoading(listCall) || statusIdle(listCall)) {
            return React.createElement(Loader$1, null);
        }
        else {
            return (React.createElement(Alert, { type: "error", message: getFormattedLabel('account.prescriptions.errors.general', { parseLink: true }) }));
        }
    };
    return PrescriptionList;
}(React.Component));
var mapStateToProps$6 = function (state) { return ({
    listCall: getPrescriptionListCall(state),
    list: getPrescriptionList(state),
}); };
var mapDispatchToProps$6 = {
    fetchList: fetchList$1,
};
var PrescriptionsList = connect(mapStateToProps$6, mapDispatchToProps$6)(withIntl(PrescriptionList));

var PrescriptionDownloadItem = function (_a) {
    var downloadUrl = _a.downloadUrl, downloadLabel = _a.downloadLabel, expiryDate = _a.expiryDate, isValid = _a.isValid, prescriptionType = _a.prescriptionType, fullName = _a.fullName, onDownload = _a.onDownload;
    return (React.createElement("div", { className: "prescription-download-item" },
        React.createElement("div", { className: "prescription-download-item__row" },
            React.createElement("span", { className: "prescription-download-item__strong" }, prescriptionType),
            React.createElement(Link, { onClick: onDownload, url: downloadUrl, target: "_blank", className: "prescription-download-item__link" }, downloadLabel)),
        fullName && (React.createElement("div", { className: "prescription-download-item__row" },
            React.createElement("span", { className: "prescription-download-item__strong" }, fullName))),
        React.createElement("div", { className: "prescription-download-item__row" },
            React.createElement(Label, { type: isValid ? 'success' : 'neutral' }, expiryDate))));
};

var PrescriptionDownloadItemContainer = function (_a) {
    var prescription = _a.prescription;
    var getLabel = useIntl().getLabel;
    var dispatch = useDispatch();
    var onDownload = function () {
        dispatch(downloadPrescription());
    };
    var formattedDate = DateUtils.toLocalDate(prescription.expiryDate);
    var downloadLabel = getLabel('account.prescription.download');
    var expiryDate = getLabel("account.prescription." + (prescription.isValid ? 'expiryDate' : 'expiredDate')) + " " + formattedDate;
    return (React__default.createElement(PrescriptionDownloadItem, { downloadLabel: downloadLabel, downloadUrl: prescription.downloadUrl, expiryDate: expiryDate, isValid: prescription.isValid, prescriptionType: prescription.prescriptionType, fullName: prescription.fullName, onDownload: onDownload }));
};

/**
 * Converts a single graphql PrescriptionDownload object to a local PrescriptionDownload object,
 * converting strings to dates and "fullName" null to undefined.
 */
var toPrescriptionDownload = function (_a) {
    var downloadUrl = _a.downloadUrl, expiryDate = _a.expiryDate, fullName = _a.fullName, id = _a.id, isValid = _a.isValid, issueDate = _a.issueDate, prescriptionType = _a.prescriptionType;
    return ({
        id: id,
        downloadUrl: downloadUrl,
        expiryDate: new Date(expiryDate),
        fullName: fullName !== null && fullName !== void 0 ? fullName : undefined,
        isValid: isValid,
        issueDate: new Date(issueDate),
        prescriptionType: prescriptionType,
    });
};
/**
 * Maps an array of graphql PrescriptionDownload objects to local PrescriptionDownload objects,
 * filtering out any duplicates. Uniqueness is determined based on the value of "fullName" and
 * "prescriptionType".
 */
var toPrescriptionDownloads = function (prescriptions) {
    return prescriptions
        .filter(function (prescription) {
        // If there is another prescription with the same "prescriptionType" and "fullName"
        // select the one with latest "issueDate"
        return !prescriptions.filter(function (ps) {
            return ps.id !== prescription.id &&
                ps.prescriptionType === prescription.prescriptionType &&
                ps.fullName === prescription.fullName &&
                ps.issueDate > prescription.issueDate;
        }).length;
    })
        .map(toPrescriptionDownload);
};

var GET_PRESCRIPTION_DOWNLOADS = gql(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  query getPrescriptionDownloads {\n    me {\n      id\n      prescriptions {\n        ... on PrescriptionDownload {\n          id\n          expiryDate\n          issueDate\n          downloadUrl\n          fullName\n          isValid\n          prescriptionType\n        }\n      }\n    }\n  }\n"], ["\n  query getPrescriptionDownloads {\n    me {\n      id\n      prescriptions {\n        ... on PrescriptionDownload {\n          id\n          expiryDate\n          issueDate\n          downloadUrl\n          fullName\n          isValid\n          prescriptionType\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$u;

var usePrescriptionDownloads = function () {
    var _a, _b;
    var _c = useQuery(GET_PRESCRIPTION_DOWNLOADS), data = _c.data, loading = _c.loading, error = _c.error;
    return {
        data: ((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.prescriptions) && toPrescriptionDownloads((_b = data === null || data === void 0 ? void 0 : data.me) === null || _b === void 0 ? void 0 : _b.prescriptions),
        loading: loading,
        error: error,
    };
};

var PrescriptionDownloadsList = function () {
    var _a = usePrescriptionDownloads(), prescriptions = _a.data, loading = _a.loading, error = _a.error;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    if (loading) {
        return React.createElement(Loader$1, null);
    }
    if (error) {
        return React.createElement(Alert, { type: "error", message: getLabel('common.error.network') });
    }
    var hasPrescriptions = prescriptions && prescriptions.length;
    return (React.createElement("section", { className: "prescription-downloads" },
        !hasPrescriptions && (React.createElement("p", { className: "no-prescription" }, getLabel('account.noPrescription.message'))),
        React.createElement("p", { className: "prescription-notice" }, getFormattedLabel('account.prescription.book-appointment', { parseLink: true })),
        hasPrescriptions && (React.createElement("div", { className: "prescription-downloads__list" }, prescriptions === null || prescriptions === void 0 ? void 0 : prescriptions.map(function (prescription) { return (React.createElement(PrescriptionDownloadItemContainer, { key: prescription.id, prescription: prescription })); })))));
};

var PrescriptionsListContainer = function (_a) {
    var bookAppointmentRoute = _a.bookAppointmentRoute;
    var _b = useFeatureToggles(), isVEPrescriptionsEnabled = _b.isVEPrescriptionsEnabled, isInlinePrescriptionsEnabled = _b.isInlinePrescriptionsEnabled;
    if (isVEPrescriptionsEnabled) {
        // Vision Express uses a custom API to fetch their prescriptions
        return React.createElement(PrescriptionsList, { bookAppointmentRoute: bookAppointmentRoute });
    }
    // @TODO Create a new container which uses graphql instead of the Vision Express CCC endpoint for the data,
    // but the same visual prescription components and return it here.
    if (isInlinePrescriptionsEnabled) {
        // This will be the global prescription solution
        return React.createElement(PrescriptionsList, { bookAppointmentRoute: bookAppointmentRoute });
    }
    return React.createElement(PrescriptionDownloadsList, null);
};

var PrescriptionPage = function (_a) {
    var bookAppointmentRoute = _a.bookAppointmentRoute;
    var getLabel = useIntl().getLabel;
    var ROUTE_KEY = RouteKey.Prescriptions;
    var routeLabel = getLabel("account.menu." + ROUTE_KEY);
    var LABEL_PREFIX = 'account.prescription';
    return (React.createElement("div", { className: "prescription-page" },
        React.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
        React.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title prescription-page__title" }, getLabel(LABEL_PREFIX + ".title")),
        React.createElement("div", { className: "prescription-page__list" },
            React.createElement(PrescriptionsListContainer, { bookAppointmentRoute: bookAppointmentRoute }))));
};

var Privacy = /** @class */ (function (_super) {
    __extends(Privacy, _super);
    function Privacy() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onOptInChange = function (selectedOptIns) {
            var optIns = _this.props.availableOptIns.reduce(function (selected, optIn) {
                var _a;
                return __assign(__assign({}, selected), (_a = {}, _a[optIn.value] = {
                    checked: selectedOptIns && selectedOptIns.some(function (o) { return o.value === optIn.value; }),
                    label: _this.props.intl.getLabel(optIn.titleKey) || optIn.value,
                }, _a));
            }, {});
            _this.props.toggleOptIns(optIns);
        };
        _this.handleSave = function () {
            _this.props.updateOptIns();
        };
        return _this;
    }
    Privacy.prototype.componentDidMount = function () {
        this.props.fetchOptIns();
    };
    Privacy.prototype.render = function () {
        var _a = this.props, intl = _a.intl, availableOptIns = _a.availableOptIns, changedOptIns = _a.changedOptIns, optInsOnServer = _a.optInsOnServer, updateOptInsCall = _a.updateOptInsCall;
        var ROUTE_KEY = RouteKey.Privacy;
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        if (statusLoading(optInsOnServer) || statusUninit(optInsOnServer)) {
            return React__default.createElement(Loader$1, null);
        }
        else if (statusFailed(optInsOnServer) || statusWarning(optInsOnServer)) {
            return (React__default.createElement(ScrollIntoView, null,
                React__default.createElement(Alert, { type: "error", message: intl.getFormattedLabel('account.privacy.fetchOptins.errors.general', {
                        parseLink: true,
                    }) })));
        }
        else {
            return (React__default.createElement("div", { className: "privacy" },
                React__default.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                React__default.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title" }, intl.getLabel('account.privacy.title')),
                statusFailed(updateOptInsCall) && (React__default.createElement(ScrollIntoView, null,
                    React__default.createElement(Alert, { type: "error", message: intl.getFormattedLabel('account.privacy.updateOptins.errors.general', {
                            parseLink: true,
                        }) }))),
                React__default.createElement(CheckboxList, { items: availableOptIns, idPrefix: "__opt-in_", renderItem: function (item) { return (React__default.createElement("span", { className: "privacy__opt-in-text" }, intl.getFormattedLabel(item.titleKey, { parseHTML: true }))); }, renderTrailingItem: function (item) {
                        return item.tooltipKey && (React__default.createElement(Tooltip, { id: item.titleKey, message: intl.getLabel(item.tooltipKey, {
                                hideLabelKey: true,
                            }), className: "privacy__opt-in-tooltip" }));
                    }, getItemIdentifier: function (item) { return item.value; }, selectedItems: Privacy.getSelectedItems(optInsOnServer, changedOptIns, availableOptIns), onChange: this.onOptInChange }),
                intl.hasLabel('account.consent.dataProcessing') && (React__default.createElement(Text, { className: "privacy__data-processing-disclaimer", variant: "caption" }, intl.getFormattedLabel('account.consent.dataProcessing', { parseLink: true }))),
                React__default.createElement(Button, { size: "medium", className: "privacy__save-button", caption: intl.getLabel('account.action.save'), disabled: statusLoading(updateOptInsCall), "data-t": "save-consent", onClick: this.handleSave })));
        }
    };
    Privacy.getSelectedItems = function (server, client, availableOptIns) {
        var selectedKeys = [];
        if (Object.keys(client).length) {
            // Take selected values from form state when not empty
            selectedKeys = Object.keys(client).reduce(function (selected, optInName) {
                if (!client[optInName].checked) {
                    return selected;
                }
                return __spreadArray(__spreadArray([], __read(selected)), [optInName]);
            }, []);
        }
        else {
            // Otherwise take selected values from server state
            selectedKeys = Object.entries(server.result.optinValues)
                .filter(function (_a) {
                var _b = __read(_a, 2); _b[0]; var value = _b[1];
                return value;
            })
                .map(function (_a) {
                var _b = __read(_a, 1), name = _b[0];
                return name;
            });
        }
        return availableOptIns.filter(function (o) { return selectedKeys.includes(o.value); });
    };
    return Privacy;
}(Component));
var mapStateToProps$5 = function (state) { return ({
    availableOptIns: Selectors.getOptIns(state),
    changedOptIns: getChangedOptIns(state),
    optInsOnServer: getOptInsOnServer(state),
    updateOptInsCall: getUpdateOptInsCall(state),
}); };
var mapDispatchToProps$5 = {
    fetchOptIns: fetchOptIns$1,
    updateOptIns: updateOptIns$1,
    toggleOptIns: toggleOptIns,
};
var Privacy$1 = connect(mapStateToProps$5, mapDispatchToProps$5)(withIntl(Privacy));

var TotalPrice = function (_a) {
    var label = _a.label, totalPrice = _a.totalPrice;
    return (React.createElement("b", null,
        React.createElement("span", null,
            label,
            " "),
        React.createElement(Price, { value: totalPrice.amount, currency: totalPrice.currency })));
};
var SubscriptionHeader$1 = function (_a) {
    var expiryDate = _a.expiryDate, totalPrice = _a.totalPrice, className = _a.className, deliveryFrequency = _a.deliveryFrequency, disabled = _a.disabled, nextDelivery = _a.nextDelivery, status = _a.status;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var isExpired = status === 'EXPIRED';
    var deliveryFrequencyLabel = getDeliveryFrequencyLabel(deliveryFrequency, getLabel);
    var durationDefinition = isExpired
        ? // Duration is fixed for IE + UK, which is the scope for now
            "2 " + getLabel('common.duration.years') + " - " + getLabel("account.subscription.status.expired")
        : "2 " + getLabel('common.duration.years');
    return (React.createElement(Summary, { className: classnames('subscription-header subscription__summary', className, {
            'subscription-header--disabled': disabled,
        }) },
        React.createElement(DetailHeader, { className: "subscription-header__info" },
            React.createElement(DetailHeader.Item, { term: getLabel('account.subscription.length') + ': ', definition: durationDefinition }),
            deliveryFrequency && (React.createElement(DetailHeader.Item, { term: getLabel('account.subscription.deliveryFrequency') + ': ', definition: deliveryFrequencyLabel })),
            React.createElement(DetailHeader.Item, { term: getLabel('account.subscription.nextDelivery') + ': ', definition: nextDelivery ? (React.createElement(DateTime, { dateTime: new Date(nextDelivery.date), locale: locale })) : (getLabel('account.subscription.nextDelivery.unavailable')) }),
            React.createElement(DetailHeader.Item, { term: React.createElement(TotalPrice, { label: getLabel('common.total') + ': ', totalPrice: totalPrice }), definition: getLabel('common.frequency.perMonth') })),
        React.createElement(Hr, { className: "subscription-header__horizontal-rule" }),
        !isExpired && (React.createElement(Label, { type: "neutral" },
            React.createElement(React.Fragment, null,
                getLabel("account.subscription.expiryDate") + ': ',
                React.createElement(DateTime, { dateTime: expiryDate, locale: locale }))))));
};
function getDeliveryFrequencyLabel(label, getLabel) {
    if (!label) {
        return undefined;
    }
    switch (label) {
        case 'ANNUALLY':
            return getLabel('common.frequency.yearly');
        case 'BI_WEEKLY':
            return getLabel('common.frequency.biweekly');
        default:
            return getLabel("common.frequency." + label.toLowerCase());
    }
}

var OrderOfPrescriptionAttributes = [
    'power',
    'baseCurve',
    'diameter',
    'axis',
    'cylinder',
    'addition',
];
var LineItemPrescription = function (_a) {
    var prescriptionAttrs = _a.prescriptionAttrs;
    var intl = useIntl();
    return (React.createElement("div", { className: "line-item__prescription" }, OrderOfPrescriptionAttributes.map(function (key) {
        var value = prescriptionAttrs[key];
        return ((isString(value) || isNumber(value)) && (React.createElement("span", { className: "line-item__prescription-item", key: key },
            intl.getLabel("products.contactLenses.prescription." + key + ".abbr") + ': ',
            value)));
    })));
};

var getSubscriptionImageUrl = function (variantInfo, isBynderImagesEnabled, staticsUrl) {
    var _a, _b, _c;
    if (staticsUrl === void 0) { staticsUrl = ''; }
    if (isBynderImagesEnabled) {
        var imageUrl_1 = getFrontImage(variantInfo.images).url;
        return imageUrl_1 + "?w=300&bg=FFFFFF&fm=jpeg&auto=format";
    }
    /**
     * Return legacy images if available
     */
    var imageUrl = (_c = (_b = (_a = variantInfo.images) === null || _a === void 0 ? void 0 : _a.primary) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : '';
    return imageUrl && "" + staticsUrl + imageUrl + "?w=300&bg=FFFFFF&fm=jpeg";
};

var getProductSubtitle = function (product) {
    var intl = useIntl();
    if (CommerceToolsApi.isLenses(product)) {
        var packageQuantity = product.packageQuantity, replacementFrequency = product.replacementFrequency;
        var frequencyLabelKey = intl.getLabel("common.frequency." + replacementFrequency.toLowerCase());
        // Todo: add eyeside in a later story
        return packageQuantity + " " + frequencyLabelKey + " " + intl.getLabel('products.unit.contactLenses') + " " + intl.getLabel('products.perBox');
    }
    else {
        return product.brandModel;
    }
};
var SubscriptionLineItem$1 = function (_a) {
    var product = _a.product, staticsUrl = _a.staticsUrl, quantity = _a.quantity, eyeSide = _a.eyeSide;
    var variantInfo = product; // Rename for clarity on what this actually is
    var isBynderImagesEnabled = useFeatureToggles().isBynderImagesEnabled;
    var brand = variantInfo.brand;
    var subtitle = getProductSubtitle(variantInfo);
    var imagePath = getSubscriptionImageUrl(variantInfo, isBynderImagesEnabled, staticsUrl);
    var eyeSideElement = eyeSide && eyeSide !== 'both' ? (React.createElement(EyeSideIndicator, { className: "subscription-line-item__eyeside-indicator", side: eyeSide })) : null;
    return (React.createElement("div", { className: "subscription-line-item" },
        React.createElement(LineItem, { className: "subscription-line-item__container" },
            React.createElement(LineItemMedia, { type: "image", imageUrl: imagePath, imageAlt: brand, overlayElement: eyeSideElement }),
            React.createElement(LineItemContent, null,
                React.createElement(LineItemTitle, { title: brand }),
                subtitle && React.createElement(LineItemSubtitle, { subtitle: subtitle }),
                CommerceToolsApi.isLenses(variantInfo) && (React.createElement(LineItemPrescription, { prescriptionAttrs: variantInfo.lensProperties })),
                React.createElement(LineItemQuantity, { quantity: quantity })))));
};

var SubscriptionLineItemFailed = function () {
    var getLabel = useIntl().getLabel;
    return (React.createElement(SkeletonLoader, { animate: false, className: "subscription-line-item-failed" },
        React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "subscription-line-item-failed__image" },
            React.createElement("rect", { width: "100%", height: "100%", rx: "5", fill: "currentColor" })),
        React.createElement("p", { className: "subscription-line-item-failed__text" }, getLabel('account.subscription.product.failed'))));
};

var SubscriptionLineItemLoader = function () { return (React.createElement(SkeletonLoader, null,
    React.createElement("svg", { fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("rect", { width: "30%", height: "100%", rx: "5", fill: "currentColor" }),
        React.createElement("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor", x: "35%" }),
        React.createElement("rect", { width: "40%", height: "15px", rx: "5", fill: "currentColor", x: "35%", y: "30" }),
        React.createElement("rect", { width: "25%", height: "15px", rx: "5", fill: "currentColor", x: "35%", y: "60" })))); };

var ChangeQuantityModal = function (_a) {
    var className = _a.className, onCancel = _a.onCancel, onEditQuantity = _a.onEditQuantity, maxQuantity = _a.maxQuantity, isLoading = _a.isLoading, errorMessage = _a.errorMessage, totalPricePerInstallment = _a.totalPricePerInstallment;
    var intl = useIntl();
    var quantityRange = Array.from({ length: maxQuantity }, function (_, i) { return i + 1; });
    var formattedQuantities = quantityRange.reduce(function (acc, quantity) {
        var _a;
        var quantityLabel = quantity === 1 ? intl.getLabel('products.box') : intl.getLabel('products.boxes');
        return __assign(__assign({}, acc), (_a = {}, _a[quantity + " " + quantityLabel] = quantity, _a));
    }, {});
    var initialOptionKey = Object.keys(formattedQuantities)[0];
    var _b = __read(React.useState(formattedQuantities[initialOptionKey]), 2), quantity = _b[0], setQuantity = _b[1];
    var initialValue = React.useMemo(function () { return ({ value: initialOptionKey }); }, [initialOptionKey]);
    var onSelectChange = function (quantity) {
        setQuantity(quantity);
    };
    var handleSubmit = function () {
        onEditQuantity(quantity);
    };
    var buttonCaption = isLoading
        ? intl.getLabel('common.loadingText')
        : intl.getLabel('account.action.changeQuantity');
    var footerButton = (React.createElement(Button, { caption: buttonCaption, className: "edit-subscription__button", "data-t": "edit-subscription-modal-confirm", disabled: isLoading, onClick: handleSubmit }));
    return (React.createElement(Modal$2, { showIcon: true, isOpen: true, onModalClose: onCancel, title: intl.getLabel('account.editSubscription.title'), footer: footerButton, className: classnames('edit-subscription', className) },
        React.createElement(Alert, { type: "info", icon: "information-circle", message: intl.getFormattedLabel('account.editSubscription.info', { parseLink: true }) }),
        errorMessage && React.createElement(Alert, { type: "error", icon: "warning", message: errorMessage }),
        React.createElement(Select, { id: "edit-quantity-select", name: "edit-quantity-select", className: "edit-subscription__select", options: formattedQuantities, initialState: initialValue, onChange: onSelectChange, label: intl.getLabel('account.editSubscription.select.label') }),
        React.createElement("p", null,
            intl.getLabel('account.editSubscription.newPrice'),
            ' ',
            React.createElement("b", null,
                React.createElement(Price, { value: totalPricePerInstallment.amount * quantity, currency: totalPricePerInstallment.currency })))));
};

var PauseSubscriptionModal = function (_a) {
    var className = _a.className, pauseDurationOptions = _a.pauseDurationOptions, onCancel = _a.onCancel, onPause = _a.onPause, isLoading = _a.isLoading, errorMessage = _a.errorMessage;
    var intl = useIntl();
    var _b = __read(React.useState(pauseDurationOptions[0]), 2), selection = _b[0], setSelection = _b[1];
    var formattedDurations = React.useMemo(function () {
        return pauseDurationOptions.reduce(function (acc, option) {
            var _a;
            var durationLabelKey = option.amount === 1 ? option.unit.slice(0, -1) : option.unit;
            var durationLabel = option.amount + " " + intl.getLabel("common.duration." + durationLabelKey.toLowerCase());
            return __assign(__assign({}, acc), (_a = {}, _a[durationLabel] = option, _a));
        }, {});
    }, [pauseDurationOptions]);
    var onSelectChange = React.useCallback(function (duration) {
        setSelection(duration);
    }, []);
    var handlePause = React.useCallback(function () {
        if (selection) {
            onPause(selection);
        }
    }, [selection]);
    var buttonCaption = isLoading
        ? intl.getLabel('common.loadingText')
        : intl.getLabel('account.pauseSubscription.actions.pause');
    return (React.createElement(Modal$2, { showIcon: true, isOpen: true, onModalClose: onCancel, "aria-label": intl.getLabel('account.pauseSubscription.title'), className: classnames('pause-subscription', className) },
        React.createElement(Heading, { variant: "smallest", component: "h2", className: "pause-subscription__title" }, intl.getLabel('account.pauseSubscription.title')),
        React.createElement(Hr, null),
        React.createElement("p", { className: "pause-subscription__description" }, intl.getLabel('account.pauseSubscription.description')),
        React.createElement(Alert, { type: "info", icon: "information-circle", message: intl.getFormattedLabel('account.pauseSubscription.info', { parseLink: true }) }),
        errorMessage && React.createElement(Alert, { type: "error", icon: "warning", message: errorMessage }),
        React.createElement(Select, { id: "pause-duration-select", name: "pause-duration-select", className: "pause-subscription__select", options: formattedDurations, onChange: onSelectChange, label: intl.getLabel('account.pauseSubscription.select.label') }),
        React.createElement("div", { className: "pause-subscription__buttons" },
            React.createElement(Button, { caption: buttonCaption, className: "pause-subscription__button", "data-t": "pause-subscription-modal-confirm", onClick: handlePause, disabled: isLoading }),
            React.createElement(Button, { caption: intl.getLabel('common.actions.cancel'), className: "pause-subscription__button", "data-t": "pause-subscription-modal-cancel", onClick: onCancel, variant: "outline" }))));
};

var getEyeSide = function (application) {
    if (!application.length) {
        return {};
    }
    if (application.length > 2) {
        return {
            eyeSide: 'both',
        };
    }
    else if (application.includes('LEFT_EYE')) {
        return {
            eyeSide: 'left',
        };
    }
    else {
        return {
            eyeSide: 'right',
        };
    }
};
var CurrentPlan$1 = /** @class */ (function (_super) {
    __extends(CurrentPlan, _super);
    function CurrentPlan() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.pauseButtonRef = React.createRef();
        _this.editButtonRef = React.createRef();
        _this.state = {
            activeModal: undefined,
        };
        _this.handleTopUp = function () {
            var _a = _this.props, subscription = _a.subscription, intl = _a.intl;
            var lineItemDrafts = subscription.lineItems.map(function (item) { return ({
                sku: item.productId,
                quantity: item.quantity,
                custom: __assign({}, getEyeSide(item.application)),
            }); });
            if (_this.props.reorder) {
                _this.props.reorder({
                    drafts: {
                        lineItems: lineItemDrafts,
                    },
                    currency: intl.currency,
                    country: intl.country,
                    locale: intl.locale,
                });
            }
        };
        _this.openQuantityModal = function () {
            _this.setState({ activeModal: 'quantity' });
        };
        _this.openPauseModal = function () {
            _this.setState({ activeModal: 'pause' });
        };
        _this.focusModalTrigger = function (focusRef) {
            focusRef.current && focusRef.current.focus();
        };
        _this.closeModal = function () {
            var focusRef = _this.state.activeModal === 'pause' ? _this.pauseButtonRef : _this.editButtonRef;
            _this.setState({ activeModal: undefined });
            _this.focusModalTrigger(focusRef);
        };
        _this.handlePause = function (duration) {
            _this.props.pause(duration);
        };
        _this.handleEdit = function (quantity) {
            _this.props.quantity({ quantity: quantity });
        };
        return _this;
    }
    CurrentPlan.prototype.componentDidUpdate = function (prevProps, prevState) {
        // Close modal if pause or quantity call went from loading to idle
        if ((statusLoading(prevProps.pauseCall) && statusIdle(this.props.pauseCall)) ||
            (statusLoading(prevProps.quantityCall) && statusIdle(this.props.quantityCall))) {
            this.closeModal();
        }
        // Pause error
        if (statusLoading(prevProps.pauseCall) && statusFailed(this.props.pauseCall)) {
            this.setState({
                pauseError: this.props.intl.getFormattedLabel('account.subscription.pause.error', {
                    parseLink: true,
                }),
            });
        }
        if (statusFailed(prevProps.pauseCall) && prevState.activeModal && !this.state.activeModal) {
            this.setState({ pauseError: undefined });
        }
        // Quantity error
        if (statusLoading(prevProps.quantityCall) && statusFailed(this.props.quantityCall)) {
            this.setState({
                quantityError: this.props.intl.getFormattedLabel('account.subscription.quantity.error', {
                    parseLink: true,
                }),
            });
        }
        if (statusFailed(prevProps.quantityCall) && prevState.activeModal && !this.state.activeModal) {
            this.setState({ quantityError: undefined });
        }
    };
    CurrentPlan.prototype.render = function () {
        var _a = this.props, subscription = _a.subscription, className = _a.className, intl = _a.intl, productData = _a.productData, staticsUrl = _a.staticsUrl, reorderCall = _a.reorderCall, pauseCall = _a.pauseCall, quantityCall = _a.quantityCall;
        var nextDelivery = subscription.deliveries.find(function (d) { return d.status !== 'DELIVERED'; });
        var price = subscription.billing.totalPricePerInstallment;
        var hasQuantityPending = subscription.pendingChanges.includes('quantity');
        var hasPausePending = subscription.pendingChanges.includes('pause');
        var isSubscriptionDisabled = ['EXPIRED', 'CANCELLED', 'ON_HOLD'].some(function (s) { return s === subscription.status; });
        var renderLineItem = function (lineItem) {
            var data = productData[lineItem.productId];
            var eyeSide = getEyeSide(lineItem.application).eyeSide;
            if (!data || statusLoading(data)) {
                return React.createElement(SubscriptionLineItemLoader, null);
            }
            if (statusFailed(data)) {
                return React.createElement(SubscriptionLineItemFailed, null);
            }
            if (statusSuccess(data)) {
                return (React.createElement(SubscriptionLineItem$1, { product: data.result, staticsUrl: staticsUrl, quantity: lineItem.quantity, eyeSide: eyeSide }));
            }
        };
        return (React.createElement("section", { className: classnames('current-plan', className) },
            renderStatusAlert(subscription.status, intl),
            renderPendingChangesAlert(subscription.pendingChanges, intl),
            React.createElement(SubscriptionHeader$1, { nextDelivery: nextDelivery, expiryDate: subscription.expiryDate, totalPrice: price, status: subscription.status, disabled: isSubscriptionDisabled, className: classnames('current-plan__summary'), deliveryFrequency: subscription.deliveryFrequency }),
            statusFailed(reorderCall) && (React.createElement(ScrollIntoView, null,
                React.createElement(Alert, { type: "error", message: intl.getFormattedLabel('account.order.topup.errors.general', {
                        parseLink: true,
                    }) }))),
            React.createElement(SummaryContainer, { className: "current-plan__summary" }, subscription.lineItems.map(function (lineItem, index) { return (React.createElement(React.Fragment, { key: lineItem.productId + "-" + index },
                !!index && React.createElement(Hr, null),
                renderLineItem(lineItem))); })),
            subscription.topUpAllowed && (React.createElement("p", { "data-t": "top-up-description", className: "current-plan__topup-description" }, intl.getLabel('account.subscription.topUp.description', {
                hideLabelKey: true,
            }))),
            React.createElement("div", { className: "current-plan__buttons" },
                subscription.topUpAllowed && (React.createElement(Button, { "data-t": "top-up", className: "current-plan__button", caption: intl.getLabel('account.subscription.action.topUp'), onClick: statusLoading(reorderCall) ? undefined : this.handleTopUp, disabled: isSubscriptionDisabled })),
                React.createElement(Button, { "data-t": "edit-subscription", btnRef: this.editButtonRef, className: "current-plan__button", caption: intl.getLabel('account.subscription.action.edit'), onClick: this.openQuantityModal, variant: "outline", disabled: !subscription.quantityChangeable || hasQuantityPending || isSubscriptionDisabled })),
            React.createElement(Hr, null),
            subscription.pauseOptions.length === 0 && (React.createElement(Alert, { type: "info", message: intl.getFormattedLabel('account.subscription.pause.noBudget', {
                    parseLink: true,
                }) })),
            React.createElement(Button, { "data-t": "pause-subscription", className: "current-plan__pause-button", caption: intl.getLabel('account.subscription.action.pause'), onClick: this.openPauseModal, btnRef: this.pauseButtonRef, variant: "outline", disabled: subscription.pauseOptions.length === 0 || hasPausePending || isSubscriptionDisabled }),
            this.state.activeModal === 'pause' && subscription.pauseOptions.length > 0 && (React.createElement(PauseSubscriptionModal, { onCancel: this.closeModal, pauseDurationOptions: subscription.pauseOptions, onPause: this.handlePause, isLoading: statusLoading(pauseCall), errorMessage: this.state.pauseError })),
            this.state.activeModal === 'quantity' && (React.createElement(ChangeQuantityModal, { onCancel: this.closeModal, maxQuantity: 3, onEditQuantity: this.handleEdit, isLoading: statusLoading(quantityCall), errorMessage: this.state.quantityError, totalPricePerInstallment: subscription.billing.totalPricePerInstallment }))));
    };
    return CurrentPlan;
}(React.Component));
var mapStateToProps$4 = function (state) { return ({
    reorderCall: getReorderCall(state),
    pauseCall: getPauseCall(state),
    productData: getProductData(state),
    productDataCall: getProductDataCall(state),
    quantityCall: getQuantityCall(state),
}); };
var mapDispatchToProps$4 = {
    reorder: reorder,
    pause: pause,
    quantity: quantity,
};
var CurrentPlan$2 = connect(mapStateToProps$4, mapDispatchToProps$4)(withIntl(CurrentPlan$1));
function renderPendingChangesAlert(pendingChanges, intl) {
    if (pendingChanges.length < 1) {
        return;
    }
    if (pendingChanges.length > 1) {
        return (React.createElement(Alert, { key: "multiple", type: "info", message: intl.getFormattedLabel("account.subscription.pauseAndQuantity.processing", {
                parseLink: true,
            }) }));
    }
    var type = pendingChanges[0];
    return (React.createElement(Alert, { key: type, type: "info", message: intl.getFormattedLabel("account.subscription." + type + ".processing", {
            parseLink: true,
        }) }));
}
function renderStatusAlert(status, intl) {
    var message;
    switch (status) {
        case 'CANCELLED':
        case 'EXPIRED':
        case 'PAUSED':
            message = intl.getFormattedLabel("account.subscription." + status.toLowerCase(), {
                parseLink: true,
            });
            break;
        case 'ON_HOLD':
            message = intl.getFormattedLabel("account.subscription.onHold", { parseLink: true });
            break;
    }
    return message && React.createElement(Alert, { type: "error", notifyScreenReader: false, message: message });
}

var DeliveryAddressesSummary = function (_a) {
    var addressSummary = _a.addressSummary, handleEditClick = _a.handleEditClick, isSubscriptionHasOneAddressEnabled = _a.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _a.isSubscriptionUpdateAddressEnabled, subscription = _a.subscription;
    var getLabel = useIntl().getLabel;
    var deliveryAddress = subscription.deliveryAddress, billingAddress = subscription.billingAddress;
    var addressLabel = isSubscriptionHasOneAddressEnabled
        ? getLabel('account.billingAndDeliveryAddress')
        : getLabel('account.deliveryAddress');
    return (React.createElement(Summary, { className: classnames([
            'subscription-deliveries__addresses-summary',
            {
                'subscription-deliveries__addresses-summary--two-addresses': !isSubscriptionHasOneAddressEnabled,
            },
        ]), onEditClick: isSubscriptionHasOneAddressEnabled && isSubscriptionUpdateAddressEnabled
            ? handleEditClick
            : undefined },
        addressSummary({ data: deliveryAddress }, addressLabel),
        !isSubscriptionHasOneAddressEnabled &&
            (billingAddress ? (addressSummary({ data: billingAddress }, getLabel('account.billingAddress'))) : (React.createElement("p", null,
                React.createElement(Heading, { component: "span", variant: "subheading2" }, getLabel('account.billingAddress')),
                React.createElement("span", null, getLabel('account.sameAddress')))))));
};

var DeliveryAddressForm = function (_a) {
    var billingAddressForm = _a.billingAddressForm, subscriptionForm = _a.subscriptionForm, onChange = _a.onChange, onSave = _a.onSave, onCancel = _a.onCancel;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var isLoading = (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.saveFormCall.status) === 'loading';
    var isError = (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.saveFormCall.status) === 'failed';
    return (React.createElement(Form, { name: "billingAddress", "data-t": "billingAddress", className: "subscription-deliveries__form", initialFormState: subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.state, onChange: function (_a) {
            var formState = _a.formState;
            onChange(formState);
        }, onSubmit: function (_a) {
            var formState = _a.formState;
            onSave(formState);
        } },
        isError && (React.createElement(Alert, { type: "error", message: getFormattedLabel('account.subscription.detail.saveFailed', { parseLink: true }) })),
        billingAddressForm,
        React.createElement("p", { className: "subscription-deliveries__note" },
            React.createElement("strong", null,
                getLabel('account.common.pleaseNote'),
                ":"),
            ' ',
            getLabel('account.subscription.detail.note')),
        React.createElement("div", { className: "subscription-deliveries__button-block" },
            React.createElement(Button, { caption: getLabel('account.action.save'), className: "subscription-deliveries__button", isLoading: isLoading, type: "submit", "data-t": "save-delivery-address" }),
            React.createElement(Button, { caption: getLabel('common.actions.cancel'), className: "subscription-deliveries__button", onClick: onCancel, variant: "outline" }))));
};

var InfoModal = function (_a) {
    var isOpen = _a.isOpen, onModalClose = _a.onModalClose, title = _a.title, message = _a.message, okLabel = _a.okLabel;
    return (React.createElement(Modal$2, { isOpen: isOpen, onModalClose: onModalClose, title: title, showIcon: true, footer: React.createElement("div", null,
            React.createElement(Button, { caption: okLabel, onClick: onModalClose })) },
        React.createElement("div", { style: { margin: '1rem 0' } }, message)));
};

var Delivery = function (_a) {
    var addressSummary = _a.addressSummary, billingAddressForm = _a.billingAddressForm, subscriptionForm = _a.subscriptionForm, isSubscriptionHasOneAddressEnabled = _a.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _a.isSubscriptionUpdateAddressEnabled, subscription = _a.subscription, onChange = _a.onChange, onCancel = _a.onCancel, onSave = _a.onSave, onEditModeChange = _a.onEditModeChange, onModalClose = _a.onModalClose;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var sortedDeliveries = subscription.deliveries.sort(function (l, r) {
        return r.date.localeCompare(l.date, 'en', { numeric: true, usage: 'sort' });
    });
    var getRow = function (rowIndex) { return sortedDeliveries[rowIndex]; };
    return (React.createElement("div", { className: "subscription-deliveries" },
        React.createElement(Heading, { variant: "smallest", component: "h2" }, getLabel('account.subscription.detail.deliveryDetails')),
        (subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.isInEditMode) ? (React.createElement(DeliveryAddressForm, { billingAddressForm: billingAddressForm, onChange: onChange, onSave: onSave, onCancel: onCancel, subscriptionForm: subscriptionForm })) : (React.createElement(DeliveryAddressesSummary, { addressSummary: addressSummary, subscription: subscription, isSubscriptionHasOneAddressEnabled: isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled: isSubscriptionUpdateAddressEnabled, handleEditClick: function () {
                onEditModeChange(true);
            } })),
        React.createElement(DataTable, { "aria-level": 2, caption: getLabel('account.subscription.detail.deliveryHistory'), numberOfRows: sortedDeliveries.length },
            React.createElement(DataTable.Col, { id: "date", header: getLabel('common.date') }, function (rowIndex) { return React.createElement(DateTime, { locale: locale, dateTime: getRow(rowIndex).date }); }),
            React.createElement(DataTable.Col, { id: "id", header: getLabel('account.subscription.detail.deliveryHistory.orderNumber') }, function (rowIndex) { return getRow(rowIndex).reference || getLabel('common.notAvailable'); }),
            React.createElement(DataTable.Col, { id: "boxes_per_eye_side", header: getLabel('account.subscription.detail.deliveryHistory.boxesPerEyeSide') }, function (rowIndex) { return getRow(rowIndex).boxesPerEyeSide || getLabel('common.notAvailable'); }),
            React.createElement(DataTable.Col, { id: "status", header: getLabel('account.subscription.detail.delivery.status') }, function (rowIndex) {
                return getLabel("account.subscription.detail.delivery.status." + getRow(rowIndex).status.toLowerCase());
            })),
        React.createElement(InfoModal, { isOpen: !!(subscriptionForm === null || subscriptionForm === void 0 ? void 0 : subscriptionForm.isModalOpen), onModalClose: onModalClose, title: getLabel('account.subscription.detail.infoModal.title'), message: getLabel('account.subscription.detail.infoModal.message'), okLabel: getLabel('common.actions.ok') })));
};

/*
 * We can assume that `installments` is already sorted in the backend by date from old to new
 * i.e. [yesterday, today, tomorrow]

 * Reverse the new array so that it's sorted from new to old (i.e. [tomorrow, today, yesterday],
 * rendering from top to bottom).
 */
var prepareInstallmentsList = function (list) {
    return list.sort(function (a, b) { return b.date.localeCompare(a.date, 'en', { usage: 'sort', numeric: true }); });
};
var Payments$1 = function (_a) {
    var className = _a.className, subscription = _a.subscription, paymentDetailsSummary = _a.paymentDetailsSummary;
    var _b = useIntl(), getLabel = _b.getLabel, locale = _b.locale;
    var installments = subscription.installments;
    var LABEL_PREFIX = 'account.subscription.detail.paymentOverview';
    var reversedInstallements = prepareInstallmentsList(installments);
    var getRow = function (rowIndex) { return reversedInstallements[rowIndex]; };
    if (reversedInstallements.length > 0) {
        return (React.createElement("section", { className: classnames('subscription-payments', className) },
            React.createElement(Heading, { variant: "smallest", component: "h2" }, getLabel('account.subscription.paymentDetails')),
            React.createElement(Summary, { className: "subscription-payments__payment-details" }, paymentDetailsSummary({
                getLabel: getLabel,
                data: subscription.paymentMethod,
            })),
            React.createElement(DataTable, { "aria-level": 2, caption: getLabel(LABEL_PREFIX + ".title"), numberOfRows: reversedInstallements.length },
                React.createElement(DataTable.Col, { id: "date", header: getLabel('common.date') }, function (rowIndex) { return React.createElement(DateTime, { locale: locale, dateTime: getRow(rowIndex).date }); }),
                React.createElement(DataTable.Col, { id: "provider", header: getLabel('common.payment.provider') }, function (rowIndex) {
                    var paymentMethodKey = getRow(rowIndex).paymentMethod.toLowerCase().replace(' ', '');
                    return getLabel("common.payment.method." + paymentMethodKey);
                }),
                React.createElement(DataTable.Col, { id: "amount", header: getLabel('common.amount') }, function (rowIndex) { return (React.createElement(Price, { value: getRow(rowIndex).totalPrice.amount, currency: getRow(rowIndex).totalPrice.currency })); }),
                React.createElement(DataTable.Col, { id: "status", header: getLabel('common.status') }, function (rowIndex) {
                    var status = getRow(rowIndex).status.toLowerCase();
                    return (React.createElement("span", { className: "status--" + status }, getLabel("common.status." + status)));
                }))));
    }
    else {
        console.error("Payment installments expected for Subscription ID:" + subscription.id + " but none were found.");
        return (React.createElement("section", null,
            React.createElement(Alert, { type: "error", title: LABEL_PREFIX + ".error" })));
    }
};

var SubscriptionDetail$1 = /** @class */ (function (_super) {
    __extends(SubscriptionDetail, _super);
    function SubscriptionDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeTabIndex: 0,
        };
        _this.setIndex = function (index) { return _this.setState({ activeTabIndex: index }); };
        return _this;
    }
    SubscriptionDetail.prototype.componentDidMount = function () {
        var _a = this.props, subscriptionId = _a.subscriptionId, fetchDetail = _a.fetchDetail;
        fetchDetail({ subscriptionId: subscriptionId });
    };
    SubscriptionDetail.prototype.render = function () {
        var _a = this.props, addressSummary = _a.addressSummary, billingAddressForm = _a.billingAddressForm, detail = _a.detail, detailCall = _a.detailCall, getLabel = _a.intl.getLabel, subscriptionForm = _a.subscriptionForm, isSubscriptionHasOneAddressEnabled = _a.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _a.isSubscriptionUpdateAddressEnabled, paymentDetailsSummary = _a.paymentDetailsSummary, staticsUrl = _a.staticsUrl, subscriptionId = _a.subscriptionId, updateSubscriptionAddress = _a.updateSubscriptionAddress, saveSubscriptionAddress = _a.saveSubscriptionAddress, resetSubscriptionAddress = _a.resetSubscriptionAddress, setSubscriptionFormIsEditMode = _a.setSubscriptionFormIsEditMode, setSubscriptionFormIsModalOpen = _a.setSubscriptionFormIsModalOpen;
        var activeTabIndex = this.state.activeTabIndex;
        var ROUTE_KEY = RouteKey.Subscriptions;
        var routeLabel = getLabel("account.menu." + ROUTE_KEY);
        var LABEL_PREFIX = 'account.subscription.details';
        if (detail && detail.id === subscriptionId) {
            return (React.createElement("div", { className: "subscription-details" },
                React.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                React.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title subscription-details__title" }, getLabel(LABEL_PREFIX + ".title")),
                detail.custom && detail.custom.membershipId && (React.createElement("p", { className: "subscription-details__membership-id" }, getLabel(LABEL_PREFIX + ".membership.id") + ": " + detail.custom.membershipId)),
                React.createElement("div", { className: "subscription-details__tabs" },
                    React.createElement(Tabs, { onChange: this.setIndex, activeTabIndex: activeTabIndex },
                        React.createElement(Tab, { label: getLabel(LABEL_PREFIX + ".tabs.currentPlan") }),
                        React.createElement(Tab, { label: getLabel(LABEL_PREFIX + ".tabs.deliveryDetails") }),
                        React.createElement(Tab, { label: getLabel(LABEL_PREFIX + ".tabs.paymentDetails") }))),
                React.createElement("div", { className: "subscription-details__body" },
                    activeTabIndex === 0 && (React.createElement(CurrentPlan$2, { subscription: detail, staticsUrl: staticsUrl, className: "subscription-details__tab" })),
                    activeTabIndex === 1 && (React.createElement(Delivery, { addressSummary: addressSummary, billingAddressForm: billingAddressForm, subscriptionForm: subscriptionForm, onChange: updateSubscriptionAddress, onCancel: resetSubscriptionAddress, onSave: saveSubscriptionAddress, onEditModeChange: setSubscriptionFormIsEditMode, onModalClose: function () {
                            setSubscriptionFormIsModalOpen(false);
                        }, isSubscriptionHasOneAddressEnabled: isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled: isSubscriptionUpdateAddressEnabled, subscription: detail })),
                    activeTabIndex === 2 && (React.createElement(Payments$1, { subscription: detail, paymentDetailsSummary: paymentDetailsSummary, className: "subscription-payments__tab" })))));
        }
        else if (statusLoading(detailCall)) {
            return React.createElement(Loader$1, null);
        }
        else {
            return React.createElement(Alert, { type: "error", title: getLabel('account.subscriptions.errors.general') });
        }
    };
    return SubscriptionDetail;
}(React.Component));
var WrappedWithIntl$1 = withIntl(SubscriptionDetail$1);
var mapStateToProps$3 = function (state) { return ({
    detailCall: getSubscriptionDetailCall(state),
    detail: getSubscriptionDetail(state),
    subscriptionForm: getSubscriptionForm(state),
}); };
var mapDispatchToProps$3 = {
    fetchDetail: fetchDetail,
    updateSubscriptionAddress: updateSubscriptionAddress,
    saveSubscriptionAddress: saveSubscriptionAddress,
    resetSubscriptionAddress: resetSubscriptionAddress,
    setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode,
    setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen,
};
var SubscriptionDetail$2 = connect(mapStateToProps$3, mapDispatchToProps$3)(WrappedWithIntl$1);

var SET_ACTIVE_MODAL = 'auth/subscriptionsV2/setActiveModal';
var CLEAR_MODAL = 'auth/subscriptionsV2/clearModal';
var SET_SUBSCRIPTION_ORDER_ID = 'auth/subscriptionsV2/setSubscriptionOrderId';
var setActiveModal = function (activeModal) { return ({
    type: SET_ACTIVE_MODAL,
    payload: {
        activeModal: activeModal,
    },
}); };
var clearModal = function () { return ({
    type: CLEAR_MODAL,
}); };
var setSubscriptionOrderId = function (id) { return ({
    type: SET_SUBSCRIPTION_ORDER_ID,
    payload: {
        subscriptionOrderId: id,
    },
}); };

var initialState$1 = {
    activeModal: null,
    subscriptionOrderId: '',
};
var reducer$1 = function (state, action) {
    if (state === void 0) { state = initialState$1; }
    switch (action.type) {
        case CLEAR_MODAL:
            return __assign(__assign({}, state), { activeModal: null });
        case SET_ACTIVE_MODAL:
            return __assign(__assign({}, state), { activeModal: action.payload.activeModal });
        case SET_SUBSCRIPTION_ORDER_ID:
            return __assign(__assign({}, state), { subscriptionOrderId: action.payload.subscriptionOrderId });
        default:
            return state;
    }
};

var ModalContext = createContext({ state: initialState$1, dispatch: function () { return null; } });
var ModalContextProvider = function (_a) {
    var subscriptionOrderId = _a.subscriptionOrderId, children = _a.children;
    var init = __assign(__assign({}, initialState$1), { subscriptionOrderId: subscriptionOrderId !== null && subscriptionOrderId !== void 0 ? subscriptionOrderId : '' });
    var _b = __read(useReducer(reducer$1, init), 2), state = _b[0], dispatch = _b[1];
    return React__default.createElement(ModalContext.Provider, { value: { state: state, dispatch: dispatch } }, children);
};
var useModalContext = function () {
    var context = useContext(ModalContext);
    if (context === null) {
        throw new Error('Missing ModalContext provider.');
    }
    return context;
};

var Actions = { setActiveModal: setActiveModal, clearModal: clearModal, setSubscriptionOrderId: setSubscriptionOrderId };

var Modal$1;
(function (Modal) {
    Modal[Modal["Cancel"] = 0] = "Cancel";
    Modal[Modal["Suspend"] = 1] = "Suspend";
    Modal[Modal["Resume"] = 2] = "Resume";
    Modal[Modal["EditSubscription"] = 3] = "EditSubscription";
    Modal[Modal["EditSolution"] = 4] = "EditSolution";
})(Modal$1 || (Modal$1 = {}));

var BillingFrequency$1;
(function (BillingFrequency) {
    BillingFrequency["Monthly"] = "Monthly";
    BillingFrequency["Quarterly"] = "Quarterly";
})(BillingFrequency$1 || (BillingFrequency$1 = {}));
var DeliveryFrequency$1;
(function (DeliveryFrequency) {
    DeliveryFrequency["Monthly"] = "Monthly";
    DeliveryFrequency["Quarterly"] = "Quarterly";
})(DeliveryFrequency$1 || (DeliveryFrequency$1 = {}));
var DeliveryStatus$1;
(function (DeliveryStatus) {
    DeliveryStatus["Completed"] = "Completed";
    DeliveryStatus["Delivered"] = "Delivered";
    DeliveryStatus["Failed"] = "Failed";
    DeliveryStatus["Rejected"] = "Rejected";
    DeliveryStatus["Scheduled"] = "Scheduled";
    DeliveryStatus["Shipped"] = "Shipped";
    DeliveryStatus["Unknown"] = "Unknown";
})(DeliveryStatus$1 || (DeliveryStatus$1 = {}));
var PaymentType$1;
(function (PaymentType) {
    PaymentType["CreditCard"] = "CreditCard";
    PaymentType["Sepa"] = "Sepa";
})(PaymentType$1 || (PaymentType$1 = {}));
var PaymentStatus$1;
(function (PaymentStatus) {
    PaymentStatus["Due"] = "Due";
    PaymentStatus["Failed"] = "Failed";
    PaymentStatus["Paid"] = "Paid";
})(PaymentStatus$1 || (PaymentStatus$1 = {}));
var SubscriptionStatus$1;
(function (SubscriptionStatus) {
    SubscriptionStatus["Active"] = "Active";
    SubscriptionStatus["Cancelled"] = "Cancelled";
    SubscriptionStatus["Pending"] = "Pending";
    SubscriptionStatus["Suspended"] = "Suspended";
    SubscriptionStatus["Locked"] = "Locked";
})(SubscriptionStatus$1 || (SubscriptionStatus$1 = {}));
var SubscriptionStatusReason$1;
(function (SubscriptionStatusReason) {
    SubscriptionStatusReason["BankIssue"] = "SYS_BANK_ISSUE";
    SubscriptionStatusReason["NonPaymentIssue"] = "SYS_NON_PAYMENT_ISSUE";
    SubscriptionStatusReason["SepaChargeback"] = "SYS_SEPA_CHARGEBACK";
    SubscriptionStatusReason["UnableToDeliver"] = "SYS_UNABLE_TO_DELIVER";
    SubscriptionStatusReason["RejectedDelivery"] = "SYS_REJECTED_DELIVERY";
    SubscriptionStatusReason["ProductReturned"] = "SYS_PRODUCT_RETURNED";
    SubscriptionStatusReason["LsrvError"] = "SYS_LRSV_ERROR";
    SubscriptionStatusReason["SuspensionLimitExceeded"] = "SYS_SUSPENSION_LIMIT_EXCEEDED";
    SubscriptionStatusReason["NonPaymentCancellation"] = "SYS_NON_PAYMENT_CANCELLATION";
})(SubscriptionStatusReason$1 || (SubscriptionStatusReason$1 = {}));
var UsageLevel$1;
(function (UsageLevel) {
    UsageLevel["One"] = "one_day_a_week";
    UsageLevel["Two"] = "two_days_a_week";
    UsageLevel["ThreeFour"] = "three_four_days_a_week";
    UsageLevel["FivePlus"] = "more_than_five_days_a_week";
})(UsageLevel$1 || (UsageLevel$1 = {}));
var ReplacementFrequency$1;
(function (ReplacementFrequency) {
    ReplacementFrequency["BiWeekly"] = "bi_weekly";
    ReplacementFrequency["Daily"] = "daily";
    ReplacementFrequency["Monthly"] = "monthly";
})(ReplacementFrequency$1 || (ReplacementFrequency$1 = {}));
var isContactLensVariant$2 = function (variant) {
    return variant.hasOwnProperty('packageQuantity');
};
var isSolutionVariant = function (variant) {
    return variant.hasOwnProperty('volume');
};
var isDailyFrequency = function (variant) {
    return variant.product.replacementFrequency === ReplacementFrequency$1.Daily;
};
var isCreditCardPaymentType = function (item) { return item.paymentType === PaymentType$1.CreditCard; };
var isSepaPaymentType = function (item) {
    return item.paymentType === PaymentType$1.Sepa;
};

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var BillingFrequency;
(function (BillingFrequency) {
    BillingFrequency["MONTHLY"] = "MONTHLY";
    BillingFrequency["QUARTERLY"] = "QUARTERLY";
})(BillingFrequency || (BillingFrequency = {}));
var DeliveryFrequency;
(function (DeliveryFrequency) {
    DeliveryFrequency["MONTHLY"] = "MONTHLY";
    DeliveryFrequency["QUARTERLY"] = "QUARTERLY";
})(DeliveryFrequency || (DeliveryFrequency = {}));
/**
 * Delivery status of an order
 */
var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus["DELIVERED"] = "DELIVERED";
    DeliveryStatus["FAILED_DELIVERY"] = "FAILED_DELIVERY";
    DeliveryStatus["PROCESSING"] = "PROCESSING";
    DeliveryStatus["REJECTED_BY_CUSTOMER"] = "REJECTED_BY_CUSTOMER";
    DeliveryStatus["RETURN_COMPLETE"] = "RETURN_COMPLETE";
    DeliveryStatus["SCHEDULED"] = "SCHEDULED";
    DeliveryStatus["SHIPPED"] = "SHIPPED";
    DeliveryStatus["UNKNOWN"] = "UNKNOWN";
})(DeliveryStatus || (DeliveryStatus = {}));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["GET"] = "GET";
    HttpMethod["POST"] = "POST";
})(HttpMethod || (HttpMethod = {}));
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["DUE"] = "DUE";
    PaymentStatus["FAILED"] = "FAILED";
    PaymentStatus["PAID"] = "PAID";
})(PaymentStatus || (PaymentStatus = {}));
var PaymentType;
(function (PaymentType) {
    PaymentType["CARD"] = "CARD";
    PaymentType["IDEAL"] = "IDEAL";
    PaymentType["ONEY_3X"] = "ONEY_3X";
    PaymentType["ONEY_4X"] = "ONEY_4X";
    PaymentType["PAYPAL"] = "PAYPAL";
    PaymentType["SEPA"] = "SEPA";
})(PaymentType || (PaymentType = {}));
/**
 * The type of prescription (contact lenses, glasses or hearing aid).
 */
var PrescriptionType;
(function (PrescriptionType) {
    PrescriptionType["CONTACT_LENS_PRESCRIPTION"] = "CONTACT_LENS_PRESCRIPTION";
    PrescriptionType["HEARING_AID_PRESCRIPTION"] = "HEARING_AID_PRESCRIPTION";
    PrescriptionType["PRESCRIPTION_GLASSES_PRESCRIPTION"] = "PRESCRIPTION_GLASSES_PRESCRIPTION";
})(PrescriptionType || (PrescriptionType = {}));
var ReplacementFrequency;
(function (ReplacementFrequency) {
    ReplacementFrequency["BI_WEEKLY"] = "BI_WEEKLY";
    ReplacementFrequency["DAILY"] = "DAILY";
    ReplacementFrequency["MONTHLY"] = "MONTHLY";
})(ReplacementFrequency || (ReplacementFrequency = {}));
var ResultType;
(function (ResultType) {
    ResultType["AUTHORISED"] = "AUTHORISED";
    ResultType["CANCELLED"] = "CANCELLED";
    ResultType["ERROR"] = "ERROR";
    ResultType["REDIRECT"] = "REDIRECT";
    ResultType["REFUSED"] = "REFUSED";
    ResultType["THREE_DS_CHALLENGE"] = "THREE_DS_CHALLENGE";
})(ResultType || (ResultType = {}));
var RetrySubscriptionPaymentStatus;
(function (RetrySubscriptionPaymentStatus) {
    RetrySubscriptionPaymentStatus["PAYMENT_FAILED"] = "PAYMENT_FAILED";
    RetrySubscriptionPaymentStatus["PAYMENT_SUCCESS"] = "PAYMENT_SUCCESS";
})(RetrySubscriptionPaymentStatus || (RetrySubscriptionPaymentStatus = {}));
var SubscriptionCancellationReason$2;
(function (SubscriptionCancellationReason) {
    SubscriptionCancellationReason["CS_BACKLOG"] = "CS_BACKLOG";
    SubscriptionCancellationReason["CS_CASH_PAYER"] = "CS_CASH_PAYER";
    SubscriptionCancellationReason["CS_CLINICAL_NON_TOLERANCE_BY_STORE"] = "CS_CLINICAL_NON_TOLERANCE_BY_STORE";
    SubscriptionCancellationReason["CS_COMPETITOR_CHEAPER"] = "CS_COMPETITOR_CHEAPER";
    SubscriptionCancellationReason["CS_DECEASED"] = "CS_DECEASED";
    SubscriptionCancellationReason["CS_DISCONTINUED_PRODUCT"] = "CS_DISCONTINUED_PRODUCT";
    SubscriptionCancellationReason["CS_DOES_NOT_FIT_MY_NEEDS"] = "CS_DOES_NOT_FIT_MY_NEEDS";
    SubscriptionCancellationReason["CS_INFREQUENT_USE"] = "CS_INFREQUENT_USE";
    SubscriptionCancellationReason["CS_LASER"] = "CS_LASER";
    SubscriptionCancellationReason["CS_LENSES_CHEAPER_IN_STORE"] = "CS_LENSES_CHEAPER_IN_STORE";
    SubscriptionCancellationReason["CS_LENS_QUALITY"] = "CS_LENS_QUALITY";
    SubscriptionCancellationReason["CS_MEDICAL"] = "CS_MEDICAL";
    SubscriptionCancellationReason["CS_MOVING_AWAY"] = "CS_MOVING_AWAY";
    SubscriptionCancellationReason["CS_OTHER"] = "CS_OTHER";
    SubscriptionCancellationReason["CS_PREFERRED_DELIVERY_FREQ_NOT_AVAILABLE"] = "CS_PREFERRED_DELIVERY_FREQ_NOT_AVAILABLE";
    SubscriptionCancellationReason["CS_PREFER_GLASSES"] = "CS_PREFER_GLASSES";
    SubscriptionCancellationReason["CS_PREGNANT"] = "CS_PREGNANT";
    SubscriptionCancellationReason["CS_PRICE_INCREASE"] = "CS_PRICE_INCREASE";
    SubscriptionCancellationReason["CS_REASON_DECLINED"] = "CS_REASON_DECLINED";
    SubscriptionCancellationReason["CS_SEASONAL_LENS_WEARER"] = "CS_SEASONAL_LENS_WEARER";
    SubscriptionCancellationReason["CS_SERVICE_GENERAL"] = "CS_SERVICE_GENERAL";
    SubscriptionCancellationReason["CS_SERVICE_STORE"] = "CS_SERVICE_STORE";
    SubscriptionCancellationReason["CS_STORE_REQUEST"] = "CS_STORE_REQUEST";
    SubscriptionCancellationReason["CS_TOO_EXPENSIVE"] = "CS_TOO_EXPENSIVE";
    SubscriptionCancellationReason["CS_TRYOUT_DIFFERENT_LENSES"] = "CS_TRYOUT_DIFFERENT_LENSES";
    SubscriptionCancellationReason["CS_WEARING_COMFORT"] = "CS_WEARING_COMFORT";
    SubscriptionCancellationReason["ECOM_BACKLOG"] = "ECOM_BACKLOG";
    SubscriptionCancellationReason["ECOM_COMPETITOR_CHEAPER"] = "ECOM_COMPETITOR_CHEAPER";
    SubscriptionCancellationReason["ECOM_DOES_NOT_FIT_MY_NEEDS"] = "ECOM_DOES_NOT_FIT_MY_NEEDS";
    SubscriptionCancellationReason["ECOM_INFREQUENT_USE"] = "ECOM_INFREQUENT_USE";
    SubscriptionCancellationReason["ECOM_LASER"] = "ECOM_LASER";
    SubscriptionCancellationReason["ECOM_MEDICAL"] = "ECOM_MEDICAL";
    SubscriptionCancellationReason["ECOM_MOVING_AWAY"] = "ECOM_MOVING_AWAY";
    SubscriptionCancellationReason["ECOM_OTHER"] = "ECOM_OTHER";
    SubscriptionCancellationReason["ECOM_PREFER_GLASSES"] = "ECOM_PREFER_GLASSES";
    SubscriptionCancellationReason["ECOM_TOO_EXPENSIVE"] = "ECOM_TOO_EXPENSIVE";
    SubscriptionCancellationReason["ECOM_TRYOUT_DIFFERENT_LENSES"] = "ECOM_TRYOUT_DIFFERENT_LENSES";
    SubscriptionCancellationReason["ECOM_WEARING_COMFORT"] = "ECOM_WEARING_COMFORT";
})(SubscriptionCancellationReason$2 || (SubscriptionCancellationReason$2 = {}));
var SubscriptionPaymentType;
(function (SubscriptionPaymentType) {
    SubscriptionPaymentType["CARD"] = "CARD";
    SubscriptionPaymentType["SEPA"] = "SEPA";
})(SubscriptionPaymentType || (SubscriptionPaymentType = {}));
/**
 * Status of a given ProductSubscription in zuora
 * https: // confluence.grandvision.global/pages/viewpage.action?spaceKey=GV&title=Status+mapping+Zuora+%7C+Frontend
 */
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["CANCELLED"] = "CANCELLED";
    SubscriptionStatus["LOCKED"] = "LOCKED";
    SubscriptionStatus["PENDING"] = "PENDING";
    SubscriptionStatus["SUSPENDED"] = "SUSPENDED";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var SubscriptionStatusReason;
(function (SubscriptionStatusReason) {
    SubscriptionStatusReason["SYS_BANK_ISSUE"] = "SYS_BANK_ISSUE";
    SubscriptionStatusReason["SYS_LRSV_ERROR"] = "SYS_LRSV_ERROR";
    SubscriptionStatusReason["SYS_NON_PAYMENT_CANCELLATION"] = "SYS_NON_PAYMENT_CANCELLATION";
    SubscriptionStatusReason["SYS_NON_PAYMENT_ISSUE"] = "SYS_NON_PAYMENT_ISSUE";
    SubscriptionStatusReason["SYS_PRODUCT_RETURNED"] = "SYS_PRODUCT_RETURNED";
    SubscriptionStatusReason["SYS_REJECTED_DELIVERY"] = "SYS_REJECTED_DELIVERY";
    SubscriptionStatusReason["SYS_SEPA_CHARGEBACK"] = "SYS_SEPA_CHARGEBACK";
    SubscriptionStatusReason["SYS_SUSPENSION_LIMIT_EXCEEDED"] = "SYS_SUSPENSION_LIMIT_EXCEEDED";
    SubscriptionStatusReason["SYS_UNABLE_TO_DELIVER"] = "SYS_UNABLE_TO_DELIVER";
})(SubscriptionStatusReason || (SubscriptionStatusReason = {}));
var SubscriptionSuspensionPeriod$1;
(function (SubscriptionSuspensionPeriod) {
    SubscriptionSuspensionPeriod["FIVE_MONTHS"] = "FIVE_MONTHS";
    SubscriptionSuspensionPeriod["FOUR_MONTHS"] = "FOUR_MONTHS";
    SubscriptionSuspensionPeriod["ONE_MONTH"] = "ONE_MONTH";
    SubscriptionSuspensionPeriod["SIX_MONTHS"] = "SIX_MONTHS";
    SubscriptionSuspensionPeriod["THREE_MONTHS"] = "THREE_MONTHS";
    SubscriptionSuspensionPeriod["TWO_MONTHS"] = "TWO_MONTHS";
})(SubscriptionSuspensionPeriod$1 || (SubscriptionSuspensionPeriod$1 = {}));
var SubscriptionSuspensionReason$1;
(function (SubscriptionSuspensionReason) {
    SubscriptionSuspensionReason["CS_BACKLOG"] = "CS_BACKLOG";
    SubscriptionSuspensionReason["CS_EMPLOYEE_DECISION"] = "CS_EMPLOYEE_DECISION";
    SubscriptionSuspensionReason["CS_NEW_TEST_COMING_UP"] = "CS_NEW_TEST_COMING_UP";
    SubscriptionSuspensionReason["CS_OTHER"] = "CS_OTHER";
    SubscriptionSuspensionReason["CS_OTHER_DELIVERY"] = "CS_OTHER_DELIVERY";
    SubscriptionSuspensionReason["CS_SEASONAL_USER"] = "CS_SEASONAL_USER";
    SubscriptionSuspensionReason["CS_TRAVEL"] = "CS_TRAVEL";
    SubscriptionSuspensionReason["CS_TRYING_NEW_PRODUCT"] = "CS_TRYING_NEW_PRODUCT";
    SubscriptionSuspensionReason["ECOM_BACKLOG"] = "ECOM_BACKLOG";
    SubscriptionSuspensionReason["ECOM_OTHER"] = "ECOM_OTHER";
    SubscriptionSuspensionReason["ECOM_OTHER_DELIVERY"] = "ECOM_OTHER_DELIVERY";
    SubscriptionSuspensionReason["ECOM_TRAVEL"] = "ECOM_TRAVEL";
})(SubscriptionSuspensionReason$1 || (SubscriptionSuspensionReason$1 = {}));
var UsageLevel;
(function (UsageLevel) {
    UsageLevel["MORE_THAN_FIVE_DAYS_A_WEEK"] = "MORE_THAN_FIVE_DAYS_A_WEEK";
    UsageLevel["ONE_DAY_A_WEEK"] = "ONE_DAY_A_WEEK";
    UsageLevel["THREE_FOUR_DAYS_A_WEEK"] = "THREE_FOUR_DAYS_A_WEEK";
    UsageLevel["TWO_DAYS_A_WEEK"] = "TWO_DAYS_A_WEEK";
})(UsageLevel || (UsageLevel = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

var SubscriptionCancellationReason;
(function (SubscriptionCancellationReason) {
    SubscriptionCancellationReason["EcomBacklog"] = "ECOM_BACKLOG";
    SubscriptionCancellationReason["EcomInfrequentUse"] = "ECOM_INFREQUENT_USE";
    SubscriptionCancellationReason["EcomWearingComfort"] = "ECOM_WEARING_COMFORT";
    SubscriptionCancellationReason["EcomTryoutDifferentLenses"] = "ECOM_TRYOUT_DIFFERENT_LENSES";
    SubscriptionCancellationReason["EcomLaser"] = "ECOM_LASER";
    SubscriptionCancellationReason["EcomMedical"] = "ECOM_MEDICAL";
    SubscriptionCancellationReason["EcomPreferGlasses"] = "ECOM_PREFER_GLASSES";
    SubscriptionCancellationReason["EcomTooExpensive"] = "ECOM_TOO_EXPENSIVE";
    SubscriptionCancellationReason["EcomCompetitorCheaper"] = "ECOM_COMPETITOR_CHEAPER";
    SubscriptionCancellationReason["EcomMovingAway"] = "ECOM_MOVING_AWAY";
    SubscriptionCancellationReason["EcomDoesNotFitMyNeeds"] = "ECOM_DOES_NOT_FIT_MY_NEEDS";
    SubscriptionCancellationReason["EcomOther"] = "ECOM_OTHER";
})(SubscriptionCancellationReason || (SubscriptionCancellationReason = {}));
var SubscriptionCancellationReason$1 = SubscriptionCancellationReason;

var _a$2;
var map = (_a$2 = {},
    _a$2[SubscriptionCancellationReason$2.ECOM_BACKLOG] = SubscriptionCancellationReason$1.EcomBacklog,
    _a$2[SubscriptionCancellationReason$2.ECOM_INFREQUENT_USE] = SubscriptionCancellationReason$1.EcomInfrequentUse,
    _a$2[SubscriptionCancellationReason$2.ECOM_WEARING_COMFORT] = SubscriptionCancellationReason$1.EcomWearingComfort,
    _a$2[SubscriptionCancellationReason$2.ECOM_TRYOUT_DIFFERENT_LENSES] = SubscriptionCancellationReason$1.EcomTryoutDifferentLenses,
    _a$2[SubscriptionCancellationReason$2.ECOM_LASER] = SubscriptionCancellationReason$1.EcomLaser,
    _a$2[SubscriptionCancellationReason$2.ECOM_MEDICAL] = SubscriptionCancellationReason$1.EcomMedical,
    _a$2[SubscriptionCancellationReason$2.ECOM_PREFER_GLASSES] = SubscriptionCancellationReason$1.EcomPreferGlasses,
    _a$2[SubscriptionCancellationReason$2.ECOM_TOO_EXPENSIVE] = SubscriptionCancellationReason$1.EcomTooExpensive,
    _a$2[SubscriptionCancellationReason$2.ECOM_COMPETITOR_CHEAPER] = SubscriptionCancellationReason$1.EcomCompetitorCheaper,
    _a$2[SubscriptionCancellationReason$2.ECOM_MOVING_AWAY] = SubscriptionCancellationReason$1.EcomMovingAway,
    _a$2[SubscriptionCancellationReason$2.ECOM_DOES_NOT_FIT_MY_NEEDS] = SubscriptionCancellationReason$1.EcomDoesNotFitMyNeeds,
    _a$2[SubscriptionCancellationReason$2.ECOM_OTHER] = SubscriptionCancellationReason$1.EcomOther,
    _a$2);
var invertedMap = Object.keys(map).reduce(function (previous, key) {
    var _a;
    return (__assign(__assign({}, previous), (_a = {}, _a[map[key]] = key, _a)));
}, {});
var toSubscriptionCancellationReason = function (raw) { return map[raw]; };
var toRawCancellationReason = function (cancellationReason) { return invertedMap[cancellationReason]; };

var CANCEL_SUBSCRIPTION = gql(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n  mutation CancelSubscription($input: CancelSubscriptionInput!) {\n    cancelSubscription(input: $input) {\n      subscription {\n        status\n      }\n    }\n  }\n"], ["\n  mutation CancelSubscription($input: CancelSubscriptionInput!) {\n    cancelSubscription(input: $input) {\n      subscription {\n        status\n      }\n    }\n  }\n"])));
var templateObject_1$t;

var useCancelSubscription = function (subscriptionOrderId, userId) {
    var _a = __read(useMutation(CANCEL_SUBSCRIPTION), 1), mutation = _a[0];
    return {
        cancelSubscription: function (cancellationReason) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mutation({
                            variables: {
                                input: {
                                    subscriptionOrderId: subscriptionOrderId,
                                    customerId: userId,
                                    cancellationReason: toRawCancellationReason(cancellationReason),
                                },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    };
};

var GET_SUBSCRIPTION_CANCELLATION_REASONS = gql(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n  query getSubscriptionCancellationReasons {\n    subscriptionCancellationReasons(channel: ECOM)\n  }\n"], ["\n  query getSubscriptionCancellationReasons {\n    subscriptionCancellationReasons(channel: ECOM)\n  }\n"])));
var templateObject_1$s;

var useGetSubscriptionCancellationReasons = function () {
    var _a;
    var _b = useQuery(GET_SUBSCRIPTION_CANCELLATION_REASONS), data = _b.data, loading = _b.loading, error = _b.error;
    return {
        data: (_a = data === null || data === void 0 ? void 0 : data.subscriptionCancellationReasons) === null || _a === void 0 ? void 0 : _a.map(toSubscriptionCancellationReason),
        loading: loading,
        error: error,
    };
};

var ModalFooter = function (_a) {
    var ctaCaption = _a.ctaCaption, onCancel = _a.onCancel, onCta = _a.onCta, ctaButtonType = _a.ctaButtonType, cancelCaption = _a.cancelCaption, associatedFormId = _a.associatedFormId, _b = _a.ctaLoading, ctaLoading = _b === void 0 ? false : _b, className = _a.className;
    var isPhone = MediaQuery.useIsPhone();
    var getLabel = useIntl().getLabel;
    var cancelProps = useMemo(function () { return ({
        'data-t': 'subscription-modal-footer-cancel-button',
        className: 'subscription-modal-footer__button',
        caption: cancelCaption !== null && cancelCaption !== void 0 ? cancelCaption : getLabel('common.actions.cancel'),
        'aria-label': cancelCaption !== null && cancelCaption !== void 0 ? cancelCaption : getLabel('common.actions.cancel'),
        variant: 'outline',
        onClick: onCancel,
    }); }, [cancelCaption, getLabel, onCancel]);
    var ctaProps = useMemo(function () { return ({
        'data-t': 'subscription-modal-footer-cta-button',
        className: 'subscription-modal-footer__button',
        caption: ctaCaption,
        'aria-label': ctaCaption,
        variant: 'solid',
        onClick: onCta,
        type: ctaButtonType,
        form: associatedFormId,
        isLoading: ctaLoading,
    }); }, [associatedFormId, ctaButtonType, ctaCaption, ctaLoading, onCta]);
    return (React__default.createElement("div", { className: classnames('subscription-modal-footer', className) }, isPhone ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, __assign({}, ctaProps)),
        React__default.createElement(Button, __assign({}, cancelProps)))) : (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Button, __assign({}, cancelProps)),
        React__default.createElement(Button, __assign({}, ctaProps))))));
};

var FORM_NAME$1 = 'cancel-subscription-form'; //set as id in the Form component
var CancelSubscriptionModal = function (_a) {
    var labels = _a.labels, onClose = _a.onClose, onConfirm = _a.onConfirm, reasonsOptions = _a.reasonsOptions, reasonsLoading = _a.reasonsLoading;
    var _b = __read(React__default.useState(), 2), selectedReason = _b[0], setSelectedReason = _b[1];
    var _c = __read(React__default.useState(false), 2), confirmLoading = _c[0], setConfirmLoading = _c[1];
    var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selectedReason)
                        return [2 /*return*/];
                    setConfirmLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onConfirm(selectedReason)];
                case 2:
                    _b.sent();
                    setConfirmLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    setConfirmLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement(Modal$2, { className: "cancel-subscription", isOpen: true, showIcon: true, title: labels.primaryAction, onModalClose: onClose, footer: React__default.createElement(ModalFooter, { ctaCaption: labels.primaryAction, onCancel: onClose, associatedFormId: FORM_NAME$1, ctaButtonType: "submit", ctaLoading: confirmLoading }) },
        reasonsLoading && React__default.createElement(Loader$1, null),
        reasonsOptions && !reasonsLoading && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Form, { name: FORM_NAME$1, onSubmit: handleConfirm, showErrorsOnInvalidSubmit: true },
                React__default.createElement("p", null, labels.introduction),
                React__default.createElement(Field, { className: "cancel-subscription__select-reason", error: labels.validationError, validations: [Util.validations.isRequired], name: "reason", label: labels.tellUsWhy, placeholder: labels.placeholder, onChange: function (state) { return setSelectedReason(state.value); }, required: true },
                    React__default.createElement(Select, { "data-t": "select-reason", id: "reason", name: "reason", options: reasonsOptions }))),
            React__default.createElement(Alert, { icon: "info", message: labels.alertMessage }),
            React__default.createElement("p", { className: "cancel-subscription__disclaimer" },
                React__default.createElement("strong", null,
                    labels.pleaseNote,
                    ":"),
                " ",
                React__default.createElement("span", null, labels.disclaimer))))));
};

var LABEL_PREFIX$8 = 'account.subscription.detail.currentPlan.cancel';
var CancelSubscriptionModalContainer = function (_a) {
    var subscriptionOrderId = _a.subscriptionOrderId, onClose = _a.onClose;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var cancelSubscription = useCancelSubscription(subscriptionOrderId, userId).cancelSubscription;
    var _b = useGetSubscriptionCancellationReasons(), reasons = _b.data, loading = _b.loading, error = _b.error;
    var _c = useIntl(), getLabel = _c.getLabel, getFormattedLabel = _c.getFormattedLabel;
    var labels = React__default.useMemo(function () { return ({
        primaryAction: getLabel(LABEL_PREFIX$8 + ".cancelSubscription"),
        secondaryAction: getLabel('common.actions.cancel'),
        alertMessage: getFormattedLabel(LABEL_PREFIX$8 + ".alertMessage", { parseLink: true }),
        introduction: getLabel(LABEL_PREFIX$8 + ".introduction"),
        pleaseNote: getLabel('common.pleaseNote'),
        disclaimer: getLabel(LABEL_PREFIX$8 + ".disclaimer"),
        tellUsWhy: getLabel(LABEL_PREFIX$8 + ".tellUsWhy"),
        placeholder: getLabel(LABEL_PREFIX$8 + ".selectReason"),
        validationError: getLabel("common.form.field.requiredError"),
    }); }, [getLabel]);
    if (loading)
        return React__default.createElement(Loader$1, null);
    if (!reasons || error) {
        toast.failed(LABEL_PREFIX$8 + ".errorMessage");
        return null;
    }
    var options = reasons.reduce(function (previous, current) {
        var _a;
        return (__assign(__assign({}, previous), (_a = {}, _a[getLabel(LABEL_PREFIX$8 + ".reason." + current)] = current, _a)));
    }, {});
    var onConfirm = function (reason) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, cancelSubscription(reason)];
                case 1:
                    _b.sent();
                    onClose();
                    toast.success(LABEL_PREFIX$8 + ".successMessage");
                    return [3 /*break*/, 3];
                case 2:
                    _b.sent();
                    toast.failed(LABEL_PREFIX$8 + ".errorMessage");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement(CancelSubscriptionModal, { labels: labels, onClose: onClose, onConfirm: onConfirm, reasonsOptions: options, reasonsLoading: loading }));
};

var Type;
(function (Type) {
    Type[Type["ChangeRatePlan"] = 0] = "ChangeRatePlan";
    Type[Type["ChangeBillingFrequency"] = 1] = "ChangeBillingFrequency";
    Type[Type["ChangeDeliveryFrequency"] = 2] = "ChangeDeliveryFrequency";
    Type[Type["ChangeSolution"] = 3] = "ChangeSolution";
})(Type || (Type = {}));
var changeRatePlan = function (ratePlan) { return ({
    type: Type.ChangeRatePlan,
    payload: ratePlan,
}); };
var changeBillingFrequency = function (billingFrequency) { return ({
    type: Type.ChangeBillingFrequency,
    payload: billingFrequency,
}); };
var changeDeliveryFrequency = function (deliveryFrequency) { return ({
    type: Type.ChangeDeliveryFrequency,
    payload: deliveryFrequency,
}); };
var changeSolutionProduct = function (solutionProduct) { return ({
    type: Type.ChangeSolution,
    payload: solutionProduct,
}); };

var toDeliveryStatus = function (raw) {
    var _a;
    return (_a = {},
        _a[DeliveryStatus.DELIVERED] = DeliveryStatus$1.Delivered,
        _a[DeliveryStatus.FAILED_DELIVERY] = DeliveryStatus$1.Failed,
        _a[DeliveryStatus.REJECTED_BY_CUSTOMER] = DeliveryStatus$1.Rejected,
        _a[DeliveryStatus.RETURN_COMPLETE] = DeliveryStatus$1.Completed,
        _a[DeliveryStatus.SCHEDULED] = DeliveryStatus$1.Scheduled,
        _a[DeliveryStatus.SHIPPED] = DeliveryStatus$1.Shipped,
        _a[DeliveryStatus.UNKNOWN] = DeliveryStatus$1.Unknown,
        _a)[raw];
};
var toPaymentType = function (raw) {
    var _a;
    return (_a = {},
        _a[SubscriptionPaymentType.CARD] = PaymentType$1.CreditCard,
        _a[SubscriptionPaymentType.SEPA] = PaymentType$1.Sepa,
        _a)[raw];
};
var toPaymentStatus = function (raw) {
    var _a;
    return (_a = {},
        _a[PaymentStatus.DUE] = PaymentStatus$1.Due,
        _a[PaymentStatus.FAILED] = PaymentStatus$1.Failed,
        _a[PaymentStatus.PAID] = PaymentStatus$1.Paid,
        _a)[raw];
};
var toSubscriptionStatus = function (raw) {
    var _a;
    return (_a = {},
        _a[SubscriptionStatus.ACTIVE] = SubscriptionStatus$1.Active,
        _a[SubscriptionStatus.CANCELLED] = SubscriptionStatus$1.Cancelled,
        _a[SubscriptionStatus.PENDING] = SubscriptionStatus$1.Pending,
        _a[SubscriptionStatus.SUSPENDED] = SubscriptionStatus$1.Suspended,
        _a[SubscriptionStatus.LOCKED] = SubscriptionStatus$1.Locked,
        _a)[raw];
};
var toSubscriptionStatusReason = function (raw) {
    var _a;
    if (!raw)
        return undefined;
    return (_a = {},
        _a[SubscriptionStatusReason.SYS_BANK_ISSUE] = SubscriptionStatusReason$1.BankIssue,
        _a[SubscriptionStatusReason.SYS_LRSV_ERROR] = SubscriptionStatusReason$1.LsrvError,
        _a[SubscriptionStatusReason.SYS_SEPA_CHARGEBACK] = SubscriptionStatusReason$1.SepaChargeback,
        _a[SubscriptionStatusReason.SYS_PRODUCT_RETURNED] = SubscriptionStatusReason$1.ProductReturned,
        _a[SubscriptionStatusReason.SYS_REJECTED_DELIVERY] = SubscriptionStatusReason$1.RejectedDelivery,
        _a[SubscriptionStatusReason.SYS_UNABLE_TO_DELIVER] = SubscriptionStatusReason$1.UnableToDeliver,
        _a[SubscriptionStatusReason.SYS_NON_PAYMENT_ISSUE] = SubscriptionStatusReason$1.NonPaymentIssue,
        _a[SubscriptionStatusReason.SYS_NON_PAYMENT_CANCELLATION] = SubscriptionStatusReason$1.NonPaymentCancellation,
        _a[SubscriptionStatusReason.SYS_SUSPENSION_LIMIT_EXCEEDED] = SubscriptionStatusReason$1.SuspensionLimitExceeded,
        _a)[raw];
};
var toReplacementFrequency = function (raw) {
    var _a;
    return (_a = {},
        _a[ReplacementFrequency.BI_WEEKLY] = ReplacementFrequency$1.BiWeekly,
        _a[ReplacementFrequency.MONTHLY] = ReplacementFrequency$1.Monthly,
        _a[ReplacementFrequency.DAILY] = ReplacementFrequency$1.Daily,
        _a)[raw];
};
var toBillingFrequency = function (raw) {
    var _a;
    return (_a = {},
        _a[BillingFrequency.MONTHLY] = BillingFrequency$1.Monthly,
        _a[BillingFrequency.QUARTERLY] = BillingFrequency$1.Quarterly,
        _a)[raw];
};
var toDeliveryFrequency = function (raw) {
    var _a;
    return (_a = {},
        _a[DeliveryFrequency.MONTHLY] = DeliveryFrequency$1.Monthly,
        _a[DeliveryFrequency.QUARTERLY] = DeliveryFrequency$1.Quarterly,
        _a)[raw];
};
var toDeliveries = function (raw) {
    return (raw || []).map(function (delivery) { return ({
        shipmentTrackingURL: delivery.shipmentTrackingURL,
        shipmentNumber: delivery.shipmentNumber,
        shippingDate: parseDateString(delivery.shippingDate),
        status: toDeliveryStatus(delivery.status),
    }); });
};
var toAddress = function (raw) {
    if (!raw) {
        return undefined;
    }
    return {
        firstName: (raw === null || raw === void 0 ? void 0 : raw.firstName) || '',
        lastName: (raw === null || raw === void 0 ? void 0 : raw.lastName) || '',
        streetName: raw === null || raw === void 0 ? void 0 : raw.streetName,
        streetNumber: raw === null || raw === void 0 ? void 0 : raw.streetNumber,
        additionalStreetInfo: (raw === null || raw === void 0 ? void 0 : raw.additionalStreetInfo) || undefined,
        city: (raw === null || raw === void 0 ? void 0 : raw.city) || '',
        postalCode: raw === null || raw === void 0 ? void 0 : raw.postalCode,
        region: (raw === null || raw === void 0 ? void 0 : raw.region) || '',
        countryCode: raw === null || raw === void 0 ? void 0 : raw.countryCode,
    };
};
// ivaNumber comes from the personalDetails object, so is passed in separately
// ivaNumber is called vatId in personalDetails object
var toBillingAddress = function (raw, ivaNumber) {
    var address = toAddress(raw);
    if (!address)
        return undefined;
    return __assign(__assign({}, address), { company: (raw === null || raw === void 0 ? void 0 : raw.company) || undefined, 
        // only store ivaNumber if company is also set. Not doing this causes
        // issues with validation when users edit their billing address
        ivaNumber: ((raw === null || raw === void 0 ? void 0 : raw.company) && ivaNumber) || undefined });
};
var toDeliveryAddress = function (raw) {
    var address = toAddress(raw);
    if (!address)
        return undefined;
    return __assign({}, address);
};
var toSubscriptionPersonalDetails = function (raw) {
    var _a, _b, _c, _d;
    return {
        certifiedEmail: (_a = raw.certifiedEmail) !== null && _a !== void 0 ? _a : undefined,
        dateOfBirth: parseDateString(raw.dateOfBirth),
        ssn: (_b = raw.ssn) !== null && _b !== void 0 ? _b : undefined,
        certifiedRecipientCode: (_c = raw.certifiedRecipientCode) !== null && _c !== void 0 ? _c : undefined,
        vatId: (_d = raw.vatId) !== null && _d !== void 0 ? _d : undefined,
    };
};
var toInvoices = function (raw) {
    return (raw || []).map(function (invoice) {
        var _a;
        return ({
            id: invoice.invoiceId,
            billingDate: invoice.billingDate,
            downloadToken: (_a = invoice.downloadToken) !== null && _a !== void 0 ? _a : '',
            paymentType: toPaymentType(invoice.paymentType),
            totalAmount: toPrice(invoice.totalAmount),
            status: toPaymentStatus(invoice.paymentStatus),
        });
    });
};
var toLens = function (raw) {
    var _a;
    if (raw === null) {
        return null;
    }
    return Object.keys(raw).reduce(function (acc, key) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[key] = raw[key] === null ? undefined : raw[key], _a)));
    }, (_a = {
            productReference: {
                gan: '',
            }
        },
        _a[PrescriptionKey.Addition] = '',
        _a[PrescriptionKey.Axis] = 0,
        _a[PrescriptionKey.BaseCurve] = 0,
        _a[PrescriptionKey.Cylinder] = 0,
        _a[PrescriptionKey.Diameter] = 0,
        _a[PrescriptionKey.Power] = 0,
        _a));
};
var toMediaImage = function (raw) {
    return {
        label: raw.label,
        url: raw.url,
    };
};
var toPrescription = function (raw) {
    if (!raw)
        return undefined;
    return {
        leftLens: toLens(raw.leftLens),
        rightLens: toLens(raw.rightLens),
    };
};
var toContactLensVariant = function (raw) {
    var _a;
    var images = ((_a = raw.media) === null || _a === void 0 ? void 0 : _a.images.filter(function (m) { return m !== null; }).map(toMediaImage)) || [];
    return {
        gan: raw.gan,
        product: toContactLensProduct(raw.product),
        packageQuantity: raw.packageQuantity,
        media: {
            images: images,
        },
    };
};
var toSolutionVariant = function (raw) {
    var _a, _b;
    var images = ((_a = raw.media) === null || _a === void 0 ? void 0 : _a.images.filter(function (m) { return m !== null; }).map(toMediaImage)) || [];
    return {
        volume: raw.volume,
        volumeUnit: raw.volumeUnit,
        gan: raw.gan,
        contactLensCareType: (_b = raw.contactLensCareType) !== null && _b !== void 0 ? _b : '',
        product: toSolutionProduct(raw.product),
        media: {
            images: images,
        },
    };
};
var toVariant = function (raw) {
    if (raw
        .packageQuantity !== undefined) {
        return toContactLensVariant(raw);
    }
    if (raw.volume !== undefined) {
        return toSolutionVariant(raw);
    }
    throw new Error('Unknown variant');
};
var toContactLensProduct = function (raw) {
    var _a;
    return {
        productMasterKey: raw.productMasterKey,
        brand: (_a = raw.brand) !== null && _a !== void 0 ? _a : '',
        name: raw.name || '',
        description: raw.description || '',
        replacementFrequency: toReplacementFrequency(raw.replacementFrequency),
    };
};
var toSolutionProduct = function (raw) {
    var _a;
    return {
        brand: (_a = raw.brand) !== null && _a !== void 0 ? _a : '',
        name: raw.name || '',
        description: raw.description || '',
    };
};
var toSubscriptionProducts = function (raw) {
    return raw.map(function (subscriptionProduct) { return ({
        includedUnits: subscriptionProduct.includedUnits || 0,
        variant: toVariant(subscriptionProduct.variant),
    }); });
};
var toPrescriptionDisplayValue = function (key, value) {
    if (value === null)
        return '';
    switch (key) {
        case PrescriptionKey.Axis:
            return value + "\u00B0";
        case PrescriptionKey.Cylinder:
            return value.toFixed(2);
        case PrescriptionKey.Diameter:
            return value.toFixed(1);
        case PrescriptionKey.BaseCurve:
            return value.toFixed(1);
        case PrescriptionKey.Power:
            return "" + (value > 0 ? '+' : '') + value.toFixed(2);
        case PrescriptionKey.Addition:
        default:
            return "" + value;
    }
};
// Date format is set to YYYY-MM-DD in the backend,
var parseDateString = function (raw) {
    if (!raw)
        return undefined;
    var split = raw.split('-');
    var year = +split[0];
    var month = +split[1] - 1;
    var day = +split[2];
    var date = new Date(year, month, day);
    // bail with raw string if date parsing returns invalid date
    return isNaN(date.getTime()) ? raw : date;
};
var toPrice = function (raw) {
    return { currencyCode: (raw === null || raw === void 0 ? void 0 : raw.currencyCode) || 'EUR', centAmount: (raw === null || raw === void 0 ? void 0 : raw.centAmount) || 0 };
};
var toPersonalDetails = function (raw) {
    return {
        dateOfBirth: parseDateString(raw.dateOfBirth) || '',
        ssn: raw.ssn || '',
    };
};
var toDeliveryAddressName = function (raw) {
    return {
        firstName: raw.firstName || '',
        lastName: raw.lastName || '',
    };
};
var toLastFour = function (iban) {
    return iban.slice(-4);
};
var toStoredPaymentMethod = function (raw) {
    if (!raw)
        return null;
    switch (raw.__typename) {
        case 'StoredCardPaymentMethod':
            return toCreditcardPaymentMethod(raw);
        case 'StoredSEPAPaymentMethod':
            return toSepaPaymentMethod(raw);
        default:
            return null;
    }
};
var toSepaPaymentMethod = function (paymentMethod) {
    return {
        holderName: paymentMethod.holderName,
        paymentToken: paymentMethod.paymentToken,
        lastFour: toLastFour(paymentMethod.iban),
        paymentType: PaymentType$1.Sepa,
    };
};
var toCreditcardPaymentMethod = function (paymentMethod) {
    return {
        brand: toCardBrandName(paymentMethod.brand),
        expiryMonth: paymentMethod.expiryMonth,
        expiryYear: paymentMethod.expiryYear,
        holderName: paymentMethod.holderName,
        lastFour: paymentMethod.lastFour,
        paymentToken: paymentMethod.paymentToken,
        paymentType: PaymentType$1.CreditCard,
    };
};
var toCardBrandName = function (brand) {
    switch (brand) {
        case 'visa':
            return CardBrandName.Visa;
        case 'mc':
            return CardBrandName.MasterCard;
        default:
            return CardBrandName.Unknown;
    }
};
var toSubscriptionBase = function (raw) { return ({
    id: raw.id,
    status: toSubscriptionStatus(raw.status),
    statusReason: toSubscriptionStatusReason(raw.statusReason),
    billingFrequency: toBillingFrequency(raw.billingFrequency),
    deliveryFrequency: toDeliveryFrequency(raw.deliveryFrequency),
    subscriptionProducts: toSubscriptionProducts(raw.subscriptionProducts || []),
    totalPrice: toPrice(raw.totalPrice),
}); };
var toSubscriptionDetail = function (raw) {
    if (!raw || raw.billingFrequency === null || raw.deliveryFrequency === null) {
        return undefined;
    }
    return __assign(__assign({}, toSubscriptionBase(raw)), { deliveryAddress: toDeliveryAddressName(raw.deliveryAddress), personalDetails: toPersonalDetails(raw.personalDetails), friendlyName: raw.friendlyName });
};
var toSubscriptionList = function (raw) {
    if (!raw || raw.billingFrequency === null || raw.deliveryFrequency === null) {
        return undefined;
    }
    return __assign({}, toSubscriptionBase(raw));
};

var toCurrentSubscriptionDetails = function (raw) {
    return !!raw
        ? {
            billingFrequency: toBillingFrequency(raw.billingFrequency),
            deliveryFrequency: toDeliveryFrequency(raw.deliveryFrequency),
            status: toSubscriptionStatus(raw.status),
            subscriptionName: raw.friendlyName,
            total: toPrice(raw.totalPrice),
        }
        : null;
};

var GET_CURRENT_SUBSCRIPTION_DETAILS = gql(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  query getCurrentSubscriptionDetails($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        billingFrequency\n        deliveryFrequency\n        friendlyName\n        status\n        totalPrice {\n          centAmount\n          currencyCode\n        }\n      }\n    }\n  }\n"], ["\n  query getCurrentSubscriptionDetails($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        billingFrequency\n        deliveryFrequency\n        friendlyName\n        status\n        totalPrice {\n          centAmount\n          currencyCode\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$r;

var useCurrentSubscriptionDetails = function (id) {
    var _a;
    var _b = useQuery(GET_CURRENT_SUBSCRIPTION_DETAILS, { variables: { id: id } }), data = _b.data, loading = _b.loading, error = _b.error;
    return {
        data: toCurrentSubscriptionDetails((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscription),
        loading: loading,
        error: error,
    };
};

var toEditSubscriptionInvoicePreview = function (raw) {
    if (!raw)
        return null;
    return {
        nextInvoiceAmount: raw.nextInvoiceAmount,
        recurringAmount: raw.recurringAmount,
        billingFrequency: toBillingFrequency(raw.billingFrequency),
    };
};
/**
 * The products package uses a slightly different type for the rateplans.
 * This mapper aligns the differing values.
 * @param ratePlans my-account style rapteplans
 * @returns rateplan compatible with products package components
 */
var toProductsRatePlans = function (ratePlans) {
    return ratePlans.map(function (ratePlan) {
        var basePrice = ratePlan.basePrice, usageLevel = ratePlan.usageLevel, packageQuantity = ratePlan.packageQuantity, rest = __rest(ratePlan, ["basePrice", "usageLevel", "packageQuantity"]);
        return __assign(__assign({}, rest), { totalPrice: basePrice, usageLevel: usageLevel || undefined, packageQuantity: packageQuantity || 0 });
    });
};
var toEditSubscriptionRatePlan = function (_a) {
    var gan = _a.gan, externalId = _a.externalId;
    return ({
        gan: gan,
        ratePlanId: externalId,
    });
};
var toUsageLevel = function (raw) {
    var _a;
    return raw &&
        (_a = {},
            _a[UsageLevel.ONE_DAY_A_WEEK] = UsageLevel$1.One,
            _a[UsageLevel.TWO_DAYS_A_WEEK] = UsageLevel$1.Two,
            _a[UsageLevel.THREE_FOUR_DAYS_A_WEEK] = UsageLevel$1.ThreeFour,
            _a[UsageLevel.MORE_THAN_FIVE_DAYS_A_WEEK] = UsageLevel$1.FivePlus,
            _a)[raw];
};
var toRatePlan = function (rawRatePlan, rawVariant) {
    var _a;
    var ratePlan = {
        gan: rawVariant.gan,
        externalId: rawRatePlan.id,
        effectiveStartDate: rawRatePlan.effectiveStartDate,
        effectiveEndDate: rawRatePlan.effectiveEndDate,
        billingPeriod: toBillingFrequency(rawRatePlan.billingPeriod),
        shippingSchedule: toDeliveryFrequency(rawRatePlan.shippingSchedule),
        includedUnits: 1,
        basePrice: {
            currencyCode: rawRatePlan.basePrice.currencyCode,
            centAmount: rawRatePlan.basePrice.centAmount,
        },
    };
    if (isContactLensVariant$1(rawVariant)) {
        ratePlan.usageLevel = toUsageLevel((_a = rawRatePlan) === null || _a === void 0 ? void 0 : _a.usageLevel);
        ratePlan.packageQuantity = rawVariant === null || rawVariant === void 0 ? void 0 : rawVariant.packageQuantity;
    }
    return ratePlan;
};
var isContactLensVariant$1 = function (variant) {
    return variant
        .packageQuantity;
};
var toContactLensRatePlans = function (subscriptionProducts) {
    var _a, _b;
    if (!subscriptionProducts)
        return undefined;
    var product = subscriptionProducts.find(function (subscriptionProduct) {
        var _a;
        var variant = subscriptionProduct.variant;
        return isContactLensVariant$1(variant) && ((_a = variant.product.ratePlans) === null || _a === void 0 ? void 0 : _a.length);
    });
    var variant = product &&
        product.variant;
    return (variant && {
        all: (_a = variant.product.ratePlans) === null || _a === void 0 ? void 0 : _a.map(function (ratePlan) { return toRatePlan(ratePlan, variant); }),
        distinct: (_b = variant.product.ratePlansDistinctByUsageLevel) === null || _b === void 0 ? void 0 : _b.map(function (ratePlan) {
            return toRatePlan(ratePlan, variant);
        }),
    });
};
var toSolutionRatePlans = function (subscriptionProducts) {
    var _a;
    if (!subscriptionProducts)
        return undefined;
    var solutionVariant = (_a = subscriptionProducts.find(function (subscriptionProduct) { return !isContactLensVariant$1(subscriptionProduct.variant); })) === null || _a === void 0 ? void 0 : _a.variant;
    if (!solutionVariant)
        return [];
    return (solutionVariant.product.ratePlans || []).map(function (ratePlan) {
        return toRatePlan(ratePlan, solutionVariant);
    });
};
var toVariants = function (subscriptionProducts) {
    if (!subscriptionProducts)
        return [];
    return subscriptionProducts.map(function (subscriptionProduct) {
        if (isContactLensVariant$1(subscriptionProduct.variant)) {
            return {
                gan: subscriptionProduct.variant.gan,
                packageQuantity: subscriptionProduct.variant.packageQuantity,
                // @TODO See how to fix these incompatible product types
                product: subscriptionProduct.variant.product,
            };
        }
        // TODO: Change this into the actual milliliterVolume
        // Setting the milliliterVolume to a hard-coded `0` is good enough for now, because the value of the property is
        // not important for determining the type of the variant.
        return { volume: 0 };
    });
};
var findContactLensVariant = function (subscriptionProducts) {
    var _a;
    if (!subscriptionProducts)
        return undefined;
    return (_a = subscriptionProducts.find(function (subscriptionProduct) {
        return isContactLensVariant$1(subscriptionProduct.variant);
    })) === null || _a === void 0 ? void 0 : _a.variant;
};
var toRecommendedSolutionProducts = function (subscriptionProducts) {
    var variant = findContactLensVariant(subscriptionProducts);
    if (!variant)
        return [];
    var values = variant.product.recommendedSolutions.map(function (product) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (!product.ratePlans || !product.ratePlans.length)
            return undefined;
        var variant = product.variants[0];
        var ratePlan = product.ratePlans[0];
        return {
            brand: (_a = product.brand) !== null && _a !== void 0 ? _a : '',
            name: (_b = product.name) !== null && _b !== void 0 ? _b : '',
            description: (_c = product.description) !== null && _c !== void 0 ? _c : '',
            variant: {
                gan: variant.gan,
                media: {
                    images: (((_d = variant.media) === null || _d === void 0 ? void 0 : _d.images) || []).map(function (_a) {
                        var url = _a.url, label = _a.label;
                        return ({ url: url, label: label });
                    }),
                },
                volume: variant.volume,
                volumeUnit: variant.volumeUnit,
                contactLensCareType: (_e = variant.contactLensCareType) !== null && _e !== void 0 ? _e : '',
                product: {
                    brand: (_f = product.brand) !== null && _f !== void 0 ? _f : '',
                    name: (_g = product.name) !== null && _g !== void 0 ? _g : '',
                    description: (_h = product.description) !== null && _h !== void 0 ? _h : '',
                },
            },
            ratePlan: toRatePlan(ratePlan, variant),
        };
    });
    return values.filter(function (value) { return Boolean(value); });
};
var toRawFrequency = function (frequency) {
    return frequency.toUpperCase();
};

var GET_SUBSCRIPTION_PRODUCT_RATEPLANS = gql(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  query getSubscriptionProductRateplans(\n    $id: ID!\n    $locale: Locale!\n    $billingFrequency: BillingFrequency!\n    $deliveryFrequency: DeliveryFrequency!\n  ) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        subscriptionProducts {\n          includedUnits\n          variant {\n            ... on ContactLensVariant {\n              gan\n              packageQuantity\n              product {\n                productMasterKey\n                recommendedSolutions {\n                  brand\n                  name(locale: $locale)\n                  description(locale: $locale)\n                  ratePlans(\n                    billingFrequency: $billingFrequency\n                    deliveryFrequency: $deliveryFrequency\n                  ) {\n                    id: externalId\n                    externalId\n                    effectiveStartDate\n                    effectiveEndDate\n                    billingPeriod\n                    shippingSchedule\n                    includedUnits\n                    basePrice {\n                      currencyCode\n                      centAmount\n                    }\n                  }\n                  variants {\n                    gan\n                    media {\n                      images {\n                        url\n                        label\n                        dimensions {\n                          w\n                          h\n                        }\n                      }\n                    }\n                    contactLensCareType(locale: $locale)\n                    volume\n                    volumeUnit\n                  }\n                }\n                ratePlans {\n                  id: externalId\n                  externalId\n                  effectiveStartDate\n                  effectiveEndDate\n                  billingPeriod\n                  shippingSchedule\n                  usageLevel\n                  includedUnits\n                  basePrice {\n                    currencyCode\n                    centAmount\n                  }\n                }\n                ratePlansDistinctByUsageLevel {\n                  id: externalId\n                  externalId\n                  effectiveStartDate\n                  effectiveEndDate\n                  billingPeriod\n                  shippingSchedule\n                  usageLevel\n                  includedUnits\n                  basePrice {\n                    currencyCode\n                    centAmount\n                  }\n                }\n              }\n            }\n            ... on SolutionVariant {\n              gan\n              product {\n                ratePlans {\n                  id: externalId\n                  externalId\n                  effectiveStartDate\n                  effectiveEndDate\n                  billingPeriod\n                  shippingSchedule\n                  includedUnits\n                  basePrice {\n                    currencyCode\n                    centAmount\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getSubscriptionProductRateplans(\n    $id: ID!\n    $locale: Locale!\n    $billingFrequency: BillingFrequency!\n    $deliveryFrequency: DeliveryFrequency!\n  ) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        subscriptionProducts {\n          includedUnits\n          variant {\n            ... on ContactLensVariant {\n              gan\n              packageQuantity\n              product {\n                productMasterKey\n                recommendedSolutions {\n                  brand\n                  name(locale: $locale)\n                  description(locale: $locale)\n                  ratePlans(\n                    billingFrequency: $billingFrequency\n                    deliveryFrequency: $deliveryFrequency\n                  ) {\n                    id: externalId\n                    externalId\n                    effectiveStartDate\n                    effectiveEndDate\n                    billingPeriod\n                    shippingSchedule\n                    includedUnits\n                    basePrice {\n                      currencyCode\n                      centAmount\n                    }\n                  }\n                  variants {\n                    gan\n                    media {\n                      images {\n                        url\n                        label\n                        dimensions {\n                          w\n                          h\n                        }\n                      }\n                    }\n                    contactLensCareType(locale: $locale)\n                    volume\n                    volumeUnit\n                  }\n                }\n                ratePlans {\n                  id: externalId\n                  externalId\n                  effectiveStartDate\n                  effectiveEndDate\n                  billingPeriod\n                  shippingSchedule\n                  usageLevel\n                  includedUnits\n                  basePrice {\n                    currencyCode\n                    centAmount\n                  }\n                }\n                ratePlansDistinctByUsageLevel {\n                  id: externalId\n                  externalId\n                  effectiveStartDate\n                  effectiveEndDate\n                  billingPeriod\n                  shippingSchedule\n                  usageLevel\n                  includedUnits\n                  basePrice {\n                    currencyCode\n                    centAmount\n                  }\n                }\n              }\n            }\n            ... on SolutionVariant {\n              gan\n              product {\n                ratePlans {\n                  id: externalId\n                  externalId\n                  effectiveStartDate\n                  effectiveEndDate\n                  billingPeriod\n                  shippingSchedule\n                  includedUnits\n                  basePrice {\n                    currencyCode\n                    centAmount\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$q;

var createOutput = function (overwriteProps) { return (__assign({ loading: false, data: {
        allLensRatePlans: [],
        distinctLensRatePlans: [],
        solutionRatePlans: [],
        variants: [],
        recommendedSolutionProducts: [],
    }, error: undefined }, overwriteProps)); };
var useGetSubscriptionProductRateplans = function (subscriptionOrderId, billingFrequency, deliveryFrequency) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var locale = useIntl().locale;
    var _j = __read(useLazyQuery(GET_SUBSCRIPTION_PRODUCT_RATEPLANS), 2), runQuery = _j[0], _k = _j[1], data = _k.data, loading = _k.loading, error = _k.error;
    useEffect(function () {
        if (billingFrequency && deliveryFrequency) {
            runQuery({
                variables: {
                    locale: locale,
                    id: subscriptionOrderId,
                    billingFrequency: toRawFrequency(billingFrequency),
                    deliveryFrequency: toRawFrequency(deliveryFrequency),
                },
            });
        }
    }, [runQuery, locale, subscriptionOrderId, billingFrequency, deliveryFrequency]);
    var lensRatePlans = toContactLensRatePlans((_b = (_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscription) === null || _b === void 0 ? void 0 : _b.subscriptionProducts);
    var solutionRatePlans = toSolutionRatePlans((_d = (_c = data === null || data === void 0 ? void 0 : data.me) === null || _c === void 0 ? void 0 : _c.subscription) === null || _d === void 0 ? void 0 : _d.subscriptionProducts);
    var variants = toVariants((_f = (_e = data === null || data === void 0 ? void 0 : data.me) === null || _e === void 0 ? void 0 : _e.subscription) === null || _f === void 0 ? void 0 : _f.subscriptionProducts);
    var recommendedSolutionProducts = toRecommendedSolutionProducts((_h = (_g = data === null || data === void 0 ? void 0 : data.me) === null || _g === void 0 ? void 0 : _g.subscription) === null || _h === void 0 ? void 0 : _h.subscriptionProducts);
    if (!(lensRatePlans === null || lensRatePlans === void 0 ? void 0 : lensRatePlans.all) || !(lensRatePlans === null || lensRatePlans === void 0 ? void 0 : lensRatePlans.distinct) || !variants.length || loading) {
        return createOutput({ loading: loading, error: error });
    }
    return createOutput({
        data: {
            allLensRatePlans: lensRatePlans.all,
            distinctLensRatePlans: lensRatePlans.distinct,
            solutionRatePlans: solutionRatePlans || [],
            variants: variants,
            recommendedSolutionProducts: recommendedSolutionProducts,
        },
        error: error,
    });
};

var initialState = {
    billingFrequency: undefined,
    deliveryFrequency: undefined,
    ratePlan: undefined,
    solutionProduct: undefined,
};
var reducer = function (state, action) {
    switch (action.type) {
        case Type.ChangeRatePlan:
            return __assign(__assign({}, state), { ratePlan: action.payload, billingFrequency: state.ratePlan ? undefined : state.billingFrequency, deliveryFrequency: state.ratePlan ? undefined : state.deliveryFrequency });
        case Type.ChangeBillingFrequency:
            return __assign(__assign({}, state), { billingFrequency: action.payload });
        case Type.ChangeDeliveryFrequency:
            return __assign(__assign({}, state), { deliveryFrequency: action.payload });
        case Type.ChangeSolution:
            return __assign(__assign({}, state), { solutionProduct: action.payload });
        default:
            return state;
    }
};

var EditSubscriptionContext = React__default.createContext({});
var useEditSubscriptionContext = function () { return React__default.useContext(EditSubscriptionContext); };
var EditSubscriptionProvider = function (_a) {
    var _b, _c;
    var children = _a.children, subscriptionId = _a.subscriptionId;
    var details = useCurrentSubscriptionDetails(subscriptionId);
    var ratePlans = useGetSubscriptionProductRateplans(subscriptionId, (_b = details.data) === null || _b === void 0 ? void 0 : _b.billingFrequency, (_c = details.data) === null || _c === void 0 ? void 0 : _c.deliveryFrequency);
    var _d = __read(useReducer(reducer, initialState), 2), formState = _d[0], dispatch = _d[1];
    React__default.useEffect(function () {
        if (ratePlans.data.allLensRatePlans.length && !formState.ratePlan) {
            dispatch(changeRatePlan(ratePlans.data.allLensRatePlans[0]));
        }
    }, [ratePlans.data, formState.ratePlan]);
    React__default.useEffect(function () {
        var _a = details.data || {
            billingFrequency: null,
            deliveryFrequency: null,
        }, billingFrequency = _a.billingFrequency, deliveryFrequency = _a.deliveryFrequency;
        if (billingFrequency && !formState.billingFrequency) {
            dispatch(changeBillingFrequency(billingFrequency));
        }
        if (deliveryFrequency && !formState.deliveryFrequency) {
            dispatch(changeDeliveryFrequency(deliveryFrequency));
        }
    }, [details.data, formState]);
    var context = { subscriptionId: subscriptionId, formState: formState, details: details, ratePlans: ratePlans, dispatch: dispatch };
    return (React__default.createElement(EditSubscriptionContext.Provider, { value: context }, children));
};

var containsSolution = function (variants) {
    return Boolean(variants.find(isSolutionVariant));
};
var isDaily = function (ratePlan) {
    return ratePlan.hasOwnProperty('usageLevel') && Boolean(ratePlan.usageLevel);
};
var containsDaily = function (ratePlans) { return Boolean(ratePlans.find(isDaily)); };
// Contact lens rateplans are available when they are also applicable for the solution that is currently part of the
// subscription. Filter out all rateplans that are not available for the current solution.
//
// For non-daily lenses, all rateplans are available. For daily lenses only the rate plans that have a usage level
// that matches the usage level of the selected rate plan, are available.
var filterAvailableRatePlans = function (contactLensRatePlans, solutionRatePlans, selectedRatePlan) {
    var availableRatePlans = contactLensRatePlans.filter(function (contactLensRatePlan) {
        if (!solutionRatePlans.length)
            return true;
        return solutionRatePlans.find(function (solutionRatePlan) {
            return solutionRatePlan.billingPeriod === contactLensRatePlan.billingPeriod &&
                solutionRatePlan.shippingSchedule === contactLensRatePlan.shippingSchedule;
        });
    });
    if (!containsDaily(availableRatePlans))
        return availableRatePlans;
    return availableRatePlans.filter(function (ratePlan) { return selectedRatePlan && ratePlan.usageLevel === selectedRatePlan.usageLevel; });
};
var findSelectedRatePlan = function (ratePlans, formState) {
    return ratePlans.find(function (ratePlan) {
        return ratePlan.billingPeriod === formState.billingFrequency &&
            ratePlan.shippingSchedule === formState.deliveryFrequency;
    });
};
// Whenever the user is opening the EditSubscriptionModal, there's only the option to change the rate plan. In this case
// the new rate plan for the solution has to be picked from the list of rate plans, based on the selected schedule.
//
// When the user is opening the EditSolutionModal, there's only the option to change the solution. In this case the new
// rate plan for the solution has to be picked from the list of rate plans, based on the selected solution.
var findSelectedSolutionRatePlan = function (ratePlans, formState) {
    var _a, _b;
    if (formState.solutionProduct === undefined)
        return findSelectedRatePlan(ratePlans, formState);
    return (_b = (_a = formState.solutionProduct) === null || _a === void 0 ? void 0 : _a.ratePlan) !== null && _b !== void 0 ? _b : undefined;
};
var findSelectedEditSubscriptionRatePlans = function (variants, contactLensRatePlans, solutionRatePlans, formState) {
    var ratePlans = [];
    // Replace rate plans for each of the existing products in the subscription.
    variants.forEach(function (variant) {
        if (isSolutionVariant(variant)) {
            var found = findSelectedSolutionRatePlan(solutionRatePlans, formState);
            if (found)
                ratePlans.push(toEditSubscriptionRatePlan(found));
        }
        if (isContactLensVariant$2(variant)) {
            var availableRatePlans = filterAvailableRatePlans(contactLensRatePlans, solutionRatePlans, formState.ratePlan);
            var found = findSelectedRatePlan(availableRatePlans, formState);
            if (found)
                ratePlans.push(toEditSubscriptionRatePlan(found));
        }
    });
    // When adding a solution, where in the current subscription there is none, an extra rate plan for this newly selected
    // solution has to be added.
    if (!containsSolution(variants) && formState.solutionProduct) {
        var found = findSelectedSolutionRatePlan(solutionRatePlans, formState);
        if (found)
            ratePlans.push(toEditSubscriptionRatePlan(found));
    }
    return ratePlans;
};

var IMAGE_URL_PARAMETERS = 'fit=fill&fm=jpeg&auto=format&w=176';
// @TODO see how to decide correct image
var findMasterImage = function (variant) { var _a; return (_a = variant === null || variant === void 0 ? void 0 : variant.media) === null || _a === void 0 ? void 0 : _a.images.find(function (image) { return image.label !== ''; }); };
var getMasterImagePath = function (variant) {
    var masterImage = findMasterImage(variant);
    if (!(masterImage === null || masterImage === void 0 ? void 0 : masterImage.url))
        return '';
    return masterImage.url + "?" + IMAGE_URL_PARAMETERS;
};

var RADIO_POSITION = 'bottom';
var EditSolutionForm = function (_a) {
    var labels = _a.labels, products = _a.products, state = _a.state, onChange = _a.onChange;
    return (React__default.createElement("div", { className: "solution-picker" },
        React__default.createElement(Heading, { component: "h3", variant: "subheading1" }, labels.title),
        React__default.createElement("div", { className: "solution-picker__options" },
            React__default.createElement(RadioButton, { className: "solution-picker__option solution-picker__option--no-image", position: RADIO_POSITION, value: "no-solution", isChecked: state.solutionProduct === null, onChange: function () { return onChange(null); } },
                React__default.createElement("div", { className: "solution-picker__option-info" },
                    React__default.createElement("div", { className: "solution-picker__option-name" }, labels.noSolution))),
            products.map(function (product) {
                var _a;
                var masterImage = findMasterImage(product.variant);
                return (React__default.createElement(RadioButton, { className: classnames({
                        'solution-picker__option': true,
                        'solution-picker__option--no-image': !masterImage,
                    }), key: product.variant.gan, position: RADIO_POSITION, value: product.variant.gan, isChecked: product.variant.gan === ((_a = state.solutionProduct) === null || _a === void 0 ? void 0 : _a.variant.gan), onChange: function () { return onChange(product); } },
                    masterImage ? (React__default.createElement("img", { src: getMasterImagePath(product.variant), alt: (masterImage === null || masterImage === void 0 ? void 0 : masterImage.label) ? masterImage.label : '' })) : null,
                    React__default.createElement("div", { className: "solution-picker__option-info" },
                        React__default.createElement("div", { className: "solution-picker__option-name" }, product.name),
                        React__default.createElement("div", { className: "solution-picker__option-description" },
                            product.variant.contactLensCareType ? (React__default.createElement("span", null,
                                product.variant.contactLensCareType,
                                ", ")) : null,
                            React__default.createElement("span", null,
                                product.variant.volume,
                                product.variant.volumeUnit)),
                        React__default.createElement(Hr, null),
                        React__default.createElement(Price, { centAmount: true, value: product.ratePlan.basePrice.centAmount, currency: product.ratePlan.basePrice.currencyCode }))));
            }))));
};

var EditSolutionFormContainer = function () {
    var getLabel = useIntl().getLabel;
    var _a = useEditSubscriptionContext(), ratePlans = _a.ratePlans, formState = _a.formState, dispatch = _a.dispatch;
    React__default.useEffect(function () {
        // If solution that is part of the current subscription is in the list of recommendedSolutions, set the
        // selected solution to that value. Otherwise set it to null, the 'no solution'-option.
        if (ratePlans.data.recommendedSolutionProducts.length &&
            formState.solutionProduct === undefined) {
            var ratePlan_1 = findSelectedSolutionRatePlan(ratePlans.data.solutionRatePlans, formState);
            var product = ratePlans.data.recommendedSolutionProducts.find(function (product) { return product.variant.gan === (ratePlan_1 === null || ratePlan_1 === void 0 ? void 0 : ratePlan_1.gan); });
            dispatch(changeSolutionProduct(product ? product : null));
        }
    }, [ratePlans.data, formState, dispatch]);
    var labels = {
        title: getLabel('products.contactLenses.solutions.title'),
        noSolution: getLabel('products.contactLenses.solutions.missing'),
    };
    var onChange = function (product) {
        return dispatch(changeSolutionProduct(product));
    };
    if (ratePlans.loading) {
        return (React__default.createElement("div", { className: "edit-subscription__loader" },
            React__default.createElement(Loader$1, null)));
    }
    return (React__default.createElement(EditSolutionForm, { labels: labels, state: formState, products: ratePlans.data.recommendedSolutionProducts, onChange: onChange }));
};

var PackageQuantity = function (_a) {
    var ratePlans = _a.ratePlans, onChange = _a.onChange, selectedSize = _a.selectedSize;
    var onUsageLevelChange = function (usageLevel) {
        var ratePlan = ratePlans.find(function (ratePlan) { return ratePlan.usageLevel === usageLevel; });
        if (ratePlan) {
            onChange(ratePlan);
        }
    };
    return (React.createElement(DailyPackageQuantity, { packageTypes: toProductsRatePlans(ratePlans), selectedSize: (selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.usageLevel) ? selectedSize.usageLevel : undefined, handlePackSizeChange: function (usageLevel) { return onUsageLevelChange(usageLevel); } }));
};

var renderer = function (item) { return (React__default.createElement("div", { className: "select-frequency-body" },
    React__default.createElement(Text, { variant: "body-head", className: "select-frequency-body__heading" }, item.label),
    React__default.createElement(Text, { variant: "body", className: "select-frequency-body__subtext" }, item.subText))); };
function FrequencySelector(_a) {
    var onSelect = _a.onSelect, selectedFrequency = _a.selectedFrequency, frequencies = _a.frequencies, rest = __rest(_a, ["onSelect", "selectedFrequency", "frequencies"]);
    var defaultSelected = selectedFrequency && frequencies.find(function (item) { return item.id === selectedFrequency; });
    var handleSelect = function (item) {
        !item.disabled && onSelect(item.id);
    };
    return (React__default.createElement(OptionCardGroup, __assign({}, rest, { bodyRenderer: renderer, items: frequencies, onSelect: handleSelect, defaultSelected: defaultSelected, className: "select-frequency" })));
}

var BillingFrequencySelector = function (_a) {
    var onSelect = _a.onSelect;
    var _b = useEditSubscriptionContext(), ratePlans = _b.ratePlans, formState = _b.formState;
    var _c = useIntl(), getLabel = _c.getLabel, locale = _c.locale;
    var availableRatePlans = React.useMemo(function () {
        return filterAvailableRatePlans(ratePlans.data.allLensRatePlans, ratePlans.data.solutionRatePlans, formState.ratePlan);
    }, [ratePlans.data, formState.ratePlan]);
    var createFrequencyOption = function (frequency) {
        var ratePlan = availableRatePlans.find(function (ratePlan) { return ratePlan.billingPeriod === frequency; });
        var frequencyName = frequency.toLowerCase();
        return {
            id: frequency,
            label: getLabel("products.contactLenses.subscription.steps.subscriptionPlan." + frequencyName + ".title"),
            subText: ratePlan
                ? formatPrice(locale, ratePlan.basePrice.centAmount, ratePlan.basePrice.currencyCode, true) + " " + getLabel("common.frequency." + frequencyName) + " "
                : getLabel('common.notAvailable'),
            disabled: !Boolean(ratePlan),
        };
    };
    var billingFrequencyOptions = [
        createFrequencyOption(BillingFrequency$1.Monthly),
        createFrequencyOption(BillingFrequency$1.Quarterly),
    ];
    return (React.createElement(FrequencySelector, { "data-t": "billing-frequency-selector", onSelect: onSelect, selectedFrequency: formState.billingFrequency, frequencies: billingFrequencyOptions }));
};

var DeliveryFrequencySelector = function (_a) {
    var onSelect = _a.onSelect;
    var _b = useEditSubscriptionContext(), ratePlans = _b.ratePlans, formState = _b.formState;
    var _c = useIntl(), getLabel = _c.getLabel, getFormattedLabel = _c.getFormattedLabel;
    var availableRatePlans = React.useMemo(function () {
        return filterAvailableRatePlans(ratePlans.data.allLensRatePlans, ratePlans.data.solutionRatePlans, formState.ratePlan);
    }, [ratePlans.data, formState.ratePlan]);
    var labels = {
        lenses: getLabel('products.unit.contactLenses'),
        lens: getLabel('products.unit.contactLens'),
        box: getLabel('products.unit.contactLensBox'),
        boxes: getLabel('products.unit.contactLensBoxes'),
    };
    var createFrequencyOption = function (frequency) {
        var ratePlan = availableRatePlans.find(function (ratePlan) { return ratePlan.shippingSchedule === frequency; });
        return {
            id: frequency,
            label: getLabel("products.contactLenses.subscription.steps.deliveryFrequency." + frequency.toLowerCase() + ".title"),
            subText: ratePlan
                ? getFormattedLabel('products.contactLenses.amountPerBox', {
                    labelData: {
                        includedUnits: ratePlan.includedUnits,
                        packageQuantity: ratePlan.packageQuantity || '0',
                        boxLabel: ratePlan.includedUnits > 1 ? labels.boxes : labels.box,
                        lensLabel: (ratePlan.packageQuantity || 0) > 1 ? labels.lenses : labels.lens,
                    },
                })
                : getLabel('common.notAvailable'),
            disabled: !Boolean(ratePlan),
        };
    };
    var deliveryFrequencyOptions = [
        createFrequencyOption(DeliveryFrequency$1.Monthly),
        createFrequencyOption(DeliveryFrequency$1.Quarterly),
    ];
    return (React.createElement(FrequencySelector, { "data-t": "delivery-frequency-selector", onSelect: onSelect, selectedFrequency: formState.deliveryFrequency, frequencies: deliveryFrequencyOptions }));
};

var EditSubscriptionForm = function (_a) {
    var handlers = _a.handlers, labels = _a.labels, ratePlans = _a.ratePlans, state = _a.state, lensIsDaily = _a.lensIsDaily;
    return ratePlans.loading ? (React__default.createElement("div", { className: "edit-subscription__loader" },
        React__default.createElement(Loader$1, null))) : (React__default.createElement("div", { className: "edit-subscription-form" },
        React__default.createElement(Heading, { component: "h3", variant: "subheading1" }, labels.deliveryPaymentHeading),
        lensIsDaily ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Text, { className: "edit-subscription-text", variant: "body-head" },
                "1. ",
                labels.usageTitle),
            React__default.createElement("div", { className: "edit-subscription-selector" },
                React__default.createElement(PackageQuantity, { onChange: handlers.onChangeRatePlan, ratePlans: ratePlans.data.distinctLensRatePlans, selectedSize: state.ratePlan })))) : null,
        React__default.createElement(Text, { className: "edit-subscription-text", variant: "body-head" },
            lensIsDaily ? '2.' : '1.',
            " ",
            labels.deliveryFrequencyTitle),
        React__default.createElement("div", { className: "edit-subscription-selector" },
            React__default.createElement(DeliveryFrequencySelector, { onSelect: handlers.onChangeDeliveryFrequency })),
        React__default.createElement(Text, { className: "edit-subscription-text", variant: "body-head" },
            lensIsDaily ? '3.' : '2.',
            " ",
            labels.billingFrequencyTitle),
        React__default.createElement("div", { className: "edit-subscription-selector" },
            React__default.createElement(BillingFrequencySelector, { onSelect: handlers.onChangeBillingFrequency }))));
};

var EditSubscriptionFormContainer = function () {
    var getLabel = useIntl().getLabel;
    var _a = useEditSubscriptionContext(), ratePlans = _a.ratePlans, formState = _a.formState, dispatch = _a.dispatch;
    var labels = {
        deliveryPaymentHeading: getLabel('account.editSubscription.deliveryPaymentDetails'),
        usageTitle: getLabel('account.editSubscription.usage.title'),
        deliveryFrequencyTitle: getLabel('account.editSubscription.deliveryFrequency.title'),
        billingFrequencyTitle: getLabel('account.editSubscription.billingFrequency.title'),
        toastError: 'account.subscriptions.errors.general',
        toastNetworkError: 'common.error.network',
        toastSuccess: 'common.status.completed',
    };
    var handlers = {
        onChangeRatePlan: function (ratePlan) { return dispatch(changeRatePlan(ratePlan)); },
        onChangeBillingFrequency: function (billingFrequency) {
            dispatch(changeBillingFrequency(billingFrequency));
            var matchingBillingRateplans = ratePlans.data.allLensRatePlans.filter(function (ratePlan) {
                var _a;
                return (ratePlan.billingPeriod === billingFrequency &&
                    (!containsDaily(ratePlans.data.allLensRatePlans) ||
                        ((_a = formState.ratePlan) === null || _a === void 0 ? void 0 : _a.usageLevel) === ratePlan.usageLevel));
            });
            if (!matchingBillingRateplans.find(function (ratePlan) { return ratePlan.shippingSchedule === formState.deliveryFrequency; })) {
                dispatch(changeDeliveryFrequency(matchingBillingRateplans[0].shippingSchedule));
            }
        },
        onChangeDeliveryFrequency: function (deliveryFrequency) {
            dispatch(changeDeliveryFrequency(deliveryFrequency));
            var matchingDeliveryRateplans = ratePlans.data.allLensRatePlans.filter(function (ratePlan) {
                var _a;
                return (ratePlan.shippingSchedule === deliveryFrequency &&
                    (!containsDaily(ratePlans.data.allLensRatePlans) ||
                        ((_a = formState.ratePlan) === null || _a === void 0 ? void 0 : _a.usageLevel) === ratePlan.usageLevel));
            });
            if (!matchingDeliveryRateplans.find(function (ratePlan) { return ratePlan.billingPeriod === formState.billingFrequency; })) {
                dispatch(changeBillingFrequency(matchingDeliveryRateplans[0].billingPeriod));
            }
        },
    };
    return (React__default.createElement(EditSubscriptionForm, { handlers: handlers, labels: labels, ratePlans: ratePlans, state: formState, lensIsDaily: containsDaily(ratePlans.data.allLensRatePlans) }));
};

var ILLEGAL_STATE_ERROR = 'ILLEGAL_STATE_ERROR';
var INVALID_RESPONSE = 'INVALID_RESPONSE';
var UNAUTHENTICATED = 'UNAUTHENTICATED';
var USER_NOT_FOUND_ERROR = 'User not found';

var CHANGE_SUBSCRIPTION = gql(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  mutation ChangeSubscription($input: ChangeSubscriptionInput!) {\n    changeSubscription(input: $input) {\n      billingFrequency\n      nextInvoiceAmount {\n        centAmount\n        currencyCode\n      }\n      recurringAmount {\n        centAmount\n        currencyCode\n      }\n    }\n  }\n"], ["\n  mutation ChangeSubscription($input: ChangeSubscriptionInput!) {\n    changeSubscription(input: $input) {\n      billingFrequency\n      nextInvoiceAmount {\n        centAmount\n        currencyCode\n      }\n      recurringAmount {\n        centAmount\n        currencyCode\n      }\n    }\n  }\n"])));
var templateObject_1$p;

var useChangeSubscription = function () {
    var _a = __read(useMutation(CHANGE_SUBSCRIPTION), 2), mutation = _a[0], _b = _a[1], loading = _b.loading, error = _b.error;
    return {
        changeSubscription: function (subscriptionOrderId, subscriptionProducts, userId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mutation({
                            variables: {
                                input: {
                                    subscriptionOrderId: subscriptionOrderId,
                                    customerId: userId,
                                    subscriptionProducts: subscriptionProducts,
                                },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        loading: loading,
        error: error,
    };
};

var CurrentSubscriptionDetails = function (_a) {
    var labels = _a.labels, details = _a.details;
    return details ? (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Heading, { component: "h3", variant: "subheading1" }, labels.title),
        React__default.createElement(Card, { "data-t": "current-subscription-details", className: "edit-subscription-current-subscription" },
            React__default.createElement(Heading, { component: "h4", variant: "subheading1" }, details.subscriptionName),
            React__default.createElement(Text, { variant: "body-head" }, labels.paymentHeading),
            React__default.createElement(Text, null,
                React__default.createElement(Price, { value: details.total.centAmount, currency: details.total.currencyCode }), " " + labels.perTimeSpan(details.billingFrequency)),
            React__default.createElement(Text, { variant: "body-head" }, labels.deliveryHeading),
            React__default.createElement(Text, null, labels.deliveryFrequency(details.deliveryFrequency)),
            React__default.createElement(Text, { variant: "body-head" }, labels.statusHeading),
            React__default.createElement(Text, null, labels.status(details.status))))) : null;
};

var CURRENT_PLAN = 'account.subscription.details.currentPlan';
var CurrentSubscriptionDetailsContainer = function () {
    var getLabel = useIntl().getLabel;
    var details = useEditSubscriptionContext().details;
    var labels = {
        deliveryFrequency: function (value) {
            return getLabel(CURRENT_PLAN + ".definition.deliveryFrequency." + value);
        },
        perTimeSpan: function (value) {
            return getLabel(CURRENT_PLAN + ".definition.payment." + value);
        },
        status: function (value) { return getLabel(CURRENT_PLAN + ".definition.status." + value); },
        deliveryHeading: getLabel(CURRENT_PLAN + ".term.deliveryFrequency"),
        paymentHeading: getLabel(CURRENT_PLAN + ".term.payment"),
        statusHeading: getLabel(CURRENT_PLAN + ".term.status"),
        title: getLabel('account.editSubscription.currentSubscriptionDetails.title'),
    };
    return React__default.createElement(CurrentSubscriptionDetails, { details: details.data, labels: labels });
};

var EditSubscriptionConsent = function (_a) {
    var hasAgreed = _a.hasAgreed, setAgreement = _a.setAgreement, showError = _a.showError;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var labels = {
        required: getLabel('common.form.field.requiredError'),
        consent: getFormattedLabel('account.consent.message', { parseLink: true }),
    };
    return (React__default.createElement("div", { className: "edit-subscription-consent" },
        React__default.createElement("div", { className: "edit-subscription-checkbox" },
            React__default.createElement(Checkbox, { id: "consent-checkbox", "data-t": "checkbox", className: classnames('edit-subscription-checkbox', showError ? 'edit-subscription-checkbox__error' : ''), value: "", onChange: function () { return setAgreement(!hasAgreed); }, checked: hasAgreed }),
            React__default.createElement("div", { className: "checkbox-list__item-content" },
                React__default.createElement("label", { className: "checkbox-list__item-label", htmlFor: "consent-checkbox" }, labels.consent))),
        showError && (React__default.createElement("div", { "data-t": "checkbox-error-message", className: "edit-subscription-consent__error-message" },
            React__default.createElement(Icon, { name: "alert-circle" }),
            labels.required))));
};

var PREVIEW_CHANGE_SUBSCRIPTION = gql(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n  query previewChangeSubscription($input: ChangeSubscriptionInput!) {\n    previewChangeSubscription(input: $input) {\n      billingFrequency\n      nextInvoiceAmount {\n        centAmount\n        currencyCode\n      }\n      recurringAmount {\n        centAmount\n        currencyCode\n      }\n    }\n  }\n"], ["\n  query previewChangeSubscription($input: ChangeSubscriptionInput!) {\n    previewChangeSubscription(input: $input) {\n      billingFrequency\n      nextInvoiceAmount {\n        centAmount\n        currencyCode\n      }\n      recurringAmount {\n        centAmount\n        currencyCode\n      }\n    }\n  }\n"])));
var templateObject_1$o;

var useGetChangeSubscriptionPreview = function (subscriptionOrderId, userId) {
    var _a = useEditSubscriptionContext(), ratePlans = _a.ratePlans, formState = _a.formState;
    var _b = __read(useLazyQuery(PREVIEW_CHANGE_SUBSCRIPTION), 2), runQuery = _b[0], _c = _b[1], data = _c.data, loading = _c.loading, error = _c.error;
    var subscriptionProducts = useMemo(function () {
        return findSelectedEditSubscriptionRatePlans(ratePlans.data.variants, ratePlans.data.allLensRatePlans, ratePlans.data.solutionRatePlans, formState);
    }, [ratePlans.data, formState]);
    useEffect(function () {
        if (subscriptionProducts.length && subscriptionOrderId !== '') {
            runQuery({
                variables: {
                    input: { subscriptionOrderId: subscriptionOrderId, customerId: userId, subscriptionProducts: subscriptionProducts },
                },
            });
        }
    }, [subscriptionOrderId, userId, subscriptionProducts, runQuery]);
    return {
        data: toEditSubscriptionInvoicePreview(data === null || data === void 0 ? void 0 : data.previewChangeSubscription) || undefined,
        loading: loading,
        error: error,
    };
};

var EditSubscriptionPreviewInvoice = function (_a) {
    var billingFrequencyLabel = _a.billingFrequencyLabel, invoicePreview = _a.invoicePreview, labels = _a.labels;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Hr, { className: "edit-subscription-invoice__hr" }),
        React__default.createElement("div", { className: "edit-subscription-invoice" },
            React__default.createElement("span", { className: "edit-subscription-invoice__detail" },
                React__default.createElement(Heading, { variant: "subheading1" }, labels.firstInvoice + " ")),
            React__default.createElement("span", null,
                React__default.createElement(Price, { "data-t": "invoice-price", 
                    // Formatting NaN will give dashes
                    value: (invoicePreview === null || invoicePreview === void 0 ? void 0 : invoicePreview.nextInvoiceAmount.centAmount) || NaN, currency: invoicePreview === null || invoicePreview === void 0 ? void 0 : invoicePreview.nextInvoiceAmount.currencyCode })),
            labels.secondInvoice,
            React__default.createElement("span", { className: "edit-subscription-invoice__price-billing" }, invoicePreview && (React__default.createElement("div", null,
                React__default.createElement(Price, { value: invoicePreview.recurringAmount.centAmount, currency: invoicePreview.recurringAmount.currencyCode }), " " + billingFrequencyLabel))))));
};

var EditSubscriptionPreviewInvoiceContainer = function () {
    var getLabel = useIntl().getLabel;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _a = useEditSubscriptionContext(), subscriptionId = _a.subscriptionId, formState = _a.formState, ratePlans = _a.ratePlans;
    var _b = useGetChangeSubscriptionPreview(subscriptionId, userId), invoicePreviewData = _b.data, invoicePreviewLoading = _b.loading, invoicePreviewError = _b.error;
    var labels = {
        firstInvoice: getLabel('account.editSubscription.firstInvoice'),
        secondInvoice: getLabel('account.editSubscription.secondInvoice'),
        monthly: getLabel('common.frequency.monthly'),
        quarterly: getLabel('common.frequency.quarterly'),
        toastError: 'account.subscriptions.errors.general',
    };
    var billingFrequencyLabel = (formState === null || formState === void 0 ? void 0 : formState.billingFrequency) === BillingFrequency$1.Monthly ? labels.monthly : labels.quarterly;
    if (invoicePreviewError)
        toast.failed(labels.toastError);
    if (invoicePreviewLoading || ratePlans.loading)
        return (React__default.createElement("div", { className: "edit-subscription__loader" },
            React__default.createElement(Loader$1, null)));
    return (React__default.createElement(EditSubscriptionPreviewInvoice, { billingFrequencyLabel: billingFrequencyLabel, invoicePreview: invoicePreviewData, labels: labels }));
};

var EditSubscriptionModal = function (_a) {
    var changeSubscriptionLoading = _a.changeSubscriptionLoading, handleEditSubscription = _a.handleEditSubscription, labels = _a.labels, onClose = _a.onClose, children = _a.children;
    var _b = __read(React__default.useState(false), 2), hasAgreed = _b[0], setAgreement = _b[1];
    var _c = __read(React__default.useState(false), 2), showError = _c[0], setShowError = _c[1];
    var _d = useEditSubscriptionContext(), details = _d.details, ratePlans = _d.ratePlans, formState = _d.formState;
    var handleCtaClick = function () {
        if (!hasAgreed)
            return setShowError(true);
        setShowError(false);
        var selectedRatePlans = findSelectedEditSubscriptionRatePlans(ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.data.variants, ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.data.allLensRatePlans, ratePlans === null || ratePlans === void 0 ? void 0 : ratePlans.data.solutionRatePlans, formState);
        selectedRatePlans.length && handleEditSubscription(selectedRatePlans);
    };
    return (React__default.createElement(Modal$2, { "data-t": "edit-subscription-modal", isOpen: true, onModalClose: onClose, showIcon: true, title: labels.title, className: "edit-subscription", footer: React__default.createElement(ModalFooter, { ctaCaption: labels.callToAction, onCta: function () { return handleCtaClick(); }, ctaLoading: changeSubscriptionLoading, onCancel: onClose }) }, details.loading ? (React__default.createElement("div", { className: "edit-subscription__loader" },
        React__default.createElement(Loader$1, null))) : (React__default.createElement("div", { "data-test": "modal-body" },
        React__default.createElement(CurrentSubscriptionDetailsContainer, null),
        children,
        !ratePlans.loading && React__default.createElement(EditSubscriptionPreviewInvoiceContainer, null),
        React__default.createElement(EditSubscriptionConsent, { hasAgreed: hasAgreed, setAgreement: setAgreement, showError: showError }),
        React__default.createElement("span", { className: "edit-subscription-note" },
            React__default.createElement("strong", null,
                labels.pleaseNote,
                ":"),
            " ",
            labels.note)))));
};

var PREFIX$1 = 'account.editSubscription';
var EditSubscriptionModalContainer = function (_a) {
    var title = _a.title, subscriptionId = _a.subscriptionId, onClose = _a.onClose, children = _a.children;
    var getLabel = useIntl().getLabel;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _b = useChangeSubscription(), changeSubscription = _b.changeSubscription, loading = _b.loading;
    var handleEditSubscription = function (editSubscriptionRatePlans) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, changeSubscription(subscriptionId, editSubscriptionRatePlans, userId)];
                case 1:
                    _a.sent();
                    toast.success(labels.toastSuccess);
                    onClose();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.networkError)
                        return [2 /*return*/, toast.failed(labels.toastNetworkError)];
                    if (getGraphQLErrorCode(error_1, ILLEGAL_STATE_ERROR))
                        return [2 /*return*/, toast.failed(labels.toastLockedError)];
                    return [2 /*return*/, toast.failed(labels.toastError)];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var labels = {
        title: title,
        pleaseNote: getLabel('account.common.pleaseNote'),
        note: getLabel(PREFIX$1 + ".note"),
        toastError: 'account.subscriptions.errors.general',
        toastNetworkError: 'common.error.network',
        toastSuccess: 'account.editSubscription.success',
        toastLockedError: 'account.editSubscription.error.locked',
        callToAction: getLabel("account.action.editSubscription"),
    };
    return (React__default.createElement(EditSubscriptionProvider, { subscriptionId: subscriptionId },
        React__default.createElement(EditSubscriptionModal, { changeSubscriptionLoading: loading, handleEditSubscription: handleEditSubscription, labels: labels, onClose: onClose }, children)));
};

var toSuspensionResumeDates = function (raw) { return ({
    minDate: parseISO(raw === null || raw === void 0 ? void 0 : raw.earliestPossibleResumeDate),
    maxDate: parseISO(raw === null || raw === void 0 ? void 0 : raw.lastPossibleResumeDate),
}); };

var RESUME_SUBSCRIPTION = gql(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  mutation ResumeSubscription($input: ResumeSubscriptionInput!) {\n    resumeSubscription(input: $input) {\n      plannedResumeDate\n    }\n  }\n"], ["\n  mutation ResumeSubscription($input: ResumeSubscriptionInput!) {\n    resumeSubscription(input: $input) {\n      plannedResumeDate\n    }\n  }\n"])));
var templateObject_1$n;

var GET_SUSPENSION_RESUME_DATES = gql(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  query getSuspensionResumeDates($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        suspensionResumeDateRange {\n          earliestPossibleResumeDate\n          lastPossibleResumeDate\n        }\n      }\n    }\n  }\n"], ["\n  query getSuspensionResumeDates($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        suspensionResumeDateRange {\n          earliestPossibleResumeDate\n          lastPossibleResumeDate\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$m;

var useGetSubscriptionResumeDates = function (id) {
    var _a, _b;
    var _c = useQuery(GET_SUSPENSION_RESUME_DATES, {
        variables: { id: id },
    }), data = _c.data, loading = _c.loading, error = _c.error;
    return {
        data: toSuspensionResumeDates((_b = (_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscription) === null || _b === void 0 ? void 0 : _b.suspensionResumeDateRange),
        loading: loading,
        error: error,
    };
};
var useResumeSubscription = function (id, userId) {
    var _a = __read(useMutation(RESUME_SUBSCRIPTION), 1), mutation = _a[0];
    var plannedResumeDates = useGetSubscriptionResumeDates(id);
    var doMutation = function (date) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, mutation({
                        variables: {
                            input: {
                                subscriptionOrderId: id,
                                customerId: userId,
                                plannedResumeDate: DateUtils.toLocalDate(date),
                            },
                        },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return [doMutation, plannedResumeDates];
};

var ResumeSubscriptionModal = function (_a) {
    var onCancel = _a.onCancel, onConfirm = _a.onConfirm, labels = _a.labels, possibleDates = _a.possibleDates, _b = _a.loading, loading = _b === void 0 ? false : _b;
    var _c = __read(useState(possibleDates.minDate), 2), resumeDate = _c[0], setResumeDate = _c[1];
    var _d = __read(useState(false), 2), confirmLoading = _d[0], setConfirmLoading = _d[1];
    var handleResume = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!resumeDate)
                        return [2 /*return*/];
                    setConfirmLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onConfirm(resumeDate)];
                case 2:
                    _b.sent();
                    setConfirmLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    setConfirmLoading(false);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [onConfirm, resumeDate]);
    var areDatesValid = Object.keys(possibleDates).length &&
        isValid(possibleDates.minDate) &&
        isValid(possibleDates.maxDate);
    return (React__default.createElement(Modal$2, { showIcon: true, "aria-label": labels.title, className: "resume-subscription", isOpen: true, onModalClose: onCancel, title: labels.title, footer: React__default.createElement(ModalFooter, { ctaCaption: labels.resumeSubscription, onCancel: onCancel, onCta: handleResume, ctaLoading: confirmLoading }) },
        React__default.createElement("p", { className: "resume-subscription__description" }, labels.description),
        loading && React__default.createElement(Loader$1, null),
        !loading && areDatesValid && (React__default.createElement(DatePicker, { label: labels.datepickerLabel, className: "resume-subscription__datepicker", onChange: setResumeDate, required: true, initialValue: possibleDates.minDate, minDate: possibleDates.minDate, maxDate: possibleDates.maxDate })),
        !loading && !!resumeDate && isValid(resumeDate) && (React__default.createElement(Alert, { type: "info", icon: "shipment-next", message: labels.infoMessage(resumeDate) })),
        !loading && !areDatesValid && React__default.createElement(Alert, { type: "error", message: labels.getDatesError })));
};

var LABEL_PREFIX$7 = 'account.subscription.detail.currentPlan.resume';
var ResumeSubscriptionModalContainer = function (_a) {
    var subscriptionId = _a.subscriptionId, onCancel = _a.onCancel;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, dateTime = _b.dateTime;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _c = __read(useResumeSubscription(subscriptionId, userId), 2), mutation = _c[0], plannedResumeDates = _c[1];
    var labels = useMemo(function () { return ({
        title: getLabel(LABEL_PREFIX$7 + ".title"),
        description: getLabel(LABEL_PREFIX$7 + ".description"),
        datepickerLabel: getLabel(LABEL_PREFIX$7 + ".datepickerLabel"),
        resumeSubscription: getLabel(LABEL_PREFIX$7 + ".resumeButtonCaption"),
        getDatesError: getFormattedLabel(LABEL_PREFIX$7 + ".getDatesError", { parseLink: true }),
        infoMessage: function (date) {
            return getFormattedLabel(LABEL_PREFIX$7 + ".infoMessage", {
                labelData: { date: dateTime.formatShortDate(date) },
            });
        },
    }); }, [dateTime, getFormattedLabel, getLabel]);
    var handleResume = useCallback(function (resumeDate) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, mutation(resumeDate)];
                case 1:
                    _b.sent();
                    onCancel();
                    toast.success(LABEL_PREFIX$7 + ".successMessage");
                    return [3 /*break*/, 3];
                case 2:
                    _b.sent();
                    toast.failed(LABEL_PREFIX$7 + ".errorMessage");
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [mutation, onCancel]);
    return (React__default.createElement(ResumeSubscriptionModal, { onCancel: onCancel, onConfirm: handleResume, labels: labels, possibleDates: plannedResumeDates.data, loading: plannedResumeDates.loading }));
};

var SubscriptionSuspensionReason;
(function (SubscriptionSuspensionReason) {
    SubscriptionSuspensionReason["CS_BACKLOG"] = "CS_BACKLOG";
    SubscriptionSuspensionReason["CS_EMPLOYEE_DECISION"] = "CS_EMPLOYEE_DECISION";
    SubscriptionSuspensionReason["CS_NEW_TEST_COMING_UP"] = "CS_NEW_TEST_COMING_UP";
    SubscriptionSuspensionReason["CS_OTHER"] = "CS_OTHER";
    SubscriptionSuspensionReason["CS_OTHER_DELIVERY"] = "CS_OTHER_DELIVERY";
    SubscriptionSuspensionReason["CS_SEASONAL_USER"] = "CS_SEASONAL_USER";
    SubscriptionSuspensionReason["CS_TRAVEL"] = "CS_TRAVEL";
    SubscriptionSuspensionReason["CS_TRYING_NEW_PRODUCT"] = "CS_TRYING_NEW_PRODUCT";
    SubscriptionSuspensionReason["ECOM_BACKLOG"] = "ECOM_BACKLOG";
    SubscriptionSuspensionReason["ECOM_OTHER"] = "ECOM_OTHER";
    SubscriptionSuspensionReason["ECOM_OTHER_DELIVERY"] = "ECOM_OTHER_DELIVERY";
    SubscriptionSuspensionReason["ECOM_TRAVEL"] = "ECOM_TRAVEL";
})(SubscriptionSuspensionReason || (SubscriptionSuspensionReason = {}));
var SubscriptionSuspensionPeriod;
(function (SubscriptionSuspensionPeriod) {
    SubscriptionSuspensionPeriod["FIVE_MONTHS"] = "FIVE_MONTHS";
    SubscriptionSuspensionPeriod["FOUR_MONTHS"] = "FOUR_MONTHS";
    SubscriptionSuspensionPeriod["ONE_MONTH"] = "ONE_MONTH";
    SubscriptionSuspensionPeriod["SIX_MONTHS"] = "SIX_MONTHS";
    SubscriptionSuspensionPeriod["THREE_MONTHS"] = "THREE_MONTHS";
    SubscriptionSuspensionPeriod["TWO_MONTHS"] = "TWO_MONTHS";
})(SubscriptionSuspensionPeriod || (SubscriptionSuspensionPeriod = {}));

var _a$1;
var reasonsMap = (_a$1 = {},
    _a$1[SubscriptionSuspensionReason$1.ECOM_BACKLOG] = SubscriptionSuspensionReason.ECOM_BACKLOG,
    _a$1[SubscriptionSuspensionReason$1.ECOM_TRAVEL] = SubscriptionSuspensionReason.ECOM_TRAVEL,
    _a$1[SubscriptionSuspensionReason$1.ECOM_OTHER_DELIVERY] = SubscriptionSuspensionReason.ECOM_OTHER_DELIVERY,
    _a$1[SubscriptionSuspensionReason$1.ECOM_OTHER] = SubscriptionSuspensionReason.ECOM_OTHER,
    _a$1[SubscriptionSuspensionReason$1.CS_BACKLOG] = SubscriptionSuspensionReason.CS_BACKLOG,
    _a$1[SubscriptionSuspensionReason$1.CS_TRAVEL] = SubscriptionSuspensionReason.CS_TRAVEL,
    _a$1[SubscriptionSuspensionReason$1.CS_OTHER_DELIVERY] = SubscriptionSuspensionReason.CS_OTHER_DELIVERY,
    _a$1[SubscriptionSuspensionReason$1.CS_OTHER] = SubscriptionSuspensionReason.CS_OTHER,
    _a$1[SubscriptionSuspensionReason$1.CS_NEW_TEST_COMING_UP] = SubscriptionSuspensionReason.CS_NEW_TEST_COMING_UP,
    _a$1[SubscriptionSuspensionReason$1.CS_SEASONAL_USER] = SubscriptionSuspensionReason.CS_SEASONAL_USER,
    _a$1[SubscriptionSuspensionReason$1.CS_EMPLOYEE_DECISION] = SubscriptionSuspensionReason.CS_EMPLOYEE_DECISION,
    _a$1[SubscriptionSuspensionReason$1.CS_TRYING_NEW_PRODUCT] = SubscriptionSuspensionReason.CS_TRYING_NEW_PRODUCT,
    _a$1);
var toSuspendSubscriptionReasons = function (raw) {
    return reasonsMap[raw];
};
var toSuspendSubscriptionDurations = function (raw) {
    if (!raw)
        return null;
    return {
        plannedResumeDate: parseISO(raw.plannedResumeDate),
        suspensionPeriod: raw.suspensionPeriod,
    };
};
var toCanSuspendInfo = function (raw) { return ({
    earliestSuspensionDate: parseISO(raw.earliestNextSuspensionDate),
    isSuspendable: raw.isSuspendable,
}); };

var GET_SUSPEND_SUBSCRIPTION = gql(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  query getSuspendSubscription($id: ID!) {\n    subscriptionSuspensionReasons(channel: ECOM)\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        suspension {\n          earliestNextSuspensionDate\n          isSuspendable\n          suspensionDateOptions {\n            suspensionPeriod\n            plannedResumeDate\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getSuspendSubscription($id: ID!) {\n    subscriptionSuspensionReasons(channel: ECOM)\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        suspension {\n          earliestNextSuspensionDate\n          isSuspendable\n          suspensionDateOptions {\n            suspensionPeriod\n            plannedResumeDate\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$l;

var useGetSuspendSubscription = function (id) {
    var _a = useQuery(GET_SUSPEND_SUBSCRIPTION, {
        variables: {
            id: id,
        },
    }), data = _a.data, loading = _a.loading, error = _a.error;
    if (data) {
        return {
            data: {
                info: toCanSuspendInfo(data.me.subscription.suspension),
                reasons: data.subscriptionSuspensionReasons.map(toSuspendSubscriptionReasons),
                durations: data.me.subscription.suspension.suspensionDateOptions.map(toSuspendSubscriptionDurations),
            },
            loading: false,
            error: undefined,
        };
    }
    return { data: data, loading: loading, error: error };
};

var SUSPEND_SUBSCRIPTION = gql(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  mutation SuspendSubscription($input: SuspendSubscriptionInput!) {\n    suspendSubscription(input: $input) {\n      plannedResumeDate\n    }\n  }\n"], ["\n  mutation SuspendSubscription($input: SuspendSubscriptionInput!) {\n    suspendSubscription(input: $input) {\n      plannedResumeDate\n    }\n  }\n"])));
var templateObject_1$k;

var useSuspendSubscription = function (subscriptionOrderId, userId) {
    var _a = __read(useMutation(SUSPEND_SUBSCRIPTION), 1), mutation = _a[0];
    return {
        suspendSubscription: function (suspensionPeriod, suspensionReason) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mutation({
                            variables: {
                                input: { subscriptionOrderId: subscriptionOrderId, customerId: userId, suspensionPeriod: suspensionPeriod, suspensionReason: suspensionReason },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    };
};

var FORM_NAME = 'suspend-subscription-form'; //set as id in the Form component
var SuspendSubscriptionModal = function (_a) {
    var durationOptions = _a.durationOptions, earliestSuspensionDate = _a.earliestSuspensionDate, handleDurationChange = _a.handleDurationChange, handleReasonChange = _a.handleReasonChange, isSuspendable = _a.isSuspendable, isLoading = _a.isLoading, labels = _a.labels, onClose = _a.onClose, onSubmit = _a.onSubmit, reasonOptions = _a.reasonOptions, selectedDuration = _a.selectedDuration;
    return (React.createElement(React.Fragment, null, isSuspendable || !earliestSuspensionDate ? (React.createElement(Modal$2, { isOpen: true, onModalClose: onClose, showIcon: true, title: labels.pause, "data-t": "suspend-modal", className: "suspend-subscription", footer: React.createElement(ModalFooter, { ctaCaption: labels.pause, onCancel: onClose, associatedFormId: FORM_NAME, ctaButtonType: "submit" }) },
        React.createElement("div", { className: "suspend-subscription__text" }, labels.info),
        durationOptions && reasonOptions && !isLoading ? (React.createElement(React.Fragment, null,
            React.createElement(Form, { name: FORM_NAME, onSubmit: onSubmit, showErrorsOnInvalidSubmit: true },
                React.createElement(Field, { className: "suspend-subscription__select-duration", error: labels.validationError, validations: [Util.validations.isRequired], name: "duration", label: labels.durationLabel, placeholder: labels.durationPlaceholder, onChange: handleDurationChange, required: true },
                    React.createElement(Select, { "data-t": "select-duration", id: "duration", name: "duration", options: durationOptions })),
                selectedDuration && (React.createElement(Alert, { type: "info", icon: "clock", message: "" + labels.durationNote(selectedDuration.plannedResumeDate) })),
                React.createElement(Field, { className: "suspend-subscription__select-reason", error: labels.validationError, validations: [Util.validations.isRequired], name: "reason", label: labels.reasonLabel, placeholder: labels.reasonPlaceholder, onChange: handleReasonChange, required: true },
                    React.createElement(Select, { "data-t": "select-reason", id: "reason", name: "reason", options: reasonOptions })),
                React.createElement("div", { className: "suspend-subscription__note" },
                    React.createElement("b", null,
                        labels.pleaseNote,
                        ": "),
                    labels.note)))) : (React.createElement(Loader$1, null)))) : (React.createElement(Modal$2, { className: "suspend-subscription", isOpen: true, onModalClose: onClose, footer: React.createElement(Button, { "data-t": "close-button", className: "suspend-subscription__button-close", caption: labels.close, variant: "solid", onClick: onClose }), showIcon: true, title: labels.pause, "data-t": "limit-suspension-modal" },
        React.createElement("div", null,
            React.createElement(Alert, { title: labels.limitTitle, type: "info", icon: "info", message: labels.limit }),
            React.createElement("p", null, labels.earliestSuspensionDate + " " + earliestSuspensionDate))))));
};

var _a;
var PREFIX = 'account.subscription.detail.currentPlan.suspend';
var durationsOrder = (_a = {},
    _a[SubscriptionSuspensionPeriod.ONE_MONTH] = 0,
    _a[SubscriptionSuspensionPeriod.TWO_MONTHS] = 1,
    _a[SubscriptionSuspensionPeriod.THREE_MONTHS] = 2,
    _a[SubscriptionSuspensionPeriod.FOUR_MONTHS] = 3,
    _a[SubscriptionSuspensionPeriod.FIVE_MONTHS] = 4,
    _a[SubscriptionSuspensionPeriod.SIX_MONTHS] = 5,
    _a);
var SuspendSubscriptionModalContainer = function (_a) {
    var onClose = _a.onClose, subscriptionOrderId = _a.subscriptionOrderId;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, dateTime = _b.dateTime;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _c = __read(React.useState(), 2), reason = _c[0], setReason = _c[1];
    var _d = __read(React.useState(), 2), duration = _d[0], setDuration = _d[1];
    var suspendSubscription = useSuspendSubscription(subscriptionOrderId, userId).suspendSubscription;
    var _e = useGetSuspendSubscription(subscriptionOrderId), data = _e.data, error = _e.error, loading = _e.loading;
    var handleReasonChange = function (reason) {
        setReason(reason.value);
    };
    var handleDurationChange = function (duration) {
        setDuration(duration.value);
    };
    var onSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!duration || !reason)
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, suspendSubscription(duration.suspensionPeriod, reason)];
                case 2:
                    _b.sent();
                    onClose();
                    toast.success(PREFIX + ".success");
                    return [3 /*break*/, 4];
                case 3:
                    _b.sent();
                    toast.failed(PREFIX + ".errorMessage");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var sortedDurations = data === null || data === void 0 ? void 0 : data.durations.sort(function (a, b) {
        return durationsOrder[a.suspensionPeriod] - durationsOrder[b.suspensionPeriod];
    });
    var formattedDurationOptions = sortedDurations === null || sortedDurations === void 0 ? void 0 : sortedDurations.reduce(function (durations, currentDuration, index) {
        var _a;
        var period = index === 0 ? getLabel(PREFIX + ".month") : getLabel(PREFIX + ".months");
        return __assign(__assign({}, durations), (_a = {}, _a[index + 1 + " " + period] = currentDuration, _a));
    }, {});
    var formattedReasonOptions = data === null || data === void 0 ? void 0 : data.reasons.reduce(function (reasons, currentReason) {
        var _a;
        return (__assign(__assign({}, reasons), (_a = {}, _a[getLabel(PREFIX + ".reason." + currentReason)] = currentReason, _a)));
    }, {});
    var labels = React.useMemo(function () { return ({
        close: getLabel("common.actions.close"),
        durationNote: function (date) {
            return getFormattedLabel(PREFIX + ".duration.note", {
                labelData: { date: dateTime.formatShortDate(date) },
            });
        },
        pause: getLabel(PREFIX + ".pause"),
        durationLabel: getLabel(PREFIX + ".duration.label"),
        durationPlaceholder: getLabel(PREFIX + ".duration.placeholder"),
        info: getLabel(PREFIX + ".info"),
        pleaseNote: getLabel("account.common.pleaseNote"),
        note: getLabel(PREFIX + ".note"),
        reasonLabel: getLabel(PREFIX + ".reason.label"),
        reasonPlaceholder: getLabel(PREFIX + ".reason.placeholder"),
        limit: getFormattedLabel(PREFIX + ".limit", { parseLink: true }),
        limitTitle: getLabel(PREFIX + ".limit.title"),
        earliestSuspensionDate: getLabel(PREFIX + ".earliestSuspensionDate"),
        validationError: getLabel('common.form.field.requiredError'),
    }); }, [getLabel, dateTime, getFormattedLabel]);
    if (error)
        toast.failed(PREFIX + ".errorMessage");
    return (React.createElement(SuspendSubscriptionModal, { selectedDuration: duration, durationOptions: formattedDurationOptions, handleDurationChange: handleDurationChange, handleReasonChange: handleReasonChange, earliestSuspensionDate: data === null || data === void 0 ? void 0 : data.info.earliestSuspensionDate, isLoading: loading, isSuspendable: Boolean(data === null || data === void 0 ? void 0 : data.info.isSuspendable), labels: labels, onClose: onClose, onSubmit: onSubmit, reasonOptions: formattedReasonOptions, suspendSubscription: suspendSubscription }));
};

var Modals = function () {
    var _a = useModalContext(), state = _a.state, dispatch = _a.dispatch;
    var getLabel = useIntl().getLabel;
    var close = function () { return dispatch(Actions.clearModal()); };
    return (React__default.createElement(React__default.Fragment, null,
        state.activeModal === Modal$1.Suspend && (React__default.createElement(SuspendSubscriptionModalContainer, { subscriptionOrderId: state.subscriptionOrderId, onClose: close })),
        state.activeModal === Modal$1.Cancel && (React__default.createElement(CancelSubscriptionModalContainer, { subscriptionOrderId: state.subscriptionOrderId, onClose: close })),
        state.activeModal === Modal$1.Resume && (React__default.createElement(ResumeSubscriptionModalContainer, { onCancel: close, subscriptionId: state.subscriptionOrderId })),
        state.activeModal === Modal$1.EditSubscription && (React__default.createElement(EditSubscriptionModalContainer, { title: getLabel(PREFIX$1 + ".title"), subscriptionId: state.subscriptionOrderId, onClose: close },
            React__default.createElement(EditSubscriptionFormContainer, null))),
        state.activeModal === Modal$1.EditSolution && (React__default.createElement(EditSubscriptionModalContainer, { title: getLabel(PREFIX$1 + ".editSolution"), subscriptionId: state.subscriptionOrderId, onClose: close },
            React__default.createElement(EditSolutionFormContainer, null)))));
};

var GET_SUBSCRIPTION_NOTIFICATIONS = gql(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  query getSubscriptionNotifications($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        nextShippingDate\n        status\n        statusReason\n        plannedResumeDate\n      }\n    }\n  }\n"], ["\n  query getSubscriptionNotifications($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        nextShippingDate\n        status\n        statusReason\n        plannedResumeDate\n      }\n    }\n  }\n"])));
var templateObject_1$j;

var useSubscriptionNotifications = function (subscriptionOrderId) {
    var _a, _b, _c;
    var _d = useQuery(GET_SUBSCRIPTION_NOTIFICATIONS, {
        variables: { id: subscriptionOrderId },
    }), data = _d.data, loading = _d.loading, error = _d.error;
    var subscription = (_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscription;
    if (!subscription) {
        return {
            data: undefined,
            loading: loading,
            error: error,
        };
    }
    return {
        data: {
            nextShippingDate: parseDateString((_c = (_b = data === null || data === void 0 ? void 0 : data.me) === null || _b === void 0 ? void 0 : _b.subscription) === null || _c === void 0 ? void 0 : _c.nextShippingDate),
            status: toSubscriptionStatus(subscription.status),
            statusReason: toSubscriptionStatusReason(subscription.statusReason),
            plannedResumeDate: parseDateString(subscription.plannedResumeDate),
        },
        loading: loading,
        error: error,
    };
};

var SubscriptionNotifications = function (_a) {
    var subscriptionOrderId = _a.subscriptionOrderId;
    var _b = useIntl(), getFormattedLabel = _b.getFormattedLabel, getLabel = _b.getLabel, dateTime = _b.dateTime;
    var _c = useSubscriptionNotifications(subscriptionOrderId), data = _c.data, loading = _c.loading, error = _c.error;
    var formatDate = function (date) {
        return date instanceof Date ? dateTime.formatDate(date, 'short') : date;
    };
    if (loading || error) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        (data === null || data === void 0 ? void 0 : data.status) === SubscriptionStatus$1.Suspended &&
            data.plannedResumeDate &&
            !(data === null || data === void 0 ? void 0 : data.statusReason) ? (React.createElement(Alert, { type: "success", icon: "checkmark-circle", message: getFormattedLabel('account.subscription.detail.suspendedNotification', {
                labelData: { date: formatDate(data.plannedResumeDate) },
            }) })) : null,
        (data === null || data === void 0 ? void 0 : data.nextShippingDate) && (React.createElement(Alert, { type: "info", message: getLabel('account.subscription.detail.deliveryNotification') + " " + formatDate(data.nextShippingDate) })),
        (data === null || data === void 0 ? void 0 : data.statusReason) && (React.createElement(Alert, { type: "error", message: getFormattedLabel("account.subscription.detail.systemSuspensionNotification." + data.statusReason.toLowerCase(), { parseLink: true }) }))));
};

var SubscriptionAdditionalDetails = function (_a) {
    var className = _a.className, firstName = _a.firstName, lastName = _a.lastName, dateOfBirth = _a.dateOfBirth, ssn = _a.ssn;
    var _b = useIntl(), getLabel = _b.getLabel, dateTime = _b.dateTime;
    return (React.createElement("div", { className: classnames('subscription-additional-details summary__container', className) },
        React.createElement(Heading, { component: "h4" }, getLabel('account.subscription.details.currentPlan.additionalDetails')),
        React.createElement("div", { className: "subscription-additional-details__item" },
            firstName,
            " ",
            lastName),
        React.createElement("div", { className: "subscription-additional-details__item" }, dateOfBirth instanceof Date ? dateTime.formatDate(dateOfBirth, 'short') : dateOfBirth),
        React.createElement("div", { className: "subscription-additional-details__item" }, ssn)));
};

var SubscriptionHeader = function (_a) {
    var className = _a.className, labels = _a.labels, items = _a.items, onEdit = _a.onEdit;
    return (React.createElement("div", { className: classnames('subscription-header', className) },
        React.createElement(Text, { variant: "body-head", className: "subscription-header__title" }, labels.title),
        onEdit ? (React.createElement(IconButton, { className: "subscription-header__action", "aria-label": labels.editButton, onClick: onEdit },
            React.createElement(Icon, { name: "pencil", width: 20, height: 20 }))) : null,
        React.createElement(DetailHeader, null, items.map(function (item) { return (React.createElement(DetailHeader.Item, __assign({ key: item.term }, item))); }))));
};

var LABEL_PREFIX$6 = 'account.subscription.details.currentPlan';
var SubscriptionHeaderContainer = function (_a) {
    var className = _a.className, totalPrice = _a.totalPrice, billingFrequency = _a.billingFrequency, status = _a.status, deliveryFrequency = _a.deliveryFrequency, onEdit = _a.onEdit;
    var getLabel = useIntl().getLabel;
    var billingItem = React.useMemo(function () {
        var _a;
        return ({
            term: getLabel(LABEL_PREFIX$6 + ".term.payment"),
            definition: (React.createElement(React.Fragment, null,
                React.createElement(Price, { value: (_a = totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.centAmount) !== null && _a !== void 0 ? _a : 0, currency: totalPrice === null || totalPrice === void 0 ? void 0 : totalPrice.currencyCode }),
                React.createElement("span", null, getLabel(LABEL_PREFIX$6 + ".definition.payment." + billingFrequency)))),
        });
    }, [getLabel, billingFrequency, totalPrice]);
    var statusItem = React.useMemo(function () { return ({
        term: getLabel(LABEL_PREFIX$6 + ".term.status"),
        definition: getLabel(LABEL_PREFIX$6 + ".definition.status." + status),
    }); }, [getLabel, status]);
    var deliveryItem = React.useMemo(function () { return ({
        term: getLabel(LABEL_PREFIX$6 + ".term.deliveryFrequency"),
        definition: getLabel(LABEL_PREFIX$6 + ".definition.deliveryFrequency." + deliveryFrequency),
    }); }, [getLabel, deliveryFrequency]);
    var labels = React.useMemo(function () { return ({
        title: getLabel('products.contactLenses.configurator.step.subscriptionPlan'),
        editButton: getLabel('account.editSubscription.title'),
    }); }, [getLabel]);
    return (React.createElement(SubscriptionHeader, { className: className, labels: labels, items: [billingItem, statusItem, deliveryItem], onEdit: onEdit }));
};

var SubscriptionFragment = gql(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  fragment SubscriptionFragment on ProductSubscription {\n    id: subscriptionOrderId\n    status\n    statusReason\n    plannedResumeDate\n    billingFrequency\n    deliveryFrequency\n    totalPrice {\n      currencyCode\n      centAmount\n    }\n    subscriptionProducts {\n      includedUnits\n      variant {\n        ... on ContactLensVariant {\n          gan\n          packageQuantity\n          media {\n            images {\n              url\n              label\n            }\n          }\n          product {\n            replacementFrequency\n            productMasterKey\n            brand\n            name(locale: $locale)\n            description(locale: $locale)\n          }\n        }\n        ... on SolutionVariant {\n          gan\n          volume\n          volumeUnit\n          contactLensCareType\n          media {\n            images {\n              url\n              label\n            }\n          }\n          product {\n            brand\n            name(locale: $locale)\n            description(locale: $locale)\n          }\n        }\n      }\n    }\n  }\n"], ["\n  fragment SubscriptionFragment on ProductSubscription {\n    id: subscriptionOrderId\n    status\n    statusReason\n    plannedResumeDate\n    billingFrequency\n    deliveryFrequency\n    totalPrice {\n      currencyCode\n      centAmount\n    }\n    subscriptionProducts {\n      includedUnits\n      variant {\n        ... on ContactLensVariant {\n          gan\n          packageQuantity\n          media {\n            images {\n              url\n              label\n            }\n          }\n          product {\n            replacementFrequency\n            productMasterKey\n            brand\n            name(locale: $locale)\n            description(locale: $locale)\n          }\n        }\n        ... on SolutionVariant {\n          gan\n          volume\n          volumeUnit\n          contactLensCareType\n          media {\n            images {\n              url\n              label\n            }\n          }\n          product {\n            brand\n            name(locale: $locale)\n            description(locale: $locale)\n          }\n        }\n      }\n    }\n  }\n"])));
var SubscriptionDetailFragment = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fragment SubscriptionDetailFragment on ProductSubscription {\n    ...SubscriptionFragment\n    deliveryAddress {\n      firstName\n      lastName\n    }\n    personalDetails {\n      dateOfBirth\n      ssn\n    }\n    friendlyName\n  }\n  ", "\n"], ["\n  fragment SubscriptionDetailFragment on ProductSubscription {\n    ...SubscriptionFragment\n    deliveryAddress {\n      firstName\n      lastName\n    }\n    personalDetails {\n      dateOfBirth\n      ssn\n    }\n    friendlyName\n  }\n  ", "\n"])), SubscriptionFragment);
var SubscriptionListFragment = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fragment SubscriptionListFragment on ProductSubscription {\n    ...SubscriptionFragment\n  }\n  ", "\n"], ["\n  fragment SubscriptionListFragment on ProductSubscription {\n    ...SubscriptionFragment\n  }\n  ", "\n"])), SubscriptionFragment);
var templateObject_1$i, templateObject_2, templateObject_3;

var FIND_SUBSCRIPTION = gql(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n  query findSubscription($id: ID!, $locale: Locale!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        ...SubscriptionDetailFragment\n      }\n    }\n  }\n  ", "\n"], ["\n  query findSubscription($id: ID!, $locale: Locale!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        ...SubscriptionDetailFragment\n      }\n    }\n  }\n  ", "\n"])), SubscriptionDetailFragment);
var templateObject_1$h;

var useFindSubscription = function (id) {
    var _a;
    var locale = useIntl().locale;
    var _b = useQuery(FIND_SUBSCRIPTION, {
        variables: { id: id, locale: locale },
    }), data = _b.data, loading = _b.loading, error = _b.error;
    return { data: toSubscriptionDetail((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscription), loading: loading, error: error };
};

var ManageSubscriptionButtonGroup = function (_a) {
    var handleCancel = _a.handleCancel, handlePause = _a.handlePause, handleResume = _a.handleResume, labels = _a.labels, subscriptionStatus = _a.subscriptionStatus, systemSuspension = _a.systemSuspension;
    // Don't show buttons if subscription is cancelled
    if (subscriptionStatus === SubscriptionStatus$1.Cancelled) {
        return null;
    }
    return (React__default.createElement("div", { className: "manage-subscription-button-group" },
        subscriptionStatus === SubscriptionStatus$1.Active ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { className: "manage-subscription-button-group__button", caption: labels.cancel, onClick: handleCancel, variant: "outline", type: "button" }),
            React__default.createElement(Button, { className: "manage-subscription-button-group__button", caption: labels.pause, onClick: handlePause, type: "button" }))) : null,
        !systemSuspension && subscriptionStatus === SubscriptionStatus$1.Suspended ? (React__default.createElement(Button, { className: "manage-subscription-button-group__button", caption: labels.resume, onClick: handleResume, type: "button" })) : null));
};

var LABEL_PREFIX$5 = 'account.subscription.detail';
var NoSolutionPanel = function (_a) {
    var className = _a.className, onAddSolution = _a.onAddSolution;
    var getLabel = useIntl().getLabel;
    return (React.createElement("div", { className: classnames('no-solution-panel', className) },
        React.createElement(Hr, null),
        React.createElement(Heading, { component: "h4" },
            React.createElement(Icon, { name: "solution", className: "no-solution-panel__icon" }),
            React.createElement("span", { className: "no-solution-panel__heading-text" }, getLabel(LABEL_PREFIX$5 + ".noSolutionsAdded"))),
        React.createElement(Heading, { component: "h5", variant: "subheading1" }, getLabel(LABEL_PREFIX$5 + ".wantToAddSolution")),
        onAddSolution ? (React.createElement("div", { className: "no-solution-panel__actions" },
            React.createElement(IconButton, { "aria-label": getLabel('products.contactLenses.subscription.steps.solution.title'), onClick: onAddSolution },
                React.createElement(Icon, { name: "plus", width: 20, height: 20 })))) : null));
};

var GET_SUBSCRIPTION_PRESCRIPTION = gql(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  query getSubscriptionPrescription($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        status\n        prescription {\n          leftLens {\n            power\n            axis\n            cylinder\n            addition\n            baseCurve\n            diameter\n            productReference {\n              gan\n            }\n          }\n          rightLens {\n            power\n            axis\n            cylinder\n            addition\n            baseCurve\n            diameter\n            productReference {\n              gan\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getSubscriptionPrescription($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        status\n        prescription {\n          leftLens {\n            power\n            axis\n            cylinder\n            addition\n            baseCurve\n            diameter\n            productReference {\n              gan\n            }\n          }\n          rightLens {\n            power\n            axis\n            cylinder\n            addition\n            baseCurve\n            diameter\n            productReference {\n              gan\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$g;

var useSubscriptionPrescription = function (id) {
    var _a;
    var _b = useQuery(GET_SUBSCRIPTION_PRESCRIPTION, {
        variables: { id: id },
    }), data = _b.data, loading = _b.loading, error = _b.error;
    if (!((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscription)) {
        return {
            data: undefined,
            loading: loading,
            error: error,
        };
    }
    return {
        data: {
            prescription: toPrescription(data.me.subscription.prescription),
            subscriptionStatus: toSubscriptionStatus(data.me.subscription.status),
        },
        loading: loading,
        error: error,
    };
};

var isContactLensVariant = function (variant) {
    return variant.hasOwnProperty('packageQuantity');
};

var toSelectableParameters = function (opticalParameters) {
    var _a, _b;
    if (!opticalParameters)
        return undefined;
    // Use a set so the array elements are unique
    var initial = (_a = {},
        _a[PrescriptionKey.Addition] = new Set(),
        _a[PrescriptionKey.Axis] = new Set(),
        _a[PrescriptionKey.BaseCurve] = new Set(),
        _a[PrescriptionKey.Cylinder] = new Set(),
        _a[PrescriptionKey.Diameter] = new Set(),
        _a[PrescriptionKey.Power] = new Set(),
        _a);
    var uniqueOpticalParameters = opticalParameters.reduce(function (selectableParameters, parameters) {
        Object.entries(parameters).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (value !== null && initial.hasOwnProperty(key)) {
                selectableParameters[key].add(value);
            }
        });
        return selectableParameters;
    }, initial);
    return _b = {},
        // required keys
        _b[PrescriptionKey.Power] = Array.from(uniqueOpticalParameters[PrescriptionKey.Power]),
        _b[PrescriptionKey.BaseCurve] = Array.from(uniqueOpticalParameters[PrescriptionKey.BaseCurve]),
        _b[PrescriptionKey.Diameter] = Array.from(uniqueOpticalParameters[PrescriptionKey.Diameter]),
        // non-required keys
        _b[PrescriptionKey.Addition] = uniqueOpticalParameters[PrescriptionKey.Addition].size
            ? Array.from(uniqueOpticalParameters[PrescriptionKey.Addition])
            : undefined,
        _b[PrescriptionKey.Axis] = uniqueOpticalParameters[PrescriptionKey.Axis].size
            ? Array.from(uniqueOpticalParameters[PrescriptionKey.Axis])
            : undefined,
        _b[PrescriptionKey.Cylinder] = uniqueOpticalParameters[PrescriptionKey.Cylinder].size
            ? Array.from(uniqueOpticalParameters[PrescriptionKey.Cylinder])
            : undefined,
        _b;
};
var toPrescriptionProduct = function (product) {
    var _a, _b;
    var variant = product.variant;
    return {
        variant: {
            gan: variant.gan,
            opticalParameters: toSelectableParameters(variant === null || variant === void 0 ? void 0 : variant.opticalParameters),
            media: {
                images: (((_a = variant === null || variant === void 0 ? void 0 : variant.media) === null || _a === void 0 ? void 0 : _a.images) || []).map(toMediaImage),
            },
            product: {
                name: (_b = variant.product.name) !== null && _b !== void 0 ? _b : '',
                replacementFrequency: toReplacementFrequency(variant.product.replacementFrequency),
            },
        },
    };
};
var toPrescriptionProducts = function (products) {
    if (!products)
        return [];
    return (products || [])
        .filter(function (_a) {
        var variant = _a.variant;
        return isContactLensVariant(variant);
    })
        .map(toPrescriptionProduct);
};

var QUERY = gql(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  query getSubscriptionPrescriptionProducts($id: ID!, $locale: Locale!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        subscriptionProducts {\n          variant {\n            ... on ContactLensVariant {\n              gan\n              packageQuantity\n              media {\n                images {\n                  url\n                  label\n                }\n              }\n              product {\n                productMasterKey\n                name(locale: $locale)\n                replacementFrequency\n              }\n              opticalParameters {\n                power\n                diameter\n                baseCurve\n                cylinder\n                axis\n                addition\n              }\n            }\n            ... on SolutionVariant {\n              gan\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query getSubscriptionPrescriptionProducts($id: ID!, $locale: Locale!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        subscriptionProducts {\n          variant {\n            ... on ContactLensVariant {\n              gan\n              packageQuantity\n              media {\n                images {\n                  url\n                  label\n                }\n              }\n              product {\n                productMasterKey\n                name(locale: $locale)\n                replacementFrequency\n              }\n              opticalParameters {\n                power\n                diameter\n                baseCurve\n                cylinder\n                axis\n                addition\n              }\n            }\n            ... on SolutionVariant {\n              gan\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$f;

var useSubscriptionPrescriptionProducts = function (id) {
    var _a;
    var locale = useIntl().locale;
    var _b = useQuery(QUERY, {
        variables: { id: id, locale: locale },
    }), data = _b.data, loading = _b.loading, error = _b.error;
    if (!((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscription))
        return { data: undefined, loading: loading, error: error };
    return {
        data: {
            subscriptionProducts: toPrescriptionProducts(data.me.subscription.subscriptionProducts),
        },
        loading: loading,
        error: error,
    };
};

var UPDATE_SUBSCRIPTION_PRESCRIPTION = gql(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  mutation UpdateSubscriptionPrescription($input: ChangePrescriptionInput!) {\n    changePrescriptionSubscription(input: $input) {\n      prescription {\n        leftLens {\n          power\n          axis\n          cylinder\n          addition\n          baseCurve\n          diameter\n        }\n        rightLens {\n          power\n          axis\n          cylinder\n          addition\n          baseCurve\n          diameter\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateSubscriptionPrescription($input: ChangePrescriptionInput!) {\n    changePrescriptionSubscription(input: $input) {\n      prescription {\n        leftLens {\n          power\n          axis\n          cylinder\n          addition\n          baseCurve\n          diameter\n        }\n        rightLens {\n          power\n          axis\n          cylinder\n          addition\n          baseCurve\n          diameter\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$e;

var useUpdateSubscriptionPrescription = function (subscriptionOrderId, userId) {
    var _a = __read(useMutation(UPDATE_SUBSCRIPTION_PRESCRIPTION), 2), mutation = _a[0], _b = _a[1], loading = _b.loading, error = _b.error;
    return {
        loading: loading,
        error: error,
        updateSubscriptionPrescription: function (prescription) { return __awaiter(void 0, void 0, void 0, function () {
            var variables;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        variables = {
                            input: {
                                subscriptionOrderId: subscriptionOrderId,
                                customerId: userId,
                                prescription: prescription,
                            },
                        };
                        return [4 /*yield*/, mutation({
                                variables: variables,
                                update: function (cache, _a) {
                                    var _b;
                                    var data = _a.data;
                                    var prescription = (_b = data === null || data === void 0 ? void 0 : data.changePrescriptionSubscription) === null || _b === void 0 ? void 0 : _b.prescription;
                                    cache.writeFragment({
                                        id: "ProductSubscription:" + subscriptionOrderId,
                                        fragment: gql(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n              fragment SubscriptionPrescriptionFragment on ProductSubscription {\n                prescription {\n                  leftLens {\n                    power\n                    axis\n                    cylinder\n                    addition\n                    baseCurve\n                    diameter\n                    addition\n                  }\n                  rightLens {\n                    power\n                    axis\n                    cylinder\n                    addition\n                    baseCurve\n                    diameter\n                    addition\n                  }\n                }\n              }\n            "], ["\n              fragment SubscriptionPrescriptionFragment on ProductSubscription {\n                prescription {\n                  leftLens {\n                    power\n                    axis\n                    cylinder\n                    addition\n                    baseCurve\n                    diameter\n                    addition\n                  }\n                  rightLens {\n                    power\n                    axis\n                    cylinder\n                    addition\n                    baseCurve\n                    diameter\n                    addition\n                  }\n                }\n              }\n            "]))),
                                        data: {
                                            prescription: prescription,
                                        },
                                    });
                                },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    };
};
var templateObject_1$d;

var sortOptions = function (a, b) {
    if (a > b)
        return 1;
    if (a < b)
        return -1;
    return 0;
};
var rangeToOptions = function (range, prescriptionKey) {
    return range.sort(sortOptions).reduce(function (obj, val) {
        // Object key is the option label in Select component and value is the option value
        obj[toPrescriptionDisplayValue(prescriptionKey, val)] = val;
        return obj;
    }, {});
};
var PrescriptionKeySelect = function (_a) {
    var _b, _c, _d;
    var side = _a.side, prescriptionKey = _a.prescriptionKey, options = _a.options, initialFormState = _a.initialFormState;
    var getLabel = useIntl().getLabel;
    var required = prescriptionKey !== PrescriptionKey.Cylinder &&
        prescriptionKey !== PrescriptionKey.Axis &&
        prescriptionKey !== PrescriptionKey.Addition;
    var name = prescriptionKey + "-" + side;
    var placeholder = !required
        ? getLabel("account.subscription.editPrescription." + prescriptionKey + ".placeholder")
        : undefined;
    var initialState = {
        value: ((_b = initialFormState === null || initialFormState === void 0 ? void 0 : initialFormState[name]) === null || _b === void 0 ? void 0 : _b.value)
            ? toPrescriptionDisplayValue(prescriptionKey, (_d = (_c = initialFormState[name]) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : null)
            : '',
        name: name,
    };
    return (React.createElement(Field, { className: "subscription-prescription-single-eye__form-select-container", label: getLabel("products.contactLenses.prescription." + prescriptionKey), name: name, error: getLabel("account.subscription.editPrescription." + prescriptionKey + ".errorMessage"), placeholder: placeholder, required: required },
        React.createElement(Select, { className: "subscription-prescription-single-eye__form-select", name: name, id: name, "data-t": name, options: rangeToOptions(options, prescriptionKey), sortOptionsBy: sortOptions, initialState: initialState })));
};

var SingleEyePrescriptionForm = function (_a) {
    var _b;
    var eye = _a.eye, side = _a.side, subscriptionProducts = _a.subscriptionProducts, prescriptionKeys = _a.prescriptionKeys, initialFormState = _a.initialFormState;
    var getLabel = useIntl().getLabel;
    if (!eye) {
        return null;
    }
    var lensVariant = (_b = subscriptionProducts.find(function (p) { return p.variant.gan === eye.productReference.gan; })) === null || _b === void 0 ? void 0 : _b.variant;
    if (!lensVariant) {
        return null;
    }
    var opticalParameters = lensVariant.opticalParameters;
    if (!opticalParameters) {
        return null;
    }
    return (React.createElement("div", { className: "subscription-prescription-single-eye", "data-t": "subscription-prescription-single-eye-" + side },
        React.createElement("div", { className: "subscription-prescription-single-eye__product-info" },
            React.createElement(Image$1, { alt: "Contact lens product image", url: getMasterImagePath(lensVariant), className: "subscription-prescription-single-eye__product-info-image" }),
            React.createElement("strong", { className: "subscription-prescription-single-eye__product-info-name" }, 
            // Name is localised in the backend
            lensVariant.product.name),
            React.createElement("span", { className: "subscription-prescription-single-eye__product-info-replacementFrequency" }, getLabel("common.frequency." + lensVariant.product.replacementFrequency)),
            React.createElement("strong", { className: "subscription-prescription-single-eye__product-info-eyeSide" }, getLabel("account.subscription.editPrescription.singleEye." + (side === PrescriptionSide.Left ? 'left' : 'right')))),
        React.createElement("div", { className: "subscription-prescription-single-eye__form" }, prescriptionKeys.map(function (key) {
            var options = opticalParameters[key];
            return (options && (React.createElement(PrescriptionKeySelect, { side: side, prescriptionKey: key, key: key, options: options, initialFormState: initialFormState })));
        }))));
};

var ModalBody = function (_a) {
    var className = _a.className, initialFormState = _a.initialFormState, isMutating = _a.isMutating, labels = _a.labels, onClose = _a.onClose, onSubmit = _a.onSubmit, prescription = _a.prescription, prescriptionKeys = _a.prescriptionKeys, subscriptionProducts = _a.subscriptionProducts;
    return (React.createElement(Form, { className: className + "__form", name: "subscription-prescription-form", onSubmit: onSubmit, initialFormState: initialFormState },
        React.createElement("div", { className: className + "__form-container" },
            prescription.rightLens && (React.createElement(SingleEyePrescriptionForm, { eye: prescription.rightLens, side: PrescriptionSide.Right, subscriptionProducts: subscriptionProducts, prescriptionKeys: prescriptionKeys, initialFormState: initialFormState })),
            prescription.leftLens && (React.createElement(SingleEyePrescriptionForm, { eye: prescription.leftLens, side: PrescriptionSide.Left, subscriptionProducts: subscriptionProducts, prescriptionKeys: prescriptionKeys, initialFormState: initialFormState }))),
        React.createElement("p", { className: className + "__note" },
            React.createElement("strong", null,
                labels.pleaseNote,
                ":"),
            " ",
            labels.note),
        React.createElement(Hr, null),
        React.createElement(Button, { "data-t": "subscription-prescription-cancel", className: className + "__action-button", variant: "outline", caption: labels.cancel, onClick: onClose }),
        React.createElement(Button, { "data-t": "subscription-prescription-submit", className: className + "__action-button", type: "submit", caption: labels.save, isLoading: isMutating })));
};
var PrescriptionForm = function (_a) {
    var className = _a.className, isQuerying = _a.isQuerying, onClose = _a.onClose, labels = _a.labels, rest = __rest(_a, ["className", "isQuerying", "onClose", "labels"]);
    return (React.createElement(Modal$2, { className: className + "__modal", isOpen: true, onModalClose: onClose, showIcon: true, title: labels.title }, isQuerying ? (React.createElement("div", { className: className + "__loader" },
        React.createElement(Loader$1, null))) : (React.createElement(ModalBody, __assign({ className: className, labels: labels, onClose: onClose }, rest)))));
};

var prescriptionKeys = [
    PrescriptionKey.Power,
    PrescriptionKey.BaseCurve,
    PrescriptionKey.Diameter,
    PrescriptionKey.Axis,
    PrescriptionKey.Cylinder,
    PrescriptionKey.Addition,
];
var lensToFormState = function (lens, side, opticalParameters) {
    if (lens === null || !opticalParameters)
        return {};
    return prescriptionKeys.reduce(function (result, key) {
        var _a;
        var _b;
        var name = key + "-" + side;
        var params = opticalParameters[key];
        if (!params)
            return result;
        var value = (_b = lens[key]) !== null && _b !== void 0 ? _b : '';
        if (value !== '') {
            if (!params.some(function (param) { return param === value; })) {
                value = params[0];
            }
        }
        return __assign(__assign({}, result), (_a = {}, _a[name] = { value: value, name: name, isTouched: false }, _a));
    }, {});
};
var PrescriptionFormContainer = function (_a) {
    var _b;
    var prescription = _a.prescription, onEdit = _a.onEdit, subscriptionOrderId = _a.subscriptionOrderId;
    var getLabel = useIntl().getLabel;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var query = useSubscriptionPrescriptionProducts(subscriptionOrderId);
    var mutation = useUpdateSubscriptionPrescription(subscriptionOrderId, userId);
    var onClose = React.useCallback(function () { return onEdit(false); }, [onEdit]);
    var onSubmit = function (_a) {
        var state = _a.formState;
        return __awaiter(void 0, void 0, void 0, function () {
            var values;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!state)
                            return [2 /*return*/];
                        values = Util.getValuesFromState(state);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, mutation.updateSubscriptionPrescription({
                                rightLens: prescription.rightLens
                                    ? {
                                        power: Number(values['power-rightEye']),
                                        diameter: Number(values['diameter-rightEye']),
                                        baseCurve: Number(values['baseCurve-rightEye']),
                                        cylinder: values['cylinder-rightEye'] ? Number(values['cylinder-rightEye']) : null,
                                        axis: values['axis-rightEye'] ? Number(values['axis-rightEye']) : null,
                                        addition: values['addition-rightEye'] ? values['addition-rightEye'] : null,
                                    }
                                    : null,
                                leftLens: prescription.leftLens
                                    ? {
                                        power: Number(values['power-leftEye']),
                                        diameter: Number(values['diameter-leftEye']),
                                        baseCurve: Number(values['baseCurve-leftEye']),
                                        cylinder: values['cylinder-leftEye'] ? Number(values['cylinder-leftEye']) : null,
                                        axis: values['axis-leftEye'] ? Number(values['axis-leftEye']) : null,
                                        addition: values['addition-leftEye'] ? values['addition-leftEye'] : null,
                                    }
                                    : null,
                            })];
                    case 2:
                        _b.sent();
                        toast.success('common.address.saveSuccess');
                        onClose();
                        return [3 /*break*/, 4];
                    case 3:
                        _b.sent();
                        toast.failed('account.subscription.editPrescription.saveFailed');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var initialFormState = React.useMemo(function () {
        var _a, _b;
        var opticalParametersForGan = function (gan) {
            var _a, _b;
            return (_b = (_a = query.data) === null || _a === void 0 ? void 0 : _a.subscriptionProducts.find(function (subscriptionProduct) { return subscriptionProduct.variant.gan === gan; })) === null || _b === void 0 ? void 0 : _b.variant.opticalParameters;
        };
        return __assign(__assign({}, lensToFormState(prescription.rightLens, PrescriptionSide.Right, opticalParametersForGan((_a = prescription.rightLens) === null || _a === void 0 ? void 0 : _a.productReference.gan))), lensToFormState(prescription.leftLens, PrescriptionSide.Left, opticalParametersForGan((_b = prescription.leftLens) === null || _b === void 0 ? void 0 : _b.productReference.gan)));
    }, [prescription, query.data]);
    var labels = React.useMemo(function () { return ({
        title: getLabel('account.subscription.editPrescription.title'),
        error: getLabel('account.subscription.editPrescription.saveFailed'),
        pleaseNote: getLabel('account.common.pleaseNote'),
        note: getLabel('account.subscription.editPrescription.note'),
        cancel: getLabel('common.actions.cancel'),
        save: getLabel('account.action.save'),
    }); }, [getLabel]);
    return (React.createElement(PrescriptionForm, { "data-t": "prescription-form", className: "prescription-form", initialFormState: initialFormState, prescription: prescription, onClose: onClose, labels: labels, isQuerying: query.loading, isMutating: mutation.loading, onSubmit: onSubmit, subscriptionProducts: ((_b = query.data) === null || _b === void 0 ? void 0 : _b.subscriptionProducts) || [], prescriptionKeys: prescriptionKeys }));
};

var PrescriptionDetails = function (_a) {
    var className = _a.className, labels = _a.labels, prescription = _a.prescription, tablePrescription = _a.tablePrescription, onEdit = _a.onEdit, isEditing = _a.isEditing, subscriptionOrderId = _a.subscriptionOrderId, subscriptionStatus = _a.subscriptionStatus;
    return (React.createElement("div", { className: classnames('prescription-details', className) },
        React.createElement(Heading, { className: "prescription-details__header", variant: "smallest" }, labels.title),
        React.createElement(PrescriptionTable, { prescription: tablePrescription }),
        onEdit && subscriptionStatus && subscriptionStatus === SubscriptionStatus$1.Active ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "prescription-details__actions" },
                React.createElement(IconButton, { "aria-label": "Edit prescription", "data-t": "prescription-details-edit-button", className: "prescription-details__button", onClick: onEdit },
                    React.createElement(Icon, { name: "pencil", width: 20, height: 20 }))),
            Boolean(isEditing) && (React.createElement(PrescriptionFormContainer, { subscriptionOrderId: subscriptionOrderId, prescription: prescription, onEdit: onEdit })))) : null));
};

var Side;
(function (Side) {
    Side["Right"] = "rightLens";
    Side["Left"] = "leftLens";
})(Side || (Side = {}));
var toTablePrescription = function (prescription) {
    var formatKeys = function (lens) {
        var _a;
        var emptyLens = (_a = {},
            _a[PrescriptionKey.Addition] = '',
            _a[PrescriptionKey.Axis] = '',
            _a[PrescriptionKey.BaseCurve] = '',
            _a[PrescriptionKey.Cylinder] = '',
            _a[PrescriptionKey.Diameter] = '',
            _a[PrescriptionKey.Power] = '',
            _a);
        if (lens === null)
            return emptyLens;
        return Object.keys(emptyLens).reduce(function (acc, key) {
            var _a;
            if (lens[key] === undefined)
                return acc;
            return __assign(__assign({}, acc), (_a = {}, _a[key] = toPrescriptionDisplayValue(key, lens[key]), _a));
        }, emptyLens);
    };
    return {
        rightEye: formatKeys(prescription[Side.Right]),
        leftEye: formatKeys(prescription[Side.Left]),
    };
};
var PrescriptionDetailsContainer = function (_a) {
    var className = _a.className, subscriptionOrderId = _a.subscriptionOrderId;
    var getLabel = useIntl().getLabel;
    var _b = useSubscriptionPrescription(subscriptionOrderId), data = _b.data, loading = _b.loading, error = _b.error;
    var _c = __read(React.useState(false), 2), isEditing = _c[0], setIsEditing = _c[1];
    var onEdit = React.useCallback(function (editing) {
        if (editing === void 0) { editing = true; }
        return setIsEditing(editing);
    }, [setIsEditing]);
    var labels = React.useMemo(function () { return ({
        title: getLabel('account.subscription.details.currentPlan.prescription'),
    }); }, [getLabel]);
    if (loading) {
        return (React.createElement("div", { className: "prescription-details__loader" },
            React.createElement(Loader$1, null)));
    }
    if (!data || !(data === null || data === void 0 ? void 0 : data.prescription) || error) {
        return null;
    }
    return (React.createElement(PrescriptionDetails, { className: className, labels: labels, tablePrescription: toTablePrescription(data.prescription), prescription: data === null || data === void 0 ? void 0 : data.prescription, isEditing: isEditing, onEdit: onEdit, subscriptionOrderId: subscriptionOrderId, subscriptionStatus: data.subscriptionStatus }));
};

var SubscriptionLineItem = function (_a) {
    var className = _a.className, name = _a.name, imagePath = _a.imagePath, eyeSide = _a.eyeSide, properties = _a.properties;
    var eyeSideElement = eyeSide && eyeSide !== 'both' ? (React.createElement(EyeSideIndicator, { className: "subscription-line-item__eyeside-indicator", side: eyeSide })) : null;
    return (React.createElement(LineItem, { className: classnames('subscription-line-item', className) },
        React.createElement(LineItemMedia, { type: "image", imageUrl: imagePath, imageAlt: name, overlayElement: eyeSideElement }),
        React.createElement(LineItemContent, { className: "subscription-line-item__content" },
            React.createElement(LineItemTitle, { title: name }), properties === null || properties === void 0 ? void 0 :
            properties.map(function (property, index) { return (React.createElement(LineItemSubtitle, { key: index, subtitle: property })); }))));
};

var LABEL_PREFIX$4 = 'account.subscription.details.currentPlan.lineItem';
var SubscriptionLineItemContainer = function (_a) {
    var subscriptionProduct = _a.subscriptionProduct, deliveryFrequency = _a.deliveryFrequency;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var toProperties = function (subscriptionProduct) {
        if (isSolutionVariant(subscriptionProduct.variant)) {
            return toSolutionProperties(subscriptionProduct.variant, subscriptionProduct.includedUnits || 0);
        }
        return toContactLensProperties(subscriptionProduct.variant);
    };
    var toContactLensProperties = function (variant) {
        var quantity = getFormattedLabel(LABEL_PREFIX$4 + ".lenses", {
            labelData: {
                units: variant.packageQuantity || 0,
            },
        });
        var frequency = getLabel(LABEL_PREFIX$4 + ".deliveryFrequency." + deliveryFrequency);
        return [variant.product.replacementFrequency, quantity + ", " + frequency];
    };
    var toSolutionProperties = function (variant, units) {
        var description = variant.contactLensCareType + ", " + 
        // @TODO check if this is correct
        variant.volume + "ml";
        var bottles = "" + getFormattedLabel(LABEL_PREFIX$4 + ".bottles", {
            labelData: { units: units },
        });
        var frequency = getLabel(LABEL_PREFIX$4 + ".deliveryFrequency." + deliveryFrequency);
        return [description, bottles + ", " + frequency];
    };
    var toLineItemProps = function (subscriptionProduct) {
        return {
            name: subscriptionProduct.variant.product.brand + " " + subscriptionProduct.variant.product.name,
            eyeSide: 'both',
            properties: toProperties(subscriptionProduct),
            imagePath: getMasterImagePath(subscriptionProduct.variant),
        };
    };
    return React.createElement(SubscriptionLineItem, __assign({}, toLineItemProps(subscriptionProduct)));
};

var SubscriptionLineItems = function (_a) {
    var title = _a.title, editAriaLabel = _a.editAriaLabel, products = _a.products, deliveryFrequency = _a.deliveryFrequency, className = _a.className, onEdit = _a.onEdit;
    if (!(products === null || products === void 0 ? void 0 : products.length))
        return null;
    return (React__default.createElement("div", { className: classnames('subscription-line-items', className) },
        React__default.createElement(Hr, null),
        React__default.createElement(Heading, { component: "h4" }, title),
        onEdit ? (React__default.createElement("div", { className: "subscription-line-items__actions" },
            React__default.createElement(IconButton, { "aria-label": editAriaLabel, onClick: onEdit },
                React__default.createElement(Icon, { name: "pencil", width: 20, height: 20 })))) : null,
        products.map(function (product, index) { return (React__default.createElement(React__default.Fragment, { key: index },
            index > 0 && React__default.createElement(Hr, null),
            React__default.createElement(SubscriptionLineItemContainer, { deliveryFrequency: deliveryFrequency, subscriptionProduct: product }))); })));
};

var CurrentPlan = function (_a) {
    var className = _a.className, subscriptionOrderId = _a.subscriptionOrderId;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var _c = useFindSubscription(subscriptionOrderId), data = _c.data, loading = _c.loading, error = _c.error;
    var dispatch = useModalContext().dispatch;
    var setActiveModal = function (modal) { return function () { return dispatch(Actions.setActiveModal(modal)); }; };
    var lenses = React__default.useMemo(function () {
        return data === null || data === void 0 ? void 0 : data.subscriptionProducts.filter(function (subscriptionProduct) {
            return isContactLensVariant$2(subscriptionProduct.variant);
        });
    }, [data === null || data === void 0 ? void 0 : data.subscriptionProducts]);
    var isDaily = lenses === null || lenses === void 0 ? void 0 : lenses.some(function (lens) { return isDailyFrequency(lens.variant); });
    var solutions = React__default.useMemo(function () {
        return data === null || data === void 0 ? void 0 : data.subscriptionProducts.filter(function (subscriptionProduct) {
            return isSolutionVariant(subscriptionProduct.variant);
        });
    }, [data === null || data === void 0 ? void 0 : data.subscriptionProducts]);
    if (loading) {
        return (React__default.createElement("div", { className: "current-plan__loader" },
            React__default.createElement(Loader$1, null)));
    }
    if (error && getGraphQLErrorCode(error, INVALID_RESPONSE)) {
        return (React__default.createElement(Alert, { className: "current-plan__alert", type: "error", message: getFormattedLabel('account.subscription.detail.currentPlan.data.error', {
                parseLink: true,
            }) }));
    }
    if (error && getGraphQLErrorCode(error, UNAUTHENTICATED)) {
        return (React__default.createElement(Alert, { type: "error", message: getFormattedLabel('account.subscriptions.errors.unauthenticated', {
                parseLink: true,
            }) }));
    }
    if (error || !data) {
        return (React__default.createElement(Alert, { type: "error", message: getFormattedLabel('account.subscriptions.errors.general', { parseLink: true }) }));
    }
    return (React__default.createElement(React__default.Fragment, null,
        (data === null || data === void 0 ? void 0 : data.personalDetails) && (React__default.createElement(SubscriptionAdditionalDetails, { firstName: data === null || data === void 0 ? void 0 : data.deliveryAddress.firstName, lastName: data === null || data === void 0 ? void 0 : data.deliveryAddress.lastName, dateOfBirth: data === null || data === void 0 ? void 0 : data.personalDetails.dateOfBirth, ssn: data === null || data === void 0 ? void 0 : data.personalDetails.ssn })),
        React__default.createElement(SummaryContainer, { className: classnames('current-plan', className) },
            React__default.createElement(SubscriptionHeaderContainer, { status: data === null || data === void 0 ? void 0 : data.status, totalPrice: data === null || data === void 0 ? void 0 : data.totalPrice, billingFrequency: data === null || data === void 0 ? void 0 : data.billingFrequency, deliveryFrequency: data === null || data === void 0 ? void 0 : data.deliveryFrequency, onEdit: (data === null || data === void 0 ? void 0 : data.status) === SubscriptionStatus$1.Active
                    ? setActiveModal(Modal$1.EditSubscription)
                    : undefined }),
            React__default.createElement(Hr, null),
            React__default.createElement(PrescriptionDetailsContainer, { subscriptionOrderId: subscriptionOrderId }),
            React__default.createElement(SubscriptionLineItems, { title: getLabel('products.contact-lenses'), products: lenses, deliveryFrequency: data === null || data === void 0 ? void 0 : data.deliveryFrequency }),
            React__default.createElement(SubscriptionLineItems, { title: getLabel('products.contactLenses.configurator.step.solution'), products: solutions, deliveryFrequency: data === null || data === void 0 ? void 0 : data.deliveryFrequency, onEdit: (data === null || data === void 0 ? void 0 : data.status) === SubscriptionStatus$1.Active
                    ? setActiveModal(Modal$1.EditSolution)
                    : undefined, editAriaLabel: getLabel('products.contactLenses.solutions.title') }),
            !(solutions === null || solutions === void 0 ? void 0 : solutions.length) && !isDaily ? (React__default.createElement(NoSolutionPanel, { onAddSolution: (data === null || data === void 0 ? void 0 : data.status) === SubscriptionStatus$1.Active
                    ? setActiveModal(Modal$1.EditSolution)
                    : undefined })) : null),
        React__default.createElement(ManageSubscriptionButtonGroup, { handleCancel: setActiveModal(Modal$1.Cancel), handlePause: setActiveModal(Modal$1.Suspend), handleResume: setActiveModal(Modal$1.Resume), subscriptionStatus: data.status, systemSuspension: Boolean(data.statusReason), labels: {
                cancel: getLabel(LABEL_PREFIX$8 + ".cancelSubscription"),
                pause: getLabel(PREFIX + ".pause"),
                resume: getLabel(LABEL_PREFIX$7 + ".resumeButtonCaption"),
            } })));
};

var removeUndefinedValues = function (values) {
    return Object.entries(values).reduce(function (result, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return (value ? ((result[key] = value), result) : result);
    }, {});
};

var AddressSummary = function (_a) {
    var title = _a.title, formatter = _a.formatter, address = _a.address, onEdit = _a.onEdit, _b = _a.allowEditing, allowEditing = _b === void 0 ? true : _b, rest = __rest(_a, ["title", "formatter", "address", "onEdit", "allowEditing"]);
    var getLabel = useIntl().getLabel;
    var templates = DefaultSummaryTemplates();
    var resolvedFormatter = formatter || templates[SummaryName.addressSummary];
    return (React__default.createElement(Summary, __assign({ className: "address-summary" }, rest),
        React__default.createElement("div", { className: "address-summary__inner" },
            React__default.createElement("div", { className: "address-summary__content" },
                React__default.createElement(Heading, { variant: "subheading2", component: "span", className: "address-summary__title" }, title),
                resolvedFormatter({ data: removeUndefinedValues(address) })),
            onEdit && allowEditing ? (React__default.createElement("div", { className: "address-summary__actions" },
                React__default.createElement(Button, { "data-t": "summary-edit-button", className: "address-summary__button", variant: "ghost", size: "custom", caption: getLabel('common.actions.edit'), onClick: onEdit }))) : null)));
};

var EditableAddressSummary = function (_a) {
    var address = _a.address, addressSummary = _a.addressSummary, addressForm = _a.addressForm, className = _a.className, name = _a.name, title = _a.title, mutate = _a.mutate, _b = _a.defaultEditing, defaultEditing = _b === void 0 ? false : _b, _c = _a.allowEditing, allowEditing = _c === void 0 ? true : _c;
    var _d = useIntl(), getLabel = _d.getLabel, getFormattedLabel = _d.getFormattedLabel;
    var initialFormState = Object.keys(address).reduce(function (formState, addressKey) {
        var value = address[addressKey];
        // Initial form state can't handle undefined values, so don't add the key for optional fields
        if (!value)
            return formState;
        formState[addressKey] = {
            isTouched: false,
            isValid: false,
            name: addressKey,
            value: value,
        };
        return formState;
    }, {});
    var _e = __read(React__default.useState(false), 2), isLoading = _e[0], setIsLoading = _e[1];
    var _f = __read(React__default.useState(false), 2), isError = _f[0], setIsError = _f[1];
    var _g = __read(React__default.useState(defaultEditing), 2), isEditing = _g[0], setIsEditing = _g[1];
    var _h = __read(React__default.useState(initialFormState), 2), formValues = _h[0], setFormValues = _h[1];
    var onCancel = function () { return setIsEditing(false); };
    var onEdit = function () { return setIsEditing(true); };
    var handleChange = React__default.useCallback(function (form) {
        if (form.formValid) {
            setFormValues(form.formState);
        }
    }, []);
    var onSubmit = function (_a) {
        var state = _a.formState;
        return __awaiter(void 0, void 0, void 0, function () {
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function (_u) {
                switch (_u.label) {
                    case 0:
                        if (!state)
                            return [2 /*return*/];
                        setIsLoading(true);
                        _u.label = 1;
                    case 1:
                        _u.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, mutate({
                                firstName: (_c = (_b = state.firstName) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : '',
                                lastName: (_e = (_d = state.lastName) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : '',
                                streetName: (_g = (_f = state.streetName) === null || _f === void 0 ? void 0 : _f.value) !== null && _g !== void 0 ? _g : '',
                                streetNumber: (_j = (_h = state.streetNumber) === null || _h === void 0 ? void 0 : _h.value) !== null && _j !== void 0 ? _j : '',
                                additionalStreetInfo: ((_k = state.additionalStreetInfo) === null || _k === void 0 ? void 0 : _k.value) || undefined,
                                city: (_m = (_l = state.city) === null || _l === void 0 ? void 0 : _l.value) !== null && _m !== void 0 ? _m : '',
                                region: (_p = (_o = state.region) === null || _o === void 0 ? void 0 : _o.value) !== null && _p !== void 0 ? _p : '',
                                postalCode: (_r = (_q = state.postalCode) === null || _q === void 0 ? void 0 : _q.value) !== null && _r !== void 0 ? _r : '',
                                countryCode: (_t = (_s = state.countryCode) === null || _s === void 0 ? void 0 : _s.value) !== null && _t !== void 0 ? _t : '',
                            })];
                    case 2:
                        _u.sent();
                        toast.success('common.address.saveSuccess');
                        setIsEditing(false);
                        return [3 /*break*/, 5];
                    case 3:
                        _u.sent();
                        setIsError(true);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return (React__default.createElement(React__default.Fragment, null, isEditing ? (React__default.createElement(Form, { name: name, "data-t": name, className: classnames('editable-address-summary', className), initialFormState: formValues, onSubmit: onSubmit, onChange: handleChange },
        isError && (React__default.createElement(Alert, { type: "error", message: getFormattedLabel('account.subscription.detail.saveFailed', {
                parseLink: true,
            }) })),
        addressForm,
        React__default.createElement("p", { className: "editable-address-summary__note" },
            React__default.createElement("strong", null,
                getLabel('account.common.pleaseNote'),
                ":"),
            ' ',
            getLabel('account.subscription.address.note')),
        React__default.createElement("div", { className: "editable-address-summary__button-block" },
            React__default.createElement(Button, { caption: getLabel('common.actions.cancel'), className: "editable-address-summary__button", onClick: onCancel, variant: "outline", "data-t": "cancel-editable-address-summary" }),
            React__default.createElement(Button, { caption: getLabel('account.action.save'), className: "editable-address-summary__button", isLoading: isLoading, type: "submit", "data-t": "save-editable-address-summary" })))) : (React__default.createElement(AddressSummary, { "data-t": "address-summary", title: title, formatter: addressSummary, address: address, onEdit: onEdit, allowEditing: allowEditing }))));
};

var HistoryTable = function (_a) {
    var title = _a.title, numberOfRows = _a.numberOfRows, columns = _a.columns, showMoreCaption = _a.showMoreCaption, _b = _a.showMoreThreshold, showMoreThreshold = _b === void 0 ? 4 : _b, className = _a.className, rest = __rest(_a, ["title", "numberOfRows", "columns", "showMoreCaption", "showMoreThreshold", "className"]);
    var _c = __read(useState(false), 2), showAll = _c[0], setShowAll = _c[1];
    var classNames = classnames('subscription-history-table', className);
    var showMoreThresholdMet = numberOfRows > showMoreThreshold;
    return (React__default.createElement("div", { className: classNames, "data-t": rest['data-t'] },
        React__default.createElement(DataTable, { "aria-level": 2, caption: title, numberOfRows: showAll ? numberOfRows : Math.min(showMoreThreshold, numberOfRows) }, columns
            .map(function (_a) {
            var id = _a.id, header = _a.header, getRow = _a.getRow;
            return (React__default.createElement(DataTable.Col, { id: id, header: header, key: id }, getRow));
        })
            .concat([
            React__default.createElement(DataTable.Footer, { key: "subscription-history-table" }, !showAll && showMoreThresholdMet ? (React__default.createElement("div", { className: "subscription-history-table__show-more" },
                React__default.createElement(Button, { variant: "ghost", caption: showMoreCaption, icon: "chevron-down", onClick: function () { return setShowAll(true); } }))) : null),
        ]))));
};

var GET_SUBSCRIPTION_DELIVERIES = gql(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  query getSubscriptionDeliveries($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        status\n        deliveryFrequency\n        nextShippingDate\n        deliveryAddress {\n          id\n          firstName\n          lastName\n          streetName\n          streetNumber\n          additionalStreetInfo\n          postalCode\n          city\n          region\n          countryCode\n        }\n        deliveries {\n          shipmentNumber\n          shippingDate\n          shipmentTrackingURL\n          status\n        }\n      }\n    }\n  }\n"], ["\n  query getSubscriptionDeliveries($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        status\n        deliveryFrequency\n        nextShippingDate\n        deliveryAddress {\n          id\n          firstName\n          lastName\n          streetName\n          streetNumber\n          additionalStreetInfo\n          postalCode\n          city\n          region\n          countryCode\n        }\n        deliveries {\n          shipmentNumber\n          shippingDate\n          shipmentTrackingURL\n          status\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$c;

var useDeliveries = function (subscriptionOrderId) {
    var _a;
    var _b = useQuery(GET_SUBSCRIPTION_DELIVERIES, {
        variables: { id: subscriptionOrderId },
    }), data = _b.data, loading = _b.loading, error = _b.error;
    if (loading)
        return { data: undefined, loading: loading, error: error };
    var response = data;
    var subscription = (_a = response === null || response === void 0 ? void 0 : response.me) === null || _a === void 0 ? void 0 : _a.subscription;
    if (!subscription) {
        return { data: undefined, loading: false, error: undefined };
    }
    return {
        data: {
            deliveryAddress: toDeliveryAddress(subscription.deliveryAddress),
            deliveries: toDeliveries(subscription.deliveries),
            subscriptionStatus: toSubscriptionStatus(subscription.status),
        },
        loading: loading,
        error: error,
    };
};

var UPDATE_DELIVERY_ADDRESS = gql(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  mutation UpdateDeliveryAddress($input: SubscriptionAddressChangeInput!) {\n    updateSubscriptionDeliveryAddress(input: $input) {\n      deliveryAddress {\n        id\n        firstName\n        lastName\n        streetName\n        streetNumber\n        additionalStreetInfo\n        postalCode\n        city\n        region\n        countryCode\n      }\n    }\n  }\n"], ["\n  mutation UpdateDeliveryAddress($input: SubscriptionAddressChangeInput!) {\n    updateSubscriptionDeliveryAddress(input: $input) {\n      deliveryAddress {\n        id\n        firstName\n        lastName\n        streetName\n        streetNumber\n        additionalStreetInfo\n        postalCode\n        city\n        region\n        countryCode\n      }\n    }\n  }\n"])));
var templateObject_1$b;

var useUpdateDeliveryAddress = function (subscriptionOrderId, userId) {
    var _a = __read(useMutation(UPDATE_DELIVERY_ADDRESS), 1), mutation = _a[0];
    return {
        updateDeliveryAddress: function (address) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mutation({
                            variables: {
                                input: {
                                    subscriptionOrderId: subscriptionOrderId,
                                    customerId: userId,
                                    address: address,
                                },
                            },
                            update: function (cache, _a) {
                                var data = _a.data;
                                var deliveryAddress = data.updateSubscriptionDeliveryAddress.deliveryAddress;
                                cache.writeFragment({
                                    id: "ProductSubscription:" + subscriptionOrderId,
                                    fragment: gql(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n              fragment DeliveryAddressFragment on ProductSubscription {\n                deliveryAddress {\n                  id\n                  firstName\n                  lastName\n                  streetName\n                  streetNumber\n                  additionalStreetInfo\n                  postalCode\n                  city\n                  region\n                  countryCode\n                }\n              }\n            "], ["\n              fragment DeliveryAddressFragment on ProductSubscription {\n                deliveryAddress {\n                  id\n                  firstName\n                  lastName\n                  streetName\n                  streetNumber\n                  additionalStreetInfo\n                  postalCode\n                  city\n                  region\n                  countryCode\n                }\n              }\n            "]))),
                                    data: {
                                        deliveryAddress: deliveryAddress,
                                    },
                                });
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    };
};
var templateObject_1$a;

var Deliveries = function (_a) {
    var className = _a.className, subscriptionOrderId = _a.subscriptionOrderId, addressSummary = _a.addressSummary, addressForm = _a.addressForm;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, locale = _b.locale;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _c = useDeliveries(subscriptionOrderId), data = _c.data, loading = _c.loading, error = _c.error;
    var updateDeliveryAddress = useUpdateDeliveryAddress(subscriptionOrderId, userId).updateDeliveryAddress;
    if (loading) {
        return (React.createElement("div", { className: "subscription-deliveries__loader" },
            React.createElement(Loader$1, null)));
    }
    if (error || !data) {
        return (React.createElement(Alert, { type: "error", message: getFormattedLabel('account.subscriptions.errors.general', { parseLink: true }) }));
    }
    var deliveries = data.deliveries, deliveryAddress = data.deliveryAddress;
    var tableProps = {
        showMoreCaption: getLabel("common.actions.showMore"),
        numberOfRows: deliveries.length,
        title: getLabel('account.subscription.detail.deliveryHistory'),
        columns: [
            {
                id: 'date',
                header: getLabel('common.date'),
                getRow: function (rowIndex) {
                    // TS control flow analysis issue workaround
                    var shippingDate = deliveries[rowIndex].shippingDate;
                    // if shippingDate is a string, it means the conversion to date
                    // bailed because of invalid data
                    return !!shippingDate && typeof shippingDate !== 'string' ? (React.createElement(DateTime, { locale: locale, dateTime: shippingDate })) : (getLabel('common.notAvailable'));
                },
            },
            {
                id: 'shipmentNumber',
                header: getLabel('account.subscription.detail.deliveryHistory.shipmentNumber'),
                getRow: function (rowIndex) {
                    return deliveries[rowIndex].shipmentNumber || getLabel('common.notAvailable');
                },
            },
            {
                id: 'tracking',
                header: getLabel('account.subscription.detail.deliveryHistory.tracking'),
                getRow: function (rowIndex) {
                    return !!deliveries[rowIndex].shipmentTrackingURL ? (React.createElement(Link, { url: deliveries[rowIndex].shipmentTrackingURL, target: "external" }, getLabel('account.subscription.detail.deliveryHistory.trackingLink'))) : (getLabel('common.notAvailable'));
                },
            },
            {
                id: 'status',
                header: getLabel('account.subscription.detail.delivery.status'),
                getRow: function (rowIndex) {
                    return getLabel("account.subscription.detail.delivery.status." + deliveries[rowIndex].status.toLowerCase());
                },
            },
        ],
    };
    return (React.createElement("div", { className: classnames('subscription-deliveries', className) },
        React.createElement(Heading, { variant: "smallest" }, getLabel('account.subscription.detail.deliveryDetails')),
        deliveryAddress && (React.createElement(EditableAddressSummary, { name: "deliveryAddress", title: getLabel("account.deliveryAddress"), address: deliveryAddress, addressSummary: addressSummary, addressForm: addressForm, mutate: updateDeliveryAddress, allowEditing: SubscriptionStatus$1.Cancelled !== data.subscriptionStatus })),
        deliveries.length ? (React.createElement(HistoryTable, __assign({}, tableProps, { className: "subscription-deliveries__delivery-history" }))) : null));
};

var InvoiceDetailsSummary = function (_a) {
    var title = _a.title, formatter = _a.formatter, invoiceDetails = _a.invoiceDetails;
    var templates = DefaultSummaryTemplates();
    var resolvedFormatter = formatter || templates[SummaryName.invoiceDetailsSummaryV2];
    return (React__default.createElement(Summary, { className: "invoice-details-summary" },
        React__default.createElement("div", { className: "invoice-details-summary__inner" },
            React__default.createElement("div", { className: "invoice-details-summary__content" },
                React__default.createElement(Heading, { variant: "subheading2", component: "span", className: "invoice-details-summary__title" }, title),
                resolvedFormatter({ data: removeUndefinedValues(invoiceDetails) })))));
};

var GET_SUBSCRIPTION_PAYMENTS = gql(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  query getSubscriptionPayments($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        billingAddress {\n          id\n          firstName\n          lastName\n          streetName\n          streetNumber\n          additionalStreetInfo\n          postalCode\n          city\n          region\n          countryCode\n          company\n        }\n        invoices {\n          invoiceId\n          billingDate\n          paymentStatus\n          paymentType\n          downloadToken\n          totalAmount {\n            currencyCode\n            centAmount\n          }\n        }\n        personalDetails {\n          certifiedEmail\n          dateOfBirth\n          ssn\n          certifiedRecipientCode\n          vatId\n        }\n        storedPaymentMethod {\n          ... on StoredCardPaymentMethod {\n            paymentToken\n            holderName\n            brand\n            expiryMonth\n            expiryYear\n            lastFour\n          }\n          ... on StoredSEPAPaymentMethod {\n            paymentToken\n            holderName\n            name\n            iban\n          }\n        }\n        status\n      }\n    }\n  }\n"], ["\n  query getSubscriptionPayments($id: ID!) {\n    me {\n      id\n      subscription(subscriptionOrderId: $id) {\n        id: subscriptionOrderId\n        billingAddress {\n          id\n          firstName\n          lastName\n          streetName\n          streetNumber\n          additionalStreetInfo\n          postalCode\n          city\n          region\n          countryCode\n          company\n        }\n        invoices {\n          invoiceId\n          billingDate\n          paymentStatus\n          paymentType\n          downloadToken\n          totalAmount {\n            currencyCode\n            centAmount\n          }\n        }\n        personalDetails {\n          certifiedEmail\n          dateOfBirth\n          ssn\n          certifiedRecipientCode\n          vatId\n        }\n        storedPaymentMethod {\n          ... on StoredCardPaymentMethod {\n            paymentToken\n            holderName\n            brand\n            expiryMonth\n            expiryYear\n            lastFour\n          }\n          ... on StoredSEPAPaymentMethod {\n            paymentToken\n            holderName\n            name\n            iban\n          }\n        }\n        status\n      }\n    }\n  }\n"])));
var templateObject_1$9;

var useSubscriptionPayments = function (id) {
    var _a;
    var _b = useQuery(GET_SUBSCRIPTION_PAYMENTS, {
        variables: { id: id },
    }), data = _b.data, loading = _b.loading, error = _b.error;
    var response = data;
    var subscription = (_a = response === null || response === void 0 ? void 0 : response.me) === null || _a === void 0 ? void 0 : _a.subscription;
    if (loading)
        return { data: undefined, loading: loading, error: error };
    if (!subscription)
        return { data: undefined, loading: false, error: undefined };
    return {
        data: {
            payments: {
                invoices: toInvoices(subscription.invoices),
                billingAddress: toBillingAddress(subscription.billingAddress, subscription.personalDetails.vatId),
                personalDetails: toSubscriptionPersonalDetails(subscription.personalDetails),
                storedPaymentMethod: toStoredPaymentMethod(subscription.storedPaymentMethod),
                status: toSubscriptionStatus(subscription.status),
            },
        },
        loading: loading,
        error: error,
    };
};

var UPDATE_BILLING_ADDRESS = gql(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  mutation UpdateBillingAddress($input: SubscriptionAddressChangeInput!) {\n    updateSubscriptionBillingAddress(input: $input) {\n      billingAddress {\n        id\n        firstName\n        lastName\n        streetName\n        streetNumber\n        additionalStreetInfo\n        postalCode\n        city\n        region\n        countryCode\n      }\n    }\n  }\n"], ["\n  mutation UpdateBillingAddress($input: SubscriptionAddressChangeInput!) {\n    updateSubscriptionBillingAddress(input: $input) {\n      billingAddress {\n        id\n        firstName\n        lastName\n        streetName\n        streetNumber\n        additionalStreetInfo\n        postalCode\n        city\n        region\n        countryCode\n      }\n    }\n  }\n"])));
var templateObject_1$8;

var useUpdateBillingAddress = function (subscriptionOrderId, userId) {
    var _a = __read(useMutation(UPDATE_BILLING_ADDRESS), 1), mutation = _a[0];
    return {
        updateBillingAddress: function (address) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mutation({
                            variables: {
                                input: {
                                    subscriptionOrderId: subscriptionOrderId,
                                    customerId: userId,
                                    address: address,
                                },
                            },
                            update: function (cache, _a) {
                                var data = _a.data;
                                var billingAddress = data.updateSubscriptionBillingAddress.billingAddress;
                                cache.writeFragment({
                                    id: "ProductSubscription:" + subscriptionOrderId,
                                    fragment: gql(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n              fragment BillingAddressFragment on ProductSubscription {\n                billingAddress {\n                  id\n                  firstName\n                  lastName\n                  streetName\n                  streetNumber\n                  additionalStreetInfo\n                  postalCode\n                  city\n                  region\n                  countryCode\n                }\n              }\n            "], ["\n              fragment BillingAddressFragment on ProductSubscription {\n                billingAddress {\n                  id\n                  firstName\n                  lastName\n                  streetName\n                  streetNumber\n                  additionalStreetInfo\n                  postalCode\n                  city\n                  region\n                  countryCode\n                }\n              }\n            "]))),
                                    data: {
                                        billingAddress: billingAddress,
                                    },
                                });
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    };
};
var templateObject_1$7;

var LABEL_PREFIX$3 = 'account.subscription.detail.payments';

var SepaIcon = 'https://cdn-test.grandvision.io/binaries/_ht_1617794409354/content/gallery/io-whitelabel/logos/payment-options/sepa.svg';
// Logo's from https://docs.adyen.com/online-payments/api-only/downloading-logos
var getCreditcardLogo = function (brand) {
    if (brand !== CardBrandName.Unknown)
        return "https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/small/" + brand + "@2x.png";
    return placeholderImage.url;
};
var getSepaLogo = function () {
    // this is introduced until the moment my-account has access to pageModel and the icon images are added to Bloomreach
    return SepaIcon;
};

// re-exported instead of defined because result types for FE should always
function isThreeDsChallenge(result) {
    return result.resultType === ResultType.THREE_DS_CHALLENGE;
}

var CREATE_STORED_CARD_PAYMENT = gql(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  mutation CreateStoredCardPayment($input: StoredCardPaymentMethodInput!) {\n    createStoredCardPaymentMethod(storedCardPaymentMethodInput: $input) {\n      code\n      message\n      success\n      storedPaymentResult {\n        ... on Payment3DSChallengeData {\n          action\n          resultType\n        }\n        ... on StoredPaymentSuccessData {\n          paymentToken\n          customerId\n          resultType\n        }\n        ... on StoredPaymentRefusedData {\n          resultType\n          refusalReasonCode\n        }\n        ... on PaymentRedirectData {\n          resultType\n          redirectUrl\n        }\n        ... on StoredPaymentErrorData {\n          resultType\n          code\n          message\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateStoredCardPayment($input: StoredCardPaymentMethodInput!) {\n    createStoredCardPaymentMethod(storedCardPaymentMethodInput: $input) {\n      code\n      message\n      success\n      storedPaymentResult {\n        ... on Payment3DSChallengeData {\n          action\n          resultType\n        }\n        ... on StoredPaymentSuccessData {\n          paymentToken\n          customerId\n          resultType\n        }\n        ... on StoredPaymentRefusedData {\n          resultType\n          refusalReasonCode\n        }\n        ... on PaymentRedirectData {\n          resultType\n          redirectUrl\n        }\n        ... on StoredPaymentErrorData {\n          resultType\n          code\n          message\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$6;

var useAddCreditCard = function (subscriptionOrderId) {
    var _a;
    var currency = useIntl().currency;
    var routes = useSelector(Selectors.getFormattedRoutes);
    var _b = __read(useMutation(CREATE_STORED_CARD_PAYMENT), 2), addCardMutation = _b[0], _c = _b[1], loading = _c.loading, data = _c.data, error = _c.error;
    var mutate = function (input) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addCardMutation({
                        variables: {
                            input: __assign(__assign({}, input), { currencyCode: currency, idempotencyKey: v4(), paymentReference: subscriptionOrderId, returnURL: "" + window.location.origin + (routes === null || routes === void 0 ? void 0 : routes.subscriptionsv2) + "/3ds-callback/" + subscriptionOrderId }),
                        },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var jsonAction = ((_a = data === null || data === void 0 ? void 0 : data.createStoredCardPaymentMethod) === null || _a === void 0 ? void 0 : _a.storedPaymentResult) &&
        isThreeDsChallenge(data.createStoredCardPaymentMethod.storedPaymentResult) &&
        data.createStoredCardPaymentMethod.storedPaymentResult.action;
    var action = jsonAction && JSON.parse(jsonAction);
    return { mutate: mutate, loading: loading, data: data, error: error, action: action };
};

var CREATE_STORED_SEPA_PAYMENT = gql(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  mutation CreateStoredSepaPaymentMethod(\n    $storedSepaPaymentMethodInput: StoredSepaPaymentMethodInput!\n  ) {\n    createStoredSepaPaymentMethod(storedSepaPaymentMethodInput: $storedSepaPaymentMethodInput) {\n      code\n      message\n      success\n      storedPaymentResult {\n        ... on Payment3DSChallengeData {\n          action\n          resultType\n        }\n        ... on PaymentRedirectData {\n          httpMethod\n          redirectUrl\n          resultType\n        }\n        ... on StoredPaymentErrorData {\n          code\n          message\n          resultType\n        }\n        ... on StoredPaymentRefusedData {\n          refusalReasonCode\n          resultType\n        }\n        ... on StoredPaymentSuccessData {\n          customerId\n          paymentToken\n          resultType\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateStoredSepaPaymentMethod(\n    $storedSepaPaymentMethodInput: StoredSepaPaymentMethodInput!\n  ) {\n    createStoredSepaPaymentMethod(storedSepaPaymentMethodInput: $storedSepaPaymentMethodInput) {\n      code\n      message\n      success\n      storedPaymentResult {\n        ... on Payment3DSChallengeData {\n          action\n          resultType\n        }\n        ... on PaymentRedirectData {\n          httpMethod\n          redirectUrl\n          resultType\n        }\n        ... on StoredPaymentErrorData {\n          code\n          message\n          resultType\n        }\n        ... on StoredPaymentRefusedData {\n          refusalReasonCode\n          resultType\n        }\n        ... on StoredPaymentSuccessData {\n          customerId\n          paymentToken\n          resultType\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$5;

var useAddSepa = function (subscriptionOrderId) {
    var currency = useIntl().currency;
    var routes = useSelector(Selectors.getFormattedRoutes);
    var _a = __read(useMutation(CREATE_STORED_SEPA_PAYMENT), 2), addSepaMutation = _a[0], _b = _a[1], loading = _b.loading, data = _b.data, error = _b.error;
    var mutate = function (input) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, addSepaMutation({
                        variables: {
                            storedSepaPaymentMethodInput: __assign(__assign({}, input), { currencyCode: currency, idempotencyKey: v4(), paymentReference: subscriptionOrderId, returnURL: window.location.origin + "/my-account/" + (routes === null || routes === void 0 ? void 0 : routes.subscriptionsv2) + "/" + subscriptionOrderId }),
                        },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return { mutate: mutate, loading: loading, data: data, error: error };
};

var isAddCreditCardInput = function (input) {
    return typeof input.encryptedExpiryYear !== 'undefined';
};
var isSepaInput = function (input) {
    return typeof input.iban !== 'undefined';
};
// In order to circumvent the limitation to conditionally load a hook, a MutationHooks is created
// that executes the hooks in the same order for every render. This wrapping hook then solely
// returns the results of the hook responsible for the required PaymentMethod.
var useMutationHook = function (paymentMethod, subscriptionId) {
    var creditMutation = useAddCreditCard(subscriptionId);
    var sepaMutation = useAddSepa(subscriptionId);
    switch (true) {
        case paymentMethod === PaymentType$1.CreditCard:
            return __assign(__assign({}, creditMutation), { mutate: function (input) {
                    return isAddCreditCardInput(input) ? creditMutation.mutate(input) : undefined;
                } });
        case paymentMethod === PaymentType$1.Sepa:
            return __assign(__assign({}, sepaMutation), { mutate: function (input) {
                    return isSepaInput(input) ? sepaMutation.mutate(input) : undefined;
                } });
        default:
            return undefined;
    }
};

var isCreditCardFormState = function (state) {
    return typeof state.data.encryptedExpiryMonth !== 'undefined';
};
var mapper$1 = function (state) { return ({
    browserInfoInput: state.data.browserInfo,
    holderName: state.data.holderName,
    encryptedCardNumber: state.data.encryptedCardNumber,
    encryptedExpiryMonth: state.data.encryptedExpiryMonth,
    encryptedExpiryYear: state.data.encryptedExpiryYear,
    encryptedSecurityCode: state.data.encryptedSecurityCode,
}); };

var isSepaFormState = function (state) {
    return typeof state.data['sepa.ibanNumber'] !== 'undefined';
};
var mapper = function (state) { return ({
    holderName: state.data['sepa.ownerName'],
    iban: state.data['sepa.ibanNumber'],
}); };

var getInputMapperFor = function (paymentMethod) {
    switch (true) {
        case paymentMethod === PaymentType$1.Sepa:
            return function (state) { return isSepaFormState(state) && mapper(state); };
        case paymentMethod === PaymentType$1.CreditCard:
            return function (state) {
                return isCreditCardFormState(state) && mapper$1(state);
            };
        default:
            return undefined;
    }
};

var createPaymentMethodIcon = function (method) {
    if (method === PaymentType$1.Sepa)
        return React__default.createElement("img", { className: "payment-method__radio-logo", src: getSepaLogo(), alt: "sepa" });
    return (React__default.createElement("img", { className: "payment-method__radio-logo", src: getCreditcardLogo(CardBrandName.NoCard), alt: "card" }));
};
var toRadioButtonGroupItems = function (labels, methods) {
    return methods.map(function (method) { return ({
        label: labels.paymentMethods[method],
        value: "" + PaymentType$1[method],
        aside: createPaymentMethodIcon(method),
    }); });
};
var toOnChange = function (fn) { return function (value) { return fn(PaymentType$1[value]); }; };
var toValue = function (method) { return PaymentType$1[method]; };
var AddPaymentMethodModal = function (_a) {
    var labels = _a.labels, isLoading = _a.isLoading, paymentMethods = _a.paymentMethods, selectedPaymentMethod = _a.selectedPaymentMethod, onSelectPaymentMethod = _a.onSelectPaymentMethod, onAddPaymentMethod = _a.onAddPaymentMethod, onClose = _a.onClose, action = _a.action;
    var _b = __read(React__default.useState(), 2), formState = _b[0], setFormState = _b[1];
    var _c = __read(React__default.useState(false), 2), hasErrors = _c[0], setHasErrors = _c[1];
    var config = useAdyen().config;
    var onSubmit = React__default.useCallback(function () {
        if (!formState || !formState.isValid)
            return setHasErrors(true);
        onAddPaymentMethod(formState);
    }, [onAddPaymentMethod, formState]);
    var onChange = React__default.useCallback(function (state) {
        setHasErrors(false);
        setFormState(state);
    }, [setHasErrors, setFormState]);
    var form = React__default.useMemo(function () {
        switch (selectedPaymentMethod) {
            case PaymentType$1.CreditCard:
                return React__default.createElement(CreditCard, { onChange: onChange, additionalOptions: config === null || config === void 0 ? void 0 : config.creditcard });
            case PaymentType$1.Sepa:
                return React__default.createElement(Sepa, { onChange: onChange });
            default:
                return null;
        }
    }, [selectedPaymentMethod, onChange, config === null || config === void 0 ? void 0 : config.creditcard]);
    return (React__default.createElement(Modal$2, { "data-t": "add-payment-method-modal", className: "add-payment-method-modal", title: labels.ctaCaption, isOpen: true, showIcon: true, onModalClose: onClose, footer: React__default.createElement(ModalFooter, { ctaCaption: labels.ctaCaption, onCta: onSubmit, ctaLoading: isLoading, onCancel: onClose }) },
        React__default.createElement(Text, null, labels.introduction),
        React__default.createElement(RadioButtonGroup, { scope: "paymentMethod", items: toRadioButtonGroupItems(labels, paymentMethods), initialValue: toValue(selectedPaymentMethod), onChange: toOnChange(onSelectPaymentMethod) }),
        hasErrors ? (React__default.createElement(ScrollIntoView, null,
            React__default.createElement(Alert, { type: "error", message: labels.errorMessages.formInvalid }))) : null,
        action ? React__default.createElement(ActionContainer, { action: action }) : form));
};

var LABEL_PREFIX$2 = 'account.addPayment';
var PAYMENT_METHODS = [PaymentType$1.CreditCard, PaymentType$1.Sepa];
var AddPaymentMethodModalContainer = function (_a) {
    var onClose = _a.onClose, subscriptionId = _a.subscriptionId;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var _c = __read(React__default.useState(PAYMENT_METHODS[0]), 2), selectedPaymentMethod = _c[0], setSelectedPaymentMethod = _c[1];
    var mutationHook = useMutationHook(selectedPaymentMethod, subscriptionId);
    var labels = React__default.useMemo(function () { return ({
        ctaCaption: getLabel(LABEL_PREFIX$2 + ".title"),
        introduction: getLabel(LABEL_PREFIX$2 + ".introduction"),
        paymentMethods: PAYMENT_METHODS.reduce(function (previous, current) {
            var _a;
            return (__assign(__assign({}, previous), (_a = {}, _a[current] = getLabel(LABEL_PREFIX$2 + ".paymentMethod." + PaymentType$1[current]), _a)));
        }, {}),
        errorMessages: {
            formInvalid: getFormattedLabel(LABEL_PREFIX$2 + ".error.invalidForm", { parseLink: true }),
        },
    }); }, [getLabel, getFormattedLabel]);
    var onSelectPaymentMethod = function (method) { return setSelectedPaymentMethod(method); };
    var onAddPaymentMethod = function (state) { return __awaiter(void 0, void 0, void 0, function () {
        var inputMapper, input;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    inputMapper = getInputMapperFor(selectedPaymentMethod);
                    if (!mutationHook || !inputMapper) {
                        toast.failed('common.error.network');
                        throw new Error('Unknown payment method');
                    }
                    if (!!mutationHook.loading) return [3 /*break*/, 2];
                    input = inputMapper(state);
                    if (!input)
                        return [2 /*return*/];
                    return [4 /*yield*/, mutationHook.mutate(input)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    React__default.useEffect(function () {
        if (mutationHook === null || mutationHook === void 0 ? void 0 : mutationHook.loading)
            return;
        if (mutationHook === null || mutationHook === void 0 ? void 0 : mutationHook.error) {
            return toast.failed(LABEL_PREFIX$2 + ".failed");
        }
        if ((mutationHook === null || mutationHook === void 0 ? void 0 : mutationHook.data) && !(mutationHook === null || mutationHook === void 0 ? void 0 : mutationHook.action)) {
            toast.success(LABEL_PREFIX$2 + ".success");
            onClose();
        }
    }, [mutationHook, onClose]);
    return (React__default.createElement(AddPaymentMethodModal, { labels: labels, isLoading: Boolean(mutationHook === null || mutationHook === void 0 ? void 0 : mutationHook.loading), paymentMethods: PAYMENT_METHODS, selectedPaymentMethod: selectedPaymentMethod, onSelectPaymentMethod: onSelectPaymentMethod, onAddPaymentMethod: onAddPaymentMethod, onClose: onClose, action: mutationHook === null || mutationHook === void 0 ? void 0 : mutationHook.action }));
};

var CHANGE_PAYMENT_METHOD = gql(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  mutation ChangePaymentMethod($input: ChangeSubscriptionStoredPaymentMethodInput!) {\n    changeSubscriptionStoredPaymentMethod(input: $input) {\n      storedPaymentMethod {\n        ... on StoredCardPaymentMethod {\n          holderName\n          name\n          paymentToken\n        }\n        ... on StoredSEPAPaymentMethod {\n          holderName\n          name\n          paymentToken\n        }\n      }\n    }\n  }\n"], ["\n  mutation ChangePaymentMethod($input: ChangeSubscriptionStoredPaymentMethodInput!) {\n    changeSubscriptionStoredPaymentMethod(input: $input) {\n      storedPaymentMethod {\n        ... on StoredCardPaymentMethod {\n          holderName\n          name\n          paymentToken\n        }\n        ... on StoredSEPAPaymentMethod {\n          holderName\n          name\n          paymentToken\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$4;

var useChangePaymentMethod = function () {
    var _a = __read(useMutation(CHANGE_PAYMENT_METHOD), 2), mutation = _a[0], loading = _a[1].loading;
    return {
        changePaymentMethod: function (paymentToken, subscriptionOrderId, userId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mutation({
                            variables: {
                                input: { paymentToken: paymentToken, subscriptionOrderId: subscriptionOrderId, customerId: userId },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        loading: loading,
    };
};

var toStoredPaymentMethods = function (raw) {
    return raw
        ? raw.map(function (paymentMethod) {
            switch (paymentMethod.paymentType) {
                case PaymentType.SEPA:
                    return toSepaPaymentMethod(paymentMethod);
                case PaymentType.CARD:
                default:
                    // default still tries to parse item as credit card to avoid breaking UI
                    return toCreditcardPaymentMethod(paymentMethod);
            }
        })
        : null;
};

var GET_STORED_PAYMENT_METHODS = gql(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  query storedPaymentMethods {\n    me {\n      storedPaymentMethods {\n        holderName\n        paymentToken\n        name\n        paymentType\n        ... on StoredCardPaymentMethod {\n          holderName\n          brand\n          expiryMonth\n          expiryYear\n          lastFour\n        }\n        ... on StoredSEPAPaymentMethod {\n          holderName\n          iban\n        }\n      }\n    }\n  }\n"], ["\n  query storedPaymentMethods {\n    me {\n      storedPaymentMethods {\n        holderName\n        paymentToken\n        name\n        paymentType\n        ... on StoredCardPaymentMethod {\n          holderName\n          brand\n          expiryMonth\n          expiryYear\n          lastFour\n        }\n        ... on StoredSEPAPaymentMethod {\n          holderName\n          iban\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$3;

var useGetStoredPaymentMethods = function () {
    var _a;
    var _b = useQuery(GET_STORED_PAYMENT_METHODS), data = _b.data, loading = _b.loading, error = _b.error;
    return {
        data: toStoredPaymentMethods((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.storedPaymentMethods),
        loading: loading,
        error: error,
    };
};

var SelectPaymentMethodModal = function (_a) {
    var changePaymentMethodLoading = _a.changePaymentMethodLoading, currentPaymentMethod = _a.currentPaymentMethod, labels = _a.labels, items = _a.items, onClose = _a.onClose, onAddPaymentMethod = _a.onAddPaymentMethod, handleChangePaymentMethod = _a.handleChangePaymentMethod;
    var _b = __read(React__default.useState(currentPaymentMethod.paymentToken), 2), selectedPaymentMethod = _b[0], setSelectedPaymentMethod = _b[1];
    var handleCtaClick = function () {
        handleChangePaymentMethod(selectedPaymentMethod);
    };
    var handleOnChange = function (selected) {
        setSelectedPaymentMethod(selected);
    };
    return (React__default.createElement(Modal$2, { "data-t": "payment-method-modal", className: "payment-method-modal", isOpen: true, onModalClose: onClose, showIcon: true, title: labels.modalTitle, footer: React__default.createElement(ModalFooter, { ctaCaption: labels.saveButton, onCta: function () { return handleCtaClick(); }, ctaLoading: changePaymentMethodLoading, onCancel: onClose }) },
        React__default.createElement("p", null, labels.info),
        React__default.createElement(RadioButtonGroup, { initialValue: currentPaymentMethod.paymentToken, scope: labels.modalTitle, onChange: handleOnChange, items: items }),
        React__default.createElement(Button, { className: "payment-method-modal__button-add", icon: "plus", variant: "outline", color: "primary", caption: labels.addButton, onClick: onAddPaymentMethod }),
        React__default.createElement("p", { className: "payment-method-modal__note" },
            React__default.createElement("span", { className: "payment-method-modal__note-text" },
                labels.pleaseNote,
                ":"),
            " ",
            labels.note)));
};

var LABEL_PREFIX$1 = 'account.subscription.detail.payments.paymentMethod';
var PaymentMethodModalContainer = function (_a) {
    var subscriptionId = _a.subscriptionId, currentPaymentMethod = _a.currentPaymentMethod, onClose = _a.onClose, onAddPaymentMethod = _a.onAddPaymentMethod;
    var getLabel = useIntl().getLabel;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _b = useGetStoredPaymentMethods(), data = _b.data, loading = _b.loading;
    var _c = useChangePaymentMethod(), changePaymentMethod = _c.changePaymentMethod, changePaymentMethodLoading = _c.loading;
    var handleChangePaymentMethod = function (paymentMethodToken) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (currentPaymentMethod.paymentToken === paymentMethodToken) {
                        onClose();
                        return [2 /*return*/, toast.success(containerLabels.toastSuccess)];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, changePaymentMethod(paymentMethodToken, subscriptionId, userId)];
                case 2:
                    _a.sent();
                    toast.success(containerLabels.toastSuccess);
                    onClose();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.networkError) {
                        return [2 /*return*/, toast.failed(containerLabels.toastNetworkError)];
                    }
                    return [2 /*return*/, toast.failed(containerLabels.toastError)];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var createCreditCardBrandLogo = function (item) {
        return (React__default.createElement("img", { className: "payment-method__radio-logo", src: getCreditcardLogo(item.brand), alt: item.brand }));
    };
    var createPaymentMethodLabel = function (lastFour, prefix) {
        return lastFour ? "" + prefix + lastFour : '';
    };
    var createSepaBrandLogo = function () {
        return React__default.createElement("img", { className: "payment-method__radio-logo", src: getSepaLogo(), alt: "sepa" });
    };
    var createCreditCardPaymentMethod = function (item) { return ({
        value: item.paymentToken,
        label: item.holderName,
        subtext: createPaymentMethodLabel(item.lastFour, ' **** **** **** '),
        aside: createCreditCardBrandLogo(item),
    }); };
    var createSepaPaymentMethod = function (item) { return ({
        value: item.paymentToken,
        label: item.holderName,
        subtext: createPaymentMethodLabel(item.lastFour, 'SEPA ******** '),
        aside: createSepaBrandLogo(),
    }); };
    var createPaymentMethodItem = function (item) {
        switch (item.paymentType) {
            case PaymentType$1.Sepa:
                return createSepaPaymentMethod(item);
            case PaymentType$1.CreditCard:
            default:
                // default still tries to parse item as credit card to avoid breaking UI
                return createCreditCardPaymentMethod(item);
        }
    };
    if (!data || loading)
        return React__default.createElement(Loader$1, null);
    var mappedPaymentMethodData = data.map(function (item) {
        return createPaymentMethodItem(item);
    });
    var labels = {
        pleaseNote: getLabel('account.common.pleaseNote'),
        modalTitle: getLabel(LABEL_PREFIX$1 + ".modal.title"),
        note: getLabel(LABEL_PREFIX$1 + ".modal.note"),
        info: getLabel(LABEL_PREFIX$1 + ".modal.info"),
        saveButton: getLabel(LABEL_PREFIX$1 + ".modal.button.save"),
        addButton: getLabel(LABEL_PREFIX$1 + ".modal.button.add"),
    };
    var containerLabels = {
        toastNetworkError: 'common.error.network',
        toastSuccess: LABEL_PREFIX$1 + ".modal.success",
        toastError: 'account.subscriptions.errors.general',
    };
    return (React__default.createElement(SelectPaymentMethodModal, { currentPaymentMethod: currentPaymentMethod, items: mappedPaymentMethodData, changePaymentMethodLoading: changePaymentMethodLoading, handleChangePaymentMethod: handleChangePaymentMethod, labels: labels, onClose: onClose, onAddPaymentMethod: onAddPaymentMethod }));
};

var Modal;
(function (Modal) {
    Modal[Modal["Select"] = 0] = "Select";
    Modal[Modal["Add"] = 1] = "Add";
})(Modal || (Modal = {}));
var PaymentMethodDetail = function (_a) {
    var currentPaymentMethod = _a.currentPaymentMethod, subscriptionId = _a.subscriptionId, subscriptionStatus = _a.subscriptionStatus;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var _c = __read(React__default.useState(null), 2), activeModal = _c[0], setActiveModal = _c[1];
    var renderModal = function (activeModal) {
        switch (activeModal) {
            case Modal.Select:
                return currentPaymentMethod ? (React__default.createElement(PaymentMethodModalContainer, { subscriptionId: subscriptionId, currentPaymentMethod: currentPaymentMethod, onClose: function () { return setActiveModal(null); }, onAddPaymentMethod: function () { return setActiveModal(Modal.Add); } })) : null;
            case Modal.Add:
                return (React__default.createElement(AddPaymentMethodModalContainer, { subscriptionId: subscriptionId, onClose: function () { return setActiveModal(null); } }));
            default:
                return null;
        }
    };
    var createCreditCardPaymentMethod = function (_a) {
        var paymentType = _a.paymentType, brand = _a.brand, lastFour = _a.lastFour, expiryMonth = _a.expiryMonth, expiryYear = _a.expiryYear;
        return (React__default.createElement("p", { className: "payment-method__details" },
            paymentType,
            React__default.createElement("span", null,
                React__default.createElement("img", { className: "payment-method__logo", src: getCreditcardLogo(brand), alt: brand }),
                lastFour && " **** **** **** " + lastFour),
            expiryMonth && expiryYear ? (React__default.createElement("span", { "data-t": "payment-method-card-expiration" }, getLabel(LABEL_PREFIX$3 + ".paymentMethod.expiryDate") + "\n        " + expiryMonth + "/" + expiryYear)) : null));
    };
    var createSepaPaymentMethod = function (_a) {
        var lastFour = _a.lastFour;
        return (React__default.createElement("p", { className: "payment-method__details" },
            "SEPA",
            React__default.createElement("span", null,
                React__default.createElement("img", { className: "payment-method__logo", src: getSepaLogo(), alt: "sepa" }),
                lastFour && " ******** " + lastFour)));
    };
    var renderCurrentPaymentMethod = function (item) {
        switch (true) {
            case isSepaPaymentType(item):
                return createSepaPaymentMethod(item);
            case isCreditCardPaymentType(item):
            default:
                // default still tries to parse item as credit card to avoid breaking UI
                return createCreditCardPaymentMethod(item);
        }
    };
    return (React__default.createElement("article", { className: "summary__container payment-method", "data-t": "payment-method-summary-container" },
        React__default.createElement(Heading, { component: "h3", variant: "subheading1" }, getLabel(LABEL_PREFIX$3 + ".paymentMethod.title")),
        !currentPaymentMethod ? (React__default.createElement(Alert, { message: getFormattedLabel(LABEL_PREFIX$3 + ".paymentMethod.noPaymentMethod", {
                parseLink: true,
            }) })) : (React__default.createElement(React__default.Fragment, null,
            (subscriptionStatus === SubscriptionStatus$1.Active ||
                subscriptionStatus === SubscriptionStatus$1.Suspended) && (React__default.createElement(IconButton, { className: "payment-method__icon-button", "aria-label": "Edit payment method", onClick: function () { return setActiveModal(Modal.Select); } },
                React__default.createElement(Icon, { name: "pencil", width: 20, height: 20 }))),
            renderModal(activeModal),
            renderCurrentPaymentMethod(currentPaymentMethod)))));
};

var RETRY_SUBSCRIPTION_PAYMENT = gql(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  mutation RetrySubscriptionPayment($input: RetrySubscriptionPaymentInput!) {\n    retrySubscriptionPayment(input: $input) {\n      status\n      message\n    }\n  }\n"], ["\n  mutation RetrySubscriptionPayment($input: RetrySubscriptionPaymentInput!) {\n    retrySubscriptionPayment(input: $input) {\n      status\n      message\n    }\n  }\n"])));
var templateObject_1$2;

var useRetrySubscriptionPayment = function (invoiceId, subscriptionOrderId, userId) {
    var _a = __read(useMutation(RETRY_SUBSCRIPTION_PAYMENT), 2), mutation = _a[0], loading = _a[1].loading;
    return {
        retrySubscriptionPayment: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, mutation({
                            variables: {
                                input: { invoiceId: invoiceId, subscriptionOrderId: subscriptionOrderId, customerId: userId },
                            },
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        loading: loading,
    };
};

var RetryPaymentModal = function (_a) {
    var _b, _c;
    var invoice = _a.invoice, onClose = _a.onClose, subscriptionOrderId = _a.subscriptionOrderId;
    var _d = useIntl(), getFormattedLabel = _d.getFormattedLabel, getLabel = _d.getLabel, locale = _d.locale;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _e = useRetrySubscriptionPayment(invoice.id, subscriptionOrderId, userId), retrySubscriptionPayment = _e.retrySubscriptionPayment, loading = _e.loading;
    var handleRetryPayment = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, retrySubscriptionPayment()];
                case 1:
                    _a.sent();
                    toast.success(LABEL_PREFIX$3 + ".paymentDetails.success");
                    onClose();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    if (error_1 === null || error_1 === void 0 ? void 0 : error_1.networkError) {
                        return [2 /*return*/, toast.failed('common.error.network')];
                    }
                    return [2 /*return*/, toast.failed(LABEL_PREFIX$3 + ".paymentDetails.lastPaymentFailed.title")];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React__default.createElement(Modal$2, { className: "retry-subscription-payment", "data-t": "modal", isOpen: true, onModalClose: onClose, showIcon: true, title: getLabel(LABEL_PREFIX$3 + ".paymentDetails.retry"), footer: React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Button, { caption: getLabel(LABEL_PREFIX$3 + ".paymentDetails.retry"), className: "retry-subscription-payment__button", "data-t": "retry-button", isLoading: loading, key: "retry-button", onClick: handleRetryPayment, variant: "solid" }),
            React__default.createElement(Button, { caption: getLabel("common.actions.cancel"), className: "retry-subscription-payment__button", "data-t": "cancel-button", key: "cancel-button", onClick: onClose, variant: "outline" })) },
        React__default.createElement("p", null, getFormattedLabel(LABEL_PREFIX$3 + ".paymentDetails.sureToRetryPayment", {
            parseHTML: true,
            labelData: {
                amount: formatPrice(locale, ((_b = invoice.totalAmount) === null || _b === void 0 ? void 0 : _b.centAmount) || 0, (_c = invoice.totalAmount) === null || _c === void 0 ? void 0 : _c.currencyCode, true),
            },
        }))));
};

var Payments = function (_a) {
    var addressForm = _a.addressForm, addressSummary = _a.addressSummary, businessAddressForm = _a.businessAddressForm, className = _a.className, invoiceDetailsSummary = _a.invoiceDetailsSummary, subscriptionOrderId = _a.subscriptionOrderId;
    var apiConfig = useApiConfig();
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel, locale = _b.locale;
    var userId = useSelector(Selectors.getUserId) || 'No customer ID found';
    var _c = useSubscriptionPayments(subscriptionOrderId), data = _c.data, loading = _c.loading, error = _c.error;
    var updateBillingAddress = useUpdateBillingAddress(subscriptionOrderId, userId).updateBillingAddress;
    var _d = __read(React__default.useState(null), 2), activeInvoice = _d[0], setActiveInvoice = _d[1];
    var paymentMethod = (data === null || data === void 0 ? void 0 : data.payments.storedPaymentMethod) || null;
    var openModal = function (invoice) { return setActiveInvoice(invoice); };
    var closeModal = function () { return setActiveInvoice(null); };
    var DOWNLOAD_URL = apiConfig.subscriptionsUrl + "/download/invoice";
    var invoices = data === null || data === void 0 ? void 0 : data.payments.invoices;
    var sortedInvoices = React__default.useMemo(function () {
        if (!invoices)
            return [];
        return __spreadArray([], __read(invoices)).sort(function (a, b) {
            return DateUtils.sortDesc(new Date(a.billingDate), new Date(b.billingDate));
        });
    }, [invoices]);
    if (loading) {
        return (React__default.createElement("div", { className: "subscription-payments__loader" },
            React__default.createElement(Loader$1, null)));
    }
    if (error || !data) {
        return (React__default.createElement(Alert, { type: "error", title: getFormattedLabel('account.subscriptions.errors.general', { parseLink: true }) }));
    }
    var _e = data.payments, billingAddress = _e.billingAddress, personalDetails = _e.personalDetails;
    var hasLastPaymentFailed = sortedInvoices.length && sortedInvoices[0].status === PaymentStatus$1.Failed;
    var tableProps = {
        showMoreCaption: getLabel("common.actions.showMore"),
        numberOfRows: sortedInvoices.length,
        title: getLabel(LABEL_PREFIX$3 + ".paymentHistory.title"),
        columns: [
            {
                id: 'date',
                header: getLabel('common.date'),
                getRow: function (rowIndex) { return (React__default.createElement(DateTime, { locale: locale, dateTime: sortedInvoices[rowIndex].billingDate })); },
            },
            {
                id: 'provider',
                header: getLabel('common.payment.provider'),
                getRow: function (rowIndex) {
                    return sortedInvoices[rowIndex].paymentType;
                },
            },
            {
                id: 'amount',
                header: getLabel('common.amount'),
                getRow: function (rowIndex) {
                    var price = sortedInvoices[rowIndex].totalAmount;
                    if (!price) {
                        return null;
                    }
                    return React__default.createElement(Price, { value: price.centAmount, currency: price.currencyCode });
                },
            },
            {
                id: 'status',
                header: getLabel('common.status'),
                getRow: function (rowIndex) {
                    var status = sortedInvoices[rowIndex].status.toLowerCase();
                    return React__default.createElement("span", { className: "status--" + status }, getLabel("common.status." + status));
                },
            },
            {
                id: 'action',
                header: '',
                getRow: function (rowIndex) {
                    return sortedInvoices[rowIndex].status === PaymentStatus$1.Failed ? (
                    // TODO: Add plain button once it has been implemented
                    React__default.createElement(Button, { variant: "ghost", className: "subscription-payments__button-retry status--failed strong", onClick: function () { return openModal(sortedInvoices[rowIndex]); }, caption: getLabel(LABEL_PREFIX$3 + ".paymentDetails.retry") })) : (React__default.createElement(Link, { target: "external", download: sortedInvoices[rowIndex].id + ".pdf", url: DOWNLOAD_URL + "/" + sortedInvoices[rowIndex].downloadToken }, getLabel("common.payment.downloadInvoice")));
                },
            },
        ],
    };
    return (React__default.createElement("section", { className: classnames('subscription-payments', className) },
        Boolean(hasLastPaymentFailed) && (React__default.createElement(Alert, { type: "error", icon: "alert-circle", notifyScreenReader: false, title: getFormattedLabel(LABEL_PREFIX$3 + ".paymentDetails.lastPaymentFailed", {
                parseLink: true,
            }) })),
        activeInvoice && (React__default.createElement(RetryPaymentModal, { invoice: activeInvoice, onClose: closeModal, subscriptionOrderId: subscriptionOrderId })),
        React__default.createElement("div", { className: classnames('subscription-payments__payment-details', className) },
            React__default.createElement(Heading, { variant: "smallest" }, getLabel(LABEL_PREFIX$3 + ".paymentDetails.title")),
            billingAddress && (React__default.createElement(EditableAddressSummary, { name: "billingAddress", title: getLabel("account.billingAddress"), address: billingAddress, addressSummary: addressSummary, addressForm: billingAddress.company ? businessAddressForm : addressForm, mutate: updateBillingAddress })),
            ((personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.certifiedEmail) || (personalDetails === null || personalDetails === void 0 ? void 0 : personalDetails.certifiedRecipientCode)) && (React__default.createElement(InvoiceDetailsSummary, { title: getLabel("account.invoiceDetails.title"), invoiceDetails: {
                    certifiedEmail: personalDetails.certifiedEmail,
                    certifiedRecipientCode: personalDetails.certifiedRecipientCode,
                    vatId: personalDetails.vatId,
                }, formatter: invoiceDetailsSummary })),
            React__default.createElement(PaymentMethodDetail, { currentPaymentMethod: paymentMethod, subscriptionId: subscriptionOrderId, subscriptionStatus: data === null || data === void 0 ? void 0 : data.payments.status })),
        Boolean(sortedInvoices.length) && React__default.createElement(HistoryTable, __assign({}, tableProps))));
};

var SubscriptionDetail = function (_a) {
    var className = _a.className, tabLabels = _a.tabLabels, subscriptionOrderId = _a.subscriptionOrderId, addressSummary = _a.addressSummary, invoiceDetailsSummary = _a.invoiceDetailsSummary, addressForm = _a.addressForm, businessAddressForm = _a.businessAddressForm;
    var _b = __read(useState(0), 2), activeTabIndex = _b[0], setActiveTabIndex = _b[1];
    return (React__default.createElement("div", { className: classnames('subscription-details__tabs', className) },
        React__default.createElement(SubscriptionNotifications, { subscriptionOrderId: subscriptionOrderId }),
        React__default.createElement(Tabs, { onChange: setActiveTabIndex, activeTabIndex: activeTabIndex },
            React__default.createElement(Tab, { label: tabLabels.currentPlan }),
            React__default.createElement(Tab, { label: tabLabels.deliveryDetails }),
            React__default.createElement(Tab, { label: tabLabels.paymentDetails })),
        React__default.createElement("div", { className: "subscription-details__body" },
            activeTabIndex === 0 && (React__default.createElement(CurrentPlan, { subscriptionOrderId: subscriptionOrderId, className: "subscription-details__tab" })),
            activeTabIndex === 1 && (React__default.createElement(Deliveries, { subscriptionOrderId: subscriptionOrderId, className: "subscription-details__tab", addressSummary: addressSummary, addressForm: addressForm })),
            activeTabIndex === 2 && (React__default.createElement(Payments, { subscriptionOrderId: subscriptionOrderId, addressSummary: addressSummary, invoiceDetailsSummary: invoiceDetailsSummary, addressForm: addressForm, businessAddressForm: businessAddressForm })))));
};

var LABEL_PREFIX = 'account.subscription.details';
var SubscriptionDetailContainer = function (_a) {
    var className = _a.className, subscriptionOrderId = _a.subscriptionOrderId, addressSummary = _a.addressSummary, invoiceDetailsSummary = _a.invoiceDetailsSummary, addressForm = _a.addressForm, businessAddressForm = _a.businessAddressForm, breadcrumbs = _a.breadcrumbs;
    var getLabel = useIntl().getLabel;
    var items = breadcrumbs !== null && breadcrumbs !== void 0 ? breadcrumbs : [
        { name: getLabel("account.menu.subscriptions"), routeKey: RouteKey.SubscriptionsV2 },
        { name: getLabel(LABEL_PREFIX + ".title") },
    ];
    var tabLabels = {
        currentPlan: getLabel(LABEL_PREFIX + ".tabs.currentPlan"),
        deliveryDetails: getLabel(LABEL_PREFIX + ".tabs.deliveryDetails"),
        paymentDetails: getLabel(LABEL_PREFIX + ".tabs.paymentDetails"),
    };
    return (React.createElement(ModalContextProvider, { subscriptionOrderId: subscriptionOrderId },
        React.createElement("div", { className: classnames('subscription-details', className) },
            React.createElement(MyAccountBreadcrumbs$1, { items: items }),
            React.createElement(Heading, { variant: "small", className: "myaccount-page-title subscription-details__title" }, getLabel(LABEL_PREFIX + ".title")),
            React.createElement(SubscriptionDetail, { tabLabels: tabLabels, subscriptionOrderId: subscriptionOrderId, addressSummary: addressSummary, invoiceDetailsSummary: invoiceDetailsSummary, addressForm: addressForm, businessAddressForm: businessAddressForm })),
        React.createElement(Modals, null)));
};

var isUnknownObject = function (x) {
    return x !== null && typeof x === 'object';
};
var to3DSecureParams = function (postParams) {
    return isUnknownObject(postParams) &&
        'MD' in postParams &&
        typeof postParams.MD === 'string' &&
        'PaRes' in postParams &&
        typeof postParams.PaRes === 'string'
        ? { MD: postParams.MD, PaRes: postParams.PaRes }
        : undefined;
};

var COMPLETE_3DS_CHALLENGE = gql(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  mutation complete3DSChallengeFlowStoredPayment(\n    $input: Completed3DSChallengeInput!\n    $redirectToken: String!\n  ) {\n    complete3DSChallengeFlowStoredPayment(\n      completed3DSChallengeInput: $input\n      redirectToken: $redirectToken\n    ) {\n      code\n      message\n      success\n      completedPaymentResultData {\n        ... on StoredPaymentSuccessData {\n          paymentToken\n          customerId\n          resultType\n        }\n        ... on StoredPaymentRefusedData {\n          resultType\n          refusalReasonCode\n        }\n        ... on StoredPaymentErrorData {\n          resultType\n          code\n          message\n        }\n      }\n    }\n  }\n"], ["\n  mutation complete3DSChallengeFlowStoredPayment(\n    $input: Completed3DSChallengeInput!\n    $redirectToken: String!\n  ) {\n    complete3DSChallengeFlowStoredPayment(\n      completed3DSChallengeInput: $input\n      redirectToken: $redirectToken\n    ) {\n      code\n      message\n      success\n      completedPaymentResultData {\n        ... on StoredPaymentSuccessData {\n          paymentToken\n          customerId\n          resultType\n        }\n        ... on StoredPaymentRefusedData {\n          resultType\n          refusalReasonCode\n        }\n        ... on StoredPaymentErrorData {\n          resultType\n          code\n          message\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$1;

var AddPaymentMethodCallback = function (_a) {
    var postParams = _a.postParams, onComplete = _a.onComplete;
    var _b = __read(useMutation(COMPLETE_3DS_CHALLENGE), 2), completeChallenge = _b[0], _c = _b[1], data = _c.data, error = _c.error, loading = _c.loading;
    React.useEffect(function () {
        // Don't attempt to parse the QS or run the mutation server side
        if (typeof window !== 'undefined') {
            var query_1 = QueryString.parse(window.location.search.substring(1));
            var adyenPostparams = to3DSecureParams(postParams);
            var runMutation = function (input) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, completeChallenge({
                                variables: {
                                    redirectToken: query_1.redirectToken,
                                    input: input,
                                },
                            })];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); };
            if (adyenPostparams && query_1.redirectToken && !loading) {
                runMutation(adyenPostparams);
            }
            else {
                toast.failed('account.addPayment.failed');
                onComplete();
            }
        }
        // Run callback only a single time
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    React.useEffect(function () {
        if (loading)
            return;
        if (data) {
            toast.success('account.addPayment.success');
            onComplete();
        }
        if (error) {
            toast.failed('account.addPayment.failed');
            onComplete();
        }
    }, [data, error, loading, onComplete]);
    return React.createElement(LoaderScreen, { height: 50 });
};

var BenefitsList$1 = function (_a) {
    var items = _a.items, className = _a.className;
    return (React.createElement("ul", { className: classnames('benefits-list', className) }, items.map(function (item) { return (React.createElement("li", { className: "benefits-list__item", key: item.title },
        React.createElement(Icon, { name: item.iconName, className: "benefits-list__icon" }),
        React.createElement("p", { className: "benefits-list__title" },
            React.createElement("strong", null, item.title)),
        React.createElement("p", { className: "benefits-list__subtitle" }, item.subtitle))); })));
};

/*
 * This is hardcoded content for VisionExpress UK and IE.
 * In the future, this content should come from Bloomreach instead.
 */
var hardCodedUspList = [
    'Free solutions for monthly lenses',
    'Manage your subscription online',
    'Free trials of the latest products',
    'Free replacement lenses',
];
var hardCodedBenefitsList = [
    {
        iconName: 'eye-test',
        title: 'Free annual eye test',
        subtitle: 'Including free retinal photography',
    },
    {
        iconName: 'discount-bubble',
        title: '50% off',
        subtitle: 'Glasses and prescription and non-prescription sunglasses',
    },
    {
        iconName: 'truck',
        title: 'Free home delivery',
        subtitle: "Never be left out of your lenses, we'll deliver them to your door",
    },
    {
        iconName: 'business',
        title: 'Free service',
        subtitle: 'Free expert aftercare service',
    },
];
var NoSubscriptions$1 = function () {
    var _a = useIntl(), getLabel = _a.getLabel, getFormattedLabel = _a.getFormattedLabel, hasLabel = _a.hasLabel;
    return (React.createElement("div", { className: "no-subscriptions" },
        hasLabel('account.noSubscriptions.help') && (React.createElement("p", { className: "no-subscriptions__help" }, getFormattedLabel('account.noSubscriptions.help', { parseHTML: true }))),
        React.createElement("p", { className: "no-subscriptions__description" }, getLabel('account.noSubscriptions.description')),
        React.createElement("section", null,
            React.createElement(Heading, { variant: "smallest", component: "h2" }, getLabel('account.noSubscriptions.benefits.title')),
            React.createElement(BenefitsList$1, { className: "no-subscriptions__benefits-list", items: hardCodedBenefitsList })),
        React.createElement(Hr, null),
        React.createElement("section", null,
            React.createElement(List, { className: "no-subscriptions__checkmark-list", icon: "checkmark", items: hardCodedUspList }))));
};

var SubscriptionList$1 = /** @class */ (function (_super) {
    __extends(SubscriptionList, _super);
    function SubscriptionList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriptionList.prototype.componentDidMount = function () {
        this.props.fetchList();
    };
    SubscriptionList.prototype.render = function () {
        var _a = this.props, intl = _a.intl, list = _a.list, onNavigate = _a.onNavigate, routes = _a.routes;
        var ROUTE_KEY = RouteKey.Subscriptions;
        var routeLabel = intl.getLabel("account.menu." + ROUTE_KEY);
        if (statusUninit(list) || statusLoading(list)) {
            return React.createElement(Loader$1, null);
        }
        if (statusSuccess(list)) {
            if (list.result.length) {
                var route = !!routes && !!routes.subscriptions ? routes.subscriptions : ROUTE_KEY;
                var url_1 = new URL("" + window.location.origin + route + "/" + list.result[0].id);
                // This ugly hack is necessary because onNavigate directly calls setState in the parent,
                // which can't be called during this render so we have to pop it on the end of the event loop
                setTimeout(function () { return onNavigate(url_1); });
                return null;
            }
            var subscriptionsList = list.result;
            return !!subscriptionsList.length ? (React.createElement(Loader$1, null)) : (React.createElement("div", { className: "subscription-list" },
                React.createElement(MyAccountBreadcrumbs$1, { items: [{ name: routeLabel, routeKey: ROUTE_KEY }] }),
                React.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title subscription-list__title" }, intl.getLabel('account.subscription.list.title')),
                React.createElement(NoSubscriptions$1, null)));
        }
        else {
            return React.createElement(Alert, { type: "error", title: intl.getLabel('account.subscriptions.errors.general') });
        }
    };
    return SubscriptionList;
}(React.Component));
var WrappedWithIntl = withIntl(SubscriptionList$1);
var mapStateToProps$2 = function (state) { return ({
    list: getSubscriptionList(state),
    routes: Selectors.getFormattedRoutes(state),
}); };
var mapDispatchToProps$2 = {
    fetchList: fetchList,
};
var SubscriptionList$2 = connect(mapStateToProps$2, mapDispatchToProps$2)(WrappedWithIntl);

var GET_MY_SUBSCRIPTIONS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query getMySubscriptions($locale: Locale!) {\n    me {\n      id\n      subscriptions {\n        ...SubscriptionListFragment\n      }\n    }\n  }\n  ", "\n"], ["\n  query getMySubscriptions($locale: Locale!) {\n    me {\n      id\n      subscriptions {\n        ...SubscriptionListFragment\n      }\n    }\n  }\n  ", "\n"])), SubscriptionListFragment);
var templateObject_1;

var useGetMySubscriptions = function () {
    var _a;
    var locale = useIntl().locale;
    var _b = useQuery(GET_MY_SUBSCRIPTIONS, { variables: { locale: locale } }), data = _b.data, loading = _b.loading, error = _b.error;
    var subscriptions = (((_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.subscriptions) || []).map(toSubscriptionList);
    return { data: { subscriptions: subscriptions }, loading: loading, error: error };
};

var BenefitsList = function (_a) {
    var items = _a.items, className = _a.className;
    return (React.createElement("ul", { className: classnames('benefits-list', className) }, items.map(function (item) { return (React.createElement("li", { className: "benefits-list__item", key: item.title },
        React.createElement(Icon, { width: 40, height: 40, name: item.iconName, className: "benefits-list__icon" }),
        React.createElement("p", { className: "benefits-list__title" },
            React.createElement("strong", null, item.title)),
        React.createElement("p", { className: "benefits-list__subtitle" }, item.subtitle))); })));
};

var NoSubscriptions = function (_a) {
    var subscriptionContactLensProductsUrl = _a.subscriptionContactLensProductsUrl, _b = _a.benefitsList, benefitsList = _b === void 0 ? [] : _b, items = _a.items, labels = _a.labels, showHelp = _a.showHelp;
    var title = labels.title, help = labels.help, description = labels.description, button = labels.button;
    return (React.createElement(React.Fragment, null,
        React.createElement(MyAccountBreadcrumbs$1, { items: items }),
        React.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title subscription-list__title" }, title),
        React.createElement("div", { className: "no-subscriptions" },
            showHelp && React.createElement("p", { className: "no-subscriptions__help" }, help),
            React.createElement("p", { className: "no-subscriptions__description" }, description),
            React.createElement(Button, { className: "no-subscriptions__action-button", variant: "solid", color: "primary", caption: button, href: subscriptionContactLensProductsUrl }),
            React.createElement("section", null,
                React.createElement(BenefitsList, { className: "no-subscriptions__benefits-list", items: benefitsList }),
                React.createElement(Hr, null)))));
};

var SubscriptionListItem = function (_a) {
    var route = _a.route, labels = _a.labels, subscription = _a.subscription, onNavigate = _a.onNavigate;
    var href = route + "/" + subscription.id;
    var onClick = function (e) {
        e.preventDefault();
        var url = new URL("" + window.location.origin + href);
        onNavigate(url);
        window.scrollTo(0, 0);
    };
    var dispatch = useModalContext().dispatch;
    var onResumeSubscription = useCallback(function (modal) { return function () {
        dispatch(Actions.setSubscriptionOrderId(subscription.id));
        dispatch(Actions.setActiveModal(modal));
    }; }, [dispatch, subscription.id]);
    return (React__default.createElement(SummaryContainer, { className: "subscription-list-item" },
        React__default.createElement(SubscriptionHeaderContainer, { status: subscription.status, totalPrice: subscription.totalPrice, billingFrequency: subscription.billingFrequency, deliveryFrequency: subscription.deliveryFrequency }),
        subscription.status === SubscriptionStatus$1.Suspended && !subscription.statusReason && (React__default.createElement(Button, { className: "subscription-list-item__action subscription-list-item__resume", size: "small", caption: labels.resumeSubscriptionButton, onClick: onResumeSubscription(Modal$1.Resume) })),
        React__default.createElement(Hr, null),
        (subscription.subscriptionProducts || []).map(function (subscriptionProduct, index) { return (React__default.createElement(React__default.Fragment, { key: index },
            index > 0 && React__default.createElement(Hr, null),
            React__default.createElement(SubscriptionLineItemContainer, { deliveryFrequency: subscription.deliveryFrequency, subscriptionProduct: subscriptionProduct }))); }),
        React__default.createElement(Hr, null),
        React__default.createElement("a", { onClick: onClick, className: "subscription-list-item__link", href: href, "data-t": "subscription-list-item-link" },
            React__default.createElement("span", null, labels.viewDetails),
            React__default.createElement(Icon, { name: "chevron-right" }))));
};

var SubscriptionList = function (_a) {
    var route = _a.route, subscriptionContactLensProductsUrl = _a.subscriptionContactLensProductsUrl, breadcrumbs = _a.breadcrumbs, labels = _a.labels, subscriptions = _a.subscriptions, onNavigate = _a.onNavigate;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(MyAccountBreadcrumbs$1, { items: breadcrumbs }),
        React__default.createElement(Heading, { variant: "small", className: "myaccount-page-title subscription-details__title" }, labels.title),
        React__default.createElement("div", { className: "subscription-list__add-subscription" },
            React__default.createElement("p", { className: "subscription-list__add-subscription__text" }, labels.addSubscription),
            React__default.createElement(Button, { href: subscriptionContactLensProductsUrl, size: "small", caption: labels.addSubscriptionButton })),
        subscriptions.map(function (subscription) { return (React__default.createElement(SubscriptionListItem, { key: subscription.id, route: route, labels: labels, subscription: subscription, onNavigate: onNavigate })); }),
        React__default.createElement(Modals, null)));
};

var SubscriptionListContainer = function (_a) {
    var _b;
    var route = _a.route, subscriptionContactLensProductsUrl = _a.subscriptionContactLensProductsUrl, benefitsList = _a.benefitsList, onNavigate = _a.onNavigate;
    var _c = useIntl(), getLabel = _c.getLabel, getFormattedLabel = _c.getFormattedLabel, hasLabel = _c.hasLabel;
    var _d = useGetMySubscriptions(), data = _d.data, loading = _d.loading, error = _d.error;
    var subscriptions = (_b = data === null || data === void 0 ? void 0 : data.subscriptions) !== null && _b !== void 0 ? _b : [];
    var routeLabel = getLabel("account.menu.subscriptions");
    var breadcrumbs = [{ name: routeLabel }];
    var userNotFoundError = (error === null || error === void 0 ? void 0 : error.message) === USER_NOT_FOUND_ERROR;
    var labels = {
        addSubscription: getLabel('account.subscription.addNew'),
        addSubscriptionButton: getLabel('account.subscription.addNew.button'),
        title: getLabel('account.subscription.list.title'),
        help: getFormattedLabel('account.noSubscriptions.help', { parseHTML: true }),
        description: getLabel('account.noSubscriptions.description'),
        button: getLabel('account.subscription.action.noSubscriptions'),
        viewDetails: getLabel('account.common.viewDetails'),
        resumeSubscriptionButton: getLabel('account.subscription.detail.currentPlan.resume.resumeButtonCaption'),
    };
    if (error && !userNotFoundError) {
        return (React__default.createElement(Alert, { type: "error", message: getFormattedLabel('account.subscriptions.errors.general', { parseLink: true }) }));
    }
    if (loading) {
        return React__default.createElement(Loader$1, null);
    }
    if (subscriptions.length < 1) {
        return (React__default.createElement(NoSubscriptions, { items: breadcrumbs, labels: labels, subscriptionContactLensProductsUrl: subscriptionContactLensProductsUrl, benefitsList: benefitsList, showHelp: hasLabel('account.noSubscriptions.help') }));
    }
    return (React__default.createElement(ModalContextProvider, null,
        React__default.createElement(SubscriptionList, { route: route, subscriptionContactLensProductsUrl: subscriptionContactLensProductsUrl, breadcrumbs: breadcrumbs, labels: labels, subscriptions: subscriptions, onNavigate: onNavigate })));
};

var UnlinkView = function (_a) {
    var viewType = _a.viewType, unlinkedItemId = _a.unlinkedItemId, unlinkType = _a.unlinkType;
    var _b = useIntl(), getLabel = _b.getLabel, getFormattedLabel = _b.getFormattedLabel;
    var titleLabel = viewType === 'success' ? "account." + unlinkType + ".success.title" : "account." + unlinkType + ".title";
    if (!viewType) {
        return React.createElement(Loader$1, null);
    }
    else {
        return (React.createElement("div", { className: "unlink-view", "data-t": "unlink-view" },
            React.createElement(Heading, { variant: "small", component: "h1", className: "myaccount-page-title unlink-view__title" }, getLabel(titleLabel)),
            viewType === 'success' && (React.createElement("p", null, getFormattedLabel("account." + unlinkType + ".success.message", {
                labelData: { unlinkedItemId: unlinkedItemId },
                parseLink: true,
            }))),
            viewType === 'failed' && (React.createElement(Alert, { type: "error", icon: "alert-circle", title: getLabel("account." + unlinkType + ".error.title"), message: getFormattedLabel("account." + unlinkType + ".error.message", {
                    labelData: { unlinkedItemId: unlinkedItemId },
                    parseLink: true,
                }) }))));
    }
};

var UnlinkAppointmentContainer = function (_a) {
    var isSuccessPage = _a.isSuccessPage, _b = _a.appointmentId, appointmentId = _b === void 0 ? '' : _b, appointmentToken = _a.appointmentToken;
    var dispatch = useDispatch();
    var unlinkAppointmentCall = useSelector(getUnlinkAppointmentCall);
    var viewType = useMemo(function () {
        if (isSuccessPage) {
            return 'success';
        }
        else {
            return statusFailed(unlinkAppointmentCall) ? 'failed' : undefined;
        }
    }, [isSuccessPage, unlinkAppointmentCall]);
    useEffect(function () {
        if (!isSuccessPage) {
            if (appointmentToken) {
                dispatch(unlinkAppointment({
                    appointmentToken: appointmentToken,
                    appointmentId: appointmentId,
                }));
            }
            else {
                dispatch(unlinkAppointmentFailed(new Error('Cannot unlink an appointment without an appointmentToken')));
            }
        }
    }, [isSuccessPage, appointmentToken, unlinkAppointment]);
    return (React__default.createElement(UnlinkView, { viewType: viewType, unlinkedItemId: appointmentId, unlinkType: "unlinkAppointment" }));
};
var UnlinkAppointmentContainer$1 = React__default.memo(UnlinkAppointmentContainer);

var UnlinkOrderContainer = function (_a) {
    var isSuccessPage = _a.isSuccessPage, _b = _a.orderNumber, orderNumber = _b === void 0 ? '' : _b, orderToken = _a.orderToken;
    var dispatch = useDispatch();
    var unlinkOrderCall = useSelector(getUnlinkOrderCall);
    var viewType = useMemo(function () {
        if (isSuccessPage) {
            return 'success';
        }
        else {
            return statusFailed(unlinkOrderCall) ? 'failed' : undefined;
        }
    }, [isSuccessPage, unlinkOrderCall]);
    useEffect(function () {
        if (!isSuccessPage) {
            if (orderToken) {
                dispatch(unlinkOrder({ orderToken: orderToken, orderNumber: orderNumber }));
            }
            else {
                dispatch(unlinkOrderFailed(new Error('Cannot unlink an order without an orderToken')));
            }
        }
    }, [isSuccessPage, orderToken, unlinkOrder]);
    return React__default.createElement(UnlinkView, { viewType: viewType, unlinkedItemId: orderNumber, unlinkType: "unlinkOrder" });
};
var UnlinkOrderContainer$1 = React__default.memo(UnlinkOrderContainer);

var setInitialState = function (name) { return ({
    value: '',
    name: name,
    isValid: false,
}); };
var getErrorLabel = function (auth, getLabel) {
    if (statusFailed(auth.changePasswordCall) && typeof auth.changePasswordCall.error === 'string') {
        var error = auth.changePasswordCall.error;
        switch (error) {
            case 'wrong_email_or_password':
                return getLabel('account.changePassword.current.error');
            case 'password_strength_error':
                return getLabel('account.changePassword.incorrect');
            default:
                return getLabel('account.changePassword.errors.general');
        }
    }
    return getLabel('account.changePassword.errors.general');
};
var ChangePassword = /** @class */ (function (_super) {
    __extends(ChangePassword, _super);
    function ChangePassword() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            currentPassword: setInitialState('currentPassword'),
            newPassword: setInitialState('newPassword'),
            isRedirecting: false,
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            var auth = _this.props.auth;
            var _a = _this.state, currentPassword = _a.currentPassword, newPassword = _a.newPassword;
            if (auth.email && currentPassword.isValid === true && newPassword.isValid === true) {
                _this.props.changePassword({
                    email: auth.email,
                    currentPassword: currentPassword.value,
                    newPassword: newPassword.value,
                });
            }
        };
        return _this;
    }
    ChangePassword.prototype.render = function () {
        var _this = this;
        var getLabel = this.props.intl.getLabel;
        var _a = this.props, auth = _a.auth, className = _a.className, currentBreakpoint = _a.currentBreakpoint, rest = __rest(_a, ["auth", "className", "currentBreakpoint"]);
        var ROUTE_KEY = 'changePassword';
        getLabel("account.menu." + ROUTE_KEY);
        var passwordIndicatorPosition = currentBreakpoint === MediaQuery.BreakpointName.DESKTOP ? 'right' : 'bottom';
        return (React.createElement(React.Fragment, null,
            React.createElement(MyAccountBreadcrumbs$1, { items: getBreadcrumbs(['profile', 'changePassword'], this.props.intl) }),
            React.createElement("form", { className: classnames('change-password', className), "data-t": rest['data-t'], noValidate: true, onSubmit: this.handleSubmit },
                React.createElement(Heading, { variant: "smallest", component: "h2" }, getLabel('account.changePassword')),
                statusFailed(auth.changePasswordCall) && (React.createElement(ScrollIntoView, null,
                    React.createElement(Alert, { type: "error", message: getErrorLabel(auth, getLabel) }))),
                this.props.isSuccess && statusIdle(auth.changePasswordCall) && (React.createElement(ScrollIntoView, null,
                    React.createElement(Alert, { type: "success", icon: "checkmark", message: getLabel('account.changePassword.success') }))),
                React.createElement(Password, { label: getLabel('account.currentPassword'), onChange: function (value) { return _this.setState({ currentPassword: value }); } }),
                React.createElement(PasswordWithStrengthIndicator, { label: getLabel('account.newPassword'), value: this.state.newPassword.value, indicatorPosition: passwordIndicatorPosition, onChange: function (value) { return _this.setState({ newPassword: value }); } }),
                React.createElement(Button, { caption: getLabel('account.action.changePassword'), isLoading: statusLoading(auth.changePasswordCall) || this.state.isRedirecting, "data-t": "submit", type: "submit", className: "change-password__button" }))));
    };
    return ChangePassword;
}(React.Component));
var mapStateToProps$1 = function (state) { return ({
    auth: Selectors.getAuth(state),
}); };
var mapDispatchToProps$1 = {
    changePassword: Actions$2.ResetPasswordActions.changePassword,
};
var ChangePassword$1 = connect(mapStateToProps$1, mapDispatchToProps$1)(MediaQuery.WithBreakpoints(withIntl(ChangePassword)));

var MyAccountRoot = /** @class */ (function (_super) {
    __extends(MyAccountRoot, _super);
    function MyAccountRoot() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            reverseRouteLookup: {},
            currentRoute: _this.props.initialRoute.replace(/\/$/, ''),
            pageViewDone: false,
        };
        _this.onNavigate = function (location, goBack) {
            var stripTrailingSlash = location.pathname.replace(/\/?$/, '');
            var urlParts = stripTrailingSlash.split('/');
            var newRoute = urlParts[2];
            if (!newRoute || !_this.state.reverseRouteLookup) {
                return;
            }
            if (newRoute in _this.state.reverseRouteLookup) {
                var path = urlParts[3] ? newRoute + "/" + urlParts[3] : newRoute;
                !goBack && window.history.pushState({}, '', location.pathname);
                _this.setState({ currentRoute: path });
            }
        };
        return _this;
    }
    MyAccountRoot.getDerivedStateFromProps = function (props) {
        return {
            reverseRouteLookup: props.routes
                ? Object.entries(props.routes).reduce(function (reverse, _a) {
                    var _b;
                    var _c = __read(_a, 2), name = _c[0], route = _c[1];
                    return (__assign(__assign({}, reverse), (_b = {}, _b[route.toLowerCase()] = name, _b)));
                }, {})
                : {},
        };
    };
    MyAccountRoot.prototype.componentDidMount = function () {
        var _this = this;
        this.unregisterHistory = Utils.history().listen(function (location) {
            // Only called on back button so don't push new history entry here
            _this.onNavigate(location, true);
        });
    };
    MyAccountRoot.prototype.componentDidUpdate = function (_, prevState) {
        var _this = this;
        var _a;
        var topLevelRoutes = Object.values((_a = this.props.routes) !== null && _a !== void 0 ? _a : {});
        var isRouteEqual = prevState.currentRoute === this.state.currentRoute;
        var hasValidAuthState = State.isLoggedIn(this.props.authState) ||
            State.isLoggedOut(this.props.authState) ||
            State.isLoggedInPasswordless(this.props.authState);
        if (hasValidAuthState &&
            !this.state.pageViewDone &&
            topLevelRoutes.some(function (route) { var _a, _b; return (_b = (_a = _this.state.currentRoute) === null || _a === void 0 ? void 0 : _a.includes(route)) !== null && _b !== void 0 ? _b : false; })) {
            this.props.pageView(this.state.currentRoute);
            this.setState({ pageViewDone: true });
        }
        if (!isRouteEqual) {
            this.setState({ pageViewDone: false });
        }
    };
    MyAccountRoot.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        var _g = this.props, authState = _g.authState, locale = _g.locale, country = _g.country, formattedRoutes = _g.formattedRoutes, staticsUrl = _g.staticsUrl, benefitsList = _g.benefitsList, subscriptionContactLensProductsUrl = _g.subscriptionContactLensProductsUrl, _h = _g.isAddressBookEnabled, isAddressBookEnabled = _h === void 0 ? false : _h, isSubscriptionHasOneAddressEnabled = _g.isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled = _g.isSubscriptionUpdateAddressEnabled, bookAppointmentUrl = _g.bookAppointmentRoute, convertOrderLineItem = _g.convertOrderLineItem, postParams = _g.postParams;
        var bookAppointmentRoute = bookAppointmentUrl && !bookAppointmentUrl.startsWith('/')
            ? "/" + bookAppointmentUrl
            : bookAppointmentUrl;
        if (State.isUninitialized(authState)) {
            return MyAccountRoot.renderSubroute(React.createElement(Loader$1, null), {
                isProtected: false,
                center: true,
            });
        }
        var currentRoute = this.state.currentRoute.toLowerCase();
        switch (currentRoute) {
            // First match special routes
            case 'callback':
            case 'logged-out':
                return (React.createElement(Callback, { type: currentRoute, parseHash: this.props.parseHash, loggedOut: this.props.loggedOut }));
            default:
                // These are the standard routes
                var activeRoute = this.state.reverseRouteLookup[currentRoute];
                switch (activeRoute) {
                    default:
                        if (currentRoute &&
                            this.props.routes &&
                            currentRoute.startsWith(this.props.routes.orders)) {
                            // orderNumber is number but we don't parse it because it has leading 0's
                            var _j = __read(/\/([0-9]+)\/?$/.exec(currentRoute) || [], 2), orderNumber = _j[1];
                            var isLegacyOrder = currentRoute.includes('legacy');
                            if (orderNumber) {
                                var formatters = MyAccountRoot.collectOrderTemplates(this.props.children);
                                return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                                    React.createElement(OrderDetail$1, { staticsUrl: staticsUrl, locale: locale, country: country, subscriptionsUrl: (_a = this.props.routes) === null || _a === void 0 ? void 0 : _a.subscriptionsv2, orderNumber: orderNumber, addressFormatter: formatters.address, storeAddressFormatter: formatters.storeAddress, contactDetailsFormatter: formatters.contactDetails, isLegacy: isLegacyOrder })), { isProtected: true });
                            }
                        }
                        else if (currentRoute &&
                            this.props.routes &&
                            this.props.routes.subscriptions &&
                            currentRoute.startsWith(this.props.routes.subscriptions) &&
                            !(this.props.routes.subscriptionsv2 &&
                                currentRoute.startsWith(this.props.routes.subscriptionsv2))) {
                            /**
                             * subscriptionId is a string that can have an uppercase ID, so need the
                             * non-lowercase version of currentRoute here
                             */
                            var _k = __read(/\/(\w+)\/?$/.exec(this.state.currentRoute) || [], 2), subscriptionId = _k[1];
                            var _l = MyAccountRoot.collectSubscriptionTemplates(this.props.children), addressSummary_1 = _l.addressSummary, billingAddress_1 = _l.billingAddress, paymentDetailsSummary = _l.paymentDetailsSummary;
                            var subscriptionBillingAddress = MyAccountRoot.collectSubscriptionFormTemplate(this.props.children);
                            return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                                React.createElement(SubscriptionDetail$2, { addressSummary: addressSummary_1, billingAddressForm: subscriptionBillingAddress || billingAddress_1, isSubscriptionHasOneAddressEnabled: isSubscriptionHasOneAddressEnabled, isSubscriptionUpdateAddressEnabled: isSubscriptionUpdateAddressEnabled, paymentDetailsSummary: paymentDetailsSummary, staticsUrl: staticsUrl, subscriptionId: subscriptionId })), { isProtected: true });
                        }
                        else if (currentRoute &&
                            this.props.routes &&
                            this.props.routes.subscriptionsv2 &&
                            currentRoute.startsWith(this.props.routes.subscriptionsv2)) {
                            // parse subscriptionId in url
                            // has to be last part of url
                            var subscriptionOrderIdRegex = /\/([\-\_\w]+)\/?$/im;
                            var _m = __read(subscriptionOrderIdRegex.exec(this.state.currentRoute) || [], 2), subscriptionId = _m[1];
                            var _o = MyAccountRoot.collectSubscriptionV2FormTemplates(this.props.children), businessAddress_1 = _o.businessAddress, address_1 = _o.address;
                            var _p = MyAccountRoot.collectSubscriptionV2SummaryTemplates(this.props.children), addressSummaryV2_1 = _p.addressSummary, invoiceSummaryV2_1 = _p.invoiceSummary;
                            if (this.state.currentRoute.includes('3ds-callback')) {
                                var urlStr = window.location.origin + "/my-account/" + ((_b = this.props.routes) === null || _b === void 0 ? void 0 : _b.subscriptionsv2) + "/" + subscriptionId;
                                var url_1 = ((_c = this.props.routes) === null || _c === void 0 ? void 0 : _c.subscriptionsv2) && new URL(urlStr);
                                var onComplete = function () { return url_1 && _this.onNavigate(url_1); };
                                return (React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                                    React.createElement(AddPaymentMethodCallback, { postParams: postParams, onComplete: onComplete })));
                            }
                            return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                                React.createElement(SubscriptionDetailContainer, { subscriptionOrderId: subscriptionId, addressSummary: addressSummaryV2_1, invoiceDetailsSummary: invoiceSummaryV2_1, addressForm: address_1, businessAddressForm: businessAddress_1 })));
                        }
                        else if (currentRoute &&
                            ((_d = this.props.routes) === null || _d === void 0 ? void 0 : _d.unlinkOrder) &&
                            currentRoute.startsWith(this.props.routes.unlinkOrder)) {
                            var isSuccessPage = currentRoute.includes('/success');
                            var query_1 = window ? QueryString.parse(window.location.search) : undefined;
                            return MyAccountRoot.renderSubroute(React.createElement("div", { className: "myaccount__form-wrapper" },
                                React.createElement(UnlinkOrderContainer$1, { isSuccessPage: isSuccessPage, orderToken: query_1 && query_1.orderToken
                                        ? StringGuard.guard('query.orderToken', query_1.orderToken)
                                        : undefined, orderNumber: query_1 && query_1.orderNumber
                                        ? StringGuard.guard('query.orderNumber', query_1.orderNumber)
                                        : undefined })), {
                                isProtected: false,
                                center: true,
                            });
                        }
                        else if (currentRoute &&
                            ((_e = this.props.routes) === null || _e === void 0 ? void 0 : _e.unlinkAppointment) &&
                            currentRoute.startsWith(this.props.routes.unlinkAppointment)) {
                            var isSuccessPage = currentRoute.includes('/success');
                            var query_2 = window ? QueryString.parse(window.location.search) : undefined;
                            return MyAccountRoot.renderSubroute(React.createElement("div", { className: "myaccount__form-wrapper" },
                                React.createElement(UnlinkAppointmentContainer$1, { isSuccessPage: isSuccessPage, appointmentToken: query_2 && query_2.appointmentToken
                                        ? StringGuard.guard('query.appointmentToken', query_2.appointmentToken)
                                        : undefined, appointmentId: query_2 && query_2.appointmentId
                                        ? StringGuard.guard('query.appointmentId', query_2.appointmentId)
                                        : undefined })), {
                                isProtected: false,
                                center: true,
                            });
                        }
                        break;
                    case RouteKey.CreateAccount:
                        return MyAccountRoot.renderSubroute(React.createElement("div", { className: "myaccount__form-wrapper" },
                            React.createElement(CreateAccount.SetPassword, { consentItems: this.props.consentItems })), { isProtected: false, center: true });
                    case 'linkExpired':
                        var query = window ? QueryString.parse(window.location.search, true) : undefined;
                        return MyAccountRoot.renderSubroute(React.createElement(ExpiredLink, { targetAction: query === null || query === void 0 ? void 0 : query.targetAction }), { isProtected: false, center: true });
                    case RouteKey.ResetPassword:
                        return MyAccountRoot.renderSubroute(React.createElement("div", { className: "myaccount__form-wrapper" },
                            React.createElement(ResetPassword.SubmitEmailAddress, null)), {
                            isProtected: false,
                            center: true,
                        });
                    case RouteKey.SetPassword:
                        return MyAccountRoot.renderSubroute(React.createElement("div", { className: "myaccount__form-wrapper" },
                            React.createElement(ResetPassword.SetPassword, null)), {
                            isProtected: false,
                            center: true,
                        });
                    case RouteKey.ChangePassword:
                        var changePasswordResult = QueryString.parse(window.location.search).changePasswordResult;
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement("div", { className: "myaccount__form-wrapper" },
                                React.createElement(ChangePassword$1, { isSuccess: changePasswordResult === 'success' }))), {
                            isProtected: true,
                        });
                    case RouteKey.Signup:
                        var templates = MyAccountRoot.collectAuthTemplates(this.props.children);
                        return MyAccountRoot.renderSubroute(React.createElement("div", { className: "myaccount__form-wrapper--double" },
                            React.createElement(CreateAccount.SignUp, { loginUrl: (formattedRoutes && formattedRoutes[RouteKey.Login]) || '#', signUpFields: templates[Types.FormName.signUp] })), { isProtected: false, center: true });
                    case RouteKey.Login:
                        var _q = window && QueryString.parse(window.location.search), returnPath = _q.returnPath, error = _q.error, email = _q.email;
                        return MyAccountRoot.renderSubroute(React.createElement("div", { className: "myaccount__form-wrapper--double" },
                            React.createElement(Login, { returnPath: returnPath
                                    ? encodeURIComponent(StringGuard.guard('returnPath', returnPath))
                                    : undefined, createAccountRichText: this.props.createAccountRichText, error: error ? StringGuard.guard('error', error) : undefined, email: email ? StringGuard.guard('email', email) : undefined })), { isProtected: false, center: true });
                    case RouteKey.Prescriptions:
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement(PrescriptionPage, null)));
                    case RouteKey.Privacy:
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement(Privacy$1, null)), { isProtected: true });
                    case RouteKey.Profile:
                        var _r = MyAccountRoot.collectProfileTemplates(this.props.children), personalDetails = _r.personalDetails, personalDetailsSummary = _r.personalDetailsSummary, billingAddress = _r.billingAddress, addressSummary = _r.addressSummary, preferredStoreSummary = _r.preferredStoreSummary, personalGreeting = _r.personalGreeting;
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement(Profile$1, { personalDetailsForm: personalDetails, personalDetailsSummary: personalDetailsSummary, addressForm: billingAddress, addressSummary: addressSummary, preferredStoreSummary: preferredStoreSummary, personalGreetingFormatter: personalGreeting, bookAppointmentRoute: bookAppointmentRoute })), { isProtected: true });
                    case RouteKey.AddressBook:
                        if (isAddressBookEnabled) {
                            var billingAddress_2 = MyAccountRoot.collectAddressBookTemplates(this.props.children).billingAddress;
                            return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                                React.createElement(AddressBookContainer$1, { addressForm: billingAddress_2 })), { isProtected: true });
                        }
                        else {
                            var formattedRoutes_1 = this.props.formattedRoutes;
                            formattedRoutes_1 && (window === null || window === void 0 ? void 0 : window.location.assign(formattedRoutes_1[RouteKey.Profile]));
                        }
                    case RouteKey.Appointments:
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement(AppointmentsContainer, { bookAppointmentRoute: bookAppointmentRoute })), { isProtected: true });
                    case RouteKey.Orders:
                        // TODO: replace this with proper locale
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement(Orders$1, { subscriptionsUrl: (_f = this.props.routes) === null || _f === void 0 ? void 0 : _f.subscriptionsv2, staticsUrl: staticsUrl, locale: locale, country: country, enableLegacyOrderHistory: authState.enableLegacyOrderHistory, convertOrderLineItem: convertOrderLineItem, onNavigate: this.onNavigate })), { isProtected: true });
                    case RouteKey.Subscriptions:
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement(SubscriptionList$2, { onNavigate: this.onNavigate })), { isProtected: true });
                    case RouteKey.SubscriptionsV2:
                        var _s = MyAccountRoot.collectSubscriptionV2FormTemplates(this.props.children), businessAddress = _s.businessAddress, address = _s.address;
                        var _t = MyAccountRoot.collectSubscriptionV2SummaryTemplates(this.props.children), addressSummaryV2 = _t.addressSummary, invoiceSummaryV2 = _t.invoiceSummary;
                        return MyAccountRoot.renderSubroute(React.createElement(PageWithMenu$1, { onNavigate: this.onNavigate },
                            React.createElement(SubscriptionListContainer, { route: (formattedRoutes && formattedRoutes[RouteKey.SubscriptionsV2]) || '', subscriptionContactLensProductsUrl: subscriptionContactLensProductsUrl, benefitsList: benefitsList, addressSummary: addressSummaryV2, addressForm: address, businessAddressForm: businessAddress, onNavigate: this.onNavigate, invoiceDetailsSummary: invoiceSummaryV2 })), { isProtected: true });
                }
        }
        if (currentRoute in this.state.reverseRouteLookup) {
            return React.createElement(Heading, { variant: "small" },
                currentRoute,
                " has not been implemented yet");
        }
        // TODO: this is really a 404 but we can't return that here anymore
        return null;
    };
    MyAccountRoot.prototype.componentWillUnmount = function () {
        this.unregisterHistory();
    };
    /**
     * Custom form fields
     */
    MyAccountRoot.PersonalDetailsFields = function (_) { return null; };
    MyAccountRoot.AddressFields = function (_) { return null; };
    MyAccountRoot.SignUpFields = function (_) { return null; };
    /**
     * Custom summary formatters
     */
    MyAccountRoot.PersonalDetailsSummary = function (_) { return null; };
    MyAccountRoot.AddressSummary = function (_) { return null; };
    MyAccountRoot.PreferredStoreSummary = function (_) { return null; };
    MyAccountRoot.PaymentDetailsSummary = function (_) { return null; };
    MyAccountRoot.InvoiceDetailsSummaryV2 = function (_) { return null; };
    MyAccountRoot.PersonalGreeting = function (_) { return null; };
    MyAccountRoot.OrderAddressFormatter = function (_) { return null; };
    MyAccountRoot.OrderContactDetailsFormatter = function (_) { return null; };
    MyAccountRoot.renderSubroute = function (component, options) {
        if (options === void 0) { options = { isProtected: true }; }
        var wrappedComponent = (React.createElement("div", { className: classnames('myaccount-root', {
                'myaccount-root--center': options.center,
            }) },
            React.createElement("div", { className: "site-container" }, component)));
        return options.isProtected ? React.createElement(Protected$1, null, wrappedComponent) : wrappedComponent;
    };
    MyAccountRoot.collectAuthTemplates = function (children) {
        var templates = __assign({}, DefaultFormTemplates());
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.SignUpFields:
                    templates[Types.FormName.signUp] = child.props.children;
                    break;
            }
        });
        return templates;
    };
    MyAccountRoot.collectProfileTemplates = function (children) {
        var templates = __assign(__assign({}, DefaultFormTemplates()), DefaultSummaryTemplates());
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.AddressFields:
                    if (child.props.type === undefined) {
                        templates[Types.FormName.billingAddress] = child.props.children;
                    }
                    break;
                case MyAccountRoot.PersonalDetailsFields:
                    templates[Types.FormName.personalDetails] = child.props.children;
                    break;
                case MyAccountRoot.PersonalDetailsSummary:
                    templates[SummaryName.personalDetailsSummary] = child.props.children;
                    break;
                case MyAccountRoot.AddressSummary:
                    if (child.props.type === undefined ||
                        child.props.type === AddressSummaryTypes.Subscription) {
                        templates[SummaryName.addressSummary] = child.props.children;
                    }
                    break;
                case MyAccountRoot.PreferredStoreSummary:
                    templates[SummaryName.preferredStoreSummary] = child.props.children;
                    break;
                case MyAccountRoot.PersonalGreeting:
                    templates[SummaryName.personalGreeting] = child.props.children;
            }
        });
        return templates;
    };
    MyAccountRoot.collectAddressBookTemplates = function (children) {
        var templates = __assign(__assign({}, DefaultFormTemplates()), DefaultSummaryTemplates());
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.AddressFields:
                    if (child.props.type === undefined) {
                        templates[Types.FormName.billingAddress] = child.props.children;
                    }
                    break;
                case MyAccountRoot.AddressSummary:
                    if (child.props.type !== undefined ||
                        child.props.type !== AddressSummaryTypes.Subscription) {
                        return;
                    }
                    templates[SummaryName.addressSummary] = child.props.children;
                    break;
            }
        });
        return templates;
    };
    MyAccountRoot.collectSubscriptionFormTemplate = function (children) {
        var subscriptionBillingAddress = null;
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            if (child.type === MyAccountRoot.AddressFields &&
                child.props.type === AddressFieldTypes.Subscription) {
                subscriptionBillingAddress = child.props.children;
            }
        });
        return subscriptionBillingAddress;
    };
    MyAccountRoot.collectSubscriptionV2FormTemplates = function (children) {
        var billingAddress = DefaultFormTemplates().billingAddress;
        var address = billingAddress;
        var businessAddress = billingAddress;
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            if (child.type === MyAccountRoot.AddressFields &&
                child.props.type === AddressFieldTypes.SubscriptionV2) {
                React.Children.forEach(child.props.children, function (child) {
                    if (!React.isValidElement(child)) {
                        return;
                    }
                    if (child.props.type === SubscriptionAddressTypes.Address) {
                        address = child;
                    }
                    if (child.props.type === SubscriptionAddressTypes.BusinessAddress) {
                        businessAddress = child;
                    }
                });
            }
        });
        return { address: address, businessAddress: businessAddress };
    };
    MyAccountRoot.collectSubscriptionTemplates = function (children) {
        var templates = __assign(__assign({}, DefaultFormTemplates()), DefaultSummaryTemplates());
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.AddressSummary:
                    if (child.props.type === undefined ||
                        child.props.type === AddressSummaryTypes.Subscription) {
                        templates.addressSummary = child.props.children;
                    }
                    break;
                case MyAccountRoot.PaymentDetailsSummary:
                    templates.paymentDetailsSummary = child.props.children;
                    break;
                case MyAccountRoot.AddressFields:
                    if (child.props.type === undefined) {
                        templates.billingAddress = child.props.children;
                    }
                    break;
            }
        });
        return templates;
    };
    MyAccountRoot.collectSubscriptionV2SummaryTemplates = function (children) {
        var templates = DefaultSummaryTemplates();
        var addressSummary = templates[SummaryName.addressSummary];
        var invoiceSummary = templates[SummaryName.invoiceDetailsSummaryV2];
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.AddressSummary:
                    if (child.props.type !== AddressSummaryTypes.SubscriptionV2) {
                        return;
                    }
                    addressSummary = child.props.children;
                    break;
                case MyAccountRoot.InvoiceDetailsSummaryV2:
                    invoiceSummary = child.props.children;
                    break;
            }
        });
        return { addressSummary: addressSummary, invoiceSummary: invoiceSummary };
    };
    MyAccountRoot.collectOrderTemplates = function (children) {
        var templates = __assign({}, DefaultOrderTemplates());
        React.Children.forEach(children, function (child) {
            if (!React.isValidElement(child)) {
                return;
            }
            switch (child.type) {
                case MyAccountRoot.OrderAddressFormatter:
                    templates.address = child.props.children;
                    break;
                case MyAccountRoot.OrderContactDetailsFormatter:
                    templates.contactDetails = child.props.children;
                    break;
            }
        });
        return templates;
    };
    return MyAccountRoot;
}(React.Component));
var mapStateToProps = function (state) {
    return {
        authState: Selectors.getAuth(state),
        formattedRoutes: Selectors.getFormattedRoutes(state),
        routes: Selectors.getRoutes(state),
    };
};
var mapDispatchToProps = {
    signup: Actions$2.CreateAccountActions.signup,
    onResend: Actions$2.CreateAccountActions.signup,
    loginWithPassword: Actions$2.LoginActions.loginWithPassword,
    parseHash: Actions$2.LoginActions.parseHash,
    loggedOut: Actions$2.LogoutActions.loggedOut,
    pageView: pageView,
};
var MyAccountRootConnected = connect(mapStateToProps, mapDispatchToProps)(MyAccountRoot);
var MyAccountRootConnectedClientOnly = function (props) {
    return (React.createElement(OnlyOnClient, null,
        React.createElement(MyAccountRootConnected, __assign({}, props))));
};
// We need to export this way to make the static properties
// available to the outside on ConnectedMyAccountRoot. TypeScript won't understand otherwise.
var MyAccountRootConnectedClientOnlyWithContext = /** @class */ (function (_super) {
    __extends(MyAccountRootConnectedClientOnlyWithContext, _super);
    function MyAccountRootConnectedClientOnlyWithContext() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyAccountRootConnectedClientOnlyWithContext.prototype.render = function () {
        return (React.createElement(AuthContextConsumer, null,
            React.createElement(MyAccountRootConnectedClientOnly, __assign({}, this.props))));
    };
    /**
     * This can be used to change the personal detail form content on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PersonalDetailsFields = MyAccountRoot.PersonalDetailsFields;
    /**
     * This can be used to change the address fields on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.AddressFields = MyAccountRoot.AddressFields;
    /**
     * This can be used to change the signup form on the signup page
     */
    MyAccountRootConnectedClientOnlyWithContext.SignUpFields = MyAccountRoot.SignUpFields;
    /**
     * This can be used to change to personal details summary on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PersonalDetailsSummary = MyAccountRoot.PersonalDetailsSummary;
    /**
     * This can be used to change the address summary on the profile page and the subscription detail page
     */
    MyAccountRootConnectedClientOnlyWithContext.AddressSummary = MyAccountRoot.AddressSummary;
    /**
     * This can be used to change the invoice details summary on the subscription detail page
     */
    MyAccountRootConnectedClientOnlyWithContext.InvoiceDetailsSummary = MyAccountRoot.InvoiceDetailsSummaryV2;
    /**
     * This can be used to change the preferred store summary on the profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PreferredStoreSummary = MyAccountRoot.PreferredStoreSummary;
    /**
     * This can be used to change the payment details summary on the subscription detail page
     */
    MyAccountRootConnectedClientOnlyWithContext.PaymentDetailsSummary = MyAccountRoot.PaymentDetailsSummary;
    /**
     * This can be used to change the address summary on the order details page
     */
    MyAccountRootConnectedClientOnlyWithContext.OrderAddressFormatter = MyAccountRoot.OrderAddressFormatter;
    /**
     * This can be used to change the contact details summary on the order details page
     */
    MyAccountRootConnectedClientOnlyWithContext.OrderContactDetailsFormatter = MyAccountRoot.OrderContactDetailsFormatter;
    /**
     * This can be used to customize the personal greeting on top of the Profile page
     */
    MyAccountRootConnectedClientOnlyWithContext.PersonalGreeting = MyAccountRoot.PersonalGreeting;
    return MyAccountRootConnectedClientOnlyWithContext;
}(React.PureComponent));

ReducersRegistry.register('myAccount', reducer$2);
SagaRegistry.register('myAccount', sagas);

export { actions as Actions, AddAddress$2 as AddAddress, selectors as AddressBookSelectors, MyAccountMenu$1 as MyAccountMenu, MyAccountRootConnectedClientOnlyWithContext as MyAccountRoot, Profile$1 as Profile, state$1 as ProfileState, state as State, types as Types, UNAVAILABLE, index as Utils, WithUserData, isDataLoading, isDataSuccess, isDataUnavailable, useAddressBook, useAddressBookList };
//# sourceMappingURL=index.es.js.map
